module.exports = {
    BubblesData: () => {
        return [
            [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[597.986,437.057],[597.986,333.453],[418.36,443.276],[418.36,345.977]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[597.986,554.568],[597.986,450.964],[418.36,553.636],[418.36,456.337]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[597.986,571.851],[597.986,675.455],[418.36,569.867],[418.36,667.166]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[597.986,687.409],[597.986,791.012],[418.36,678.392],[418.36,775.691]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[597.986,810.198],[597.986,913.802],[418.36,793.71],[418.36,891.008]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[555.536,324.616],[555.536,229.009],[515.084,327.6],[515.084,233.323]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[560.869,317.63],[560.869,218.912],[529.662,321.87],[529.662,225.04]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[585.413,314.598],[585.413,214.529],[560.869,317.63],[560.869,218.912]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[626.682,310.268],[626.682,208.27],[585.413,314.599],[585.413,214.529]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[803.761,429.932],[803.761,319.106],[599.086,437.019],[599.086,333.377]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[803.761,555.635],[803.761,444.809],[599.086,554.573],[599.086,450.931]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[803.761,574.124],[803.761,684.95],[599.086,571.863],[599.086,675.506]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[803.761,697.737],[803.761,808.564],[599.086,687.464],[599.086,791.106]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[804.572,829.162],[804.572,940.017],[599.795,810.365],[599.795,914.032]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[684.381,306.871],[684.381,203.359],[629.303,309.905],[629.303,207.745]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[724,305.062],[724,200.745],[684.381,306.871],[684.381,203.359]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[781.434,302.724],[781.434,197.366],[724,305.062],[724,200.745]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[781.434,302.724],[781.434,197.366],[806.099,305.971],[806.099,202.059]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[893.308,430.025],[803.761,429.933],[893.308,319.291],[803.761,319.106]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[893.308,555.622],[893.308,444.888],[803.761,555.635],[803.761,444.809]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[893.308,574.094],[803.761,574.124],[893.308,684.828],[803.761,684.95]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[893.308,697.604],[803.761,697.737],[893.308,808.338],[803.761,808.564]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[894.376,828.865],[804.572,829.162],[894.376,939.606],[804.572,940.017]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[855.279,302.341],[855.279,196.811],[806.099,305.971],[806.099,202.059]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[855.278,302.341],[941.96,303.864],[855.278,196.811],[941.96,199.013]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[893.308,430.025],[893.308,319.291],[934.581,432.7],[934.581,324.679]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[893.308,555.622],[893.308,444.888],[934.581,555.221],[934.581,447.2]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[893.308,574.094],[893.308,684.828],[934.581,573.241],[934.581,681.262]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[893.308,697.604],[893.308,808.338],[934.581,693.725],[934.581,801.746]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[894.376,828.865],[894.376,939.606],[933.709,822.099],[933.709,930.254]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[975.964,825.735],[975.964,935.28],[933.708,822.099],[933.708,930.254]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[975.261,431.382],[975.261,322.025],[934.581,432.7],[934.581,324.679]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[975.261,555.418],[975.261,446.061],[934.581,555.22],[934.581,447.2]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[975.261,573.661],[975.261,683.018],[934.581,573.241],[934.581,681.262]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[975.261,695.636],[975.261,804.993],[934.581,693.725],[934.581,801.746]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[941.961,303.864],[941.961,199.013],[1028.06,308.226],[1028.06,205.318]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[975.261,431.382],[975.261,322.025],[1053.87,436.672],[1053.87,332.678]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[975.261,555.418],[975.261,446.061],[1053.87,554.625],[1053.87,450.631]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[975.261,573.661],[975.261,683.019],[1053.87,571.974],[1053.87,675.968]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[975.261,695.636],[975.261,804.993],[1053.87,687.966],[1053.87,791.96]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[975.965,825.735],[975.965,935.28],[1059.82,810.741],[1059.82,914.552]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1028.06,308.226],[1028.06,205.318],[1134.1,315.927],[1134.1,216.449]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1124.44,434.548],[1124.44,328.4],[1053.87,436.672],[1053.87,332.678]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1124.44,554.944],[1124.44,448.796],[1053.87,554.625],[1053.87,450.631]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1124.44,572.651],[1124.44,678.799],[1053.87,571.974],[1053.87,675.968]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1124.44,691.046],[1124.44,797.194],[1053.87,687.966],[1053.87,791.96]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1122.99,816.94],[1122.99,923.121],[1052.72,811.327],[1052.72,915.363]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1122.99,816.94],[1122.99,923.121],[1192.77,803.622],[1192.77,904.711]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1124.44,434.548],[1124.44,328.4],[1227.39,438.304],[1227.39,335.963]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1124.44,554.944],[1124.44,448.796],[1227.39,554.381],[1227.39,452.041]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1124.44,572.651],[1124.44,678.799],[1227.39,571.454],[1227.39,673.794]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1124.44,691.046],[1124.44,797.194],[1227.39,685.602],[1227.39,787.942]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1134.9,316.007],[1134.9,216.565],[1220.11,324.856],[1220.11,229.355]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1208.04,804.76],[1208.04,906.284],[1272.38,792.291],[1272.38,889.047]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1220.11,324.856],[1220.11,229.355],[1287.96,335.567],[1287.96,244.838]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1209.14,442.2],[1209.14,340.407],[1389.66,454.998],[1389.66,366.628]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1209.14,557.657],[1209.14,455.864],[1389.66,555.23],[1389.66,466.86]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1209.14,574.639],[1209.14,676.432],[1389.66,569.973],[1389.66,658.343]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1209.14,688.177],[1209.14,789.971],[1389.66,668.539],[1389.66,756.91]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1287.96,335.567],[1287.96,244.838],[1319.88,344.945],[1319.88,258.392]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1323.4,345.202],[1323.4,258.765],[1335.93,354.112],[1335.93,271.643]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1411.23,452.043],[1411.23,363.632],[1423.66,456.1],[1423.66,371.802]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1411.23,552.322],[1411.23,463.911],[1423.66,551.714],[1423.66,467.416]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1411.23,567.071],[1411.23,655.482],[1423.66,565.777],[1423.66,650.075]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:1,
                    verts:[[1411.23,665.682],[1411.23,754.094],[1423.66,659.801],[1423.66,744.099]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[635.702,436.718],[635.702,332.771],[437.535,442.214],[437.535,343.839]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[635.702,554.618],[635.702,450.671],[437.535,553.795],[437.535,455.419]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[635.702,571.959],[635.702,675.907],[437.535,570.206],[437.535,668.581]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[635.702,687.9],[635.702,791.848],[437.535,679.932],[437.535,778.307]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[635.702,811.097],[635.702,915.045],[437.535,796.525],[437.535,894.901]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[529.294,325.956],[529.294,230.946],[522.83,332.76],[522.83,240.781]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[573.669,323.32],[573.669,227.136],[529.294,325.956],[529.294,230.946]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[586.49,316.433],[586.49,217.181],[550.252,320.38],[550.252,222.886]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[614.6,313.637],[614.6,213.139],[586.49,316.433],[586.49,217.181]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[660.914,309.707],[660.914,207.459],[614.599,313.637],[614.599,213.139]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[859.018,430.524],[859.018,320.297],[636.906,436.685],[636.906,332.703]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[859.018,555.547],[859.018,445.32],[636.906,554.623],[636.906,450.642]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[859.018,573.935],[859.018,684.162],[636.906,571.97],[636.906,675.951]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[859.018,696.88],[859.018,807.107],[636.906,687.949],[636.906,791.93]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[859.891,827.583],[859.891,937.835],[637.682,811.243],[637.682,915.246]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[722.609,306.857],[722.609,203.339],[663.942,309.371],[663.942,206.973]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[764.256,305.423],[764.256,201.267],[722.609,306.857],[722.609,203.339]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[824.099,303.632],[824.099,198.678],[764.255,305.423],[764.255,201.267]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[824.099,303.632],[824.099,198.678],[845.325,307.036],[845.325,203.599]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[897.945,303.908],[897.945,199.077],[845.325,307.036],[845.325,203.599]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[859.018,430.524],[947.564,430.978],[859.018,320.297],[947.564,321.211]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[859.018,555.547],[859.018,445.32],[947.564,555.479],[947.564,445.712]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[859.018,573.935],[859.018,684.162],[947.564,573.79],[947.564,683.557]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[859.018,696.88],[947.564,696.222],[859.018,807.107],[947.564,805.988]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[859.891,827.583],[948.637,826.325],[859.891,937.835],[948.637,936.095]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[897.944,303.908],[897.944,199.077],[982.091,306.158],[982.091,202.328]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[947.564,430.978],[947.564,321.211],[982.071,433.755],[982.071,326.803]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[947.564,555.479],[947.564,445.712],[982.071,555.063],[982.071,448.111]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[947.564,573.79],[947.564,683.557],[982.071,572.905],[982.071,679.857]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[947.564,696.222],[947.564,805.988],[982.071,692.196],[982.071,799.148]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[948.637,826.325],[948.637,936.095],[981.518,819.305],[981.518,926.39]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1026.26,822.404],[1026.26,930.675],[981.518,819.305],[981.518,926.39]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[982.092,306.158],[982.092,202.328],[1062.27,311.151],[1062.27,209.546]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1025.14,432.631],[1025.14,324.539],[982.071,433.754],[982.071,326.803]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1025.14,555.231],[1025.14,447.14],[982.071,555.063],[982.071,448.111]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1025.14,573.263],[1025.14,681.354],[982.071,572.905],[982.071,679.857]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1025.14,693.826],[1025.14,801.917],[982.071,692.196],[982.071,799.148]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1025.14,432.631],[1025.14,324.539],[1089.99,438.083],[1089.99,335.519]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1025.14,555.231],[1025.14,447.14],[1089.99,554.414],[1089.99,451.85]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1025.14,573.263],[1025.14,681.354],[1089.99,571.524],[1089.99,674.088]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1025.14,693.826],[1025.14,801.917],[1089.99,685.921],[1089.99,788.485]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1026.26,822.404],[1026.26,930.675],[1095.39,806.955],[1095.39,909.319]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1062.27,311.151],[1062.27,209.546],[1158.04,319.52],[1158.04,221.643]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1163.64,436.288],[1163.64,331.905],[1089.99,438.083],[1089.99,335.519]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1163.64,554.683],[1163.64,450.299],[1089.99,554.414],[1089.99,451.85]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1163.64,572.096],[1163.64,676.48],[1089.99,571.524],[1089.99,674.088]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1163.64,688.524],[1163.64,792.907],[1089.99,685.921],[1089.99,788.485]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1162.31,812.339],[1162.31,916.76],[1088.96,807.596],[1088.96,910.204]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1158.73,319.605],[1158.73,221.765],[1232.56,328.865],[1232.56,235.15]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1162.31,812.339],[1162.31,916.76],[1218.59,798.747],[1218.59,897.972]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1163.64,436.288],[1163.64,331.905],[1254.86,440.309],[1254.86,340.001]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1163.64,554.683],[1163.64,450.299],[1254.86,554.08],[1254.86,453.773]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1163.64,572.096],[1163.64,676.48],[1254.86,570.814],[1254.86,671.122]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1163.64,688.524],[1163.64,792.907],[1254.86,682.695],[1254.86,783.002]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1232.56,328.865],[1232.56,235.15],[1287.44,339.75],[1287.44,250.884]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1234.34,799.701],[1234.34,899.291],[1285.82,787.038],[1285.82,881.786]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1236,444.057],[1236,344.21],[1379.88,457.011],[1379.88,370.752]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1236,557.305],[1236,457.459],[1379.88,554.849],[1379.88,468.59]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1236,573.962],[1236,673.809],[1379.88,569.239],[1379.88,655.498]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1236,685.329],[1236,785.175],[1379.88,665.45],[1379.88,751.709]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1287.44,339.749],[1287.44,250.883],[1308.9,349.053],[1308.9,264.329]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1312.03,349.326],[1312.03,264.726],[1315.28,358.034],[1315.28,277.313]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1400.59,454.195],[1400.59,367.965],[1403.43,458.145],[1403.43,375.919]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1400.59,551.999],[1400.59,465.77],[1403.43,551.407],[1403.43,469.182]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1400.59,566.384],[1400.59,652.614],[1403.43,565.125],[1403.43,647.35]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:2,
                    verts:[[1400.59,662.563],[1400.59,748.793],[1403.43,656.837],[1403.43,739.063]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[675.864,436.514],[675.864,332.359],[461.177,441.226],[461.177,341.848]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[675.864,554.649],[675.864,450.494],[461.177,553.943],[461.177,454.565]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[675.864,572.024],[675.864,676.179],[461.177,570.521],[461.177,669.899]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[675.864,688.196],[675.864,792.351],[461.177,681.365],[461.177,780.743]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[675.864,811.639],[675.864,915.794],[461.177,799.146],[461.177,898.524]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[546.955,324.427],[546.955,228.735],[533.184,331.145],[533.184,238.446]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[594.859,322.166],[594.859,225.467],[546.955,324.427],[546.955,228.735]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[615.09,315.44],[615.09,215.746],[574.159,319.055],[574.159,220.971]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[646.473,312.906],[646.473,212.083],[615.09,315.44],[615.09,215.746]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[697.31,309.414],[697.31,207.035],[646.472,312.906],[646.472,212.083]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[913.662,431.294],[913.662,321.848],[677.158,436.485],[677.158,332.302]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[913.662,555.431],[913.662,445.985],[677.158,554.653],[677.158,450.47]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[913.662,573.689],[913.662,683.135],[677.158,572.034],[677.158,676.217]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[913.662,695.763],[913.662,805.209],[677.158,688.238],[677.158,792.421]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[914.583,825.531],[914.583,934.997],[677.992,811.763],[677.992,915.965]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[762.26,307.131],[762.26,203.735],[700.709,309.108],[700.709,206.592]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[805.418,306.079],[805.418,202.215],[762.259,307.131],[762.259,203.735]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[866.914,304.837],[866.914,200.42],[805.418,306.079],[805.418,202.215]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[866.914,304.837],[866.914,200.42],[884.533,308.359],[884.533,205.511]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[939.881,305.746],[939.881,201.733],[884.533,308.359],[884.533,205.511]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[913.662,431.294],[913.662,321.848],[1000.08,432.089],[1000.08,323.448]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[913.662,555.431],[913.662,445.985],[1000.08,555.312],[1000.08,446.671]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[913.662,573.689],[913.662,683.135],[1000.08,573.436],[1000.08,682.077]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[913.662,695.763],[913.662,805.209],[1000.08,694.612],[1000.08,803.253]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[914.583,825.531],[914.583,934.997],[1001.14,823.369],[1001.14,932.009]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[939.881,305.746],[939.881,201.733],[1020.6,308.662],[1020.6,205.948]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1000.08,432.089],[1000.08,323.448],[1027.64,434.931],[1027.64,329.171]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1000.08,555.312],[1000.08,446.671],[1027.64,554.886],[1027.64,449.127]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1000.08,573.436],[1000.08,682.077],[1027.64,572.53],[1027.64,678.289]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1000.08,694.612],[1000.08,803.253],[1027.64,690.492],[1027.64,796.251]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1001.14,823.369],[1001.14,932.009],[1027.4,816.184],[1027.4,922.076]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1020.6,308.662],[1020.6,205.948],[1094.21,314.199],[1094.21,213.952]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1072.47,434.001],[1072.47,327.299],[1027.64,434.93],[1027.64,329.171]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1072.47,555.026],[1072.47,448.324],[1027.64,554.886],[1027.64,449.127]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1072.47,572.826],[1072.47,679.528],[1027.64,572.529],[1027.64,678.289]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1072.47,691.839],[1072.47,798.541],[1027.64,690.492],[1027.64,796.251]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1073.97,818.746],[1073.97,925.619],[1027.4,816.184],[1027.4,922.076]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1072.47,434.001],[1072.47,327.299],[1123.44,439.549],[1123.44,338.471]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1072.47,555.026],[1072.47,448.324],[1123.44,554.194],[1123.44,453.116]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1072.47,572.826],[1072.47,679.528],[1123.44,571.056],[1123.44,672.134]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1072.47,691.839],[1072.47,798.541],[1123.44,683.796],[1123.44,784.874]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1073.97,818.746],[1073.97,925.619],[1128.26,803.031],[1128.26,903.895]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1094.21,314.199],[1094.21,213.952],[1179.24,323.11],[1179.24,226.832]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1199.17,438.077],[1199.17,335.506],[1123.44,439.549],[1123.44,338.471]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1199.17,554.415],[1199.17,451.844],[1123.44,554.194],[1123.44,453.116]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1199.17,571.526],[1199.17,674.096],[1123.44,571.056],[1123.44,672.134]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1199.17,685.931],[1199.17,788.501],[1123.44,683.796],[1123.44,784.874]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1197.96,807.607],[1197.96,910.22],[1122.54,803.716],[1122.54,904.842]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1179.83,323.197],[1179.83,226.958],[1242.25,332.752],[1242.25,240.769]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1197.96,807.607],[1197.96,910.22],[1240.95,793.899],[1240.95,891.271]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1199.17,438.077],[1199.17,335.506],[1278.38,442.299],[1278.38,344.008]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1199.17,554.415],[1199.17,451.844],[1278.38,553.782],[1278.38,455.492]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1199.17,571.526],[1199.17,674.096],[1278.38,570.179],[1278.38,668.469]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1199.17,685.931],[1199.17,788.501],[1278.38,679.81],[1278.38,778.1]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1242.25,332.752],[1242.25,240.769],[1284.54,343.704],[1284.54,256.6]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1256.98,794.678],[1256.98,892.347],[1295.96,781.956],[1295.96,874.76]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1259.16,445.902],[1259.16,347.99],[1367.7,458.885],[1367.7,374.591]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1259.16,556.956],[1259.16,459.044],[1367.7,554.493],[1367.7,470.199]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1259.16,573.289],[1259.16,671.201],[1367.7,568.556],[1367.7,652.85]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1259.16,682.497],[1259.16,780.409],[1367.7,662.575],[1367.7,746.869]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:3,
                    verts:[[1284.54,343.704],[1284.54,256.6],[1296.09,352.869],[1296.09,269.845]]
                },
                ],
                [
                {
                    num:"102",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[490.664,788.141],[490.664,883.311],[451.694,786.481],[451.694,881.016]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[491.948,445.472],[491.948,350.399],[454.397,446.075],[454.397,351.613]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[491.948,553.307],[491.948,458.234],[454.397,553.216],[454.397,458.754]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[491.948,569.167],[491.948,664.24],[454.397,568.975],[454.397,663.437]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[491.948,675.209],[491.948,770.282],[454.397,674.336],[454.397,768.798]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[488.917,440.297],[488.917,339.978],[458.601,443.098],[458.601,345.617]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[488.917,554.082],[488.917,453.763],[458.601,553.662],[458.601,456.182]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[488.917,570.818],[488.917,671.137],[458.601,569.924],[458.601,667.405]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[488.917,682.712],[488.917,783.031],[458.601,678.652],[458.601,776.132]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[488.917,801.609],[488.917,901.928],[458.878,794.143],[458.878,891.607]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[717.92,436.418],[717.92,332.166],[488.917,440.297],[488.917,339.978]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[717.92,554.663],[717.92,450.412],[488.917,554.082],[488.917,453.763]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[717.92,572.055],[717.92,676.307],[488.917,570.818],[488.917,671.137]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[717.92,688.335],[717.92,792.587],[488.917,682.712],[488.917,783.031]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[717.92,811.893],[717.92,916.144],[488.917,801.609],[488.917,901.928]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[567.767,322.976],[567.767,226.638],[546.715,329.554],[546.715,236.146]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[618.778,321.112],[618.778,223.945],[567.767,322.976],[567.767,226.638]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[646.252,314.606],[646.252,214.54],[601.018,317.857],[601.018,219.239]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[680.584,312.356],[680.584,211.288],[646.251,314.606],[646.251,214.54]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[735.38,309.329],[735.38,206.913],[680.583,312.356],[680.583,211.288]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[967.089,432.198],[967.089,323.667],[719.288,436.395],[719.288,332.12]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[967.089,555.296],[967.089,446.766],[719.288,554.667],[719.288,450.392]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[967.089,573.401],[967.089,681.932],[719.288,572.062],[719.288,676.338]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[967.089,694.453],[967.089,802.984],[719.288,688.369],[719.288,792.644]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[968.045,823.125],[968.045,931.672],[720.17,811.994],[720.17,916.284]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[802.831,307.626],[802.831,204.451],[739.11,309.056],[739.11,206.517]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[846.992,306.957],[802.831,307.626],[846.992,203.483],[802.831,204.451]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[909.409,306.258],[846.992,306.956],[909.409,202.473],[846.992,203.483]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[909.409,306.258],[909.409,202.473],[923.317,309.861],[923.317,207.681]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[980.7,307.763],[980.7,204.65],[923.317,309.861],[923.317,207.681]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[967.089,432.198],[967.089,323.667],[1050.37,433.307],[1050.37,325.901]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[967.089,555.296],[967.089,446.766],[1050.37,555.13],[1050.37,447.724]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[967.089,573.401],[967.089,681.932],[1050.37,573.047],[1050.37,680.453]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[967.089,694.454],[967.089,802.984],[1050.37,692.845],[1050.37,800.251]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[968.045,823.125],[968.045,931.672],[1051.42,820.128],[1051.42,927.529]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[980.7,307.763],[980.7,204.65],[1057.22,311.286],[1057.22,209.741]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1050.37,433.307],[1050.37,325.901],[1070.96,436.183],[1070.96,331.692]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1050.37,555.13],[1050.37,447.724],[1070.96,554.699],[1070.96,450.208]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1050.37,573.047],[1050.37,680.453],[1070.96,572.13],[1070.96,676.621]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1050.37,692.845],[1050.37,800.251],[1070.96,688.676],[1070.96,793.167]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1051.42,820.128],[1051.42,927.529],[1071.02,812.858],[1071.02,917.478]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1057.22,311.286],[1057.22,209.74],[1123.78,317.283],[1123.78,218.41]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1116.94,435.445],[1116.94,330.207],[1070.96,436.183],[1070.96,331.692]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1116.94,554.809],[1116.94,449.571],[1070.96,554.699],[1070.96,450.208]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1116.94,572.365],[1116.94,677.604],[1070.96,572.13],[1070.96,676.62]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1116.94,689.746],[1116.94,794.984],[1070.96,688.676],[1070.96,793.167]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1118.78,814.892],[1071.02,812.858],[1118.78,920.29],[1071.02,917.478]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1116.94,435.445],[1116.94,330.207],[1154.16,441.029],[1154.16,341.452]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1116.94,554.809],[1116.94,449.571],[1154.16,553.972],[1154.16,454.395]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1116.94,572.365],[1116.94,677.604],[1154.16,570.584],[1154.16,670.162]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1116.94,689.746],[1116.94,794.984],[1154.16,681.651],[1154.16,781.228]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1118.78,814.892],[1118.78,920.29],[1158.38,799.077],[1158.38,898.429]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1123.78,317.283],[1123.78,218.41],[1197.8,326.621],[1197.8,231.906]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1231.05,439.868],[1231.05,339.114],[1154.16,441.029],[1154.16,341.452]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1231.05,554.146],[1231.05,453.392],[1154.16,553.972],[1154.16,454.395]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1231.05,570.954],[1231.05,671.708],[1154.16,570.584],[1154.16,670.162]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1231.05,683.333],[1231.05,784.087],[1154.16,681.651],[1154.16,781.228]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1229.98,802.865],[1229.98,903.664],[1153.38,799.797],[1153.38,899.424]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1198.28,326.71],[1198.28,232.036],[1249.42,336.459],[1249.42,246.127]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1229.98,802.865],[1229.98,903.664],[1260.04,789.174],[1260.04,884.739]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1231.05,439.868],[1231.05,339.114],[1298.2,444.236],[1298.2,347.91]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1231.05,554.146],[1231.05,453.392],[1298.2,553.492],[1298.2,457.166]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1231.05,570.954],[1231.05,671.708],[1298.2,569.561],[1298.2,665.887]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1231.05,683.333],[1231.05,784.087],[1298.2,677.001],[1298.2,773.327]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1249.42,336.459],[1249.42,246.127],[1279.58,347.391],[1279.58,261.929]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1279.58,347.391],[1279.58,261.929],[1281.77,356.367],[1281.77,274.902]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1276.19,789.784],[1276.19,885.582],[1303.12,777.116],[1303.12,868.069]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1278.82,447.7],[1278.82,351.674],[1353.55,460.608],[1353.55,378.121]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1278.82,556.615],[1278.82,460.589],[1353.55,554.167],[1353.55,471.68]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1278.82,572.634],[1278.82,668.659],[1353.55,567.927],[1353.55,650.414]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:4,
                    verts:[[1278.82,679.738],[1278.82,775.764],[1353.55,659.931],[1353.55,742.418]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[527.871,449.799],[527.871,359.113],[462.961,450.524],[462.961,360.573]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[527.871,552.658],[527.871,461.972],[462.961,552.549],[462.961,462.598]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[527.871,567.787],[527.871,658.473],[462.961,567.555],[462.961,657.506]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[527.871,668.936],[527.871,759.622],[462.961,667.885],[462.961,757.836]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[528.447,776.574],[528.447,867.32],[463.759,774.657],[463.759,864.67]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[510.127,790.499],[510.127,886.571],[468.739,789.198],[468.739,884.771]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[511.213,444.587],[511.213,348.617],[471.339,445.059],[471.339,349.568]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[511.213,553.439],[511.213,457.469],[471.339,553.368],[471.339,457.877]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[511.213,569.449],[511.213,665.419],[471.339,569.299],[471.339,664.79]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[511.213,676.492],[511.213,772.463],[471.339,675.808],[471.339,771.299]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[520.397,439.413],[520.397,338.198],[482.736,442.099],[482.736,343.607]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[520.397,554.215],[520.397,452.999],[482.736,553.812],[482.736,455.32]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[520.397,571.1],[520.397,672.315],[482.736,570.243],[482.736,668.735]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[520.397,683.993],[520.397,785.208],[482.736,680.099],[482.736,778.591]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[520.397,803.952],[520.397,905.167],[482.982,796.787],[482.982,895.263]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[761.375,436.406],[761.375,332.142],[520.397,439.413],[520.397,338.198]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[761.375,554.665],[761.375,450.401],[520.397,554.215],[520.397,452.999]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[761.375,572.059],[761.375,676.323],[520.397,571.1],[520.397,672.315]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[761.375,688.353],[761.375,792.617],[520.397,683.993],[520.397,785.208]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[761.375,811.925],[761.375,916.189],[520.397,803.952],[520.397,905.167]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[563.205,327.955],[563.205,233.835],[558.091,335.473],[558.091,244.702]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[591.447,321.569],[591.447,224.604],[563.205,327.955],[563.205,233.835]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[645.118,320.121],[645.118,222.512],[591.447,321.569],[591.447,224.604]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[679.595,313.886],[679.595,213.499],[630.487,316.745],[630.487,217.632]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[716.527,311.938],[716.527,210.684],[679.595,313.886],[679.595,213.499]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[774.69,309.398],[774.69,207.012],[716.527,311.938],[716.527,210.684]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1018.84,433.193],[1018.84,325.671],[762.802,436.388],[762.802,332.106]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1018.84,555.147],[1018.84,447.625],[762.802,554.668],[762.802,450.386]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1018.84,573.084],[1018.84,680.605],[762.802,572.065],[762.802,676.347]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1018.84,693.011],[1018.84,800.532],[762.802,688.379],[762.802,792.661]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1019.82,820.476],[1019.82,928.01],[763.722,812.003],[763.722,916.296]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[843.896,308.279],[843.896,205.394],[778.71,309.159],[778.71,206.666]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[888.568,307.987],[843.896,308.279],[888.568,204.972],[843.896,205.394]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[951.211,307.819],[888.568,307.987],[951.211,204.73],[888.568,204.972]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[951.211,307.819],[951.211,204.73],[961.361,311.469],[961.361,210.006]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1020.11,309.884],[1020.11,207.715],[961.361,311.469],[961.361,210.006]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1018.84,433.193],[1018.84,325.671],[1098.14,434.59],[1098.14,328.486]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1018.84,555.147],[1018.84,447.625],[1098.14,554.937],[1098.14,448.833]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1018.84,573.084],[1018.84,680.605],[1098.14,572.638],[1098.14,678.743]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1018.84,693.011],[1018.84,800.532],[1098.14,690.985],[1098.14,797.09]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1020.11,309.884],[1020.11,207.715],[1091.8,313.951],[1091.8,213.593]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1019.82,820.476],[1019.82,928.01],[1099.15,816.716],[1099.15,922.811]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1091.8,313.95],[1091.8,213.592],[1150.97,320.331],[1150.97,222.815]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1098.14,434.59],[1098.14,328.486],[1111.81,437.472],[1111.81,334.288]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1098.14,554.937],[1098.14,448.833],[1111.81,554.505],[1111.81,451.322]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1098.14,572.638],[1098.14,678.743],[1111.81,571.719],[1111.81,674.902]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1098.14,690.985],[1098.14,797.09],[1111.81,686.807],[1111.81,789.991]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1099.15,816.716],[1099.15,922.811],[1112.16,809.431],[1112.16,912.741]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1158.38,436.92],[1158.38,333.177],[1111.81,437.472],[1111.81,334.288]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1158.38,554.588],[1158.38,450.845],[1111.81,554.505],[1111.81,451.322]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1158.38,571.895],[1158.38,675.638],[1111.81,571.719],[1111.81,674.902]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1158.38,687.607],[1158.38,791.35],[1111.81,686.807],[1111.81,789.991]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1160.54,810.952],[1112.16,809.431],[1160.54,914.844],[1112.16,912.741]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1150.97,320.331],[1150.97,222.815],[1213.86,329.993],[1213.86,236.781]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1158.39,436.92],[1158.39,333.177],[1182.14,442.49],[1182.14,344.394]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1158.39,554.588],[1158.39,450.845],[1182.14,553.753],[1182.14,455.658]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1158.39,571.895],[1158.39,675.638],[1182.14,570.118],[1182.14,668.214]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1158.39,687.607],[1158.39,791.35],[1182.14,679.532],[1182.14,777.628]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1160.54,810.952],[1160.54,914.844],[1185.75,795.18],[1185.75,893.041]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1259.39,441.627],[1259.39,342.656],[1182.14,442.49],[1182.14,344.394]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1259.39,553.883],[1259.39,454.912],[1182.14,553.753],[1182.14,455.658]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1259.39,570.393],[1259.39,669.364],[1182.14,570.118],[1182.14,668.214]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1259.39,680.783],[1259.39,779.754],[1182.14,679.532],[1182.14,777.628]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1258.45,798.208],[1181.49,795.927],[1258.45,897.226],[1181.49,894.073]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1214.24,330.084],[1214.24,236.912],[1254.31,339.941],[1254.31,251.161]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1254.31,339.941],[1254.31,251.161],[1272.83,350.783],[1272.83,266.831]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1258.45,798.208],[1258.45,897.226],[1276.07,784.644],[1276.07,878.476]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1259.39,441.627],[1259.39,342.656],[1314.59,446.093],[1314.59,351.649]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1259.39,553.883],[1259.39,454.912],[1314.59,553.213],[1314.59,458.77]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1259.39,570.393],[1259.39,669.364],[1314.59,568.969],[1314.59,663.412]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1259.39,680.783],[1259.39,779.754],[1314.59,674.309],[1314.59,768.753]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1295.23,449.424],[1295.23,355.207],[1337.74,462.174],[1337.74,381.33]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1295.23,556.288],[1295.23,462.071],[1337.74,553.87],[1337.74,473.026]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1295.23,572.005],[1295.23,666.222],[1337.74,567.356],[1337.74,648.2]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:5,
                    verts:[[1295.23,677.093],[1295.23,771.309],[1337.74,657.528],[1337.74,738.372]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[538.479,448.959],[538.479,357.422],[470.327,449.474],[470.327,358.458]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[538.479,552.784],[538.479,461.246],[470.327,552.707],[470.327,461.691]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[538.479,568.055],[538.479,659.592],[470.327,567.89],[470.327,658.906]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[538.479,670.154],[538.479,761.691],[470.327,669.407],[470.327,760.423]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[539.207,778.796],[539.207,870.392],[471.291,777.435],[471.291,868.511]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[532.872,792.876],[532.872,889.855],[489.375,791.952],[489.375,888.579]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[533.746,443.694],[533.746,346.819],[491.847,444.029],[491.847,347.494]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[533.746,553.573],[533.746,456.698],[491.847,553.523],[491.847,456.987]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[533.746,569.734],[533.746,666.609],[491.847,569.627],[491.847,666.163]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[533.746,677.786],[533.746,774.662],[491.847,677.301],[491.847,773.836]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[555.296,438.561],[555.296,336.482],[510.505,441.109],[510.505,341.612]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[555.296,554.342],[555.296,452.263],[510.505,553.96],[510.505,454.464]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[555.296,571.371],[555.296,673.45],[510.505,570.559],[510.505,670.055]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[555.296,685.228],[555.296,787.307],[510.505,681.535],[510.505,781.032]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[555.296,806.21],[555.296,908.289],[510.719,799.411],[510.719,898.89]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[805.82,436.455],[805.82,332.24],[555.296,438.561],[555.296,336.482]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[805.82,554.658],[805.82,450.443],[555.296,554.342],[555.296,452.263]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[805.82,572.043],[805.82,676.258],[555.296,571.371],[555.296,673.45]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[805.82,688.282],[805.82,792.497],[555.296,685.228],[555.296,787.307]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[805.82,811.796],[805.82,916.011],[555.296,806.21],[555.296,908.289]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[582.465,326.32],[582.465,231.472],[569.5,333.785],[569.5,242.262]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[617.749,320.173],[617.749,222.587],[582.465,326.32],[582.465,231.472]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[673.615,319.156],[673.615,221.117],[617.75,320.173],[617.75,222.587]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[714.797,313.24],[714.797,212.565],[662.271,315.683],[662.271,216.097]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[753.962,311.609],[753.962,210.208],[714.797,313.24],[714.797,212.565]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[814.885,309.57],[814.885,207.262],[753.962,311.609],[753.962,210.208]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1068.59,434.245],[1068.59,327.79],[807.29,436.442],[807.29,332.215]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1068.59,554.989],[1068.59,448.534],[807.29,554.66],[807.29,450.433]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1068.59,572.748],[1068.59,679.203],[807.29,572.047],[807.29,676.275]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1068.59,691.486],[1068.59,797.941],[807.29,688.3],[807.29,792.528]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1069.57,817.677],[1069.57,924.14],[808.238,811.85],[808.238,916.086]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[885.114,309.033],[819.15,309.367],[885.114,206.484],[819.15,206.967]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[929.827,309.112],[885.114,309.033],[929.827,206.598],[885.114,206.484]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[929.827,309.112],[992.046,309.458],[929.827,206.598],[992.046,207.1]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[992.046,309.458],[992.046,207.1],[998.438,313.126],[998.438,212.401]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1057.93,312.042],[998.438,313.126],[1057.93,210.834],[998.438,212.401]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1057.93,312.042],[1057.93,210.834],[1124.27,316.594],[1124.27,217.413]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1068.59,434.245],[1068.59,327.79],[1143.17,435.903],[1143.17,331.129]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1068.59,554.989],[1068.59,448.534],[1143.17,554.741],[1143.17,449.967]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1068.59,572.748],[1068.59,679.203],[1143.17,572.219],[1143.17,676.993]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1068.59,691.486],[1068.59,797.941],[1143.17,689.082],[1143.17,793.856]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1069.57,817.677],[1069.57,924.14],[1144.14,813.226],[1144.14,917.987]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1124.27,316.594],[1124.27,217.413],[1175.81,323.287],[1175.81,227.088]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1143.17,435.903],[1143.17,331.129],[1150.08,438.766],[1150.08,336.895]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1143.17,554.741],[1143.17,449.967],[1150.08,554.311],[1150.08,452.441]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1143.17,572.219],[1143.17,676.993],[1150.08,571.306],[1150.08,673.177]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1143.17,689.082],[1143.17,793.856],[1150.08,684.931],[1150.08,786.802]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1144.14,813.226],[1144.14,917.987],[1150.7,805.987],[1150.7,907.981]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1196.75,438.393],[1150.08,438.766],[1196.75,336.144],[1150.08,336.895]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1196.75,554.367],[1196.75,452.118],[1150.08,554.311],[1150.08,452.44]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1196.75,571.425],[1196.75,673.674],[1150.08,571.306],[1150.08,673.177]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1196.75,685.471],[1150.08,684.931],[1196.75,787.721],[1150.08,786.802]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1199.18,807.016],[1150.7,805.987],[1199.18,909.403],[1150.7,907.981]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1175.81,323.287],[1175.81,227.088],[1227.58,333.183],[1227.58,241.392]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1196.75,438.393],[1196.75,336.144],[1207.45,443.907],[1207.45,347.248]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1196.75,554.367],[1196.75,452.118],[1207.45,553.541],[1207.45,456.882]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1196.75,571.425],[1196.75,673.674],[1207.45,569.666],[1207.45,666.326]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1196.75,685.471],[1196.75,787.721],[1207.45,677.478],[1207.45,774.137]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1199.18,807.016],[1199.18,909.403],[1210.45,791.406],[1210.45,887.824]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1284.35,443.327],[1207.45,443.907],[1284.35,346.078],[1207.45,347.248]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1284.35,553.628],[1284.35,456.38],[1207.45,553.541],[1207.45,456.882]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1284.35,569.851],[1284.35,667.099],[1207.45,569.666],[1207.45,666.326]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1284.35,678.32],[1207.45,677.478],[1284.35,775.568],[1207.45,774.137]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1283.54,793.707],[1206.93,792.173],[1283.54,891.005],[1206.93,888.884]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1227.86,333.274],[1227.86,241.524],[1257.14,343.169],[1257.14,255.826]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1257.14,343.169],[1257.14,255.826],[1264.52,353.863],[1264.52,271.283]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1284.35,443.327],[1284.35,346.078],[1327.81,447.849],[1327.81,355.185]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1284.35,553.628],[1284.35,456.38],[1327.81,552.95],[1327.81,460.287]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1284.35,569.851],[1284.35,667.099],[1327.81,568.409],[1327.81,661.072]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1284.35,678.32],[1284.35,775.568],[1327.81,671.764],[1327.81,764.427]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:6,
                    verts:[[1283.54,793.707],[1283.54,891.005],[1289.26,780.359],[1289.26,872.554]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[551.877,448.068],[551.877,355.628],[480.908,448.362],[480.908,356.219]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[551.877,552.917],[551.877,460.477],[480.908,552.873],[480.908,460.73]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[551.877,568.339],[551.877,660.779],[480.908,568.245],[480.908,660.388]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[551.877,671.445],[551.877,763.886],[480.908,671.019],[480.908,763.162]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[552.755,781.151],[552.755,873.648],[482.038,780.375],[482.038,872.575]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[558.721,795.298],[558.721,893.205],[513.447,794.772],[513.447,892.478]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[559.371,442.784],[559.371,344.985],[515.766,442.974],[515.766,345.369]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[559.371,553.709],[559.371,455.911],[515.766,553.681],[515.766,456.076]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[559.371,570.025],[559.371,667.823],[515.766,569.964],[515.766,667.569]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[559.371,679.107],[559.371,776.905],[515.766,678.83],[515.766,776.435]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[593.333,437.729],[593.333,334.807],[541.698,440.115],[541.698,339.611]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[593.333,554.467],[593.333,451.545],[541.698,554.109],[541.698,453.606]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[593.333,571.637],[593.333,674.559],[541.698,570.876],[541.698,671.38]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[593.333,686.434],[593.333,789.356],[541.698,682.976],[541.698,783.479]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[593.333,808.416],[593.333,911.338],[541.875,802.043],[541.875,902.528]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[583.481,331.988],[583.481,239.664],[574.222,342.195],[574.222,254.418]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[604.336,324.624],[604.336,229.02],[583.481,331.988],[583.481,239.664]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[850.911,436.545],[850.911,332.421],[593.333,437.729],[593.333,334.807]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[850.911,554.644],[850.911,450.521],[593.333,554.467],[593.333,451.545]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[850.911,572.015],[850.911,676.138],[593.333,571.637],[593.333,674.559]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[850.911,688.152],[850.911,792.275],[593.333,686.434],[593.333,789.356]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[850.911,811.557],[850.911,915.68],[593.333,808.416],[593.333,911.338]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[646.465,318.762],[646.465,220.547],[604.336,324.624],[604.336,229.02]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[704.045,318.188],[704.045,219.718],[646.465,318.762],[646.465,220.547]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[751.58,312.634],[751.58,211.689],[696.117,314.642],[696.117,214.592]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[792.599,311.331],[792.599,209.806],[751.58,312.634],[751.58,211.689]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[855.669,309.805],[855.669,207.601],[792.599,311.331],[792.599,209.806]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1116.11,435.325],[1116.11,329.965],[852.409,436.538],[852.409,332.407]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1116.11,554.827],[1116.11,449.467],[852.409,554.646],[852.409,450.515]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1116.11,572.404],[1116.11,677.764],[852.409,572.017],[852.409,676.147]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1116.11,689.92],[1116.11,795.28],[852.409,688.162],[852.409,792.292]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1117.09,814.803],[1117.09,920.168],[853.375,811.587],[853.375,915.722]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[860.135,309.638],[926.211,309.843],[860.135,207.359],[926.211,207.656]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[926.211,309.843],[970.52,310.282],[926.211,207.656],[970.52,208.29]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[970.52,310.282],[1031.71,311.124],[970.52,208.29],[1031.71,209.507]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1031.71,311.124],[1031.71,209.507],[1034.38,314.782],[1034.38,214.794]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1094.03,314.187],[1034.38,314.782],[1094.03,213.934],[1034.38,214.794]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1094.03,314.187],[1094.03,213.934],[1154.58,319.167],[1154.58,221.132]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1116.11,435.325],[1116.11,329.965],[1185.38,437.217],[1185.38,333.776]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1116.11,554.827],[1116.11,449.467],[1185.38,554.544],[1185.38,451.102]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1116.11,572.404],[1116.11,677.764],[1185.38,571.8],[1185.38,675.242]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1116.11,689.92],[1116.11,795.28],[1185.38,687.177],[1185.38,790.618]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1117.09,814.803],[1117.09,920.168],[1186.29,809.733],[1186.29,913.159]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1154.58,319.166],[1154.58,221.132],[1198.36,326.109],[1198.36,231.166]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1185.38,437.217],[1185.38,333.776],[1185.73,440.042],[1185.73,339.464]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1185.38,554.544],[1185.38,451.102],[1185.73,554.12],[1185.73,453.542]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1185.38,571.8],[1185.38,675.242],[1185.73,570.899],[1185.73,671.477]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1185.38,687.177],[1185.38,790.618],[1185.73,683.082],[1185.73,783.66]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1185.73,440.042],[1232.04,439.839],[1185.73,339.464],[1232.04,339.055]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1185.73,554.12],[1232.04,554.151],[1185.73,453.542],[1232.04,453.367]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1185.73,570.899],[1232.04,570.964],[1185.73,671.477],[1232.04,671.747]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1185.73,683.082],[1232.04,683.375],[1185.73,783.66],[1232.04,784.159]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1186.29,809.733],[1186.29,913.159],[1186.61,802.594],[1186.61,903.289]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1186.61,802.594],[1234.7,803.152],[1186.61,903.289],[1234.7,904.062]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1198.36,326.109],[1198.36,231.166],[1239.1,336.161],[1239.1,245.696]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1230.2,445.261],[1306.1,444.947],[1230.2,349.974],[1306.1,349.341]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1230.2,553.338],[1230.2,458.051],[1306.1,553.385],[1306.1,457.78]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1230.2,569.234],[1306.1,569.334],[1230.2,664.521],[1306.1,664.94]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1230.2,675.515],[1306.1,675.971],[1230.2,770.802],[1306.1,771.576]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1229.8,788.585],[1305.43,789.415],[1229.8,883.924],[1305.43,885.072]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1239.29,336.252],[1239.29,245.828],[1258.08,346.123],[1258.08,260.096]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1299.83,776.356],[1315.53,776.519],[1299.83,867.019],[1315.53,867.245]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1306.1,444.947],[1306.1,349.341],[1338.13,449.491],[1338.13,358.492]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1306.1,553.385],[1306.1,457.78],[1338.13,552.704],[1338.13,461.706]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1306.1,569.334],[1306.1,664.94],[1338.13,567.885],[1338.13,658.884]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:7,
                    verts:[[1306.1,675.971],[1306.1,771.576],[1338.13,669.383],[1338.13,760.382]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[494.667,447.181],[494.667,353.84],[483.81,451.708],[483.81,362.957]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[494.667,553.05],[494.667,459.71],[483.81,552.372],[483.81,463.621]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[494.667,568.622],[494.667,661.963],[483.81,567.178],[483.81,655.929]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[494.667,672.732],[494.667,766.073],[483.81,666.168],[483.81,754.919]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[495.957,783.498],[495.957,876.893],[484.786,770.793],[484.786,859.329]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[567.994,447.118],[567.994,353.714],[494.666,447.181],[494.666,353.84]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[567.994,553.06],[567.994,459.656],[494.666,553.05],[494.666,459.71]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[567.994,568.642],[567.994,662.046],[494.666,568.622],[494.666,661.963]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[567.994,672.823],[567.994,766.227],[494.666,672.732],[494.666,766.073]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[569.02,783.663],[569.02,877.12],[495.957,783.498],[495.957,876.893]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[587.539,797.79],[540.841,797.679],[587.539,896.649],[540.841,896.495]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[587.954,441.846],[587.954,343.098],[542.981,441.887],[542.981,343.179]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[587.954,553.85],[587.954,455.101],[542.981,553.844],[542.981,455.136]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[587.954,570.324],[587.954,669.072],[542.981,570.311],[542.981,669.018]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[587.954,680.466],[587.954,779.214],[542.981,680.407],[542.981,779.115]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[634.271,436.909],[634.271,333.154],[576.143,439.111],[576.143,337.589]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[634.271,554.59],[634.271,450.836],[576.143,554.26],[576.143,452.738]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[634.271,571.899],[634.271,675.653],[576.143,571.196],[576.143,672.718]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[634.271,687.624],[634.271,791.378],[576.143,684.432],[576.143,785.954]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[634.271,810.592],[634.271,914.347],[576.281,804.704],[576.281,906.207]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[599.956,330.061],[599.956,236.88],[580.078,340.225],[580.078,251.571]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[628.699,322.846],[628.699,226.451],[599.956,330.061],[599.956,236.88]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[677.427,317.314],[677.427,218.454],[628.699,322.846],[628.699,226.451]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[896.367,436.662],[896.367,332.657],[634.271,436.909],[634.271,333.154]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[896.367,554.627],[896.367,450.622],[634.271,554.59],[634.271,450.836]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[896.367,571.977],[896.367,675.982],[634.271,571.899],[634.271,675.653]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[896.367,687.982],[896.367,791.987],[634.271,687.624],[634.271,791.378]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[896.367,811.247],[896.367,915.252],[634.271,810.592],[634.271,914.347]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[736.229,317.194],[677.427,317.314],[736.229,218.281],[677.427,218.454]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[789.716,312.041],[789.716,210.832],[731.819,313.597],[731.819,213.081]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[832.202,311.075],[832.202,209.437],[789.716,312.041],[789.716,210.832]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[896.802,310.07],[896.802,207.983],[832.202,311.075],[832.202,209.437]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[897.877,436.66],[1161.25,436.412],[897.877,332.654],[1161.25,332.154]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[897.877,554.627],[897.877,450.621],[1161.25,554.664],[1161.25,450.406]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[897.877,571.978],[1161.25,572.057],[897.877,675.984],[1161.25,676.315]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[897.877,687.984],[1161.25,688.344],[897.877,791.991],[1161.25,792.602]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[898.851,811.253],[1162.23,811.912],[898.851,915.261],[1162.23,916.17]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[901.424,309.94],[966.971,310.674],[901.424,207.796],[966.971,208.857]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[966.971,310.674],[1010.46,311.462],[966.971,208.857],[1010.46,209.995]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1010.46,311.462],[1010.46,209.995],[1070.06,312.778],[1070.06,211.898]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1069.07,316.401],[1128.33,316.28],[1069.07,217.135],[1128.33,216.96]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1128.33,316.28],[1128.33,216.96],[1182.75,321.635],[1182.75,224.699]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1161.25,436.412],[1161.25,332.154],[1224.71,438.512],[1224.71,336.383]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1161.25,554.664],[1161.25,450.406],[1224.71,554.349],[1224.71,452.221]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1161.25,572.057],[1161.25,676.315],[1224.71,571.387],[1224.71,673.516]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1161.25,688.344],[1161.25,792.602],[1224.71,685.299],[1224.71,787.428]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1162.23,811.912],[1162.23,916.17],[1225.57,806.292],[1225.57,908.402]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1182.75,321.634],[1182.75,224.699],[1218.7,328.768],[1218.7,235.011]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1218.7,328.768],[1218.7,235.011],[1248.56,338.908],[1248.56,249.667]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1218.76,441.28],[1264.3,441.239],[1218.76,341.957],[1264.3,341.875]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1218.76,553.935],[1218.76,454.612],[1264.3,553.941],[1264.3,454.577]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1218.76,570.504],[1218.76,669.827],[1264.3,570.517],[1264.3,669.881]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1218.76,681.286],[1264.3,681.346],[1218.76,780.609],[1264.3,780.71]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1219.88,799.296],[1267.16,799.409],[1219.88,898.731],[1267.16,898.887]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1248.66,338.999],[1248.66,249.799],[1257.31,348.795],[1257.31,263.958]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1250.47,446.539],[1250.47,352.547],[1324.82,446.476],[1324.82,352.42]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1250.47,553.147],[1250.47,459.155],[1324.82,553.156],[1324.82,459.101]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1250.47,568.827],[1250.47,662.818],[1324.82,568.847],[1324.82,662.902]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1250.47,673.663],[1250.47,767.654],[1324.82,673.754],[1324.82,767.81]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1250.2,785.197],[1324.28,785.364],[1250.2,879.241],[1324.28,879.472]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1324.82,446.476],[1324.82,352.42],[1345.77,451.012],[1345.77,361.556]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1324.82,553.156],[1324.82,459.101],[1345.77,552.476],[1345.77,463.02]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1324.82,568.847],[1324.82,662.902],[1345.77,567.4],[1345.77,656.856]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:8,
                    verts:[[1324.82,673.754],[1324.82,767.81],[1345.77,667.177],[1345.77,756.634]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[511.602,445.923],[511.602,351.308],[489.873,450.452],[489.873,360.427]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[511.602,553.239],[511.602,458.624],[489.873,552.56],[489.873,462.536]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[511.602,569.023],[511.602,663.638],[489.873,567.578],[489.873,657.603]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[511.602,674.555],[511.602,769.17],[489.873,667.99],[489.873,758.015]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[513.049,786.821],[513.049,881.486],[490.381,774.112],[490.381,863.917]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[586.801,446.103],[586.801,351.67],[511.601,445.923],[511.601,351.308]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[586.801,553.212],[586.801,458.779],[511.601,553.239],[511.601,458.624]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[586.801,568.966],[586.801,663.398],[511.601,569.023],[511.601,663.638]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[586.801,674.294],[586.801,768.727],[511.601,674.555],[511.601,769.17]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[587.97,786.346],[513.049,786.821],[587.97,880.829],[513.049,881.486]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[619.226,800.363],[571.48,800.683],[619.226,900.206],[571.48,900.649]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[619.395,440.878],[573.417,440.761],[619.395,341.147],[573.417,340.913]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[619.395,553.995],[619.395,454.264],[573.417,554.013],[573.417,454.164]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[619.395,570.633],[619.395,670.363],[573.417,570.67],[573.417,670.518]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[619.395,681.87],[573.417,682.039],[619.395,781.601],[573.417,781.887]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[588.248,338.056],[588.248,248.435],[579.019,347.862],[579.019,262.609]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[618.884,327.993],[618.884,233.89],[588.248,338.056],[588.248,248.435]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[677.914,436.094],[677.914,331.514],[613.708,438.091],[613.708,335.535]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[677.914,554.712],[677.914,450.132],[613.708,554.413],[613.708,451.857]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[677.914,572.158],[677.914,676.739],[613.708,571.521],[613.708,674.077]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[677.914,688.805],[677.914,793.385],[613.708,685.91],[613.708,788.465]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[677.914,812.752],[677.914,917.332],[613.805,807.406],[613.805,909.942]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[655.47,320.975],[655.47,223.746],[618.884,327.993],[618.884,233.89]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[710.501,315.816],[710.501,216.289],[655.47,320.975],[655.47,223.746]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[941.951,436.795],[677.914,436.094],[941.951,332.926],[677.914,331.514]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[941.951,554.607],[677.914,554.712],[941.951,450.738],[677.914,450.132]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[941.951,571.935],[677.914,572.158],[941.951,675.804],[677.914,676.739]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[941.951,687.788],[677.914,688.805],[941.951,791.657],[677.914,793.385]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[941.951,810.893],[677.914,812.752],[941.951,914.762],[677.914,917.332]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[770.019,316.159],[710.501,315.816],[770.019,216.784],[710.501,216.289]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[829.016,311.445],[829.016,209.971],[769.204,312.534],[769.204,211.545]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[872.572,310.825],[829.016,311.445],[872.572,209.074],[829.016,209.971]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[938.084,310.343],[872.572,310.825],[938.084,208.378],[872.572,209.074]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[942.817,310.252],[942.817,208.247],[1007.22,311.502],[1007.22,210.054]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[943.458,436.799],[943.458,332.934],[1203.91,437.491],[1203.91,334.327]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[943.458,554.606],[943.458,450.741],[1203.91,554.503],[1203.91,451.339]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[943.458,571.933],[943.458,675.799],[1203.91,571.713],[1203.91,674.877]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[943.458,687.782],[943.458,791.648],[1203.91,686.78],[1203.91,789.943]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[944.429,810.875],[944.429,914.738],[1204.87,809.041],[1204.87,912.203]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1007.22,311.502],[1007.22,210.054],[1049.48,312.626],[1049.48,211.678]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1049.48,312.626],[1049.48,211.678],[1106.97,314.394],[1106.97,214.234]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1102.42,317.961],[1160.78,318.297],[1102.42,219.389],[1160.78,219.875]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1160.78,318.297],[1160.78,219.875],[1208.79,323.976],[1208.79,228.084]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1203.91,437.491],[1203.91,334.327],[1261.14,439.774],[1261.14,338.925]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1203.91,554.503],[1203.91,451.339],[1261.14,554.16],[1261.14,453.311]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1203.91,571.713],[1203.91,674.877],[1261.14,570.984],[1261.14,671.833]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1203.91,686.78],[1203.91,789.944],[1261.14,683.469],[1261.14,784.318]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1204.87,809.041],[1204.87,912.203],[1261.94,802.939],[1261.94,903.766]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1208.79,323.976],[1208.79,228.084],[1236.9,331.25],[1236.9,238.598]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1236.9,331.25],[1236.9,238.598],[1256.08,341.417],[1256.08,253.294]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1249.19,442.47],[1249.19,344.354],[1293.59,442.582],[1293.59,344.58]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1249.19,553.756],[1249.19,455.64],[1293.59,553.74],[1293.59,455.737]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1249.19,570.124],[1249.19,668.241],[1293.59,570.089],[1293.59,668.091]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1249.19,679.561],[1249.19,777.677],[1293.59,679.398],[1293.59,777.401]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1250.53,796.125],[1296.62,795.816],[1250.53,894.348],[1296.62,893.92]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1268.36,447.734],[1268.36,354.954],[1340.68,447.907],[1340.68,355.303]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1268.36,552.968],[1268.36,460.188],[1340.68,552.942],[1340.68,460.337]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1268.36,568.445],[1268.36,661.225],[1340.68,568.39],[1340.68,660.995]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1268.36,671.93],[1268.36,764.71],[1340.68,671.679],[1340.68,764.284]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1268.22,782.028],[1268.22,874.861],[1340.27,781.571],[1340.27,874.228]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1340.68,447.907],[1340.68,355.303],[1350.9,452.411],[1350.9,364.372]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1340.68,552.942],[1340.68,460.337],[1350.9,552.267],[1350.9,464.228]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1340.68,568.39],[1340.68,660.995],[1350.9,566.954],[1350.9,654.992]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:9,
                    verts:[[1340.68,671.679],[1340.68,764.284],[1350.9,665.15],[1350.9,753.189]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[531.76,444.588],[531.76,348.619],[498.877,449.09],[498.877,357.685]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[531.76,553.439],[531.76,457.47],[498.877,552.764],[498.877,461.359]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[531.76,569.449],[531.76,665.418],[498.877,568.013],[498.877,659.418]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[531.76,676.491],[531.76,772.46],[498.877,669.964],[498.877,761.369]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[533.359,790.35],[533.359,886.364],[498.893,777.711],[498.893,868.893]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[608.302,445.021],[531.759,444.588],[608.302,349.491],[531.759,348.619]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[608.302,553.374],[608.302,457.844],[531.759,553.439],[531.759,457.47]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[608.302,569.311],[531.759,569.449],[608.302,664.841],[531.759,665.418]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[608.302,675.863],[531.759,676.491],[608.302,771.393],[531.759,772.46]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[609.61,789.205],[533.359,790.35],[609.61,884.782],[533.359,886.364]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[598.763,335.678],[598.763,244.998],[579.326,345.492],[579.326,259.185]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[640.259,325.777],[640.259,230.688],[598.763,335.678],[598.763,244.998]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[653.715,803.02],[605.325,803.788],[653.715,903.879],[605.325,904.941]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[607.035,439.598],[653.632,439.877],[607.035,338.57],[653.632,339.131]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[607.035,554.187],[653.632,554.145],[607.035,453.159],[653.632,453.4]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[607.035,571.041],[653.632,570.952],[607.035,672.069],[653.632,671.697]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[607.035,683.725],[653.632,683.321],[607.035,784.753],[653.632,784.067]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[684.596,319.006],[684.596,220.9],[640.259,325.777],[640.259,230.688]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[654.294,437.056],[654.294,333.451],[653.632,439.877],[653.632,339.131]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[654.294,554.568],[654.294,450.963],[653.632,554.145],[653.632,453.4]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[654.294,571.852],[654.294,675.456],[653.632,570.952],[653.632,671.697]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[654.294,687.41],[654.294,791.015],[653.632,683.321],[653.632,784.067]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[654.348,810.148],[654.348,913.733],[653.715,803.02],[653.715,903.879]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[724.091,435.286],[724.091,329.886],[654.294,437.056],[654.294,333.451]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[724.091,554.833],[724.091,449.433],[654.294,554.568],[654.294,450.963]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[724.091,572.416],[724.091,677.816],[654.294,571.852],[654.294,675.456]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[724.091,689.977],[724.091,795.377],[654.294,687.41],[654.294,791.015]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[724.091,814.895],[724.091,920.295],[654.348,810.148],[654.348,913.733]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[745.585,314.265],[745.585,214.047],[684.596,319.006],[684.596,220.9]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[724.091,435.286],[724.091,329.886],[987.453,436.941],[987.453,333.22]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[724.091,554.833],[724.091,449.433],[987.453,554.585],[987.453,450.864]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[724.091,572.416],[724.091,677.816],[987.453,571.888],[987.453,675.61]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[724.091,689.977],[724.091,795.377],[987.453,687.577],[987.453,791.298]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[724.091,814.895],[724.091,920.295],[987.453,810.506],[987.453,914.228]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[745.585,314.265],[805.296,315.078],[745.585,214.047],[805.296,215.222]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[808.13,311.448],[808.13,209.975],[805.296,315.078],[805.296,215.222]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[869.316,310.84],[808.13,311.448],[869.316,209.097],[808.13,209.975]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[913.536,310.571],[869.316,310.84],[913.536,208.707],[869.316,209.097]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[913.536,310.571],[979.342,310.616],[913.536,208.707],[979.342,208.772]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[984.14,310.563],[984.14,208.696],[1046.8,312.316],[1046.8,211.23]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[988.943,436.951],[988.943,333.239],[1244,438.554],[1244,336.467]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[988.943,554.584],[988.943,450.872],[1244,554.343],[1244,452.257]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[988.943,571.885],[988.943,675.597],[1244,571.374],[1244,673.46]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[988.943,687.563],[988.943,791.275],[1244,685.239],[1244,787.325]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[989.903,810.465],[989.903,914.171],[1244.93,806.215],[1244.93,908.295]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1046.8,312.316],[1046.8,211.23],[1087.47,313.762],[1087.47,213.32]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1087.47,313.762],[1087.47,213.32],[1142.37,315.959],[1142.37,216.496]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1134.36,319.448],[1134.36,221.539],[1191.33,320.225],[1191.33,222.662]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1191.33,320.225],[1191.33,222.662],[1232.72,326.182],[1232.72,231.273]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1232.72,326.182],[1232.72,231.273],[1253.01,333.548],[1253.01,241.919]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1244,438.554],[1244,336.467],[1294.69,440.997],[1294.69,341.386]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1244,554.343],[1244,452.257],[1294.69,553.977],[1294.69,454.367]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1244,571.374],[1244,673.46],[1294.69,570.594],[1294.69,670.205]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1244,685.239],[1244,787.325],[1294.69,681.697],[1294.69,781.308]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1244.93,806.215],[1244.93,908.295],[1295.42,799.692],[1295.42,899.279]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1253.01,333.548],[1253.01,241.919],[1261.74,343.688],[1261.74,256.576]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1277.04,443.607],[1277.04,346.642],[1319.97,443.863],[1319.97,347.16]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1277.04,553.586],[1277.04,456.622],[1319.97,553.548],[1319.97,456.844]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1277.04,569.762],[1277.04,666.726],[1319.97,569.68],[1319.97,666.384]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1277.04,677.914],[1277.04,774.878],[1319.97,677.541],[1319.97,774.245]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1278.57,793.097],[1278.57,890.161],[1323.13,792.389],[1323.13,889.183]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1283.96,448.844],[1283.96,357.19],[1353.79,449.239],[1353.79,357.985]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1283.96,552.801],[1283.96,461.147],[1353.79,552.742],[1353.79,461.488]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1283.96,568.091],[1283.96,659.746],[1353.79,567.965],[1353.79,659.219]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1283.96,670.321],[1283.96,761.975],[1353.79,669.748],[1353.79,761.002]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:10,
                    verts:[[1283.93,779.084],[1283.93,870.791],[1353.51,778.04],[1353.51,869.347]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[555.223,443.176],[555.223,345.775],[510.942,447.622],[510.942,354.729]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[555.223,553.651],[555.223,456.25],[510.942,552.984],[510.942,460.091]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[555.223,569.899],[555.223,667.3],[510.942,568.481],[510.942,661.374]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[555.223,678.538],[555.223,775.939],[510.942,672.092],[510.942,764.985]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[556.967,794.081],[556.967,891.521],[510.444,781.595],[510.444,874.262]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[555.223,443.176],[632.533,443.873],[555.223,345.775],[632.533,347.18]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[555.223,553.651],[555.223,456.25],[632.533,553.546],[632.533,456.853]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[555.223,569.899],[555.223,667.3],[632.533,569.677],[632.533,666.37]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[555.223,678.538],[632.533,677.527],[555.223,775.939],[632.533,774.221]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[556.967,794.081],[633.974,792.238],[556.967,891.521],[633.974,888.974]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[581.792,342.863],[581.792,255.383],[573.876,353.511],[573.876,270.775]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[611.689,333.091],[611.689,241.259],[581.792,342.862],[581.792,255.383]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[664.1,323.418],[664.1,227.277],[611.689,333.091],[611.689,241.259]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[642.361,806.982],[642.361,909.356],[630.408,791.489],[630.408,887.938]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[643.82,438.4],[643.82,336.158],[632.533,443.873],[632.533,347.18]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[643.82,554.366],[643.82,452.124],[632.533,553.546],[632.533,456.853]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[643.82,571.423],[643.82,673.665],[632.533,569.677],[632.533,666.37]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[643.82,685.461],[643.82,787.704],[632.533,677.527],[632.533,774.221]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[642.361,806.982],[690.962,805.75],[642.361,909.356],[690.962,907.653]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[643.82,438.4],[690.619,438.847],[643.82,336.158],[690.619,337.058]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[643.82,554.366],[643.82,452.124],[690.619,554.299],[690.619,452.51]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[643.82,571.423],[643.82,673.665],[690.619,571.28],[690.619,673.069]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[643.82,685.461],[690.619,684.814],[643.82,787.704],[690.619,786.603]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[716.046,316.946],[716.046,217.923],[664.1,323.418],[664.1,227.277]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[697.817,436.011],[697.817,331.347],[690.619,438.847],[690.619,337.058]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[697.817,554.724],[697.817,450.06],[690.619,554.299],[690.619,452.51]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[697.817,572.185],[697.817,676.849],[690.619,571.28],[690.619,673.069]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[697.817,688.925],[697.817,793.59],[690.619,684.814],[690.619,786.603]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[697.825,812.919],[697.825,917.563],[690.962,805.75],[690.962,907.653]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[772.647,434.488],[772.647,328.28],[697.817,436.011],[697.817,331.347]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[772.647,554.953],[772.647,448.744],[697.817,554.724],[697.817,450.06]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[772.647,572.671],[772.647,678.879],[697.817,572.185],[697.817,676.849]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[772.647,691.133],[772.647,797.342],[697.817,688.925],[697.817,793.59]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[772.647,817.01],[772.647,923.218],[697.825,812.919],[697.825,917.563]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[782.592,312.667],[782.592,211.737],[716.046,316.946],[716.046,217.923]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[772.647,434.488],[772.647,328.28],[1032.67,437.099],[1032.67,333.538]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[772.647,554.953],[772.647,448.744],[1032.67,554.561],[1032.67,451]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[772.647,572.671],[772.647,678.879],[1032.67,571.838],[1032.67,675.399]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[772.647,691.133],[772.647,797.342],[1032.67,687.348],[1032.67,790.909]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[772.647,817.01],[772.647,923.218],[1032.67,810.087],[1032.67,913.648]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[782.592,312.667],[841.954,313.957],[782.592,211.737],[841.954,213.602]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[848.465,310.346],[848.465,208.382],[841.954,313.957],[841.954,213.602]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[910.461,310.23],[848.465,310.346],[910.461,208.215],[848.465,208.382]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[910.462,310.23],[954.932,310.316],[910.462,208.215],[954.932,208.34]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[954.931,310.317],[1020.41,310.888],[954.931,208.34],[1020.41,209.167]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1025.22,310.874],[1025.22,209.146],[1085.57,313.114],[1085.57,212.383]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1034.13,437.114],[1034.13,333.568],[1281.44,439.597],[1281.44,338.569]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1034.13,554.559],[1034.13,451.013],[1281.44,554.187],[1281.44,453.158]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1034.13,571.833],[1034.13,675.379],[1281.44,571.041],[1281.44,672.069]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1034.13,687.326],[1034.13,790.873],[1281.44,683.726],[1281.44,784.755]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1035.07,810.023],[1035.07,913.56],[1282.34,803.44],[1282.34,904.459]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1085.57,313.114],[1085.57,212.383],[1124.29,314.868],[1124.29,214.919]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1124.29,314.868],[1124.29,214.919],[1176.14,317.471],[1176.14,218.681]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1164.81,320.863],[1164.81,223.584],[1219.94,322.062],[1219.94,225.317]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1219.94,322.062],[1219.94,225.317],[1254.54,328.252],[1254.54,234.265]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1254.54,328.252],[1254.54,234.265],[1267.08,335.665],[1267.08,244.979]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1281.44,439.597],[1281.44,338.569],[1325.31,442.177],[1325.31,343.763]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1281.44,554.187],[1281.44,453.158],[1325.31,553.8],[1325.31,455.387]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1281.44,571.041],[1281.44,672.069],[1325.31,570.218],[1325.31,668.632]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1281.44,683.726],[1281.44,784.755],[1325.31,679.987],[1325.31,778.401]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1282.34,803.44],[1282.34,904.459],[1325.97,796.558],[1325.97,894.947]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1302.3,444.688],[1302.3,348.82],[1343.46,445.081],[1343.46,349.612]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1302.3,553.424],[1302.3,457.556],[1343.46,553.365],[1343.46,457.896]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1302.3,569.417],[1302.3,665.284],[1343.46,569.292],[1343.46,664.761]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1302.3,676.346],[1302.3,772.213],[1343.46,675.776],[1343.46,771.245]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1304.01,790.212],[1304.01,886.173],[1346.73,789.129],[1346.73,884.676]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1297.3,449.87],[1297.3,359.256],[1364.24,450.474],[1364.24,360.473]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1297.3,552.647],[1297.3,462.034],[1364.24,552.557],[1364.24,462.555]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1297.3,567.764],[1297.3,658.378],[1364.24,567.571],[1364.24,657.573]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1297.3,668.833],[1297.3,759.447],[1364.24,667.957],[1364.24,757.959]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:11,
                    verts:[[1297.39,776.361],[1297.39,867.027],[1364.09,774.765],[1364.09,864.82]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[543.701,449.386],[543.701,355.129],[500.031,462.031],[500.031,381.037]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[543.701,556.295],[543.701,462.038],[500.031,553.897],[500.031,472.903]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[543.701,572.019],[543.701,666.276],[500.031,567.408],[500.031,648.402]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[543.701,677.151],[543.701,771.408],[500.031,657.747],[500.031,738.741]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[543.701,785.754],[543.701,880.01],[500.031,751.069],[500.031,832.063]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[582.107,441.693],[582.107,342.789],[526.236,446.051],[526.236,351.564]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[582.107,553.873],[582.107,454.969],[526.236,553.22],[526.236,458.733]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[582.107,570.372],[582.107,669.276],[526.236,568.982],[526.236,663.469]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[582.107,680.688],[582.107,779.592],[526.236,674.371],[526.236,768.857]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[583.988,797.997],[583.988,896.936],[525.2,785.758],[525.2,880.016]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[586.534,339.973],[586.534,251.206],[567.516,350.703],[567.516,266.716]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[582.107,441.693],[582.107,342.789],[659.552,442.666],[659.552,344.749]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[582.107,553.873],[582.107,454.969],[659.552,553.727],[659.552,455.809]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[582.107,570.372],[582.107,669.276],[659.552,570.062],[659.552,667.98]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[582.107,680.688],[582.107,779.592],[659.552,679.277],[659.552,777.195]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[583.988,797.997],[661.119,795.427],[583.988,896.936],[661.119,893.382]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[627.123,330.302],[627.123,237.227],[586.534,339.973],[586.534,251.206]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[690.448,320.928],[690.448,223.678],[627.123,330.302],[627.123,237.227]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[682.583,810.239],[682.583,913.859],[656.826,794.702],[656.826,892.381]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[683.768,437.178],[683.768,333.697],[659.552,442.666],[659.552,344.749]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[683.768,554.549],[683.768,451.069],[659.552,553.727],[659.552,455.809]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[683.768,571.813],[683.768,675.293],[659.552,570.062],[659.552,667.98]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[683.768,687.233],[683.768,790.714],[659.552,679.277],[659.552,777.195]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[682.583,810.239],[730.929,808.53],[682.583,913.859],[730.929,911.496]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[683.768,437.178],[683.768,333.697],[730.321,437.798],[730.321,334.946]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[683.768,554.549],[683.768,451.069],[730.321,554.457],[730.321,451.604]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[683.768,571.813],[683.768,675.294],[730.321,571.615],[730.321,674.467]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[683.768,687.233],[683.768,790.714],[730.321,686.334],[730.321,789.186]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[749.799,314.812],[749.799,214.837],[690.448,320.928],[690.448,223.678]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[744.193,434.966],[744.193,329.243],[730.321,437.798],[730.321,334.946]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[744.193,554.881],[744.193,449.158],[730.321,554.457],[730.321,451.604]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[744.193,572.518],[744.193,678.241],[730.321,571.615],[730.321,674.467]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[744.193,690.44],[744.193,796.163],[730.321,686.334],[730.321,789.186]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[744.156,815.688],[744.156,921.39],[730.929,808.53],[730.929,911.496]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[823.414,433.712],[823.414,326.718],[744.193,434.966],[744.193,329.243]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[823.414,555.069],[823.414,448.074],[744.193,554.881],[744.193,449.158]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[823.414,572.918],[823.414,679.913],[744.193,572.518],[744.193,678.241]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[823.414,692.258],[823.414,799.253],[744.193,690.44],[744.193,796.163]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[823.414,819.066],[823.414,926.061],[744.156,815.688],[744.156,921.39]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[821.434,311.04],[821.434,209.386],[749.799,314.812],[749.799,214.837]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[821.434,311.041],[821.434,209.386],[879.884,312.813],[879.884,211.948]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[823.414,433.712],[823.414,326.718],[1077.4,437.275],[1077.4,333.892]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[823.414,555.069],[823.414,448.074],[1077.4,554.535],[1077.4,451.152]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[823.414,572.918],[823.414,679.913],[1077.4,571.782],[1077.4,675.165]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[823.414,692.258],[823.414,799.253],[1077.4,687.093],[1077.4,790.476]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[823.414,819.066],[823.414,926.061],[1077.4,809.621],[1077.4,913.004]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[890.072,309.245],[890.072,206.79],[879.883,312.813],[879.883,211.948]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[890.073,309.245],[952.292,309.632],[890.073,206.79],[952.292,207.35]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[952.292,309.632],[996.585,310.077],[952.292,207.35],[996.585,207.994]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[996.585,310.077],[996.585,207.994],[1061.1,311.173],[1061.1,209.578]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1065.89,311.198],[1065.89,209.614],[1123.36,313.906],[1123.36,213.528]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1078.81,437.295],[1078.81,333.932],[1316.12,440.624],[1316.12,340.635]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1078.81,554.532],[1078.81,451.169],[1316.12,554.033],[1316.12,454.045]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1078.81,571.775],[1078.81,675.138],[1316.12,570.713],[1316.12,670.702]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1078.81,687.064],[1078.81,790.427],[1316.12,682.238],[1316.12,782.226]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1079.72,809.535],[1079.72,912.884],[1316.97,800.711],[1316.97,900.687]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1123.36,313.906],[1123.36,213.528],[1159.79,315.953],[1159.79,216.486]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1159.79,315.953],[1159.79,216.486],[1208.17,318.936],[1208.17,220.799]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1193.68,322.212],[1193.68,225.535],[1246.54,323.816],[1246.54,227.853]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1246.53,323.816],[1246.53,227.853],[1274.21,330.195],[1274.21,237.073]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1274.21,330.195],[1274.21,237.073],[1279.1,337.612],[1279.1,247.793]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1316.12,440.624],[1316.12,340.635],[1352.98,443.317],[1352.98,346.059]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1316.12,554.033],[1316.12,454.045],[1352.98,553.63],[1352.98,456.372]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1316.12,570.714],[1316.12,670.702],[1352.98,569.854],[1352.98,667.112]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1316.12,682.238],[1316.12,782.226],[1352.98,678.334],[1352.98,775.592]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1316.97,800.711],[1316.97,900.687],[1353.56,793.531],[1353.56,890.761]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1324.95,445.718],[1324.95,350.895],[1364.06,446.239],[1364.06,351.944]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1324.95,553.27],[1324.95,458.447],[1364.06,553.192],[1364.06,458.897]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1324.95,569.088],[1324.95,663.911],[1364.06,568.922],[1364.06,663.217]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1324.95,674.852],[1324.95,769.675],[1364.06,674.097],[1364.06,768.392]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1326.83,787.462],[1326.83,882.372],[1367.41,786.027],[1367.41,880.388]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1308.4,450.818],[1308.4,361.165],[1372.1,451.618],[1372.1,362.776]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1308.4,552.505],[1308.4,462.852],[1372.1,552.385],[1372.1,463.543]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1308.4,567.462],[1308.4,657.115],[1372.1,567.206],[1372.1,656.048]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1308.4,667.459],[1308.4,757.112],[1372.1,666.299],[1372.1,755.141]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:12,
                    verts:[[1308.6,773.847],[1308.6,863.55],[1372.06,771.732],[1372.06,860.626]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[562.401,447.835],[562.401,351.951],[486.74,460.563],[486.74,378.028]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[562.401,556.589],[562.401,460.705],[486.74,554.175],[486.74,471.641]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[562.401,572.584],[562.401,668.468],[486.74,567.944],[486.74,650.478]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[562.401,679.531],[562.401,775.415],[486.74,660.001],[486.74,742.535]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[562.401,790.008],[562.401,885.892],[486.74,755.097],[486.74,837.631]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[612.548,440.151],[612.548,339.685],[544.963,444.383],[544.963,348.205]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[612.548,554.104],[612.548,453.637],[544.963,553.47],[544.963,457.292]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[612.548,570.864],[612.548,671.331],[544.963,569.514],[544.963,665.692]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[612.548,682.923],[612.548,783.39],[544.963,676.789],[544.963,772.966]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[563.165,347.59],[563.165,262.216],[560.731,356.497],[560.731,275.089]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[593.711,336.832],[593.711,246.666],[563.165,347.59],[563.165,262.216]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[614.554,802.068],[614.554,902.563],[543.37,790.179],[543.37,886.128]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[645.19,327.328],[645.19,232.929],[593.711,336.832],[593.711,246.666]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[612.547,440.151],[612.547,339.685],[689.429,441.411],[689.429,342.22]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[612.547,554.104],[612.547,453.637],[689.429,553.915],[689.429,454.725]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[612.547,570.864],[612.547,671.331],[689.429,570.462],[689.429,669.653]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[612.547,682.923],[612.547,783.39],[689.429,681.097],[689.429,780.287]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[614.554,802.068],[614.554,902.563],[691.113,798.742],[691.113,897.965]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[719.353,318.333],[719.353,219.928],[645.19,327.328],[645.19,232.929]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[725.976,813.517],[725.976,918.39],[686.1,798.049],[686.1,897.007]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[726.864,435.948],[726.864,331.219],[689.429,441.411],[689.429,342.22]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[726.864,554.734],[726.864,450.005],[689.429,553.915],[689.429,454.725]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[726.864,572.205],[726.864,676.934],[689.429,570.462],[689.429,669.653]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[726.864,689.017],[726.864,793.745],[689.429,681.097],[689.429,780.287]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[785.827,312.632],[785.827,211.687],[719.353,318.333],[719.353,219.928]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[726.864,435.948],[726.864,331.219],[772.687,436.745],[772.687,332.825]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[726.864,554.734],[726.864,450.005],[772.687,554.614],[772.687,450.694]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[726.864,572.205],[726.864,676.934],[772.687,571.951],[772.687,675.871]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[726.864,689.017],[726.864,793.745],[772.687,687.861],[772.687,791.781]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[725.976,813.517],[773.563,811.319],[725.976,918.39],[773.563,915.351]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[793.317,433.94],[793.317,327.175],[772.687,436.745],[772.687,332.825]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[793.317,555.035],[793.317,448.27],[772.687,554.614],[772.687,450.694]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[793.317,572.846],[793.317,679.61],[772.687,571.951],[772.687,675.871]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[793.317,691.928],[793.317,798.693],[772.687,687.861],[772.687,791.781]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[793.231,818.41],[793.231,925.154],[773.563,811.319],[773.563,915.351]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[862.01,309.416],[862.01,207.038],[785.827,312.632],[785.827,211.687]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[876.195,432.975],[876.195,325.233],[793.317,433.94],[793.317,327.175]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[876.195,555.179],[876.195,447.437],[793.317,555.035],[793.317,448.27]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[876.195,573.153],[876.195,680.895],[793.317,572.846],[793.317,679.61]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[876.195,693.327],[876.195,801.069],[793.317,691.928],[793.317,798.693]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[876.195,821.021],[876.195,928.763],[793.231,818.41],[793.231,925.154]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[862.01,309.416],[862.01,207.038],[918.96,311.673],[918.96,210.3]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[876.195,432.975],[876.195,325.233],[1121.4,437.479],[1121.4,334.302]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[876.195,555.179],[876.195,447.437],[1121.4,554.504],[1121.4,451.328]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[876.195,573.153],[876.195,680.895],[1121.4,571.717],[1121.4,674.893]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[876.195,693.327],[876.195,801.069],[1121.4,686.798],[1121.4,789.975]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[876.195,821.021],[876.195,928.763],[1121.4,809.081],[1121.4,912.258]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[932.795,308.174],[932.795,205.243],[918.959,311.673],[918.959,210.3]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[932.795,308.174],[994.624,309.071],[932.795,205.243],[994.624,206.54]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[994.624,309.071],[1038.3,309.877],[994.624,206.54],[1038.3,207.704]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1038.3,309.877],[1038.3,207.704],[1101.23,311.493],[1101.23,210.04]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1105.95,311.556],[1105.95,210.131],[1160,314.712],[1160,214.693]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1122.75,437.503],[1122.75,334.352],[1347.91,441.638],[1347.91,342.679]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1122.75,554.501],[1122.75,451.349],[1347.91,553.881],[1347.91,454.922]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1122.75,571.709],[1122.75,674.86],[1347.91,570.39],[1347.91,669.349]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1122.75,686.762],[1122.75,789.914],[1347.91,680.767],[1347.91,779.726]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1123.62,808.974],[1123.62,912.109],[1348.71,798.013],[1348.71,896.958]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1160,314.712],[1160,214.693],[1193.82,317.034],[1193.82,218.049]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1193.82,317.034],[1193.82,218.049],[1238.34,320.372],[1238.34,222.875]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1220.84,323.514],[1220.84,227.415],[1271.02,325.503],[1271.02,230.291]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1271.02,325.503],[1271.02,230.291],[1291.68,332.026],[1291.68,239.72]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1347.91,441.639],[1347.91,342.679],[1377.62,444.423],[1377.62,348.287]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1347.91,553.881],[1347.91,454.922],[1377.62,553.464],[1377.62,457.327]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1347.91,570.39],[1347.91,669.349],[1377.62,569.502],[1377.62,665.638]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1347.91,680.767],[1347.91,779.726],[1377.62,676.73],[1377.62,772.866]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1348.71,798.013],[1348.71,896.958],[1378.12,790.593],[1378.12,886.7]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1344.94,446.704],[1344.94,352.88],[1381.75,447.345],[1381.75,354.17]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1344.94,553.122],[1344.94,459.298],[1381.75,553.026],[1381.75,459.851]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1344.94,568.774],[1344.94,662.598],[1381.75,568.57],[1381.75,661.744]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1344.94,673.423],[1344.94,767.247],[1381.75,672.494],[1381.75,765.669]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:13,
                    verts:[[1346.96,784.83],[1346.96,878.734],[1385.14,783.066],[1385.14,876.295]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[584.615,446.207],[584.615,348.615],[475.584,458.94],[475.584,374.704]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[584.615,556.898],[584.615,459.306],[475.584,554.483],[475.584,470.247]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[584.615,573.178],[584.615,670.77],[475.584,568.535],[475.584,652.771]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[584.615,682.03],[584.615,779.621],[475.584,662.49],[475.584,746.726]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[584.615,794.475],[584.615,892.066],[475.584,759.547],[475.584,843.783]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[561.029,344.18],[561.029,257.288],[549.327,353.229],[549.327,270.365]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[603.519,333.459],[603.519,241.791],[561.029,344.18],[561.029,257.288]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[646.679,438.57],[646.679,336.499],[567.362,442.632],[567.362,344.679]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[646.679,554.341],[646.679,452.27],[567.362,553.732],[567.362,455.78]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[646.679,571.369],[646.679,673.439],[567.362,570.073],[567.362,668.025]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[646.679,685.216],[646.679,787.287],[567.362,679.327],[567.362,777.28]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[648.798,806.244],[648.798,908.336],[565.191,794.825],[565.191,892.55]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[666.029,324.198],[666.029,228.405],[603.519,333.459],[603.519,241.791]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[646.678,438.569],[646.678,336.499],[722.225,440.125],[722.225,339.63]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[646.678,554.341],[646.678,452.27],[722.225,554.108],[722.225,453.614]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[646.678,571.369],[646.678,673.439],[722.225,570.873],[722.225,671.367]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[646.678,685.216],[646.678,787.287],[722.225,682.962],[722.225,783.456]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[648.798,806.244],[648.798,908.336],[724.015,802.137],[724.016,902.658]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[750.853,315.671],[750.853,216.079],[666.029,324.198],[666.029,228.405]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[772.49,816.756],[772.49,922.867],[718.299,801.482],[718.299,901.753]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[773.059,434.731],[773.059,328.77],[722.225,440.125],[722.225,339.63]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[773.059,554.916],[773.059,448.955],[722.225,554.108],[722.225,453.614]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[773.059,572.593],[773.059,678.555],[722.225,570.873],[722.225,671.367]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[773.059,690.78],[773.059,796.742],[722.225,682.962],[722.225,783.456]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[824.079,310.449],[824.079,208.532],[750.853,315.671],[750.853,216.079]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[772.49,816.756],[772.49,922.867],[818.779,814.06],[818.779,919.141]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[773.059,434.731],[773.059,328.77],[817.634,435.709],[817.634,330.739]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[773.059,554.916],[773.059,448.955],[817.634,554.77],[817.634,449.799]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[773.059,572.593],[773.059,678.555],[817.634,572.281],[817.634,677.252]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[773.059,690.78],[773.059,796.742],[817.634,689.363],[817.634,794.333]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[845.032,432.954],[845.032,325.191],[817.634,435.709],[817.634,330.739]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[845.032,555.182],[845.032,447.419],[817.634,554.77],[817.634,449.799]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[845.032,573.16],[845.032,680.923],[817.634,572.281],[817.634,677.252]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[845.032,693.357],[845.032,801.12],[817.634,689.363],[817.634,794.333]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[844.899,821.023],[844.899,928.766],[818.779,814.06],[818.779,919.141]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[904.179,307.837],[904.179,204.755],[824.079,310.449],[824.079,208.532]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[930.734,432.299],[930.734,323.872],[845.032,432.954],[845.032,325.191]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[930.734,555.281],[930.734,446.854],[845.032,555.182],[845.032,447.419]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[930.734,573.369],[930.734,681.796],[845.032,573.16],[845.032,680.923]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[930.734,694.306],[930.734,802.733],[845.032,693.357],[845.032,801.12]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[930.734,822.813],[930.734,931.24],[844.899,821.023],[844.899,928.766]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[904.179,307.837],[904.179,204.755],[959.02,310.576],[959.02,208.714]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[930.734,432.299],[930.734,323.872],[1164.39,437.724],[1164.39,334.795]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[930.734,555.281],[930.734,446.854],[1164.39,554.468],[1164.39,451.54]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[930.734,573.369],[930.734,681.796],[1164.39,571.639],[1164.39,674.567]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[930.734,694.306],[930.734,802.733],[1164.39,686.443],[1164.39,789.371]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[930.734,822.813],[930.734,931.24],[1164.39,808.432],[1164.39,911.36]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[976.434,307.175],[976.434,203.799],[959.02,310.576],[959.02,208.714]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[976.434,307.175],[976.434,203.799],[1037.23,308.586],[1037.23,205.839]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[1037.23,308.586],[1037.23,205.839],[1079.84,309.751],[1079.84,207.523]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[1079.84,309.751],[1079.84,207.523],[1140.54,311.878],[1140.54,210.597]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[1145.14,311.979],[1145.14,210.743],[1195.26,315.559],[1195.26,215.917]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[1165.66,437.753],[1165.66,334.855],[1376.64,442.651],[1376.64,344.718]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[1165.66,554.463],[1165.66,451.565],[1376.64,553.729],[1376.64,455.796]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[1165.66,571.629],[1165.66,674.527],[1376.64,570.067],[1376.64,668]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[1165.66,686.4],[1165.66,789.298],[1376.64,679.299],[1376.64,777.232]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[1166.48,808.303],[1166.48,911.182],[1377.38,795.322],[1377.38,893.238]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[1195.26,315.559],[1195.26,215.917],[1226.17,318.138],[1226.17,219.645]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[1226.17,318.138],[1226.17,219.645],[1266.46,321.802],[1266.46,224.942]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[1246.14,324.79],[1246.14,229.261],[1293.26,327.145],[1293.26,232.664]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:14,
                    verts:[[1293.26,327.145],[1293.26,232.664],[1306.87,333.768],[1306.87,242.237]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[447.811,454.368],[447.811,368.314],[444.963,458.277],[444.963,376.185]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[447.811,551.973],[447.811,465.919],[444.963,551.388],[444.963,469.296]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[447.811,566.329],[447.811,652.383],[444.963,565.082],[444.963,647.174]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[447.811,662.312],[447.811,748.366],[444.963,656.646],[444.963,738.738]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[610.571,444.52],[610.571,345.16],[466.862,457.166],[466.862,371.07]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[610.571,557.218],[610.571,457.857],[466.862,554.819],[466.862,468.723]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[610.571,573.793],[610.571,673.153],[466.862,569.182],[466.862,655.278]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[610.571,684.617],[610.571,783.978],[466.862,665.212],[466.862,751.308]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[610.571,799.101],[610.571,898.461],[466.862,764.412],[466.862,850.509]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[536.506,349.888],[536.506,265.538],[533.281,358.499],[533.281,277.984]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[561.357,340.492],[561.357,251.956],[539.897,349.637],[539.897,265.174]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[616.177,329.885],[616.177,236.625],[561.357,340.492],[561.357,251.957]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[686.825,810.457],[686.825,914.159],[590.913,799.643],[590.913,899.21]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[684.61,436.973],[684.61,333.284],[593.676,440.818],[593.676,341.027]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[684.61,554.58],[684.61,450.891],[593.676,554.004],[593.676,454.213]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[684.61,571.878],[684.61,675.567],[593.676,570.652],[593.676,670.443]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[684.61,687.531],[684.61,791.22],[593.676,681.956],[593.676,781.748]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[689.782,320.955],[689.782,223.717],[616.177,329.885],[616.177,236.625]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[684.61,436.973],[684.61,333.284],[757.974,438.831],[757.974,337.026]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[684.61,554.58],[684.61,450.891],[757.974,554.302],[757.974,452.497]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[684.61,571.878],[684.61,675.567],[757.974,571.285],[757.974,673.09]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[684.61,687.531],[684.61,791.22],[757.974,684.836],[757.974,786.642]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[686.825,810.457],[686.825,914.159],[759.857,805.549],[759.857,907.375]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[784.961,312.992],[784.961,212.207],[689.782,320.955],[689.782,223.717]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[822.01,819.876],[822.01,927.18],[753.463,804.94],[753.463,906.534]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[822.239,433.559],[822.239,326.408],[757.974,438.831],[757.974,337.026]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[822.239,555.092],[822.239,447.941],[757.974,554.302],[757.974,452.497]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[822.239,572.967],[822.239,680.118],[757.974,571.285],[757.974,673.09]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[822.239,692.481],[822.239,799.631],[757.974,684.836],[757.974,786.642]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[864.455,308.319],[864.455,205.452],[784.961,312.992],[784.961,212.207]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[822.239,433.559],[822.239,326.408],[865.013,434.718],[865.013,328.742]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[822.239,555.092],[822.239,447.941],[865.013,554.918],[865.013,448.943]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[822.239,572.967],[822.239,680.118],[865.013,572.597],[865.013,678.573]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[822.239,692.481],[822.239,799.631],[865.013,690.8],[865.013,796.776]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[822.01,819.876],[822.01,927.18],[866.424,816.68],[866.424,922.763]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[947.746,306.357],[947.746,202.616],[864.455,308.319],[864.455,205.452]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[899.101,432.04],[899.101,323.35],[865.013,434.718],[865.013,328.742]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[899.101,555.319],[899.101,446.63],[865.013,554.918],[865.013,448.943]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[899.101,573.451],[899.101,682.141],[865.013,572.597],[865.013,678.573]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[899.101,694.682],[899.101,803.372],[865.013,690.8],[865.013,796.776]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[898.919,823.447],[898.919,932.116],[866.424,816.68],[866.424,922.763]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[986.689,431.714],[986.689,322.693],[899.101,432.04],[899.101,323.35]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[986.689,555.368],[986.689,446.348],[899.101,555.319],[899.101,446.63]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[986.689,573.556],[986.689,682.577],[899.101,573.451],[899.101,682.141]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[986.689,695.155],[899.101,694.682],[986.689,804.176],[899.101,803.372]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[986.689,824.365],[898.919,823.447],[986.689,933.386],[898.919,932.116]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[947.746,306.357],[947.746,202.616],[999.85,309.571],[999.85,207.263]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[986.689,431.714],[986.689,322.693],[1206.03,438.028],[1206.03,335.408]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[986.689,555.368],[986.689,446.348],[1206.03,554.422],[1206.03,451.802]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[986.689,573.556],[986.689,682.577],[1206.03,571.542],[1206.03,674.161]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[986.689,695.155],[986.689,804.176],[1206.03,686.001],[1206.03,788.621]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[986.689,824.365],[986.689,933.386],[1206.03,807.625],[1206.03,910.245]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1020.73,306.3],[1020.73,202.534],[999.849,309.571],[999.849,207.263]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1020.73,306.3],[1020.73,202.534],[1079.83,308.224],[1079.83,205.316]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1079.83,308.224],[1079.83,205.316],[1120.92,309.745],[1120.92,207.514]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1120.92,309.745],[1120.92,207.514],[1178.76,312.369],[1178.76,211.306]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1183.2,312.507],[1183.2,211.506],[1228.88,316.482],[1228.88,217.252]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1207.21,438.062],[1207.21,335.477],[1402.1,443.672],[1402.1,346.774]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1207.21,554.417],[1207.21,451.832],[1402.1,553.576],[1402.1,456.679]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1207.21,571.531],[1207.21,674.116],[1402.1,569.741],[1402.1,666.639]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1207.21,685.952],[1207.21,788.537],[1402.1,677.819],[1402.1,774.716]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1207.98,807.476],[1207.98,910.039],[1402.78,792.608],[1402.78,889.486]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1228.88,316.482],[1228.88,217.252],[1256.61,319.296],[1256.61,221.319]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1256.61,319.296],[1256.61,221.319],[1292.34,323.256],[1292.34,227.043]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1269.42,326.072],[1269.42,231.113],[1313.09,328.769],[1313.09,235.011]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:15,
                    verts:[[1313.09,328.769],[1313.09,235.011],[1319.66,335.445],[1319.66,244.662]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[441.057,452.323],[441.057,364.196],[428.756,456.323],[428.756,372.25]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[441.057,552.28],[441.057,464.153],[428.756,551.68],[428.756,467.608]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[441.057,566.981],[441.057,655.109],[428.756,565.706],[428.756,649.779]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[441.057,665.277],[441.057,753.404],[428.756,659.479],[428.756,743.552]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[640.479,442.802],[640.479,341.64],[460.95,455.249],[460.95,367.141]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[640.479,557.543],[640.479,456.381],[460.95,555.183],[460.95,467.075]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[640.479,574.419],[640.479,675.582],[460.95,569.881],[460.95,657.989]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[640.479,687.254],[640.479,788.416],[460.95,668.155],[460.95,756.263]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[640.479,803.813],[640.479,904.975],[460.95,769.673],[460.95,857.781]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[528.968,345.971],[528.968,259.876],[516.622,354.748],[516.622,272.563]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[564.446,336.553],[564.446,246.263],[532.738,345.738],[532.738,259.538]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[631.922,326.154],[631.922,231.232],[564.446,336.553],[564.446,246.263]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[728.686,814.617],[728.686,919.91],[620.776,804.559],[620.776,906.006]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[726.394,435.396],[726.394,330.108],[624.141,438.969],[624.141,337.304]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[726.394,554.817],[726.394,449.529],[624.141,554.281],[624.141,452.616]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[726.394,572.381],[726.394,677.669],[624.141,571.241],[624.141,672.906]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[726.394,689.817],[726.394,795.105],[624.141,684.636],[624.141,786.302]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[716.57,317.654],[716.57,218.946],[631.922,326.154],[631.922,231.232]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[821.636,310.362],[821.636,208.405],[716.57,317.654],[716.57,218.946]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[726.393,435.396],[726.393,330.108],[796.651,437.562],[796.651,334.469]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[726.393,554.817],[726.393,449.529],[796.651,554.492],[796.651,451.4]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[726.393,572.381],[726.393,677.669],[796.651,571.69],[796.651,674.783]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[726.393,689.817],[726.393,795.105],[796.651,686.677],[796.651,789.77]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[728.686,814.617],[728.686,919.91],[798.611,808.898],[798.611,912.004]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[874.194,432.466],[874.194,324.207],[796.651,437.562],[796.651,334.469]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[874.194,555.256],[874.194,446.997],[796.651,554.492],[796.651,451.4]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[874.194,573.316],[874.194,681.574],[796.651,571.69],[796.651,674.783]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[874.194,694.065],[874.194,802.324],[796.651,686.677],[796.651,789.77]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[874.32,822.78],[874.32,931.195],[791.576,808.344],[791.576,911.239]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[906.783,306.308],[906.783,202.546],[821.636,310.362],[821.636,208.405]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[874.194,432.466],[874.194,324.207],[914.585,433.805],[914.585,326.903]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[874.194,555.256],[874.194,446.997],[914.585,555.055],[914.585,448.154]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[874.194,573.316],[874.194,681.574],[914.585,572.889],[914.585,679.79]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[874.194,694.065],[874.194,802.324],[914.585,692.124],[914.585,799.025]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[874.32,822.781],[874.32,931.195],[916.253,819.09],[916.253,926.093]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[992.436,305.042],[992.436,200.716],[906.783,306.308],[906.783,202.546]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[955.177,431.234],[955.177,321.727],[914.585,433.805],[914.585,326.903]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[955.177,555.44],[955.177,445.933],[914.585,555.055],[914.585,448.154]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[955.177,573.709],[955.177,683.216],[914.585,572.889],[914.585,679.79]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[955.177,695.85],[955.177,805.357],[914.585,692.124],[914.585,799.025]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[954.947,825.585],[954.947,935.072],[916.253,819.09],[916.253,926.093]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[955.177,431.234],[1043.61,431.251],[955.177,321.727],[1043.61,321.762]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[955.177,555.44],[955.177,445.933],[1043.61,555.438],[1043.61,445.948]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[955.177,573.709],[1043.61,573.703],[955.177,683.216],[1043.61,683.193]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[955.177,695.85],[1043.61,695.825],[955.177,805.357],[1043.61,805.315]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[954.947,825.585],[1043.61,825.591],[954.947,935.072],[1043.61,935.081]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[992.436,305.042],[992.436,200.716],[1041.16,308.72],[1041.16,206.031]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1065.35,305.608],[1065.35,201.534],[1041.16,308.719],[1041.16,206.031]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1043.61,431.251],[1043.61,321.762],[1245.93,438.411],[1245.93,336.18]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1043.61,555.438],[1043.61,445.948],[1245.93,554.365],[1245.93,452.134]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1043.61,573.703],[1043.61,683.193],[1245.93,571.419],[1245.93,673.65]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1043.61,695.825],[1043.61,805.315],[1245.93,685.446],[1245.93,787.677]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1043.61,825.591],[1043.61,935.081],[1245.93,806.609],[1245.93,908.84]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1065.35,305.608],[1065.35,201.534],[1122.07,308.041],[1122.07,205.05]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1122.07,308.04],[1122.07,205.05],[1161.18,309.908],[1161.18,207.749]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1161.18,309.908],[1161.18,207.749],[1215.53,313.01],[1215.53,212.233]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1219.75,313.184],[1219.75,212.485],[1260.56,317.521],[1260.56,218.754]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1247.02,438.45],[1247.02,336.257],[1424.06,444.714],[1424.06,348.873]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1247.02,554.359],[1247.02,452.167],[1424.06,553.42],[1424.06,457.579]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1247.02,571.407],[1247.02,673.599],[1424.06,569.409],[1424.06,665.25]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1247.02,685.39],[1247.02,787.582],[1424.06,676.308],[1424.06,772.149]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1247.72,806.441],[1247.72,908.608],[1424.67,789.839],[1424.67,885.658]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1260.56,317.521],[1260.56,218.754],[1284.84,320.546],[1284.84,223.126]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1284.84,320.546],[1284.84,223.126],[1315.72,324.767],[1315.72,229.226]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:16,
                    verts:[[1290.43,327.391],[1290.43,233.02],[1330.33,330.405],[1330.33,237.377]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[437.645,450.136],[437.645,359.79],[415.201,454.203],[415.201,367.981]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[437.645,552.608],[437.645,462.262],[415.201,551.998],[415.201,465.776]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[437.645,567.679],[437.645,658.025],[415.201,566.382],[415.201,652.603]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[437.645,668.448],[437.645,758.794],[415.201,662.552],[415.201,748.773]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[674.508,441.087],[674.508,338.126],[458.294,453.199],[458.294,362.941]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[674.508,557.869],[674.508,454.908],[458.294,555.572],[458.294,465.314]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[674.508,575.045],[674.508,678.006],[458.294,570.629],[458.294,660.886]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[674.508,689.885],[674.508,792.846],[458.294,671.3],[458.294,761.557]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[674.508,808.517],[674.508,911.478],[458.294,775.295],[458.294,865.552]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[502.013,350.667],[502.013,266.663],[499.719,356.684],[499.719,275.361]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[524.055,341.77],[524.055,253.804],[502.013,350.667],[502.013,266.663]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[570.632,332.406],[570.632,240.269],[528.203,341.56],[528.203,253.499]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[650.991,322.323],[650.991,225.695],[570.632,332.406],[570.632,240.269]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[746.474,314.367],[746.474,214.195],[650.991,322.323],[650.991,225.695]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[774.337,818.613],[774.337,925.434],[654.977,809.478],[654.977,912.806]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[771.992,433.88],[771.992,327.054],[658.944,437.123],[658.944,333.585]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[771.992,555.044],[771.992,448.219],[658.944,554.558],[658.944,451.02]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[771.992,572.865],[771.992,679.69],[658.944,571.83],[658.944,675.368]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[771.992,692.015],[771.992,798.841],[658.944,687.314],[658.944,790.851]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[860.763,307.86],[860.763,204.789],[746.474,314.367],[746.474,214.195]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[771.992,433.88],[771.992,327.054],[838.154,436.352],[838.154,332.033]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[771.992,555.044],[771.992,448.219],[838.154,554.673],[838.154,450.355]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[771.992,572.865],[771.992,679.69],[838.154,572.076],[838.154,676.395]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[771.992,692.015],[771.992,798.841],[838.154,688.431],[838.154,792.75]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[774.337,818.613],[774.337,925.434],[840.171,812.085],[840.172,916.411]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[929.079,825.356],[929.079,934.756],[832.549,811.595],[832.549,915.733]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[928.585,431.495],[928.585,322.253],[838.154,436.352],[838.154,332.033]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[928.585,555.401],[928.585,446.159],[838.154,554.673],[838.154,450.355]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[928.585,573.625],[928.585,682.868],[838.154,572.076],[838.154,676.395]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[928.585,695.472],[928.585,804.714],[838.154,688.431],[838.154,792.75]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[950.801,304.498],[950.801,199.93],[860.763,307.86],[860.763,204.789]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[928.585,431.495],[928.585,322.253],[965.996,433.009],[965.996,325.301]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[928.585,555.401],[928.585,446.159],[965.996,555.174],[965.996,447.466]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[928.585,573.625],[928.585,682.868],[965.996,573.143],[965.996,680.85]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[928.585,695.472],[928.585,804.714],[965.996,693.277],[965.996,800.985]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[929.079,825.356],[929.079,934.756],[967.911,821.184],[967.911,928.989]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1037.88,303.967],[950.801,304.498],[1037.88,199.162],[950.801,199.93]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1012.78,430.577],[1012.78,320.404],[965.996,433.009],[965.996,325.301]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1012.78,555.539],[1012.78,445.366],[965.996,555.174],[965.996,447.466]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1012.78,573.918],[1012.78,684.091],[965.996,573.142],[965.996,680.85]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1012.78,696.803],[1012.78,806.976],[965.996,693.277],[965.996,800.985]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1012.5,827.329],[1012.5,937.483],[967.911,821.184],[967.911,928.989]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1012.5,827.329],[1100.92,826.391],[1012.5,937.483],[1100.92,936.187]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1012.78,430.577],[1012.78,320.404],[1100.92,430.95],[1100.92,321.154]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1012.78,555.539],[1012.78,445.366],[1100.92,555.483],[1100.92,445.687]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1012.78,573.918],[1012.78,684.091],[1100.92,573.799],[1100.92,683.595]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1012.78,696.803],[1012.78,806.976],[1100.92,696.263],[1100.92,806.059]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1037.88,303.967],[1037.88,199.162],[1082.59,308.086],[1082.59,205.116]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1109.86,305.169],[1109.86,200.9],[1082.59,308.086],[1082.59,205.116]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1100.92,430.95],[1100.92,321.154],[1283.66,438.894],[1283.66,337.153]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1100.92,555.483],[1100.92,445.687],[1283.66,554.292],[1283.66,452.551]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1100.92,573.799],[1100.92,683.595],[1283.66,571.265],[1283.66,673.006]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1100.92,696.263],[1100.92,806.059],[1283.66,684.745],[1283.66,786.486]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1100.92,826.391],[1100.92,936.187],[1283.66,805.327],[1283.66,907.068]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1109.86,305.169],[1109.86,200.9],[1163.53,308.095],[1163.53,205.129]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1163.53,308.095],[1163.53,205.129],[1200.2,310.296],[1200.2,208.31]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1200.2,310.296],[1200.2,208.31],[1250.46,313.85],[1250.46,213.447]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1254.42,314.059],[1254.42,213.749],[1289.93,318.718],[1289.93,220.484]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1284.63,438.937],[1284.63,337.238],[1442.26,445.79],[1442.26,351.04]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1284.63,554.286],[1284.63,452.588],[1442.26,553.259],[1442.26,458.508]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1284.63,571.252],[1284.63,672.95],[1442.26,569.065],[1442.26,663.816]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1284.63,684.684],[1284.63,786.382],[1442.26,674.748],[1442.26,769.498]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1285.26,805.143],[1285.26,906.814],[1442.8,786.982],[1442.8,881.709]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1289.93,318.718],[1289.93,220.484],[1310.55,321.926],[1310.55,225.12]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1310.55,321.926],[1310.55,225.12],[1336.34,326.368],[1336.34,231.542]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:17,
                    verts:[[1308.94,328.784],[1308.94,235.033],[1344.76,332.086],[1344.76,239.807]]
                },
                ],
                [
                {
                    num:"104",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[466.518,766.384],[466.518,853.235],[397.798,758.299],[397.798,842.058]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[463.852,453.793],[463.852,367.155],[399.663,456.638],[399.663,372.886]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[463.852,552.06],[463.852,465.422],[399.663,551.633],[399.663,467.88]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[463.852,566.513],[463.852,653.15],[399.663,565.605],[399.663,649.358]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[463.852,663.146],[463.852,749.784],[399.663,659.021],[399.663,742.774]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[438.111,447.824],[438.111,355.136],[404.821,451.93],[404.821,363.405]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[438.111,552.954],[438.111,460.266],[404.821,552.339],[404.821,463.813]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[438.111,568.417],[438.111,661.105],[404.821,567.107],[404.821,655.632]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[438.111,671.799],[438.111,764.488],[404.821,665.846],[404.821,754.372]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[441.802,782.18],[441.802,875.07],[406.015,770.644],[406.015,859.124]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[712.739,439.418],[712.739,334.706],[459.402,451.037],[459.402,358.512]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[712.739,558.185],[712.739,453.473],[459.402,555.982],[459.402,463.457]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[712.739,575.654],[712.739,680.366],[459.402,571.417],[459.402,663.942]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[712.739,692.447],[712.739,797.159],[459.402,674.617],[459.402,767.143]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[712.739,813.097],[712.739,917.809],[459.402,781.225],[459.402,873.75]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[489.862,346.28],[489.862,260.322],[481.077,352.432],[481.077,269.215]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[522.174,337.328],[522.174,247.383],[489.862,346.28],[489.862,260.322]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[580.264,328.108],[580.264,234.057],[526.695,337.145],[526.695,247.117]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[673.588,318.469],[673.588,220.124],[580.264,328.108],[580.264,234.057]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[779.504,311.18],[779.504,209.589],[673.588,318.469],[673.588,220.124]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[823.599,822.316],[823.599,930.553],[693.627,814.28],[693.627,919.444]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[821.229,432.473],[821.229,324.222],[698.188,435.323],[698.188,329.961]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[821.229,555.255],[821.229,447.004],[698.188,554.828],[698.188,449.466]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[821.229,573.313],[821.229,681.564],[698.188,572.404],[698.188,677.766]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[821.229,694.054],[821.229,802.305],[698.188,689.923],[698.188,795.285]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[902.118,305.577],[902.118,201.49],[779.504,311.181],[779.504,209.589]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[821.228,432.473],[821.228,324.222],[882.261,435.245],[882.261,329.804]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[821.228,555.255],[821.228,447.004],[882.261,554.839],[882.261,449.398]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[821.228,573.313],[821.228,681.564],[882.261,572.429],[882.261,677.87]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[821.228,694.054],[821.228,802.305],[882.261,690.036],[882.261,795.477]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[823.599,822.316],[823.599,930.553],[884.313,814.999],[884.314,920.439]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[984.913,430.695],[984.913,320.64],[882.261,435.245],[882.261,329.804]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[984.913,555.521],[984.913,445.467],[882.261,554.839],[882.261,449.398]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[984.913,573.881],[984.913,683.935],[882.261,572.429],[882.261,677.87]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[984.913,696.633],[984.913,806.687],[882.261,690.036],[882.261,795.477]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[985.781,827.478],[985.781,937.689],[876.17,814.582],[876.17,919.862]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[996.128,302.976],[996.128,197.73],[902.118,305.577],[902.118,201.49]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[984.913,430.695],[984.913,320.64],[1018.75,432.374],[1018.75,324.022]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[984.913,555.521],[984.913,445.467],[1018.75,555.27],[1018.75,446.918]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[984.913,573.881],[984.913,683.935],[1018.75,573.345],[1018.75,681.697]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[984.913,696.633],[984.913,806.687],[1018.75,694.199],[1018.75,802.551]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[985.781,827.478],[985.781,937.69],[1020.89,822.85],[1020.89,931.292]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[996.128,302.976],[1083.59,303.213],[996.128,197.73],[1083.59,198.072]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1071.26,430.113],[1071.26,319.469],[1018.75,432.374],[1018.75,324.022]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1071.26,555.608],[1071.26,444.965],[1018.75,555.27],[1018.75,446.918]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1071.26,574.066],[1071.26,684.71],[1018.75,573.345],[1018.75,681.697]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1071.26,697.476],[1071.26,808.12],[1018.75,694.199],[1018.75,802.551]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1070.94,828.563],[1070.94,939.189],[1020.89,822.85],[1020.89,931.292]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1071.26,430.113],[1071.26,319.469],[1157.9,430.846],[1157.9,320.946]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1071.26,555.608],[1071.26,444.965],[1157.9,555.498],[1157.9,445.598]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1071.26,574.066],[1071.26,684.71],[1157.9,573.832],[1157.9,683.733]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1071.26,697.476],[1071.26,808.12],[1157.9,696.413],[1157.9,806.314]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1070.94,828.563],[1070.94,939.189],[1157.9,826.666],[1157.9,936.566]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1083.59,303.213],[1083.59,198.072],[1123.68,307.743],[1123.68,204.62]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1153.75,305.053],[1153.75,200.732],[1123.68,307.743],[1123.68,204.62]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1153.75,305.053],[1153.75,200.732],[1203.69,308.451],[1203.69,205.643]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1157.9,430.846],[1157.9,320.946],[1318.69,439.498],[1318.69,338.369]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1157.9,555.498],[1157.9,445.598],[1318.69,554.202],[1318.69,453.073]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1157.9,573.832],[1157.9,683.733],[1318.69,571.072],[1318.69,672.201]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1157.9,696.413],[1157.9,806.314],[1318.69,683.87],[1318.69,784.999]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1157.9,826.666],[1157.9,936.566],[1318.69,803.726],[1318.69,904.855]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1203.69,308.451],[1203.69,205.643],[1237.48,310.965],[1237.48,209.277]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1237.48,310.965],[1237.48,209.277],[1283.08,314.936],[1283.08,215.017]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1286.75,315.178],[1286.75,215.366],[1316.61,320.113],[1316.61,222.501]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1316.61,320.113],[1316.61,222.501],[1333.4,323.473],[1333.4,227.356]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1319.54,439.544],[1319.54,338.461],[1456.44,446.911],[1456.44,353.296]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1319.54,554.195],[1319.54,453.112],[1456.44,553.091],[1456.44,459.477]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1319.54,571.058],[1319.54,672.141],[1456.44,568.708],[1456.44,662.322]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1319.54,683.803],[1319.54,784.886],[1456.44,673.123],[1456.44,766.738]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1320.09,803.527],[1320.09,904.58],[1456.91,784.007],[1456.91,877.596]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1333.4,323.473],[1333.4,227.356],[1353.9,328.095],[1353.9,234.038]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:18,
                    verts:[[1324.69,330.284],[1324.69,237.202],[1356.15,333.843],[1356.15,242.345]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[413.14,455.466],[413.14,370.524],[379.164,456.678],[379.164,372.966]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[413.14,551.809],[413.14,466.867],[379.164,551.627],[379.164,467.915]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[413.14,565.979],[413.14,650.921],[379.164,565.592],[379.164,649.305]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[413.14,660.721],[413.14,745.663],[379.164,658.963],[379.164,742.675]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[458.538,772.076],[458.538,861.103],[379.365,764.373],[379.365,850.454]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[455.249,451.643],[455.249,362.826],[381.302,454.354],[381.302,368.285]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[455.249,552.382],[455.249,463.565],[381.302,551.976],[381.302,465.907]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[455.249,567.199],[455.249,656.016],[381.302,566.334],[381.302,652.402]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[455.249,666.263],[455.249,755.08],[381.302,662.333],[381.302,748.402]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[443.048,445.417],[443.048,350.288],[398.235,449.524],[398.235,358.559]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[443.048,553.315],[443.048,458.186],[398.235,552.699],[398.235,461.734]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[443.048,569.184],[443.048,664.313],[398.235,567.874],[398.235,658.84]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[443.048,675.289],[443.048,770.418],[398.235,669.335],[398.235,760.3]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[447.384,788.541],[447.384,883.863],[399.372,777.01],[399.372,867.923]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[480.653,341.627],[480.653,253.598],[464.914,347.875],[464.914,262.628]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[755.134,437.844],[755.134,331.481],[464.83,448.79],[464.83,353.908]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[755.134,558.484],[755.134,452.121],[464.83,556.408],[464.83,461.526]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[755.134,576.227],[755.134,682.59],[464.83,572.236],[464.83,667.118]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[755.134,694.862],[755.134,801.225],[464.83,678.066],[464.83,772.948]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[755.134,817.414],[755.134,923.776],[464.83,787.389],[464.83,882.271]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[523.782,332.7],[523.782,240.693],[480.653,341.627],[480.653,253.598]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[593.7,323.734],[593.7,227.733],[528.665,332.548],[528.665,240.473]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[699.867,314.683],[699.867,214.651],[593.7,323.734],[593.7,227.733]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[815.573,308.195],[815.573,205.273],[699.867,314.683],[699.867,214.651]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[876.126,825.58],[876.126,935.066],[736.716,818.824],[736.716,925.726]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[873.762,431.232],[873.762,321.723],[741.848,433.624],[741.848,326.539]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[873.762,555.441],[873.762,445.931],[741.848,555.082],[741.848,447.998]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[873.762,573.709],[873.762,683.219],[741.848,572.946],[741.848,680.031]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[873.762,695.854],[873.762,805.363],[741.848,692.386],[741.848,799.471]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[945.359,303.613],[945.359,198.651],[815.573,308.195],[815.573,205.273]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[873.762,431.232],[873.762,321.723],[928.616,434.288],[928.616,327.877]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[873.762,555.441],[873.762,445.931],[928.616,554.983],[928.616,448.572]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[873.762,573.709],[873.762,683.219],[928.616,572.734],[928.616,679.146]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[873.762,695.854],[873.762,805.363],[928.616,691.423],[928.616,797.834]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[876.126,825.58],[876.126,935.066],[930.678,817.514],[930.678,923.916]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1042.51,430.113],[1042.51,319.468],[928.616,434.288],[928.616,327.877]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1042.51,555.608],[1042.51,444.964],[928.616,554.983],[928.616,448.572]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1042.51,574.066],[1042.51,684.711],[928.616,572.734],[928.616,679.146]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1042.51,697.477],[1042.51,808.121],[928.616,691.423],[928.616,797.834]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1043.75,829.015],[1043.75,939.814],[922.1,817.179],[922.1,923.452]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1042.26,301.836],[1042.26,196.082],[945.359,303.613],[945.359,198.651]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1042.26,301.836],[1042.26,196.082],[1129,302.862],[1129,197.564]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1042.51,430.113],[1042.51,319.468],[1072.2,431.943],[1072.2,323.154]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1042.51,555.608],[1042.51,444.964],[1072.2,555.334],[1072.2,446.546]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1042.51,574.066],[1042.51,684.711],[1072.2,573.483],[1072.2,682.271]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1042.51,697.477],[1042.51,808.121],[1072.2,694.823],[1072.2,803.612]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1043.75,829.015],[1043.75,939.814],[1074.54,823.971],[1074.54,932.841]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1129.83,429.886],[1129.83,319.012],[1072.2,431.943],[1072.2,323.154]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1129.83,555.642],[1129.83,444.768],[1072.2,555.334],[1072.2,446.546]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1129.83,574.139],[1129.83,685.013],[1072.2,573.483],[1072.2,682.271]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1129.83,697.805],[1129.83,808.679],[1072.2,694.823],[1072.2,803.612]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1129.47,829.168],[1129.47,940.025],[1074.54,823.971],[1074.54,932.841]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1129,302.862],[1129,197.564],[1163.89,307.761],[1163.89,204.646]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1129.47,829.168],[1129.47,940.025],[1213.71,826.315],[1213.71,936.081]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1129.83,429.886],[1129.83,319.012],[1213.71,430.978],[1213.71,321.212]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1129.83,555.642],[1129.83,444.768],[1213.71,555.479],[1213.71,445.712]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1129.83,574.139],[1129.83,685.013],[1213.71,573.79],[1213.71,683.557]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1129.83,697.805],[1129.83,808.679],[1213.71,696.221],[1213.71,805.988]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1196.4,305.331],[1196.4,201.134],[1163.89,307.761],[1163.89,204.646]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1196.4,305.331],[1196.4,201.134],[1241.97,309.167],[1241.97,206.678]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1213.71,430.978],[1213.71,321.212],[1350.51,440.241],[1350.51,339.866]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1213.71,555.479],[1213.71,445.712],[1350.51,554.09],[1350.51,453.715]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1213.71,573.79],[1213.71,683.557],[1350.51,570.835],[1350.51,671.211]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1213.71,696.221],[1213.71,805.988],[1350.51,682.792],[1350.51,783.168]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1213.71,826.315],[1213.71,936.081],[1350.51,801.756],[1350.51,902.132]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1241.97,309.167],[1241.97,206.678],[1272.48,311.969],[1272.48,210.729]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1272.48,311.969],[1272.48,210.729],[1312.92,316.315],[1312.92,217.01]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1316.25,316.586],[1316.25,217.402],[1340.2,321.746],[1340.2,224.86]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1340.2,321.746],[1340.2,224.86],[1353.02,325.222],[1353.02,229.885]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1351.22,440.29],[1351.22,339.964],[1466.35,448.086],[1466.35,355.663]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1351.22,554.083],[1351.22,453.757],[1466.35,552.915],[1466.35,460.492]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1351.22,570.82],[1351.22,671.146],[1466.35,568.333],[1466.35,660.756]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1351.22,682.722],[1351.22,783.048],[1466.35,671.42],[1466.35,763.843]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1351.69,801.544],[1351.69,901.839],[1466.74,780.888],[1466.74,873.284]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:19,
                    verts:[[1353.02,325.222],[1353.02,229.885],[1368.11,329.978],[1368.11,236.759]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[397.017,453.18],[397.017,365.922],[358.451,454.314],[358.451,368.206]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[397.017,552.151],[397.017,464.893],[358.451,551.981],[358.451,465.873]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[397.017,566.708],[397.017,653.966],[358.451,566.346],[358.451,652.455]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[397.017,664.034],[397.017,751.292],[358.451,662.39],[358.451,748.499]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[396.176,767.379],[396.176,854.61],[359.443,764.516],[359.443,850.651]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[454.339,778.018],[454.339,869.316],[364.444,770.826],[364.444,859.375]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[450.403,449.396],[450.403,358.301],[366.443,451.927],[366.443,363.398]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[450.403,552.719],[450.403,461.623],[366.443,552.339],[366.443,463.81]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[450.403,567.915],[450.403,659.01],[366.443,567.108],[366.443,655.637]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[450.403,669.521],[450.403,760.616],[366.443,665.852],[366.443,754.381]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[453.069,442.952],[453.069,345.325],[396.124,447.012],[396.124,353.5]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[453.069,553.684],[453.069,456.057],[396.124,553.076],[396.124,459.564]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[453.069,569.971],[453.069,667.598],[396.124,568.676],[396.124,662.188]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[453.069,678.862],[453.069,776.49],[396.124,672.977],[396.124,766.489]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[458.059,795.046],[458.059,892.857],[397.186,783.656],[397.186,877.11]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[474.921,336.764],[474.921,246.568],[451.773,343.055],[451.773,255.661]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[529.349,327.959],[529.349,233.841],[474.921,336.764],[474.921,246.568]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[801.481,436.422],[801.481,328.568],[475.149,446.494],[475.149,349.203]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[801.481,558.753],[801.481,450.899],[475.149,556.843],[475.149,459.553]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[801.481,576.746],[801.481,684.6],[475.149,573.074],[475.149,670.364]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[801.481,697.044],[801.481,804.898],[475.149,681.589],[475.149,778.88]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[801.481,821.314],[801.481,929.168],[475.149,793.688],[475.149,890.978]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[611.259,319.374],[611.259,221.431],[534.574,327.844],[534.574,233.673]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[729.888,311.071],[729.888,209.43],[611.258,319.374],[611.258,221.431]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[854.459,305.52],[854.459,201.407],[729.888,311.071],[729.888,209.43]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[929.042,430.214],[929.042,319.673],[789.717,432.086],[789.717,323.442]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[929.042,555.593],[929.042,445.052],[789.717,555.313],[789.717,446.669]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[929.042,574.034],[929.042,684.575],[789.717,573.437],[789.717,682.081]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[929.042,697.329],[929.042,807.87],[789.717,694.616],[789.717,803.26]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[931.364,828.251],[931.364,938.758],[784.056,822.95],[784.056,931.43]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[989.996,302.072],[989.996,196.423],[854.459,305.52],[854.459,201.407]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[929.042,430.214],[929.042,319.673],[976.698,433.53],[976.698,326.351]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[929.042,555.593],[929.042,445.052],[976.698,555.096],[976.698,447.917]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[929.042,574.034],[929.042,684.575],[976.698,572.976],[976.698,680.156]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[929.042,697.329],[929.042,807.87],[976.698,692.522],[976.698,799.701]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[931.364,828.251],[931.364,938.758],[978.741,819.501],[978.742,926.662]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1100.51,429.798],[1100.51,318.834],[976.698,433.53],[976.698,326.351]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1100.51,555.656],[1100.51,444.692],[976.698,555.096],[976.698,447.917]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1100.51,574.167],[1100.51,685.13],[976.698,572.976],[976.698,680.156]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1100.51,697.933],[1100.51,808.897],[976.698,692.522],[976.698,799.701]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1102.12,829.838],[1102.12,940.952],[969.832,819.256],[969.832,926.323]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1088.56,301.171],[989.996,302.072],[1088.56,195.121],[989.996,196.423]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1088.56,301.171],[1088.56,195.121],[1173.39,302.991],[1173.39,197.751]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1100.51,429.798],[1100.51,318.834],[1125.54,431.76],[1125.54,322.786]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1100.51,555.656],[1100.51,444.692],[1125.54,555.362],[1125.54,446.387]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1100.51,574.167],[1100.51,685.13],[1125.54,573.541],[1125.54,682.515]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1100.51,697.933],[1100.51,808.897],[1125.54,695.088],[1125.54,804.062]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1102.12,829.838],[1102.12,940.952],[1128.06,824.431],[1128.06,933.477]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1187.52,429.937],[1187.52,319.116],[1125.54,431.76],[1125.54,322.786]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1187.52,555.635],[1187.52,444.813],[1125.54,555.361],[1125.54,446.387]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1187.52,574.122],[1187.52,684.944],[1125.54,573.541],[1125.54,682.515]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1187.52,697.731],[1187.52,808.552],[1125.54,695.088],[1125.54,804.062]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1187.13,829.035],[1187.13,939.842],[1128.06,824.431],[1128.06,933.477]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1173.39,302.991],[1173.39,197.751],[1202.59,308.206],[1202.59,205.289]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1187.52,429.937],[1187.52,319.116],[1267.4,431.379],[1267.4,322.018]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1187.52,555.635],[1187.52,444.813],[1267.4,555.419],[1267.4,446.058]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1187.52,574.122],[1187.52,684.944],[1267.4,573.662],[1267.4,683.023]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1187.52,697.731],[1187.52,808.552],[1267.4,695.641],[1267.4,805.001]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1187.13,829.035],[1187.13,939.842],[1267.4,825.253],[1267.4,934.614]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1237.15,306.067],[1237.15,202.197],[1202.59,308.206],[1202.59,205.289]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1237.15,306.067],[1237.15,202.197],[1277.76,310.297],[1277.76,208.312]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1267.4,431.379],[1267.4,322.018],[1378.57,441.139],[1378.57,341.672]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1267.4,555.419],[1267.4,446.058],[1378.57,553.956],[1378.57,454.49]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1267.4,573.663],[1267.4,683.023],[1378.57,570.549],[1378.57,670.015]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1267.4,695.641],[1267.4,805.001],[1378.57,681.492],[1378.57,780.958]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1267.4,825.253],[1267.4,934.614],[1378.57,799.378],[1378.57,898.844]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1277.76,310.297],[1277.76,208.312],[1304.63,313.354],[1304.63,212.731]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1304.63,313.354],[1304.63,212.731],[1339.47,318.023],[1339.47,219.479]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1342.43,318.321],[1342.43,219.909],[1360.28,323.646],[1360.28,227.607]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1360.28,323.646],[1360.28,227.607],[1369.06,327.202],[1369.06,232.747]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1369.06,327.202],[1369.06,232.747],[1378.69,332.041],[1378.69,239.741]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1379.15,441.19],[1379.15,341.775],[1471.78,449.322],[1471.78,358.151]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1379.15,553.948],[1379.15,454.534],[1471.78,552.73],[1471.78,461.559]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1379.15,570.533],[1379.15,669.948],[1471.78,567.939],[1471.78,659.109]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1379.15,681.418],[1379.15,780.832],[1471.78,669.628],[1471.78,760.798]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:20,
                    verts:[[1379.52,799.155],[1379.52,898.537],[1472.09,777.609],[1472.09,868.751]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[384.748,450.783],[384.748,361.094],[341.487,451.815],[341.487,363.173]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[384.748,552.511],[384.748,462.822],[341.487,552.356],[341.487,463.714]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[384.748,567.473],[384.748,657.161],[341.487,567.144],[341.487,655.786]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[384.748,667.51],[384.748,757.198],[341.487,666.013],[341.487,754.656]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[383.799,773.741],[383.799,863.404],[342.595,771.135],[342.595,859.801]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[454.534,784.12],[454.534,877.752],[353.792,777.591],[353.792,868.726]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[449.934,447.085],[449.934,353.647],[355.841,449.383],[355.841,358.275]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[449.934,553.065],[449.934,459.627],[355.841,552.72],[355.841,461.613]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[449.934,568.652],[449.934,662.09],[355.841,567.919],[355.841,659.027]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[449.934,672.871],[449.934,766.309],[355.841,669.539],[355.841,760.647]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[468.766,440.477],[468.766,340.341],[399.211,444.431],[399.211,348.303]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[468.766,554.055],[468.766,453.919],[399.211,553.463],[399.211,457.334]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[468.766,570.76],[468.766,670.897],[399.211,569.499],[399.211,665.627]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[468.766,682.45],[468.766,782.586],[399.211,676.718],[399.211,772.847]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[474.408,801.568],[474.408,901.872],[400.18,790.482],[400.18,886.547]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[442.266,338.03],[442.266,248.399],[437.36,344.065],[437.36,257.121]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[473.246,331.763],[473.246,239.339],[442.266,338.03],[442.266,248.399]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[539.336,323.197],[539.336,226.958],[473.246,331.763],[473.246,239.339]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[851.366,435.211],[851.366,326.087],[490.905,444.194],[490.905,344.492]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[851.366,558.983],[851.366,449.859],[490.905,557.279],[490.905,457.577]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[851.366,577.187],[851.366,686.311],[490.905,573.912],[490.905,673.614]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[851.366,698.902],[851.366,808.026],[490.905,685.118],[490.905,784.82]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[851.366,824.635],[851.366,933.759],[490.905,799.995],[490.905,899.698]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[633.193,315.137],[633.193,215.307],[544.873,323.125],[544.873,226.851]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[763.585,307.751],[763.585,204.632],[633.193,315.137],[633.193,215.307]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[895.79,303.273],[895.79,198.158],[763.585,307.751],[763.585,204.632]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[988.544,830.177],[988.544,941.42],[835.242,826.49],[835.242,936.323]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[986.301,429.478],[986.301,318.19],[841.376,430.773],[841.376,320.798]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[986.301,555.703],[986.301,444.416],[841.376,555.509],[841.376,445.534]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[986.301,574.269],[986.301,685.556],[841.376,573.856],[841.376,683.831]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[986.301,698.397],[986.301,809.684],[841.376,696.52],[841.376,806.495]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1035.4,301.054],[1035.4,194.952],[895.79,303.273],[895.79,198.158]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[986.301,429.478],[986.301,318.19],[1025.83,433.019],[1025.83,325.322]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[986.301,555.703],[986.301,444.416],[1025.83,555.173],[1025.83,447.475]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[986.301,574.269],[986.301,685.556],[1025.83,573.139],[1025.83,680.837]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[986.301,698.397],[986.301,809.684],[1025.83,693.263],[1025.83,800.96]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[988.544,830.177],[988.544,941.42],[1027.82,820.833],[1027.82,928.504]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1157.92,429.793],[1157.92,318.825],[1025.83,433.019],[1025.83,325.322]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1157.92,555.656],[1157.92,444.688],[1025.83,555.173],[1025.83,447.475]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1157.92,574.168],[1157.92,685.137],[1025.83,573.139],[1025.83,680.837]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1157.92,697.94],[1157.92,808.908],[1025.83,693.263],[1025.83,800.96]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1159.86,829.833],[1159.86,940.945],[1018.7,820.684],[1018.7,928.297]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1035.4,301.054],[1134.28,301.066],[1035.4,194.952],[1134.28,194.969]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1134.28,301.066],[1134.28,194.969],[1216,303.666],[1216,198.727]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1157.92,429.793],[1157.92,318.825],[1177.84,431.863],[1177.84,322.993]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1157.92,555.656],[1157.92,444.688],[1177.84,555.346],[1177.84,446.476]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1157.92,574.168],[1157.92,685.137],[1177.84,573.508],[1177.84,682.378]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1157.92,697.94],[1157.92,808.908],[1177.84,694.939],[1177.84,803.809]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1159.86,829.833],[1159.86,940.945],[1180.5,824.13],[1180.5,933.062]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1243.28,430.302],[1243.28,319.849],[1177.84,431.863],[1177.84,322.993]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1243.28,555.58],[1243.28,445.128],[1177.84,555.346],[1177.84,446.476]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1243.28,574.006],[1243.28,684.459],[1177.84,573.508],[1177.84,682.378]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1243.28,697.202],[1243.28,807.655],[1177.84,694.939],[1177.84,803.809]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1242.85,828.074],[1242.85,938.513],[1180.5,824.13],[1180.5,933.062]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1216,303.666],[1216,198.727],[1239.1,309.134],[1239.1,206.631]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1275.25,307.312],[1275.25,203.996],[1239.1,309.134],[1239.1,206.631]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1243.28,430.302],[1243.28,319.849],[1317.94,432.072],[1317.94,323.415]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1243.28,555.58],[1243.28,445.128],[1317.94,555.315],[1317.94,446.657]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1243.28,574.006],[1243.28,684.459],[1317.94,573.441],[1317.94,682.099]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1243.28,697.202],[1243.28,807.655],[1317.94,694.635],[1317.94,803.293]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1242.85,828.074],[1242.85,938.513],[1317.94,823.415],[1317.94,932.072]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1275.25,307.312],[1275.25,203.997],[1310.42,311.882],[1310.42,210.603]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1310.42,311.882],[1310.42,210.603],[1333.34,315.155],[1333.34,215.333]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1317.94,432.072],[1317.94,323.415],[1402.36,442.199],[1402.36,343.808]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1317.94,555.315],[1317.94,446.657],[1402.36,553.797],[1402.36,455.406]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1317.94,573.441],[1317.94,682.099],[1402.36,570.211],[1402.36,668.602]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1317.94,694.635],[1317.94,803.293],[1402.36,679.954],[1402.36,778.345]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1317.94,823.415],[1317.94,932.072],[1402.36,796.566],[1402.36,894.957]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1333.34,315.155],[1333.34,215.333],[1362.26,320.087],[1362.26,222.463]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1364.81,320.407],[1364.81,222.925],[1376.48,325.836],[1376.48,230.772]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1376.48,325.836],[1376.48,230.772],[1381.22,329.431],[1381.22,235.969]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1381.22,329.431],[1381.22,235.969],[1385.41,334.301],[1385.41,243.008]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1402.8,442.252],[1402.8,343.914],[1472.58,450.621],[1472.58,360.769]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1402.8,553.789],[1402.8,455.452],[1472.58,552.535],[1472.58,462.682]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1402.8,570.194],[1402.8,668.532],[1472.58,567.524],[1472.58,657.377]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1402.8,679.878],[1402.8,778.216],[1472.58,667.744],[1472.58,757.597]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:21,
                    verts:[[1403.09,796.336],[1403.09,894.64],[1472.81,774.161],[1472.81,863.985]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[377.086,448.307],[377.086,356.107],[329.096,449.21],[329.096,357.927]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[377.086,552.882],[377.086,460.682],[329.096,552.746],[329.096,461.463]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[377.086,568.263],[377.086,660.462],[329.096,567.974],[329.096,659.258]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[377.086,671.1],[377.086,763.299],[329.096,669.79],[329.096,761.073]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[376.029,780.314],[376.029,872.491],[330.322,778.032],[330.322,869.336]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[459.735,790.271],[459.735,886.254],[348.223,784.572],[348.223,878.377]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[454.465,444.753],[454.465,348.95],[350.307,446.758],[350.307,352.99]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[454.465,553.414],[454.465,457.612],[350.307,553.114],[350.307,459.345]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[454.465,569.396],[454.465,665.199],[350.307,568.757],[350.307,662.525]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[454.465,676.252],[454.465,772.055],[350.307,673.344],[350.307,767.113]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[490.651,438.051],[490.651,335.455],[408.213,441.831],[408.213,343.066]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[490.651,554.419],[490.651,451.823],[408.213,553.852],[408.213,455.088]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[490.651,571.534],[490.651,674.13],[408.213,570.328],[408.213,669.093]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[490.651,685.968],[490.651,788.564],[408.213,680.489],[408.213,779.253]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[496.927,807.951],[496.927,910.695],[409.069,797.362],[409.069,896.058]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[437.042,332.878],[437.042,240.951],[425.263,339.03],[425.263,249.843]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[476.209,326.713],[476.209,232.039],[437.042,332.878],[437.042,240.951]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[554.154,318.523],[554.154,220.202],[476.209,326.713],[476.209,232.039]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[904.142,434.272],[904.142,324.162],[512.563,441.946],[512.563,339.886]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[904.142,559.161],[904.142,449.052],[512.563,557.706],[512.563,455.646]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[904.142,577.53],[904.142,687.639],[512.563,574.732],[512.563,676.792]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[904.142,700.344],[904.142,810.453],[512.563,688.567],[512.563,790.627]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[904.142,827.212],[904.142,937.322],[512.563,806.161],[512.563,908.221]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[659.642,311.146],[659.642,209.538],[559.961,318.498],[559.961,220.164]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[800.73,304.85],[800.73,200.438],[659.642,311.146],[659.642,209.538]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[939.029,301.565],[939.029,195.691],[800.73,304.85],[800.73,200.438]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1046.68,831.216],[889.628,829.271],[1046.68,942.857],[889.628,940.168]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1044.56,429.076],[1044.56,317.381],[896.157,429.749],[896.157,318.736]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1044.56,555.764],[1044.56,444.069],[896.157,555.663],[896.157,444.65]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1044.56,574.397],[1044.56,686.092],[896.157,574.182],[896.157,685.195]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1044.56,698.979],[1044.56,810.674],[896.157,698.004],[896.157,809.016]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1080.79,300.651],[939.029,301.565],[1080.79,194.369],[939.029,195.691]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1044.56,429.076],[1044.56,317.381],[1075.16,432.798],[1075.16,324.877]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1044.56,555.764],[1044.56,444.069],[1075.16,555.206],[1075.16,447.285]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1044.56,574.397],[1044.56,686.092],[1075.16,573.21],[1075.16,681.131]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1044.56,698.979],[1044.56,810.674],[1075.16,693.583],[1075.16,801.504]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1046.68,831.216],[1046.68,942.857],[1077.07,821.396],[1077.07,929.282]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1213.58,430.132],[1213.58,319.508],[1075.16,432.798],[1075.16,324.877]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1213.58,555.605],[1213.58,444.981],[1075.16,555.206],[1075.16,447.285]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1213.58,574.06],[1213.58,684.684],[1075.16,573.21],[1075.16,681.131]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1213.58,697.448],[1213.58,808.072],[1075.16,693.583],[1075.16,801.504]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1215.84,828.91],[1215.84,939.668],[1067.87,821.348],[1067.87,929.215]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1080.79,300.651],[1080.79,194.369],[1178.56,301.59],[1178.56,195.726]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1178.56,301.59],[1178.56,195.726],[1256.01,304.938],[1256.01,200.566]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1213.58,430.132],[1213.58,319.508],[1228.09,432.281],[1228.09,323.834]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1213.58,555.605],[1213.58,444.981],[1228.09,555.284],[1228.09,446.837]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1213.58,574.06],[1213.58,684.684],[1228.09,573.375],[1228.09,681.821]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1213.58,697.448],[1213.58,808.072],[1228.09,694.333],[1228.09,802.78]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1215.84,828.91],[1215.84,939.668],[1230.84,822.992],[1230.84,931.488]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1295.95,431.003],[1295.95,321.261],[1228.09,432.281],[1228.09,323.834]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1295.95,555.475],[1295.95,445.733],[1228.09,555.283],[1228.09,446.837]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1295.95,573.783],[1295.95,683.524],[1228.09,573.375],[1228.09,681.821]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1295.95,696.186],[1295.95,805.928],[1228.09,694.333],[1228.09,802.78]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1295.5,826.221],[1295.5,935.951],[1230.84,822.992],[1230.84,931.488]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1256.01,304.938],[1256.01,200.566],[1272.75,310.587],[1272.75,208.73]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1309.97,309.1],[1272.75,310.587],[1309.97,206.581],[1272.75,208.73]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1295.95,431.003],[1295.95,321.261],[1364.32,433.073],[1364.32,325.43]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1295.95,555.475],[1295.95,445.733],[1364.32,555.165],[1364.32,447.522]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1295.95,573.783],[1295.95,683.524],[1364.32,573.122],[1364.32,680.765]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1295.95,696.186],[1295.95,805.928],[1364.32,693.185],[1364.32,800.827]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1295.5,826.221],[1295.5,935.951],[1364.32,820.761],[1364.32,928.404]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1309.97,309.1],[1309.97,206.581],[1339.31,313.947],[1339.31,213.588]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1339.31,313.947],[1339.31,213.588],[1358.08,317.39],[1358.08,218.564]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1358.08,317.39],[1358.08,218.564],[1380.85,322.52],[1380.85,225.979]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1364.32,433.073],[1364.32,325.43],[1421.45,443.426],[1421.45,346.278]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1364.32,555.165],[1364.32,447.522],[1421.45,553.613],[1421.45,456.466]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1364.32,573.122],[1364.32,680.765],[1421.45,569.82],[1421.45,666.967]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1364.32,693.185],[1364.32,800.827],[1421.45,678.176],[1421.45,775.324]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1364.32,820.761],[1364.32,928.404],[1421.45,793.314],[1421.45,890.462]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1382.98,322.858],[1382.98,226.468],[1388.48,328.324],[1388.48,234.369]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1421.75,443.479],[1421.75,346.386],[1468.68,451.983],[1468.68,363.511]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1421.75,553.605],[1421.75,456.512],[1468.68,552.331],[1468.68,463.859]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1421.75,569.803],[1421.75,666.896],[1468.68,567.09],[1468.68,655.562]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1421.75,678.098],[1421.75,775.191],[1468.68,665.77],[1468.68,754.241]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:22,
                    verts:[[1421.94,793.08],[1421.94,890.138],[1468.84,770.549],[1468.84,858.992]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[322.152,446.539],[322.152,352.547],[318.232,449.337],[318.232,358.181]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[322.152,553.147],[322.152,459.155],[318.232,552.727],[318.232,461.572]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[322.152,568.827],[322.152,662.819],[318.232,567.934],[318.232,659.089]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[322.152,673.663],[322.152,767.655],[318.232,669.607],[318.232,760.762]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[323.493,785.105],[323.493,879.114],[319.163,777.677],[319.163,868.845]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[374.805,445.792],[374.805,351.044],[322.152,446.539],[322.152,352.547]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[374.805,553.259],[374.805,458.51],[322.152,553.147],[322.152,459.155]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[374.805,569.065],[374.805,663.813],[322.152,568.827],[322.152,662.819]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[374.805,674.745],[374.805,769.493],[322.152,673.663],[322.152,767.655]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[373.641,786.989],[373.641,881.718],[323.493,785.105],[323.493,879.114]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[470.507,796.335],[470.507,894.638],[348.571,791.65],[348.571,888.161]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[464.574,442.448],[464.574,344.31],[350.668,444.098],[350.668,347.632]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[464.574,553.76],[464.574,455.621],[350.668,553.512],[350.668,457.047]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[464.574,570.131],[464.574,668.27],[350.668,569.605],[350.668,666.071]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[464.574,679.593],[464.574,777.731],[350.668,677.201],[350.668,773.667]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[445.873,338.397],[445.873,248.928],[416.49,339.282],[416.49,250.208]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[436.756,327.691],[436.756,233.454],[417.625,333.896],[417.625,242.422]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[519.091,435.741],[519.091,330.802],[423.782,439.268],[423.782,337.906]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[519.091,554.765],[519.091,449.826],[423.782,554.236],[423.782,452.874]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[519.091,572.271],[519.091,677.21],[423.782,571.146],[423.782,672.508]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[519.091,689.317],[519.091,794.256],[423.782,684.203],[423.782,785.565]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[525.964,814.015],[525.964,919.078],[424.502,804.141],[424.502,905.429]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[484.355,321.722],[484.355,224.826],[436.756,327.691],[436.756,233.454]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[574.111,314.06],[574.111,213.75],[484.355,321.722],[484.355,224.826]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[958.935,433.657],[958.935,322.903],[540.446,439.813],[540.446,335.515]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[958.935,559.278],[958.935,448.523],[540.446,558.11],[540.446,453.813]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[958.935,577.754],[958.935,688.508],[540.446,575.509],[540.446,679.807]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[958.935,701.287],[958.935,812.041],[540.446,691.841],[540.446,796.138]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[958.935,828.898],[958.935,939.653],[540.446,812.013],[540.446,916.31]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[690.59,307.53],[690.59,204.313],[580.131,314.088],[580.131,213.789]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[840.916,302.489],[840.916,197.026],[690.59,307.53],[690.59,204.313]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[983.474,300.501],[983.474,194.153],[840.916,302.489],[840.916,197.026]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[946.318,831.137],[1104.62,831.256],[946.318,942.748],[1104.62,942.912]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[953.147,429.073],[1102.64,429.051],[953.147,317.375],[1102.64,317.331]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[953.147,555.764],[953.147,444.066],[1102.64,555.767],[1102.64,444.047]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[953.147,574.398],[1102.64,574.405],[953.147,686.096],[1102.64,686.125]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[953.147,698.983],[1102.64,699.015],[953.147,810.681],[1102.64,810.735]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[983.474,300.501],[1125.32,300.934],[983.474,194.153],[1125.32,194.779]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1102.64,429.051],[1102.64,317.331],[1123.74,432.902],[1123.74,325.085]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1102.64,555.767],[1102.64,444.047],[1123.74,555.19],[1123.74,447.374]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1102.64,574.405],[1102.64,686.125],[1123.74,573.177],[1123.74,680.993]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1102.64,699.015],[1102.64,810.735],[1123.74,693.433],[1123.74,801.249]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1104.62,831.256],[1104.62,942.912],[1125.54,821.1],[1125.54,928.873]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1266.32,430.837],[1266.32,320.927],[1123.74,432.902],[1123.74,325.085]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1266.32,555.5],[1266.32,445.59],[1123.74,555.19],[1123.74,447.374]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1266.32,573.835],[1266.32,683.745],[1123.74,573.177],[1123.74,680.993]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1266.32,696.426],[1266.32,806.336],[1123.74,693.433],[1123.74,801.249]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1125.32,300.934],[1125.32,194.779],[1220.53,302.791],[1220.53,197.462]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1268.85,827.014],[1268.85,937.047],[1116.4,821.156],[1116.4,928.949]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1220.53,302.791],[1220.53,197.462],[1292.63,306.833],[1292.63,203.304]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1266.32,430.837],[1266.32,320.927],[1275.22,433.031],[1275.22,325.345]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1266.32,555.5],[1266.32,445.59],[1275.22,555.171],[1275.22,447.485]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1266.32,573.835],[1266.32,683.745],[1275.22,573.136],[1275.22,680.821]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1266.32,696.426],[1266.32,806.336],[1275.22,693.246],[1275.22,800.931]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1268.85,827.014],[1268.85,937.047],[1278.03,820.972],[1278.03,928.695]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1344.41,432.05],[1344.41,323.37],[1275.22,433.031],[1275.22,325.345]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1344.41,555.318],[1344.41,446.638],[1275.22,555.171],[1275.22,447.485]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1344.41,573.448],[1344.41,682.128],[1275.22,573.135],[1275.22,680.821]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1344.41,694.667],[1344.41,803.347],[1275.22,693.246],[1275.22,800.931]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1343.95,823.448],[1278.03,820.972],[1343.95,932.119],[1278.03,928.695]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1292.63,306.833],[1292.63,203.304],[1302.86,312.582],[1302.86,211.615]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1340.63,311.444],[1302.86,312.582],[1340.63,209.969],[1302.86,211.615]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1340.63,311.444],[1340.63,209.969],[1363.89,316.496],[1363.89,217.272]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1344.41,432.05],[1344.41,323.37],[1405.58,434.382],[1405.58,328.066]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1344.41,555.318],[1344.41,446.638],[1405.58,554.969],[1405.58,448.653]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1344.41,573.448],[1344.41,682.128],[1405.58,572.705],[1405.58,679.02]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1344.41,694.667],[1344.41,803.347],[1405.58,691.287],[1405.58,797.603]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1343.95,823.448],[1343.95,932.119],[1405.58,817.291],[1405.58,923.607]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1363.89,316.496],[1363.89,217.272],[1378.37,320.06],[1378.37,222.424]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1378.37,320.06],[1378.37,222.424],[1394.89,325.317],[1394.89,230.022]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1405.58,434.382],[1405.58,328.066],[1435.5,444.813],[1435.5,349.073]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1405.58,554.969],[1405.58,448.653],[1435.5,553.405],[1435.5,457.665]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1405.58,572.705],[1405.58,679.021],[1435.5,569.377],[1435.5,665.118]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1405.58,691.287],[1405.58,797.603],[1435.5,676.164],[1435.5,771.905]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1405.58,817.291],[1405.58,923.607],[1435.5,789.635],[1435.5,885.375]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1435.65,444.867],[1435.65,349.181],[1460.13,453.402],[1460.13,366.368]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1435.65,553.397],[1435.65,457.711],[1460.13,552.118],[1460.13,465.085]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1435.65,569.36],[1435.65,665.046],[1460.13,566.637],[1460.13,653.671]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1435.65,676.086],[1435.65,771.772],[1460.13,663.713],[1460.13,750.746]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:23,
                    verts:[[1435.75,789.399],[1435.75,885.05],[1460.21,766.788],[1460.21,853.792]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[321.525,443.849],[321.525,347.13],[310.229,446.708],[310.229,352.888]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[321.525,553.55],[321.525,456.831],[310.229,553.121],[310.229,459.301]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[321.525,569.685],[321.525,666.404],[310.229,568.773],[310.229,662.593]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[321.525,677.563],[321.525,774.282],[310.229,673.418],[310.229,767.238]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[322.977,792.224],[322.977,888.954],[311.24,784.637],[311.24,878.467]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[378.646,443.291],[378.646,346.007],[321.525,443.849],[321.525,347.13]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[378.646,553.633],[378.646,456.349],[321.525,553.55],[321.525,456.831]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[378.646,569.863],[378.646,667.147],[321.525,569.685],[321.525,666.404]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[378.646,678.371],[378.646,775.656],[321.525,677.563],[321.525,774.282]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[377.381,793.632],[377.381,890.901],[322.977,792.224],[322.977,888.954]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[487.306,802.161],[487.306,902.692],[355.622,798.677],[355.622,897.875]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[480.735,440.23],[480.735,339.843],[357.705,441.457],[357.705,342.314]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[480.735,554.092],[480.735,453.705],[357.705,553.908],[357.705,454.765]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[480.735,570.839],[480.735,671.226],[357.705,570.448],[357.705,669.591]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[480.735,682.809],[480.735,783.196],[357.705,681.03],[357.705,780.173]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[439.51,333.603],[439.51,241.999],[407.899,334.261],[407.899,242.949]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[442.012,322.58],[442.012,226.066],[415.124,328.758],[415.124,234.996]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[498.138,316.913],[498.138,217.875],[442.012,322.58],[442.012,226.066]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[554.235,433.619],[554.235,326.529],[446.428,436.812],[446.428,332.959]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[554.235,555.083],[554.235,447.993],[446.428,554.604],[446.428,450.752]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[554.235,572.948],[554.235,680.038],[446.428,571.929],[446.428,675.782]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[554.235,692.393],[554.235,799.483],[446.428,687.764],[446.428,791.617]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[561.642,819.568],[561.642,926.755],[446.99,810.642],[446.99,914.415]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[599.362,309.941],[599.362,207.797],[498.138,316.913],[498.138,217.875]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1014.66,433.411],[1014.66,322.399],[574.665,437.862],[574.665,331.518]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1014.66,559.324],[1014.66,448.312],[574.665,558.48],[574.665,452.137]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1014.66,577.844],[1014.66,688.855],[574.665,576.221],[574.665,682.565]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1014.66,701.664],[1014.66,812.676],[574.665,694.834],[574.665,801.178]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1014.66,829.572],[1014.66,940.584],[574.665,817.364],[574.665,923.708]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[725.828,304.423],[725.828,199.821],[605.528,310.025],[605.528,207.917]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[883.542,300.783],[883.542,194.56],[725.828,304.423],[725.828,199.821]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1028.29,300.163],[883.542,300.783],[1028.29,193.663],[883.542,194.56]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1004.19,831.96],[1004.19,943.885],[1161.08,830.225],[1161.08,941.486]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1011.21,428.793],[1011.21,316.811],[1159.29,429.432],[1159.29,318.098]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1011.21,555.806],[1011.21,443.824],[1159.29,555.71],[1159.29,444.376]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1011.21,574.487],[1011.21,686.469],[1159.29,574.283],[1159.29,685.617]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1011.21,699.39],[1011.21,811.371],[1159.29,698.463],[1159.29,809.797]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1028.29,300.163],[1028.29,193.663],[1168.06,301.949],[1168.06,196.245]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1159.29,429.432],[1159.29,318.098],[1170.54,433.351],[1170.54,325.99]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1159.29,555.71],[1159.29,444.376],[1170.54,555.123],[1170.54,447.762]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1159.29,574.283],[1159.29,685.617],[1170.54,573.033],[1170.54,680.394]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1159.29,698.463],[1159.29,809.797],[1170.54,692.781],[1170.54,800.142]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1161.08,830.225],[1161.08,941.486],[1172.21,819.89],[1172.21,927.199]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1168.06,301.949],[1168.06,196.245],[1259.3,304.687],[1259.3,200.202]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1314.96,431.911],[1314.96,323.09],[1170.54,433.351],[1170.54,325.99]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1314.96,555.339],[1314.96,446.518],[1170.54,555.123],[1170.54,447.762]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1314.96,573.493],[1314.96,682.314],[1170.54,573.033],[1170.54,680.394]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1314.96,694.869],[1314.96,803.69],[1170.54,692.781],[1170.54,800.142]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1317.72,824.133],[1163.27,820.047],[1317.72,933.066],[1163.27,927.417]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1259.3,304.687],[1259.3,200.202],[1325.1,309.349],[1325.1,206.942]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1314.96,431.911],[1314.96,323.09],[1318.24,434.116],[1318.24,327.531]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1314.96,555.339],[1314.96,446.518],[1318.24,555.008],[1318.24,448.423]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1314.96,573.493],[1314.96,682.314],[1318.24,572.789],[1318.24,679.375]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1314.96,694.869],[1314.96,803.69],[1318.24,691.672],[1318.24,798.258]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1387.65,433.438],[1318.24,434.116],[1387.65,326.166],[1318.24,327.531]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1387.65,555.11],[1387.65,447.837],[1318.24,555.008],[1318.24,448.423]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1387.65,573.006],[1318.24,572.789],[1387.65,680.278],[1318.24,679.375]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1387.65,692.655],[1318.24,691.672],[1387.65,799.927],[1318.24,798.258]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1317.72,824.133],[1317.72,933.066],[1321.06,818.062],[1321.06,924.672]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1387.18,819.773],[1321.06,818.062],[1387.18,927.039],[1321.06,924.672]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1325.1,309.349],[1325.1,206.942],[1328.85,315.117],[1328.85,215.279]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1366.65,314.331],[1328.85,315.117],[1366.65,214.142],[1328.85,215.279]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1366.65,314.331],[1366.65,214.142],[1383.7,319.513],[1383.7,221.633]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1383.7,319.513],[1383.7,221.633],[1393.86,323.146],[1393.86,226.885]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1387.18,819.773],[1387.18,927.039],[1440.91,813.039],[1440.91,917.729]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1387.65,433.438],[1387.65,326.166],[1440.91,435.986],[1440.91,331.296]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1387.65,555.11],[1387.65,447.837],[1440.91,554.728],[1440.91,450.038]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1387.65,573.006],[1387.65,680.278],[1440.91,572.193],[1440.91,676.883]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1387.65,692.655],[1387.65,799.927],[1440.91,688.962],[1440.91,793.652]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1393.86,323.146],[1393.86,226.885],[1404.15,328.458],[1404.15,234.562]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1440.91,435.986],[1440.91,331.296],[1444.28,446.35],[1444.28,352.167]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1440.91,554.728],[1440.91,450.038],[1444.28,553.175],[1444.28,458.992]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1440.91,572.193],[1440.91,676.883],[1444.28,568.887],[1444.28,663.07]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1440.91,688.962],[1440.91,793.652],[1444.28,673.936],[1444.28,768.119]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1440.91,813.039],[1440.91,917.729],[1444.28,785.561],[1444.28,879.744]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1444.3,446.404],[1444.3,352.275],[1447.05,454.868],[1447.05,369.32]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1444.3,553.167],[1444.3,459.038],[1447.05,551.898],[1447.05,466.351]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1444.3,568.87],[1444.3,662.998],[1447.05,566.17],[1447.05,651.718]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:24,
                    verts:[[1444.3,673.859],[1444.3,767.987],[1447.05,661.588],[1447.05,747.136]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[328.014,441.198],[328.014,341.793],[308.771,444.083],[308.771,347.602]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[328.014,553.947],[328.014,454.541],[308.771,553.515],[308.771,457.034]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[328.014,570.53],[328.014,669.936],[308.771,569.61],[308.771,666.091]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[328.014,681.405],[328.014,780.811],[308.771,677.223],[308.771,773.704]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[329.567,799.236],[329.567,898.647],[309.859,791.586],[309.859,888.073]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[389.254,440.86],[389.254,341.112],[328.014,441.198],[328.014,341.793]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[389.254,553.998],[389.254,454.249],[328.014,553.947],[328.014,454.541]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[389.254,570.638],[389.254,670.386],[328.014,570.53],[328.014,669.936]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[389.254,681.895],[389.254,781.643],[328.014,681.405],[328.014,780.811]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[387.894,800.089],[387.894,899.827],[329.567,799.236],[329.567,898.647]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[510.418,807.583],[510.418,910.187],[370.044,805.485],[370.044,907.286]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[503.255,438.16],[503.255,335.674],[372.083,438.899],[372.083,337.163]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[503.255,554.402],[503.255,451.917],[372.083,554.292],[372.083,452.555]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[503.255,571.499],[503.255,673.985],[372.083,571.264],[372.083,673]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[503.255,685.81],[503.255,788.295],[372.083,684.738],[372.083,786.474]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[438.301,328.885],[438.301,235.18],[404.641,329.281],[404.641,235.752]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[453.316,317.668],[453.316,218.966],[418.379,323.727],[418.379,227.724]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[517.861,312.418],[517.861,211.377],[453.316,317.668],[453.316,218.966]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[595.945,431.76],[595.945,322.786],[476.443,434.534],[476.443,328.373]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[595.945,555.361],[595.945,446.388],[476.443,554.946],[476.443,448.784]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[595.945,573.541],[595.945,682.515],[476.443,572.656],[476.443,678.818]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[595.945,695.088],[595.945,804.062],[476.443,691.066],[476.443,797.228]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[603.802,824.412],[603.802,933.451],[476.827,816.67],[476.827,922.749]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[629.867,306.3],[629.867,202.535],[517.861,312.418],[517.861,211.377]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1070.11,433.564],[1070.11,322.712],[615.061,436.162],[615.061,328.036]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1070.11,559.295],[1070.11,448.443],[615.061,558.803],[615.061,450.676]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1070.11,577.788],[1070.11,688.64],[615.061,576.841],[615.061,684.967]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1070.11,701.43],[1070.11,812.282],[615.061,697.443],[615.061,805.569]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1070.11,829.154],[1070.11,940.006],[615.061,822.026],[615.061,930.153]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[764.931,301.946],[764.931,196.241],[636.095,306.445],[636.095,202.742]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[927.837,299.823],[927.837,193.171],[764.931,301.946],[764.931,196.241]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[927.837,299.823],[1072.54,300.604],[927.837,193.171],[1072.54,194.301]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1061.98,831.654],[1061.98,943.461],[1214.77,828.097],[1214.77,938.545]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1069.06,428.94],[1069.06,317.107],[1213.2,430.228],[1213.2,319.7]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1069.06,555.784],[1069.06,443.951],[1213.2,555.591],[1213.2,445.064]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1069.06,574.44],[1069.06,686.273],[1213.2,574.03],[1213.2,684.557]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1069.06,699.176],[1069.06,811.009],[1213.2,697.31],[1213.2,807.837]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1072.54,300.604],[1072.54,194.301],[1208.1,303.708],[1208.1,198.788]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1208.1,303.708],[1208.1,198.788],[1294.08,307.266],[1294.08,203.93]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1213.2,430.228],[1213.2,319.7],[1214.55,434.152],[1214.55,327.604]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1213.2,555.591],[1213.2,445.064],[1214.55,555.003],[1214.55,448.454]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1213.2,574.03],[1213.2,684.557],[1214.55,572.778],[1214.55,679.326]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1213.2,697.31],[1213.2,807.837],[1214.55,691.62],[1214.55,798.168]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1214.55,434.152],[1358.47,433.341],[1214.55,327.604],[1358.47,325.971]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1214.55,555.003],[1214.55,448.454],[1358.47,555.124],[1358.47,447.754]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1214.55,572.778],[1358.47,573.036],[1214.55,679.326],[1358.47,680.407]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1214.55,691.62],[1358.47,692.795],[1214.55,798.168],[1358.47,800.166]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1214.77,828.097],[1214.77,938.545],[1216.06,817.748],[1216.05,924.239]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1207.46,818.004],[1361.41,820.305],[1207.46,924.592],[1361.41,927.774]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1294.08,307.266],[1294.08,203.93],[1352.82,312.458],[1352.82,211.435]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1350.25,318.163],[1387.57,317.724],[1350.25,219.681],[1387.57,219.046]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1356.25,435.523],[1424.8,435.145],[1356.25,330.365],[1424.8,329.603]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1356.25,554.797],[1356.25,449.639],[1424.8,554.854],[1424.8,449.312]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1356.25,572.34],[1356.25,677.499],[1424.8,572.461],[1424.8,678.003]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1356.25,689.632],[1424.8,690.181],[1356.25,794.791],[1424.8,795.723]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1359.04,814.299],[1424.33,815.254],[1359.04,919.471],[1424.33,920.791]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1387.57,317.724],[1387.57,219.046],[1398.45,322.959],[1398.45,226.613]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1398.45,322.959],[1398.45,226.613],[1404.33,326.61],[1404.33,231.891]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1404.33,326.61],[1404.33,231.891],[1408.55,331.906],[1408.55,239.546]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1424.33,815.254],[1424.33,920.791],[1469.69,808.076],[1469.69,910.868]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1424.8,435.145],[1424.8,329.603],[1469.69,437.858],[1469.69,335.066]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1424.8,554.854],[1424.8,449.312],[1469.69,554.448],[1469.69,451.656]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1424.8,572.461],[1424.8,678.003],[1469.69,571.596],[1469.69,674.388]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:25,
                    verts:[[1424.8,690.181],[1424.8,795.723],[1469.69,686.248],[1469.69,789.04]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[342.266,438.652],[342.266,336.665],[314.62,441.52],[314.62,342.44]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[342.266,554.329],[342.266,452.342],[314.62,553.899],[314.62,454.819]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[342.266,571.343],[342.266,673.33],[314.62,570.428],[314.62,669.508]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[342.266,685.097],[342.266,787.084],[314.62,680.939],[314.62,780.019]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[343.909,805.97],[343.909,907.957],[315.776,798.372],[315.776,897.453]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[407.101,438.563],[407.101,336.487],[342.266,438.652],[342.266,336.665]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[407.101,554.342],[407.101,452.265],[342.266,554.329],[342.266,452.342]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[407.101,571.371],[407.101,673.448],[342.266,571.343],[342.266,673.33]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[407.101,685.225],[407.101,787.302],[342.266,685.097],[342.266,787.084]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[405.658,806.193],[405.658,908.266],[343.909,805.97],[343.909,907.957]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[539.904,812.436],[539.904,916.895],[392.304,811.89],[392.304,916.141]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[532.219,436.301],[532.219,331.931],[394.265,436.493],[394.265,332.318]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[532.219,554.681],[532.219,450.311],[394.265,554.652],[394.265,450.477]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[532.219,572.092],[532.219,676.463],[394.265,572.031],[394.265,676.207]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[532.219,688.505],[532.219,792.875],[394.265,688.226],[394.265,792.402]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[442.753,324.349],[407.301,324.452],[442.753,228.623],[407.301,228.772]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[471.007,313.085],[471.007,212.342],[427.888,318.922],[427.888,220.779]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[543.628,308.369],[543.628,205.525],[471.007,313.085],[471.007,212.342]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[643.763,430.235],[643.763,319.715],[513.833,432.509],[513.833,324.295]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[643.763,555.59],[643.763,445.07],[513.833,555.249],[513.833,447.035]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[643.763,574.027],[643.763,684.547],[513.833,573.302],[513.833,681.516]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[643.763,697.299],[643.763,807.819],[513.833,694.002],[513.833,802.217]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[651.958,828.364],[651.958,938.914],[514.018,822.032],[514.018,930.16]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[665.352,303.265],[665.352,198.148],[543.628,308.369],[543.628,205.525]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1123.98,434.124],[1123.98,323.86],[661.172,434.777],[661.172,325.198]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1123.98,559.189],[1123.98,448.925],[661.172,559.065],[661.172,449.486]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1123.98,577.584],[1123.98,687.848],[661.172,577.346],[661.172,686.925]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1123.98,700.57],[1123.98,810.834],[661.172,699.568],[661.172,809.147]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1123.98,827.616],[1123.98,937.88],[661.172,825.825],[661.172,935.404]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[807.263,300.203],[807.263,193.722],[671.55,303.472],[671.55,198.444]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[972.893,299.67],[807.263,300.203],[972.893,192.95],[807.263,193.722]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[972.893,299.67],[972.893,192.95],[1115.28,301.842],[1115.28,196.09]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1115.28,301.842],[1115.28,196.09],[1244.61,306.19],[1244.61,202.375]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1118.32,830.185],[1118.32,941.431],[1264.47,824.903],[1264.47,934.13]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1125.35,429.526],[1125.35,318.287],[1263.14,431.427],[1263.14,322.115]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1125.35,555.696],[1125.35,444.457],[1263.14,555.411],[1263.14,446.1]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1125.35,574.254],[1125.35,685.493],[1263.14,573.647],[1263.14,682.959]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1125.35,698.327],[1125.35,809.566],[1263.14,695.571],[1263.14,804.883]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1244.61,306.19],[1244.61,202.375],[1324.22,310.482],[1324.22,208.579]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1254.83,435.295],[1254.83,329.904],[1396.02,435.098],[1396.02,329.508]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1254.83,554.832],[1254.83,449.441],[1396.02,554.861],[1396.02,449.271]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1254.83,572.413],[1254.83,677.804],[1396.02,572.476],[1396.02,678.066]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1254.83,689.964],[1254.83,795.355],[1396.02,690.249],[1396.02,795.839]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1248.03,815.052],[1248.03,920.512],[1399.08,815.611],[1399.08,921.284]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1324.22,310.482],[1324.22,208.579],[1375.34,316.103],[1375.34,216.704]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1366.76,321.668],[1403.14,321.562],[1366.76,224.748],[1403.14,224.595]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1388.58,437.224],[1388.58,333.79],[1455.27,437.133],[1455.27,333.606]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1388.58,554.543],[1388.58,451.108],[1455.27,554.556],[1455.27,451.029]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1388.58,571.798],[1388.58,675.233],[1455.27,571.827],[1455.27,675.354]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1388.58,687.167],[1388.58,790.601],[1455.27,687.299],[1455.27,790.825]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1391.29,809.759],[1454.81,809.989],[1391.29,913.195],[1454.81,913.512]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1403.14,321.562],[1403.14,224.595],[1407.99,326.775],[1407.99,232.13]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1407.99,326.775],[1407.99,232.13],[1409.74,330.395],[1409.74,237.363]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1455.27,437.133],[1455.27,333.606],[1491.58,439.959],[1491.58,339.296]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1455.27,554.556],[1455.27,451.029],[1491.58,554.133],[1491.58,453.471]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1455.27,571.827],[1455.27,675.354],[1491.58,570.926],[1491.58,671.588]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1455.27,687.299],[1455.27,790.825],[1491.58,683.202],[1491.58,783.864]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:26,
                    verts:[[1454.81,809.989],[1454.81,913.512],[1491.58,802.506],[1491.58,903.168]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[364.697,436.277],[364.697,331.883],[328.351,439.079],[328.351,337.524]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[364.697,554.685],[364.697,450.29],[328.351,554.265],[328.351,452.71]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[364.697,572.1],[364.697,676.495],[328.351,571.206],[328.351,672.761]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[364.697,688.539],[364.697,792.934],[328.351,684.478],[328.351,786.032]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[366.411,812.247],[366.411,916.634],[329.565,804.83],[329.565,906.381]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[432.417,436.464],[432.417,332.259],[364.697,436.277],[364.697,331.883]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[432.417,554.656],[432.417,450.452],[364.697,554.685],[364.697,450.29]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[432.417,572.04],[432.417,676.245],[364.697,572.1],[364.697,676.495]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[432.417,688.268],[432.417,792.473],[364.697,688.539],[364.697,792.934]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[430.907,811.775],[366.411,812.247],[430.907,915.981],[366.411,916.634]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[411.924,325.13],[411.924,229.751],[410.512,328.776],[410.512,235.023]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[416.319,319.886],[416.319,222.171],[411.924,325.13],[411.924,229.751]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[453.225,320.103],[416.319,319.886],[453.225,222.486],[416.319,222.171]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[575.548,816.562],[575.548,922.599],[422.589,817.706],[422.589,924.18]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[567.433,434.712],[567.433,328.731],[424.436,434.309],[424.436,327.92]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[567.433,554.919],[567.433,448.938],[424.436,554.979],[424.436,448.59]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[567.433,572.599],[567.433,678.58],[424.436,572.728],[424.436,679.117]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[567.433,690.808],[567.433,796.789],[424.436,691.392],[424.436,797.782]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[495.203,308.961],[495.203,206.38],[443.968,314.465],[443.968,214.337]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[575.293,304.894],[575.293,200.502],[495.203,308.961],[495.203,206.38]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[696.886,429.103],[696.886,317.434],[558.254,430.806],[558.254,320.866]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[696.886,555.76],[696.886,444.092],[558.254,555.504],[558.254,445.564]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[696.886,574.389],[696.886,686.057],[558.254,573.845],[558.254,683.786]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[696.886,698.941],[696.886,810.609],[558.254,696.471],[558.254,806.411]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[705.289,831.268],[705.289,942.929],[558.228,826.542],[558.228,936.395]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[705.296,300.943],[705.296,194.791],[575.293,304.894],[575.293,200.502]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[851.995,299.268],[851.995,192.37],[711.367,301.211],[711.367,195.176]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[712.218,433.761],[712.218,323.116],[1175.06,435.083],[1175.06,325.824]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[712.218,559.258],[712.218,448.613],[1175.06,559.007],[1175.06,449.749]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[712.218,577.716],[712.218,688.361],[1175.06,577.234],[1175.06,686.493]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[712.218,701.127],[712.218,811.772],[1175.06,699.099],[1175.06,808.357]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[712.218,828.613],[712.218,939.257],[1175.06,824.987],[1175.06,934.245]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[851.995,299.268],[1017.73,300.349],[851.995,192.37],[1017.73,193.933]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1017.73,300.349],[1017.73,193.933],[1155.59,303.858],[1155.59,199.004]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1155.59,303.858],[1155.59,199.004],[1276.9,309.339],[1276.9,206.926]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1178.76,430.539],[1178.76,320.327],[1308.08,432.999],[1308.08,325.28]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1178.76,555.544],[1178.76,445.333],[1308.08,555.176],[1308.08,447.458]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1178.76,573.93],[1178.76,684.142],[1308.08,573.146],[1308.08,680.864]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1178.76,696.858],[1178.76,807.07],[1308.08,693.292],[1308.08,801.011]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1171.9,827.58],[1171.9,937.83],[1309.17,820.726],[1309.17,928.355]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1276.9,309.339],[1276.9,206.926],[1349.24,314.263],[1349.24,214.045]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1290.6,436.751],[1290.6,332.837],[1427.03,437.136],[1427.03,333.611]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1290.6,554.614],[1290.6,450.699],[1427.03,554.556],[1427.03,451.032]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1290.6,571.949],[1290.6,675.863],[1427.03,571.826],[1427.03,675.35]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1290.6,687.853],[1290.6,791.767],[1427.03,687.295],[1427.03,790.819]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1284.18,811.262],[1284.18,915.272],[1430.16,810.17],[1430.16,913.762]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1349.24,314.263],[1349.24,214.045],[1392.42,320.205],[1392.42,222.632]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1378.25,325.561],[1413.27,325.768],[1378.25,230.375],[1413.27,230.674]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1414.76,439.177],[1414.76,337.723],[1478.72,439.354],[1478.72,338.078]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1414.76,554.25],[1414.76,452.795],[1478.72,554.223],[1478.72,452.948]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1414.76,571.175],[1414.76,672.629],[1478.72,571.119],[1478.72,672.394]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1414.76,684.335],[1414.76,785.79],[1478.72,684.079],[1478.72,785.355]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1417.36,804.552],[1417.36,905.997],[1478.27,804.106],[1478.27,905.38]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1478.27,804.106],[1478.27,905.38],[1506.5,796.455],[1506.5,894.804]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1478.72,439.354],[1478.72,338.078],[1506.5,442.241],[1506.5,343.892]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1478.72,554.223],[1478.72,452.948],[1506.5,553.791],[1506.5,455.442]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1478.72,571.119],[1478.72,672.394],[1506.5,570.198],[1506.5,668.546]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:27,
                    verts:[[1478.72,684.079],[1478.72,785.355],[1506.5,679.894],[1506.5,778.242]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[395.418,434.141],[395.418,327.581],[350.293,436.823],[350.293,332.982]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[395.418,555.005],[395.418,448.444],[350.293,554.603],[350.293,450.762]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[395.418,572.781],[395.418,679.342],[350.293,571.926],[350.293,675.767]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[395.418,691.636],[395.418,798.197],[350.293,687.748],[350.293,791.589]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[397.181,817.891],[397.181,924.436],[351.551,810.796],[351.551,914.629]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[465.138,434.623],[395.418,434.141],[465.138,328.552],[395.418,327.581]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[465.138,554.932],[465.138,448.861],[395.418,555.005],[395.418,448.444]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[465.138,572.628],[465.138,678.699],[395.418,572.781],[395.418,679.342]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[465.138,690.937],[395.418,691.636],[465.138,797.008],[395.418,798.197]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[463.581,816.673],[397.181,817.891],[463.581,922.752],[397.181,924.436]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[415.813,324.634],[415.813,229.035],[412.061,329.98],[412.061,236.763]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[421.425,320.957],[421.425,223.719],[415.814,324.634],[415.814,229.035]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[431.941,315.693],[431.941,216.111],[421.424,320.957],[421.424,223.719]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[469.886,316.252],[431.941,315.692],[469.886,216.92],[431.941,216.111]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[616.851,819.83],[460.752,822.756],[616.851,927.117],[460.752,931.162]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[608.419,433.445],[462.446,432.413],[608.419,326.178],[462.446,324.102]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[608.419,555.109],[608.419,447.843],[462.446,555.264],[462.446,446.952]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[608.419,573.004],[462.446,573.332],[608.419,680.27],[462.446,681.644]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[608.419,692.646],[462.446,694.141],[608.419,799.912],[462.446,802.453]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[525.764,305.412],[525.764,201.25],[466.707,310.474],[466.707,208.568]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[612.45,302.098],[612.45,196.461],[525.764,305.412],[525.764,201.25]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[754.211,428.405],[754.211,316.03],[609.011,429.484],[609.011,318.203]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[754.211,555.864],[754.211,443.489],[609.011,555.703],[609.011,444.421]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[754.211,574.611],[754.211,686.986],[609.011,574.267],[609.011,685.548]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[754.211,699.951],[754.211,812.326],[609.011,698.387],[609.011,809.668]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[762.678,833.016],[762.678,945.345],[608.764,830.047],[608.764,941.24]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[748.956,299.413],[748.956,192.579],[612.45,302.098],[612.45,196.461]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[898.162,299.178],[898.162,192.239],[754.797,299.739],[754.797,193.048]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[767.142,433.151],[767.142,321.866],[1222.24,436.41],[1222.24,328.543]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[767.142,559.374],[767.142,448.089],[1222.24,558.756],[1222.24,450.889]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[767.142,577.938],[767.142,689.223],[1222.24,576.75],[1222.24,684.617]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[767.142,702.063],[767.142,813.348],[1222.24,697.063],[1222.24,804.93]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[767.142,830.285],[767.142,941.57],[1222.24,821.347],[1222.24,929.214]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[898.162,299.178],[898.162,192.239],[1061.36,301.845],[1061.36,196.095]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1061.36,301.845],[1061.36,196.095],[1192.66,306.596],[1192.66,202.961]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1192.66,306.596],[1192.66,202.961],[1304.48,313.069],[1304.48,212.318]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1228.14,431.947],[1228.14,323.163],[1347.23,434.895],[1347.23,329.099]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1228.14,555.333],[1228.14,446.549],[1347.23,554.892],[1347.23,449.096]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1228.14,573.481],[1228.14,682.265],[1347.23,572.541],[1347.23,678.337]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1228.14,694.816],[1228.14,803.6],[1347.23,690.543],[1347.23,796.339]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1221.56,823.922],[1221.56,932.773],[1348.06,815.692],[1348.06,921.396]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1304.48,313.069],[1304.48,212.318],[1368.91,318.513],[1368.91,220.188]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1321.3,438.481],[1321.3,336.32],[1451.23,439.399],[1451.23,338.169]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1321.3,554.354],[1321.3,452.194],[1451.23,554.217],[1451.23,452.987]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1321.3,571.397],[1321.3,673.558],[1451.23,571.104],[1451.23,672.334]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1321.3,685.345],[1321.3,787.505],[1451.23,684.014],[1451.23,785.244]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1315.33,806.738],[1315.33,909.018],[1454.37,804.131],[1454.37,905.415]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1368.91,318.513],[1368.91,220.188],[1404.02,324.667],[1404.02,229.082]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1384.77,329.758],[1384.77,236.442],[1418.1,330.25],[1418.1,237.152]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1434.61,441.332],[1434.61,342.062],[1495.13,441.751],[1495.13,342.905]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1434.61,553.927],[1434.61,454.657],[1495.13,553.864],[1495.13,455.019]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1434.61,570.488],[1434.61,669.758],[1495.13,570.354],[1495.13,669.2]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1434.61,681.211],[1434.61,780.482],[1495.13,680.604],[1495.13,779.45]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1437.07,798.813],[1437.07,898.064],[1494.71,797.756],[1494.71,896.602]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1495.13,441.751],[1495.13,342.905],[1514.61,444.651],[1514.61,348.746]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1495.13,553.864],[1495.13,455.019],[1514.61,553.43],[1514.61,457.524]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1495.13,570.354],[1495.13,669.2],[1514.61,569.429],[1514.61,665.334]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1495.13,680.604],[1495.13,779.45],[1514.61,676.399],[1514.61,772.305]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:28,
                    verts:[[1494.71,797.756],[1494.71,896.602],[1514.61,790.065],[1514.61,885.97]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[379.047,445.383],[379.047,350.22],[377.896,453.967],[377.896,367.505]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[379.047,553.32],[379.047,458.157],[377.896,552.034],[377.896,465.572]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[379.047,569.195],[379.047,664.358],[377.896,566.457],[377.896,652.918]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[379.047,675.338],[379.047,770.501],[377.896,662.894],[377.896,749.355]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[380.464,434.812],[380.464,328.932],[379.054,445.329],[379.054,350.111]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[380.464,554.904],[380.464,449.024],[379.054,553.328],[379.054,458.11]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[380.464,572.567],[380.464,678.448],[379.054,569.213],[379.054,664.43]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[380.464,690.664],[380.464,796.544],[379.054,675.417],[379.054,770.635]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[434.193,432.303],[434.193,323.879],[380.464,434.812],[380.464,328.932]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[434.193,555.28],[434.193,446.857],[380.464,554.904],[380.464,449.024]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[434.193,573.368],[434.193,681.791],[380.464,572.567],[380.464,678.448]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[434.193,694.301],[434.193,802.725],[380.464,690.664],[380.464,796.544]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[381.748,816.115],[381.748,921.981],[380.21,788.238],[380.21,883.444]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[435.978,822.743],[435.978,931.144],[381.748,816.115],[381.748,921.981]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[427.358,320.837],[427.358,223.546],[417.398,326.197],[417.398,231.294]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[437.339,317.18],[437.339,218.261],[427.358,320.837],[427.358,223.546]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[434.193,432.303],[504.879,433.093],[434.193,323.879],[504.879,325.47]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[434.193,555.28],[434.193,446.857],[504.879,555.162],[504.879,447.539]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[434.193,573.368],[504.879,573.116],[434.193,681.791],[504.879,680.739]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[434.193,694.301],[504.879,693.156],[434.193,802.724],[504.879,800.779]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[435.978,822.743],[503.298,820.749],[435.978,931.144],[503.298,928.387]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[454.178,311.974],[454.178,210.735],[437.338,317.18],[437.338,218.261]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[454.178,311.974],[492.678,312.89],[454.178,210.735],[492.678,212.059]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[495.934,307.051],[495.934,203.619],[492.678,312.89],[492.679,212.059]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[562.278,302.535],[562.278,197.093],[495.934,307.051],[495.934,203.619]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[506.284,826.892],[506.284,936.879],[503.298,820.749],[503.298,928.387]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[507.788,430.861],[507.788,320.976],[504.879,433.093],[504.879,325.47]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[507.788,555.496],[507.788,445.611],[504.879,555.162],[504.879,447.539]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[507.788,573.828],[507.788,683.713],[504.879,573.116],[504.879,680.739]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[507.788,696.391],[507.788,806.276],[504.879,693.156],[504.879,800.779]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[506.284,826.892],[663.041,822.146],[506.284,936.879],[663.041,930.318]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[507.788,430.861],[507.788,320.976],[654.42,432.534],[654.42,324.346]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[507.788,555.496],[507.788,445.611],[654.42,555.245],[654.42,447.057]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[507.788,573.828],[507.788,683.713],[654.42,573.294],[654.42,681.483]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[507.788,696.391],[507.788,806.276],[654.42,693.965],[654.42,802.154]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[654.437,300.061],[654.437,193.516],[562.278,302.535],[562.278,197.093]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[795.405,298.715],[795.405,191.571],[654.437,300.061],[654.437,193.516]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[665.077,428.585],[665.077,316.392],[654.42,432.534],[654.42,324.346]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[665.077,555.837],[665.077,443.644],[654.42,555.245],[654.42,447.057]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[665.077,574.554],[665.077,686.747],[654.42,573.294],[654.42,681.483]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[665.077,699.691],[665.077,811.885],[654.42,693.965],[654.42,802.154]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[664.606,832.435],[664.606,944.542],[654.016,822.021],[654.016,930.146]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[822.786,833.555],[822.786,946.091],[664.606,832.435],[664.606,944.542]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[814.405,428.164],[814.405,315.545],[665.077,428.585],[665.077,316.392]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[814.405,555.9],[814.405,443.281],[665.077,555.837],[665.077,443.644]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[814.405,574.688],[814.405,687.307],[665.077,574.554],[665.077,686.747]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[814.405,700.301],[814.405,812.92],[665.077,699.691],[665.077,811.885]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[800.92,299.096],[944.735,299.927],[800.92,192.119],[944.735,193.322]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[824.681,432.965],[824.681,321.485],[1264.66,438.058],[1264.66,331.92]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[824.681,559.409],[824.681,447.929],[1264.66,558.443],[1264.66,452.305]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[824.681,578.006],[824.681,689.486],[1264.66,576.149],[1264.66,682.287]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[824.681,702.348],[824.681,813.828],[1264.66,694.533],[1264.66,800.671]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[824.681,830.796],[824.681,942.275],[1264.66,816.826],[1264.66,922.963]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[944.735,299.927],[944.735,193.322],[1102.87,304.103],[1102.87,199.359]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1102.88,304.103],[1102.88,199.359],[1225.86,309.967],[1225.86,207.834]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1225.86,309.967],[1225.86,207.834],[1327.07,317.274],[1327.07,218.397]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1266.35,819.341],[1266.35,926.441],[1380.67,809.963],[1380.67,913.476]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1272.55,433.701],[1272.55,326.695],[1380.09,437.055],[1380.09,333.45]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1272.55,555.071],[1272.55,448.064],[1380.09,554.568],[1380.09,450.962]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1272.55,572.922],[1272.55,679.928],[1380.09,571.852],[1380.09,675.457]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1272.55,692.274],[1272.55,799.28],[1380.09,687.411],[1380.09,791.017]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1327.07,317.274],[1327.07,218.397],[1383.2,323.121],[1383.2,226.848]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1346.59,440.433],[1346.59,340.251],[1468.63,441.826],[1468.63,343.056]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1346.59,554.062],[1346.59,453.88],[1468.63,553.853],[1468.63,455.083]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1346.59,570.774],[1346.59,670.956],[1468.63,570.33],[1468.63,669.1]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1346.59,682.515],[1346.59,782.696],[1468.63,680.496],[1468.63,779.266]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1341.14,801.615],[1341.14,901.937],[1471.75,797.661],[1471.75,896.47]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1383.2,323.121],[1383.2,226.848],[1410.32,329.384],[1410.32,235.901]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1386.54,334.166],[1386.54,242.812],[1417.9,334.912],[1417.9,243.891]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1448.2,443.632],[1448.2,346.694],[1504.74,444.264],[1504.74,347.966]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1448.2,553.582],[1448.2,456.644],[1504.74,553.488],[1504.74,457.19]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1448.2,569.754],[1448.2,666.692],[1504.74,569.552],[1504.74,665.85]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1448.2,677.877],[1448.2,774.815],[1504.74,676.961],[1504.74,773.259]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1450.5,792.692],[1450.5,889.602],[1504.34,791.097],[1504.34,887.397]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1504.74,444.264],[1504.74,347.966],[1516.32,447.136],[1516.32,353.749]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1504.74,553.488],[1504.74,457.19],[1516.32,553.057],[1516.32,459.671]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1504.74,569.552],[1504.74,665.85],[1516.32,568.636],[1516.32,662.023]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1504.74,676.961],[1504.74,773.259],[1516.32,672.798],[1516.32,766.184]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:29,
                    verts:[[1504.34,791.097],[1504.34,887.397],[1516.32,783.478],[1516.32,876.865]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[389.756,443.723],[389.756,346.877],[366.332,452.372],[366.332,364.294]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[389.756,553.569],[389.756,456.723],[366.332,552.272],[366.332,464.195]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[389.756,569.725],[389.756,666.571],[366.332,566.966],[366.332,655.044]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[389.756,677.745],[389.756,774.591],[366.332,665.206],[366.332,753.284]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[418.542,433.094],[418.542,325.473],[389.904,443.668],[389.904,346.767]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[418.542,555.161],[418.542,447.54],[389.904,553.577],[389.904,456.676]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[418.542,573.115],[418.542,680.736],[389.904,569.742],[389.904,666.644]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[418.542,693.154],[418.542,800.775],[389.904,677.824],[389.904,774.725]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[419.835,820.653],[419.835,928.254],[391.073,792.628],[391.073,889.514]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[480.424,430.811],[480.424,320.876],[418.542,433.094],[418.542,325.473]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[480.424,555.504],[480.424,445.568],[418.542,555.161],[418.542,447.54]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[480.424,573.843],[480.424,683.779],[418.542,573.115],[418.542,680.736]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[480.424,696.463],[480.424,806.399],[418.542,693.154],[418.542,800.775]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[482.203,826.676],[482.203,936.581],[419.835,820.653],[419.835,928.254]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[445.139,317.462],[445.139,218.668],[428.784,322.761],[428.784,226.328]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[459.569,313.88],[459.569,213.491],[445.14,317.462],[445.14,218.668]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[482.79,308.812],[482.79,206.165],[459.569,313.88],[459.569,213.491]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[480.424,430.811],[480.424,320.876],[550.937,431.911],[550.937,323.09]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[480.424,555.504],[480.424,445.568],[550.937,555.339],[550.937,446.518]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[480.424,573.843],[480.424,683.779],[550.937,573.493],[550.937,682.314]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[480.424,696.463],[480.424,806.399],[550.937,694.869],[550.937,803.69]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[482.79,308.812],[521.31,310.089],[482.79,206.165],[521.31,208.01]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[482.203,826.676],[549.358,823.9],[482.203,936.581],[549.358,932.743]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[531.212,304.274],[531.212,199.606],[521.311,310.089],[521.311,208.01]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[604.073,300.399],[604.073,194.005],[531.212,304.274],[531.212,199.606]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[558.327,830.003],[558.327,941.18],[549.358,823.9],[549.358,932.743]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[559.608,429.694],[559.608,318.626],[550.937,431.911],[550.937,323.09]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[559.608,555.671],[559.608,444.603],[550.937,555.339],[550.937,446.518]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[559.608,574.2],[559.608,685.268],[550.937,573.493],[550.937,682.314]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[559.608,698.083],[559.608,809.151],[550.937,694.869],[550.937,803.69]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[558.327,830.003],[558.327,941.18],[713.121,823.458],[713.121,932.132]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[559.608,429.694],[559.608,318.626],[704.45,432.002],[704.45,323.274]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[559.608,555.671],[559.608,444.603],[704.45,555.325],[704.45,446.597]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[559.608,574.2],[559.608,685.268],[704.45,573.464],[704.45,682.192]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[559.608,698.083],[559.608,809.151],[704.45,694.737],[704.45,803.465]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[700.379,298.826],[700.379,191.731],[604.073,300.399],[604.073,194.005]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[843.602,298.853],[700.379,298.826],[843.602,191.771],[700.379,191.731]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[725.163,428.128],[725.163,315.473],[704.45,432.002],[704.45,323.274]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[725.163,555.906],[725.163,443.25],[704.45,555.325],[704.45,446.597]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[725.163,574.699],[725.163,687.355],[704.45,573.464],[704.45,682.192]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[725.163,700.353],[725.163,813.009],[704.45,694.737],[704.45,803.465]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[724.473,833.652],[724.473,946.224],[703.883,823.438],[703.882,932.104]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[884.159,832.896],[724.473,833.652],[884.159,945.179],[724.473,946.224]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[876.011,428.377],[725.163,428.128],[876.011,315.974],[725.163,315.473]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[876.011,555.868],[876.011,443.465],[725.163,555.906],[725.163,443.25]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[876.011,574.62],[876.011,687.023],[725.163,574.699],[725.163,687.355]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[876.011,699.992],[725.163,700.353],[876.011,812.396],[725.163,813.009]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[848.703,299.282],[848.703,192.389],[990.698,301.471],[990.698,195.555]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[883.462,433.199],[883.462,321.965],[1301.71,439.97],[1301.71,335.837]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[883.462,559.364],[883.462,448.13],[1301.71,558.08],[1301.71,453.948]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[883.462,577.921],[883.462,689.155],[1301.71,575.452],[1301.71,679.585]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[883.462,701.989],[883.462,813.223],[1301.71,691.599],[1301.71,795.732]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[883.462,830.153],[883.462,941.387],[1301.71,811.581],[1301.71,915.714]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[990.698,301.471],[990.698,195.555],[1141.51,307.036],[1141.51,203.598]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1141.51,307.036],[1141.51,203.598],[1254.77,313.86],[1254.77,213.462]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1254.77,313.86],[1254.77,213.462],[1344.6,321.836],[1344.6,224.99]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1311.36,435.737],[1311.36,330.794],[1406.48,439.412],[1406.48,338.196]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1311.36,554.766],[1311.36,449.823],[1406.48,554.215],[1406.48,452.999]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1311.36,572.272],[1311.36,677.215],[1406.48,571.1],[1406.48,672.316]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1311.36,689.323],[1311.36,794.265],[1406.48,683.994],[1406.48,785.21]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1344.6,321.836],[1344.6,224.99],[1392.25,327.97],[1392.25,233.856]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1305.61,814.003],[1305.61,919.062],[1406.82,803.716],[1406.82,904.84]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1392.25,327.97],[1392.25,233.856],[1411.63,334.251],[1411.63,242.935]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1366.39,442.551],[1366.39,344.516],[1479.51,444.353],[1479.51,348.146]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1366.39,553.744],[1366.39,455.71],[1479.51,553.474],[1479.51,457.267]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1366.39,570.099],[1366.39,668.133],[1479.51,569.524],[1479.51,665.731]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1366.39,679.444],[1366.39,777.479],[1479.51,676.831],[1479.51,773.038]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1361.5,796.043],[1361.5,894.234],[1482.56,790.924],[1482.56,887.158]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1383.9,338.69],[1383.9,249.352],[1413.1,339.658],[1413.1,250.751]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1455.82,446.021],[1455.82,351.505],[1508.01,446.835],[1508.01,353.144]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1455.82,553.224],[1455.82,458.708],[1508.01,553.102],[1508.01,459.411]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1455.82,568.992],[1455.82,663.508],[1508.01,568.732],[1508.01,662.423]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1455.82,674.413],[1455.82,768.93],[1508.01,673.233],[1508.01,766.925]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1457.94,786.339],[1457.94,880.819],[1507.63,784.284],[1507.63,877.979]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1508.01,446.835],[1508.01,353.144],[1512.21,449.642],[1512.21,358.797]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1508.01,553.102],[1508.01,459.411],[1512.21,552.682],[1512.21,461.836]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1508.01,568.732],[1508.01,662.423],[1512.21,567.837],[1512.21,658.682]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1508.01,673.233],[1508.01,766.925],[1512.21,669.164],[1512.21,760.009]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:30,
                    verts:[[1507.63,784.284],[1507.63,877.979],[1512.21,776.832],[1512.21,867.678]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[406.901,442.238],[406.901,343.886],[360.33,450.844],[360.33,361.218]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[406.901,553.791],[406.901,455.44],[360.33,552.501],[360.33,462.875]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[406.901,570.199],[406.901,668.55],[360.33,567.453],[360.33,657.08]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[406.901,679.898],[406.901,778.25],[360.33,667.421],[360.33,757.047]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[463.879,431.708],[463.879,322.682],[407.195,442.184],[407.195,343.777]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[463.879,555.369],[463.879,446.343],[407.195,553.799],[407.195,455.393]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[463.879,573.557],[463.879,682.584],[407.195,570.216],[407.195,668.623]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[463.879,695.163],[463.879,804.19],[407.195,679.977],[407.195,778.383]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[465.158,824.313],[465.158,933.314],[408.362,796.553],[408.362,894.939]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[445.121,320.122],[445.121,222.513],[439.914,325.676],[439.914,230.541]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[468.934,314.567],[468.934,214.484],[446.13,319.729],[446.13,221.945]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[533.192,429.698],[533.192,318.634],[463.879,431.708],[463.879,322.682]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[533.192,555.67],[533.192,444.606],[463.879,555.369],[463.879,446.343]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[533.192,574.199],[533.192,685.263],[463.879,573.557],[463.879,682.584]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[533.192,698.077],[533.192,809.141],[463.879,695.163],[463.879,804.19]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[534.934,829.607],[534.934,940.633],[465.158,824.313],[465.158,933.314]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[487.791,311.115],[487.791,209.494],[468.935,314.568],[468.935,214.484]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[517.295,306.265],[517.295,202.483],[487.79,311.115],[487.79,209.494]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[517.295,306.265],[555.272,307.897],[517.295,202.483],[555.272,204.843]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[533.192,429.698],[533.192,318.634],[602.346,431.1],[602.346,321.457]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[533.192,555.67],[533.192,444.606],[602.346,555.46],[602.346,445.817]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[533.192,574.199],[533.192,685.263],[602.346,573.751],[602.346,683.394]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[533.192,698.077],[533.192,809.141],[602.346,696.045],[602.346,805.688]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[534.934,829.607],[534.934,940.633],[600.794,826.068],[600.794,935.739]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[571.868,302.195],[571.868,196.601],[555.273,307.897],[555.273,204.843]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[650.268,299.035],[650.268,192.033],[571.868,302.195],[571.868,196.601]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[615.738,832.03],[615.738,943.982],[600.794,826.068],[600.794,935.739]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[616.77,428.935],[616.77,317.096],[602.346,431.1],[602.346,321.457]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[616.77,555.785],[616.77,443.947],[602.346,555.46],[602.346,445.817]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[616.77,574.442],[616.77,686.28],[602.346,573.751],[602.346,683.394]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[616.77,699.184],[616.77,811.022],[602.346,696.045],[602.346,805.688]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[615.738,832.03],[615.738,943.982],[765.953,823.766],[765.953,932.558]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[616.77,428.935],[616.77,317.096],[757.373,431.85],[757.373,322.967]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[616.77,555.785],[616.77,443.947],[757.373,555.348],[757.373,446.465]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[616.77,574.442],[616.77,686.28],[757.373,573.512],[757.373,682.395]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[616.77,699.184],[616.77,811.022],[757.373,694.958],[757.373,803.841]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[749.255,298.399],[749.255,191.113],[650.268,299.035],[650.268,192.033]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[749.255,298.399],[892.477,299.788],[749.255,191.113],[892.478,193.121]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[787.827,428.114],[787.827,315.443],[757.373,431.85],[757.373,322.967]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[787.827,555.908],[787.827,443.237],[757.373,555.348],[757.373,446.465]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[787.827,574.704],[787.827,687.375],[757.373,573.512],[757.373,682.395]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[787.827,700.374],[787.827,813.045],[757.373,694.958],[757.373,803.841]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[786.93,833.702],[786.93,946.294],[756.65,823.85],[756.649,932.674]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[787.827,428.114],[787.827,315.443],[937.572,429.018],[937.572,317.265]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[787.827,555.908],[787.827,443.237],[937.572,555.772],[937.572,444.019]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[787.827,574.704],[787.827,687.375],[937.572,574.415],[937.572,686.169]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[787.827,700.375],[787.827,813.045],[937.572,699.063],[937.572,810.816]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[786.93,833.702],[945.351,831.108],[786.93,946.294],[945.351,942.707]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[897.09,300.258],[897.09,193.799],[1035.12,303.732],[1035.12,198.822]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[942.12,433.829],[942.12,323.256],[1333.08,442.08],[1333.08,340.161]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[942.12,559.245],[942.12,448.672],[1333.08,557.68],[1333.08,455.761]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[942.12,577.691],[942.12,688.265],[1333.08,574.683],[1333.08,676.602]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[942.12,701.022],[942.12,811.596],[1333.08,688.361],[1333.08,790.281]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[942.12,828.425],[942.12,938.999],[1333.08,805.793],[1333.08,907.712]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1035.12,303.732],[1035.12,198.822],[1176.66,310.531],[1176.66,208.65]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1176.66,310.531],[1176.66,208.65],[1279.16,318.152],[1279.16,219.666]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1279.16,318.152],[1279.16,219.666],[1357.19,326.631],[1357.19,231.921]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1344.24,437.984],[1344.24,335.321],[1426.5,441.897],[1426.5,343.201]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1344.24,554.429],[1344.24,451.765],[1426.5,553.842],[1426.5,455.145]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1344.24,571.555],[1344.24,674.219],[1426.5,570.307],[1426.5,669.004]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1344.24,686.064],[1344.24,788.728],[1426.5,680.392],[1426.5,779.089]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1357.19,326.631],[1357.19,231.921],[1396.42,332.945],[1396.42,241.048]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1339,808.094],[1339,910.893],[1426.62,797.133],[1426.62,895.74]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1396.42,332.945],[1396.42,241.048],[1408.42,339.163],[1408.42,250.036]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1380.83,444.776],[1380.83,348.998],[1484.34,446.923],[1484.34,353.32]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1380.83,553.411],[1380.83,457.633],[1484.34,553.089],[1484.34,459.487]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1380.83,569.389],[1380.83,665.167],[1484.34,568.704],[1484.34,662.307]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1380.83,676.218],[1380.83,771.996],[1484.34,673.106],[1484.34,766.709]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1376.51,790.176],[1376.51,886.124],[1487.3,784.081],[1487.3,877.698]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1457.93,448.444],[1457.93,356.385],[1505.55,449.41],[1505.55,358.328]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1457.93,552.861],[1457.93,460.801],[1505.55,552.716],[1505.55,461.635]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1457.93,568.219],[1457.93,660.279],[1505.55,567.911],[1505.55,658.992]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1457.93,670.9],[1457.93,762.96],[1505.55,669.501],[1505.55,760.582]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:31,
                    verts:[[1459.87,779.898],[1459.87,871.915],[1505.2,777.461],[1505.2,868.547]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[430.233,440.948],[430.233,341.288],[360.042,449.4],[360.042,358.31]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[430.233,553.985],[430.233,454.325],[360.042,552.718],[360.042,461.627]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[430.233,570.61],[430.233,670.27],[360.042,567.914],[360.042,659.004]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[430.233,681.768],[430.233,781.428],[360.042,669.514],[360.042,760.605]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[515.54,430.675],[515.54,320.6],[430.675,440.895],[430.675,341.181]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[515.54,555.524],[515.54,445.45],[430.675,553.993],[430.675,454.279]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[515.54,573.887],[515.54,683.961],[430.675,570.627],[430.675,670.341]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[515.54,696.662],[515.54,806.736],[430.675,681.845],[430.675,781.559]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[516.786,827.039],[516.786,937.083],[431.825,799.958],[431.825,899.646]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[451.48,326.683],[451.48,231.996],[447.488,331.638],[447.488,239.159]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[456.104,323.028],[456.104,226.714],[451.48,326.683],[451.48,231.996]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[467.678,317.523],[467.678,218.756],[456.104,323.028],[456.104,226.714]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[498.319,312.19],[498.319,211.048],[469.154,317.139],[469.154,218.202]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[521.474,308.919],[521.474,206.319],[498.319,312.19],[498.319,211.048]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[591.318,428.977],[591.318,317.181],[515.54,430.675],[515.54,320.6]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[591.318,555.779],[591.318,443.983],[515.54,555.524],[515.54,445.45]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[591.318,574.429],[591.318,686.224],[515.54,573.887],[515.54,683.961]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[591.318,699.123],[591.318,810.919],[515.54,696.662],[515.54,806.736]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[592.993,831.501],[592.993,943.25],[516.786,827.039],[516.786,937.083]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[557.003,304.362],[557.003,199.733],[521.474,308.919],[521.474,206.319]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[557.003,304.362],[557.003,199.733],[593.871,306.335],[593.871,202.585]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[591.318,428.977],[591.318,317.181],[657.943,430.664],[657.943,320.579]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[591.318,555.779],[591.318,443.983],[657.943,555.526],[657.943,445.441]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[591.318,574.429],[591.318,686.224],[657.943,573.89],[657.943,683.975]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[591.318,699.123],[591.318,810.919],[657.943,696.677],[657.943,806.762]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[592.993,831.501],[592.993,943.25],[656.444,827.241],[656.444,937.361]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[617.038,300.829],[617.038,194.626],[593.871,306.335],[593.871,202.585]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[699.841,298.439],[699.841,191.171],[617.037,300.829],[617.037,194.626]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[677.18,832.969],[677.18,945.279],[656.444,827.241],[656.444,937.361]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[677.942,428.584],[677.942,316.39],[657.943,430.664],[657.943,320.579]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[677.942,555.838],[677.942,443.644],[657.943,555.526],[657.943,445.441]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[677.942,574.554],[677.942,686.748],[657.943,573.891],[657.943,683.975]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[677.942,699.692],[677.942,811.886],[657.943,696.677],[657.943,806.762]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[677.942,428.584],[677.942,316.39],[811.989,432.06],[811.989,323.39]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[677.942,555.837],[677.942,443.644],[811.989,555.316],[811.989,446.647]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[677.942,574.554],[677.942,686.748],[811.989,573.445],[811.989,682.115]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[677.942,699.692],[677.942,811.886],[811.989,694.653],[811.989,803.323]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[677.179,832.969],[677.179,945.279],[820.341,823.118],[820.341,931.661]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[799.977,298.744],[699.841,298.439],[799.977,191.613],[699.841,191.171]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[799.977,298.744],[799.977,191.613],[941.009,301.445],[941.009,195.517]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[851.592,428.517],[851.592,316.255],[811.989,432.06],[811.989,323.39]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[851.592,555.848],[851.592,443.586],[811.989,555.317],[811.989,446.647]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[851.592,574.575],[851.592,686.837],[811.989,573.445],[811.989,682.115]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[851.592,699.79],[851.592,812.052],[811.989,694.653],[811.989,803.323]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[850.505,832.647],[850.505,944.835],[811.123,823.304],[811.123,931.919]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[850.505,832.648],[850.505,944.835],[1005.04,828.311],[1005.04,938.841]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[851.592,428.517],[851.592,316.255],[997.745,430.044],[997.745,319.33]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[851.592,555.848],[851.592,443.586],[997.745,555.619],[997.745,444.905]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[851.592,574.575],[851.592,686.837],[997.745,574.088],[997.745,684.802]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[851.592,699.79],[851.592,812.052],[997.745,697.576],[997.745,808.29]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[945.074,301.948],[945.074,196.242],[1077.23,306.601],[1077.23,202.969]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[999.401,434.813],[999.401,325.271],[1358.74,444.323],[1358.74,344.755]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[999.401,559.058],[999.401,449.517],[1358.74,557.255],[1358.74,457.688]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[999.401,577.333],[999.401,686.874],[1358.74,573.865],[1358.74,673.432]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[999.401,699.513],[999.401,809.055],[1358.74,684.92],[1358.74,784.488]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[999.401,825.728],[999.401,935.27],[1358.74,799.642],[1358.74,899.209]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1077.23,306.601],[1077.23,202.969],[1207.96,314.463],[1207.96,214.333]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1207.96,314.463],[1207.96,214.333],[1299,322.714],[1299,226.26]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1299,322.714],[1299,226.26],[1365.13,331.541],[1365.13,239.019]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1365.13,331.541],[1365.13,239.019],[1396.15,337.941],[1396.15,248.269]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1371.14,440.373],[1371.14,340.13],[1440.48,444.445],[1440.48,348.33]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1371.14,554.071],[1371.14,453.828],[1440.48,553.461],[1440.48,457.346]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1371.14,570.793],[1371.14,671.036],[1440.48,569.495],[1440.48,665.609]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1371.14,682.602],[1371.14,782.844],[1440.48,676.699],[1440.48,772.813]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1396.15,337.941],[1396.15,248.269],[1401.21,344.03],[1401.21,257.071]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1366.44,801.801],[1366.44,902.194],[1440.38,790.387],[1440.38,886.415]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1390.21,447.054],[1390.21,353.585],[1483.74,449.479],[1483.74,358.469]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1390.21,553.069],[1390.21,459.6],[1483.74,552.706],[1483.74,461.696]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1390.21,568.662],[1390.21,662.132],[1483.74,567.889],[1483.74,658.899]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1390.21,672.916],[1390.21,766.385],[1483.74,669.4],[1483.74,760.41]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1386.48,784.162],[1386.48,877.81],[1486.57,777.274],[1486.57,868.289]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1455.13,450.853],[1455.13,361.235],[1498.07,451.94],[1498.07,363.425]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1455.13,552.5],[1455.13,462.882],[1498.07,552.337],[1498.07,463.822]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1455.13,567.451],[1455.13,657.068],[1498.07,567.104],[1498.07,655.619]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1455.13,667.409],[1455.13,757.026],[1498.07,665.832],[1498.07,754.347]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:32,
                    verts:[[1456.87,773.499],[1456.87,863.07],[1497.75,770.754],[1497.75,859.275]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[459.315,439.863],[459.315,339.104],[365.47,448.052],[365.47,355.594]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[459.315,554.147],[459.315,453.388],[365.47,552.92],[365.47,460.462]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[459.315,570.956],[459.315,671.715],[365.47,568.344],[365.47,660.802]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[459.315,683.341],[459.315,784.1],[365.47,671.469],[365.47,763.927]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[468.689,324.369],[468.689,228.652],[459.074,329.282],[459.074,235.754]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[572.384,429.997],[572.384,319.237],[459.903,439.812],[459.903,339.001]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[572.384,555.626],[572.384,444.865],[459.903,554.155],[459.903,453.344]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[572.384,574.103],[572.384,684.864],[459.903,570.972],[459.903,671.783]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[572.384,697.643],[572.384,808.404],[459.903,683.415],[459.903,784.226]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[573.575,828.822],[573.575,939.546],[461.02,802.817],[461.02,903.598]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[477.497,320.763],[477.497,223.44],[468.69,324.369],[468.69,228.652]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[495.471,315.377],[495.471,215.654],[477.497,320.763],[477.497,223.44]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[532.702,310.341],[532.702,208.375],[497.408,315.008],[497.408,215.121]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[559.925,307.298],[559.925,203.977],[532.703,310.341],[532.703,208.375]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[601.071,303.102],[601.071,197.911],[559.925,307.298],[559.925,203.977]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[653.467,428.641],[653.467,316.505],[572.384,429.997],[572.384,319.237]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[653.467,555.829],[653.467,443.693],[572.384,555.626],[572.384,444.865]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[653.467,574.536],[653.467,686.672],[572.384,574.103],[572.384,684.864]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[653.467,699.61],[653.467,811.746],[572.384,697.643],[572.384,808.404]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[655.047,832.373],[655.047,944.456],[573.575,828.822],[573.575,939.546]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[601.071,303.102],[601.071,197.911],[636.287,305.392],[636.287,201.222]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[665.739,300.159],[665.739,193.658],[636.287,305.392],[636.287,201.222]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[653.467,428.641],[653.467,316.505],[716.47,430.589],[716.47,320.427]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[653.467,555.829],[653.467,443.693],[716.47,555.537],[716.47,445.376]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[653.467,574.536],[653.467,686.672],[716.47,573.914],[716.47,684.076]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[653.467,699.61],[653.467,811.746],[716.47,696.786],[716.47,806.948]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[655.047,832.373],[655.047,944.456],[715.049,827.456],[715.049,937.658]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[751.705,298.569],[751.705,191.36],[665.738,300.159],[665.738,193.658]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[741.228,832.865],[741.228,945.136],[715.049,827.456],[715.049,937.658]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[741.709,428.625],[741.709,316.472],[716.47,430.589],[716.47,320.427]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[741.709,555.831],[741.709,443.679],[716.47,555.537],[716.47,445.376]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[741.709,574.541],[741.709,686.694],[716.47,573.915],[716.47,684.076]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[741.709,699.634],[741.709,811.786],[716.47,696.786],[716.47,806.948]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[741.708,428.625],[741.708,316.472],[867.13,432.601],[867.13,324.479]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[741.708,555.831],[741.708,443.679],[867.13,555.235],[867.13,447.114]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[741.708,574.541],[741.708,686.694],[867.13,573.273],[867.13,681.395]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[741.708,699.634],[741.708,811.786],[867.13,693.87],[867.13,801.991]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[741.228,832.865],[741.228,945.136],[875.131,821.6],[875.131,929.564]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[751.705,298.569],[851.473,299.797],[751.705,191.36],[851.473,193.134]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[851.473,299.797],[851.473,193.134],[988.291,303.725],[988.291,198.813]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[915.059,429.296],[915.059,317.824],[867.13,432.601],[867.13,324.479]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[915.059,555.731],[915.059,444.259],[867.13,555.235],[867.13,447.114]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[915.059,574.327],[915.059,685.799],[867.13,573.273],[867.13,681.395]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[915.059,698.66],[915.059,810.132],[867.13,693.87],[867.13,801.991]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[913.805,830.598],[913.805,942.002],[866.136,821.883],[866.136,929.954]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[913.805,830.598],[913.805,942.002],[1062.09,824.663],[1062.09,933.798]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[915.059,429.296],[915.059,317.824],[1055.39,431.395],[1055.39,322.051]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[915.059,555.731],[915.059,444.259],[1055.39,555.416],[1055.39,446.072]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[915.059,574.327],[915.059,685.799],[1055.39,573.657],[1055.39,683.002]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[915.059,698.66],[915.059,810.132],[1055.39,695.617],[1055.39,804.962]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[991.768,304.253],[991.768,199.574],[1116.42,309.956],[1116.42,207.819]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1054.24,436.095],[1054.24,327.898],[1378.85,446.635],[1378.85,349.492]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1054.24,558.815],[1054.24,450.618],[1378.85,556.817],[1378.85,459.674]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1054.24,576.865],[1054.24,685.062],[1378.85,573.022],[1378.85,670.165]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1054.24,697.546],[1054.24,805.743],[1378.85,681.373],[1378.85,778.515]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1054.24,822.211],[1054.24,930.408],[1378.85,793.301],[1378.85,890.443]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1116.42,309.956],[1116.42,207.819],[1235.2,318.7],[1235.2,220.457]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1235.2,318.7],[1235.2,220.457],[1314.45,327.423],[1314.45,233.067]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1314.45,327.423],[1314.45,233.067],[1368.82,336.459],[1368.82,246.127]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1368.82,336.459],[1368.82,246.127],[1391.94,342.863],[1391.94,255.383]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1392.25,442.835],[1392.25,345.088],[1448.9,446.996],[1448.9,353.467]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1392.25,553.702],[1392.25,455.955],[1448.9,553.078],[1448.9,459.55]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1392.25,570.008],[1392.25,667.755],[1448.9,568.681],[1448.9,662.209]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1392.25,679.033],[1392.25,776.78],[1448.9,673],[1448.9,766.529]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1388.1,795.305],[1388.1,893.214],[1448.61,783.633],[1448.61,877.079]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1394.96,449.333],[1394.96,358.175],[1478.38,451.978],[1478.38,363.5]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1394.96,552.728],[1394.96,461.569],[1478.38,552.332],[1478.38,463.854]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1394.96,567.935],[1394.96,659.094],[1478.38,567.092],[1478.38,655.569]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1394.96,669.611],[1394.96,760.77],[1478.38,665.778],[1478.38,754.255]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1391.81,778.135],[1391.81,869.479],[1481.08,770.625],[1481.08,859.097]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1448.04,453.205],[1448.04,365.971],[1486.32,454.388],[1486.32,368.354]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1448.04,552.148],[1448.04,464.914],[1486.32,551.97],[1486.32,465.936]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1448.04,566.7],[1448.04,653.934],[1486.32,566.323],[1486.32,652.357]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1448.04,663.999],[1448.04,751.232],[1486.32,662.283],[1486.32,748.317]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:33,
                    verts:[[1449.59,767.253],[1449.59,854.435],[1486.03,764.266],[1486.03,850.307]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[493.562,438.986],[493.562,337.337],[376.475,446.804],[376.475,353.082]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[493.562,554.279],[493.562,452.63],[376.475,553.107],[376.475,459.385]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[493.562,571.236],[493.562,672.885],[376.475,568.742],[376.475,662.464]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[493.562,684.613],[493.562,786.261],[376.475,673.278],[376.475,767]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[490.672,322.395],[490.672,225.799],[475.403,327.209],[475.403,232.757]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[503.654,318.881],[503.654,220.72],[490.672,322.395],[490.672,225.799]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[633.155,429.664],[633.155,318.566],[494.292,438.937],[494.292,337.239]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[633.155,555.676],[633.155,444.577],[494.292,554.286],[494.292,452.588]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[633.155,574.209],[633.155,685.308],[494.292,571.251],[494.292,672.949]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[633.155,698.126],[633.155,809.225],[494.292,684.683],[494.292,786.381]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[634.271,829.692],[634.271,940.75],[495.361,805.125],[495.361,906.789]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[527.934,313.681],[527.934,213.202],[503.653,318.881],[503.653,220.719]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[571.375,309.008],[571.375,206.449],[530.315,313.331],[530.315,212.697]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[602.345,306.236],[602.345,202.441],[571.376,309.008],[571.376,206.449]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[648.573,302.455],[648.573,196.977],[602.344,306.236],[602.344,202.441]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[718.254,428.668],[718.254,316.559],[633.155,429.664],[633.155,318.566]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[718.254,555.825],[718.254,443.716],[633.155,555.676],[633.155,444.577]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[718.254,574.527],[718.254,686.636],[633.155,574.209],[633.155,685.308]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[718.254,699.571],[718.254,811.68],[633.155,698.126],[633.155,809.225]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[719.714,832.287],[719.714,944.337],[634.271,829.692],[634.271,940.75]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[648.573,302.455],[648.573,196.977],[681.638,305.033],[681.638,200.703]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[716.946,300.139],[716.946,193.629],[681.639,305.033],[681.639,200.703]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[804.797,299.358],[804.797,192.501],[716.946,300.139],[716.946,193.629]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[718.254,428.668],[718.254,316.559],[776.671,430.845],[776.671,320.943]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[718.254,555.825],[718.254,443.716],[776.671,555.499],[776.671,445.597]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[718.254,574.527],[718.254,686.636],[776.671,573.833],[776.671,683.734]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[718.254,699.571],[718.254,811.68],[776.671,696.415],[776.671,806.316]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[719.714,832.287],[719.714,944.337],[775.348,826.79],[775.348,936.738]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[806.488,831.811],[806.488,943.679],[775.348,826.79],[775.348,936.738]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[806.683,429.022],[806.683,317.272],[776.671,430.845],[776.671,320.943]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[806.683,555.772],[806.683,444.022],[776.671,555.499],[776.671,445.597]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[806.683,574.414],[806.683,686.164],[776.671,573.833],[776.671,683.734]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[806.683,699.058],[806.683,810.808],[776.671,696.415],[776.671,806.316]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[804.797,299.358],[804.797,192.5],[902.759,301.464],[902.76,195.544]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[806.683,429.022],[806.683,317.272],[921.736,433.427],[921.736,326.144]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[806.683,555.772],[806.683,444.022],[921.736,555.112],[921.736,447.828]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[806.683,574.414],[806.683,686.164],[921.736,573.009],[921.736,680.293]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[806.683,699.058],[806.683,810.808],[921.736,692.671],[921.736,799.955]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[806.487,831.811],[806.487,943.679],[929.278,819.333],[929.278,926.43]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[902.759,301.464],[902.76,195.544],[1033.58,306.512],[1033.58,202.841]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[977.004,430.396],[977.004,320.04],[921.736,433.427],[921.736,326.143]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[977.004,555.566],[977.004,445.209],[921.736,555.112],[921.736,447.828]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[977.004,573.976],[977.004,684.332],[921.736,573.009],[921.736,680.293]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[977.004,697.065],[977.004,807.422],[921.736,692.671],[921.736,799.955]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[975.608,827.699],[975.608,937.994],[920.633,819.705],[920.633,926.943]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[975.608,827.699],[975.608,937.995],[1115.66,820.341],[1115.66,927.823]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[977.004,430.396],[977.004,320.04],[1109.61,433.005],[1109.61,325.292]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[977.004,555.566],[977.004,445.209],[1109.61,555.175],[1109.61,447.463]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[977.004,573.976],[977.004,684.332],[1109.61,573.144],[1109.61,680.856]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[977.004,697.065],[977.004,807.422],[1109.61,693.284],[1109.61,800.996]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1036.44,307.057],[1036.44,203.626],[1152.3,313.67],[1152.3,213.187]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1105.81,437.614],[1105.81,331.01],[1393.77,448.96],[1393.77,354.256]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1105.81,558.527],[1105.81,451.924],[1393.77,556.376],[1393.77,461.672]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1105.81,576.311],[1105.81,682.915],[1393.77,572.174],[1393.77,666.878]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1105.81,695.215],[1105.81,801.818],[1393.77,677.805],[1393.77,772.509]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1105.81,818.044],[1105.81,924.647],[1393.77,786.923],[1393.77,881.627]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1152.3,313.67],[1152.3,213.186],[1258.38,323.116],[1258.38,226.841]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1258.38,323.116],[1258.38,226.841],[1325.76,332.167],[1325.76,239.923]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1325.76,332.167],[1325.76,239.923],[1368.71,341.291],[1368.71,253.112]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1368.71,341.291],[1368.71,253.112],[1384.35,347.632],[1384.35,262.277]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1404.33,788.765],[1404.33,884.174],[1451.88,777.003],[1451.88,867.914]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1407.93,445.31],[1407.93,350.072],[1452.34,449.501],[1452.34,358.512]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1407.93,553.331],[1407.93,458.093],[1452.34,552.703],[1452.34,461.714]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1407.93,569.219],[1407.93,664.456],[1452.34,567.882],[1452.34,658.871]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1407.93,675.445],[1407.93,770.682],[1452.34,669.369],[1452.34,760.358]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1395.58,451.571],[1395.58,362.681],[1468.98,454.381],[1468.98,368.341]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1395.58,552.393],[1395.58,463.503],[1468.98,551.971],[1468.98,465.931]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1395.58,567.221],[1395.58,656.111],[1468.98,566.325],[1468.98,652.366]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1395.58,666.367],[1395.58,755.257],[1468.98,662.293],[1468.98,748.334]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1392.99,772.212],[1392.99,861.29],[1471.53,764.231],[1471.53,850.257]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1437.32,455.466],[1437.32,370.525],[1471.01,456.722],[1471.01,373.054]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1437.32,551.809],[1437.32,466.868],[1471.01,551.621],[1471.01,467.953]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1437.32,565.979],[1437.32,650.92],[1471.01,565.578],[1471.01,649.246]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:34,
                    verts:[[1437.32,660.72],[1437.32,745.661],[1471.01,658.9],[1471.01,742.568]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[532.289,438.307],[532.289,335.971],[392.8,445.659],[392.8,350.775]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[532.289,554.38],[532.289,452.044],[392.8,553.279],[392.8,458.395]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[532.289,571.452],[532.289,673.789],[392.8,569.107],[392.8,663.991]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[532.289,685.596],[532.289,787.932],[392.8,674.938],[392.8,769.822]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[525.847,327.717],[525.847,233.491],[493.838,331.264],[493.838,238.618]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[516.97,320.745],[516.97,223.414],[496.114,325.407],[496.114,230.152]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[534.042,317.363],[534.042,218.526],[516.97,320.745],[516.97,223.414]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[564.417,312.41],[564.417,211.366],[534.042,317.363],[534.042,218.526]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[696.576,429.649],[696.576,318.535],[533.154,438.262],[533.154,335.879]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[696.576,555.678],[696.576,444.564],[533.154,554.387],[533.154,452.005]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[696.576,574.214],[696.576,685.328],[533.154,571.467],[533.154,673.849]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[696.576,698.149],[696.576,809.263],[533.154,685.662],[533.154,788.045]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[697.602,829.723],[697.602,940.792],[534.159,806.906],[534.159,909.25]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[613.566,308.159],[613.566,205.221],[567.218,312.084],[567.218,210.895]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[647.887,305.69],[647.887,201.652],[613.566,308.159],[613.566,205.221]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[698.563,302.369],[698.563,196.852],[647.886,305.69],[647.886,201.652]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[784.344,429.02],[784.344,317.268],[696.576,429.649],[696.576,318.535]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[784.344,555.772],[784.344,444.02],[696.576,555.678],[696.576,444.564]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[784.344,574.415],[784.344,686.167],[696.576,574.214],[696.576,685.328]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[784.344,699.061],[784.344,810.813],[696.576,698.149],[696.576,809.263]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[785.662,831.341],[785.662,943.029],[697.602,829.723],[697.602,940.792]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[698.563,302.369],[698.563,196.852],[729.041,305.199],[729.041,200.944]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[769.662,300.698],[769.662,194.437],[729.041,305.2],[729.042,200.944]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[858.136,300.715],[769.662,300.698],[858.136,194.461],[769.662,194.437]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[784.344,429.02],[784.344,317.268],[837.37,431.391],[837.37,322.044]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[784.344,555.772],[784.344,444.02],[837.37,555.417],[837.37,446.069]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[784.344,574.415],[784.344,686.167],[837.37,573.658],[837.37,683.006]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[784.344,699.061],[784.344,810.813],[837.37,695.622],[837.37,804.97]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[785.662,831.341],[785.662,943.029],[836.162,825.353],[836.162,934.751]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[871.681,829.932],[871.681,941.081],[836.162,825.353],[836.162,934.751]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[871.596,429.729],[871.596,318.696],[837.37,431.391],[837.37,322.044]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[871.596,555.666],[871.596,444.633],[837.37,555.417],[837.37,446.069]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[871.596,574.189],[871.596,685.222],[837.37,573.658],[837.37,683.006]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[871.596,698.033],[871.596,809.066],[837.37,695.622],[837.37,804.97]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[858.136,300.715],[858.136,194.461],[952.989,303.637],[952.99,198.685]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[871.596,429.729],[871.596,318.696],[974.909,434.489],[974.909,328.281]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[871.596,555.666],[871.596,444.633],[974.909,554.953],[974.909,448.745]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[871.596,574.189],[871.596,685.222],[974.909,572.67],[974.909,678.878]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[871.596,698.033],[871.596,809.066],[974.909,691.133],[974.909,797.34]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[871.681,829.932],[871.681,941.081],[981.902,816.454],[981.902,922.45]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[952.989,303.637],[952.99,198.685],[1076.31,309.681],[1076.31,207.422]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1036.43,431.755],[1036.43,322.776],[974.909,434.488],[974.909,328.281]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1036.43,555.362],[1036.43,446.383],[974.909,554.953],[974.909,448.745]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1036.43,573.542],[1036.43,682.521],[974.909,572.671],[974.909,678.878]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1036.43,695.095],[1036.43,804.074],[974.909,691.133],[974.909,797.34]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1034.92,824.116],[1034.92,933.041],[973.717,816.905],[973.716,923.074]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1034.92,824.116],[1034.92,933.041],[1165.14,815.527],[1165.14,921.168]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1036.43,431.755],[1036.43,322.776],[1159.79,434.804],[1159.79,328.917]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1036.43,555.362],[1036.43,446.383],[1159.79,554.905],[1159.79,449.018]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1036.43,573.542],[1036.43,682.521],[1159.79,572.57],[1159.79,678.457]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1036.43,695.095],[1036.43,804.074],[1159.79,690.674],[1159.79,796.562]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1078.56,310.235],[1078.56,208.22],[1184.64,317.615],[1184.64,218.889]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1153.55,439.306],[1153.55,334.477],[1403.94,451.25],[1403.94,358.948]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1153.55,558.206],[1153.55,453.377],[1403.94,555.941],[1403.94,463.639]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1153.55,575.694],[1153.55,680.523],[1403.94,571.339],[1403.94,663.641]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1153.55,692.618],[1153.55,797.447],[1403.94,674.291],[1403.94,766.593]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1153.55,813.402],[1153.55,918.231],[1403.94,780.641],[1403.94,872.943]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1184.64,317.615],[1184.64,218.889],[1277.62,327.598],[1277.62,233.319]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1277.62,327.598],[1277.62,233.319],[1333.28,336.847],[1333.28,246.688]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1333.28,336.847],[1333.28,246.688],[1365.28,345.96],[1365.28,259.86]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1365.28,345.96],[1365.28,259.86],[1373.89,352.185],[1373.89,268.857]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1418.65,447.747],[1418.65,354.979],[1451.43,451.919],[1451.43,363.381]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1418.65,552.966],[1418.65,460.199],[1451.43,552.34],[1451.43,463.803]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1418.65,568.441],[1418.65,661.209],[1451.43,567.11],[1451.43,655.648]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1418.65,671.912],[1418.65,764.679],[1451.43,665.863],[1451.43,754.401]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1415.61,782.319],[1415.61,875.262],[1450.82,770.604],[1450.82,859.068]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1390.54,766.487],[1390.54,853.377],[1458.59,758.167],[1458.59,841.875]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1392.6,453.732],[1392.6,367.032],[1456.2,456.661],[1456.2,372.932]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1392.6,552.069],[1392.6,465.369],[1456.2,551.63],[1456.2,467.9]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1392.6,566.532],[1392.6,653.232],[1456.2,565.598],[1456.2,649.327]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:35,
                    verts:[[1392.6,663.235],[1392.6,749.935],[1456.2,658.988],[1456.2,742.717]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[574.765,437.812],[574.765,334.974],[414.102,444.61],[414.102,348.663]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[574.765,554.455],[574.765,451.616],[414.102,553.436],[414.102,457.489]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[574.765,571.61],[574.765,674.449],[414.102,569.442],[414.102,665.389]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[574.765,686.314],[574.765,789.152],[414.102,676.459],[414.102,772.406]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[548.584,326.382],[548.584,231.562],[512.121,329.655],[512.121,236.293]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[547.076,319.392],[547.076,221.458],[520.787,323.852],[520.787,227.904]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[568.086,316.178],[568.086,216.812],[547.076,319.392],[547.076,221.458]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[604.237,311.527],[604.237,210.089],[568.086,316.178],[568.086,216.812]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[761.442,429.914],[761.442,319.068],[575.755,437.77],[575.755,334.89]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[761.442,555.638],[761.442,444.793],[575.755,554.461],[575.755,451.58]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[761.442,574.13],[761.442,684.975],[575.755,571.624],[575.755,674.504]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[761.442,697.765],[761.442,808.61],[575.755,686.375],[575.755,789.255]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[762.363,829.012],[762.363,939.81],[576.684,808.199],[576.684,911.039]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[658.494,307.743],[658.494,204.619],[607.425,311.228],[607.425,209.657]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[695.717,305.602],[695.717,201.525],[658.494,307.743],[658.494,204.619]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[750.14,302.771],[750.14,197.433],[695.716,305.602],[695.716,201.525]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[750.141,302.771],[750.141,197.433],[777.668,305.817],[777.668,201.837]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[850.534,429.65],[850.534,318.537],[761.442,429.914],[761.442,319.068]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[850.534,555.678],[850.534,444.565],[761.442,555.638],[761.442,444.793]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[850.534,574.214],[850.534,685.327],[761.442,574.13],[761.442,684.975]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[850.534,698.147],[850.534,809.261],[761.442,697.765],[761.442,808.61]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[851.696,829.66],[762.363,829.012],[851.696,940.705],[762.363,939.81]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[822.978,301.75],[822.978,195.958],[777.668,305.817],[777.669,201.837]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[822.977,301.75],[910.879,302.535],[822.977,195.958],[910.879,197.092]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[850.534,429.65],[850.534,318.537],[897.544,432.18],[897.544,323.632]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[850.534,555.678],[850.534,444.565],[897.544,555.299],[897.544,446.75]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[850.534,574.214],[850.534,685.327],[897.544,573.407],[897.544,681.955]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[850.534,698.147],[850.534,809.26],[897.544,694.479],[897.544,803.028]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[851.696,829.66],[851.696,940.705],[896.466,823.272],[896.466,931.875]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[935.72,827.372],[935.72,937.543],[896.466,823.272],[896.466,931.875]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[935.365,430.691],[935.365,320.634],[897.544,432.18],[897.544,323.632]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[935.365,555.522],[935.365,445.464],[897.544,555.299],[897.544,446.75]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[935.365,573.882],[935.365,683.939],[897.544,573.407],[897.544,681.955]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[935.365,696.638],[935.365,806.695],[897.544,694.479],[897.544,803.028]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[910.879,302.535],[910.879,197.092],[1001.49,306.201],[1001.49,202.392]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[935.365,430.691],[935.365,320.634],[1025.95,435.73],[1025.95,330.78]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[935.365,555.522],[935.365,445.464],[1025.95,554.767],[1025.95,449.817]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[935.365,573.882],[935.365,683.939],[1025.95,572.275],[1025.95,677.224]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[935.365,696.638],[935.365,806.695],[1025.95,689.333],[1025.95,794.283]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[935.72,827.372],[935.72,937.543],[1032.32,813.108],[1032.32,917.825]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1001.49,306.201],[1001.49,202.392],[1116.12,313.112],[1116.12,212.38]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1092.6,433.307],[1092.6,325.902],[1025.95,435.73],[1025.95,330.78]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1092.6,555.13],[1092.6,447.724],[1025.95,554.767],[1025.95,449.817]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1092.6,573.047],[1092.6,680.453],[1025.95,572.275],[1025.95,677.224]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1092.6,692.845],[1092.6,800.25],[1025.95,689.333],[1025.95,794.283]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1091,820.02],[1091,927.379],[1024.68,813.629],[1024.68,918.545]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1091,820.02],[1091,927.379],[1210.2,810.395],[1210.2,914.074]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1092.6,433.307],[1092.6,325.902],[1205.57,436.728],[1205.57,332.79]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1092.6,555.13],[1092.6,447.724],[1205.57,554.617],[1205.57,450.679]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1092.6,573.047],[1092.6,680.453],[1205.57,571.956],[1205.57,675.894]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1092.6,692.845],[1092.6,800.25],[1205.57,687.886],[1205.57,791.823]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1117.75,313.668],[1117.75,213.182],[1213.38,321.675],[1213.38,224.758]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1213.38,321.675],[1213.38,224.758],[1293.14,332.045],[1293.14,239.747]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1197.12,441.11],[1197.12,338.174],[1409.88,453.466],[1409.88,363.49]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1197.12,557.864],[1197.12,454.928],[1409.88,555.521],[1409.88,465.544]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1197.12,575.036],[1197.12,677.973],[1409.88,570.531],[1409.88,660.508]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1197.12,689.85],[1197.12,792.786],[1409.88,670.889],[1409.88,760.866]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1197.12,808.454],[1197.12,911.39],[1409.88,774.561],[1409.88,864.538]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1293.14,332.045],[1293.14,239.747],[1337.41,341.384],[1337.41,253.246]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1337.41,341.384],[1337.41,253.246],[1359.02,350.404],[1359.02,266.284]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1359.02,350.404],[1359.02,266.284],[1361.05,356.472],[1361.05,275.055]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1424.95,450.104],[1424.95,359.727],[1446.8,454.219],[1446.8,368.014]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1424.95,552.612],[1424.95,462.235],[1446.8,551.996],[1446.8,465.791]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1424.95,567.689],[1424.95,658.066],[1446.8,566.377],[1446.8,652.582]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:36,
                    verts:[[1424.95,668.494],[1424.95,758.871],[1446.8,662.528],[1446.8,748.733]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[620.259,437.479],[620.259,334.302],[439.977,443.648],[439.977,346.726]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[620.259,554.504],[620.259,451.328],[439.977,553.58],[439.977,456.658]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[620.259,571.717],[620.259,674.893],[439.977,569.749],[439.977,666.671]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[620.259,686.797],[620.259,789.974],[439.977,677.853],[439.977,774.775]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[574.527,325.24],[574.527,229.911],[533.927,328.207],[533.927,234.2]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[580.461,318.296],[580.461,219.874],[548.971,322.51],[548.971,225.965]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[605.198,315.283],[605.198,215.518],[580.461,318.296],[580.461,219.874]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[646.72,310.979],[646.72,209.297],[605.198,315.283],[605.198,215.518]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[826.674,430.415],[826.674,320.077],[621.362,437.441],[621.362,334.226]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[826.674,555.563],[826.674,445.225],[621.362,554.51],[621.362,451.295]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[826.674,573.97],[826.674,684.307],[621.362,571.729],[621.362,674.943]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[826.674,697.038],[826.674,807.376],[621.362,686.852],[621.362,790.067]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[827.48,827.676],[827.48,937.963],[622.204,809.065],[622.204,912.235]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[705.417,307.697],[705.417,204.553],[650.257,310.71],[650.257,208.908]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[745.058,305.901],[745.058,201.958],[705.417,307.697],[705.417,204.553]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[802.493,303.58],[802.493,198.603],[745.057,305.901],[745.057,201.958]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[802.493,303.58],[802.493,198.603],[826.782,306.804],[826.782,203.263]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[876.105,303.199],[876.105,198.052],[826.783,306.804],[826.783,203.263]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[915.807,430.506],[826.674,430.415],[915.807,320.261],[826.674,320.077]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[915.807,555.549],[826.674,555.563],[915.807,445.304],[826.674,445.225]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[915.807,573.941],[826.674,573.97],[915.807,684.186],[826.674,684.307]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[915.807,696.906],[826.674,697.038],[915.807,807.151],[826.674,807.376]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[916.8,827.381],[827.48,827.676],[916.8,937.556],[827.48,937.963]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[876.105,303.199],[876.105,198.052],[962.341,304.712],[962.341,200.239]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[915.807,430.506],[915.807,320.261],[956.352,433.159],[956.352,325.603]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[915.807,555.549],[915.807,445.304],[956.352,555.152],[956.352,447.596]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[915.807,573.941],[915.807,684.186],[956.352,573.095],[956.352,680.651]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[915.807,696.906],[915.807,807.151],[956.352,693.06],[956.352,800.616]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[916.8,827.381],[916.8,937.556],[955.414,820.684],[955.414,928.298]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[997.734,824.283],[997.734,933.273],[955.414,820.684],[955.414,928.298]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[997.124,431.852],[997.124,322.971],[956.352,433.159],[956.352,325.603]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[997.124,555.348],[997.124,446.467],[956.352,555.152],[956.352,447.596]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[997.124,573.512],[997.124,682.392],[956.352,573.095],[956.352,680.651]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[997.124,694.955],[997.124,803.836],[956.352,693.06],[956.352,800.616]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[962.341,304.712],[962.341,200.239],[1047.76,309.043],[1047.76,206.499]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[997.123,431.852],[997.123,322.971],[1074.34,437.098],[1074.34,333.534]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[997.123,555.348],[997.123,446.467],[1074.34,554.562],[1074.34,450.999]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[997.123,573.511],[997.123,682.392],[1074.34,571.838],[1074.34,675.401]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[997.123,694.955],[997.123,803.836],[1074.34,687.35],[1074.34,790.913]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[997.734,824.283],[997.734,933.273],[1080.05,809.437],[1080.05,912.75]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1047.76,309.043],[1047.76,206.499],[1152.78,316.69],[1152.78,217.553]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1145.03,434.991],[1145.03,329.292],[1074.34,437.098],[1074.34,333.534]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1145.03,554.877],[1145.03,449.179],[1074.34,554.562],[1074.34,450.999]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1145.03,572.51],[1145.03,678.209],[1074.34,571.838],[1074.34,675.401]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1145.03,690.404],[1145.03,796.103],[1074.34,687.35],[1074.34,790.913]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1143.37,815.576],[1143.37,921.236],[1073.02,810.018],[1073.02,913.552]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1143.37,815.576],[1143.37,921.236],[1250.72,805.105],[1250.72,906.761]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1145.03,434.991],[1145.03,329.292],[1246.83,438.715],[1246.83,336.793]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1145.03,554.877],[1145.03,449.179],[1246.83,554.319],[1246.83,452.396]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1145.03,572.51],[1145.03,678.209],[1246.83,571.322],[1246.83,673.245]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1145.03,690.404],[1145.03,796.103],[1246.83,685.005],[1246.83,786.927]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1153.81,317.243],[1153.81,218.35],[1238.58,325.749],[1238.58,230.647]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1238.58,325.749],[1238.58,230.647],[1305.24,336.374],[1305.24,246.004]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1236.4,442.971],[1236.4,341.985],[1412.1,455.579],[1412.1,367.819]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1236.4,557.511],[1236.4,456.526],[1412.1,555.12],[1412.1,467.36]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1236.4,574.358],[1236.4,675.343],[1412.1,569.761],[1412.1,657.521]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1236.4,686.995],[1236.4,787.98],[1412.1,667.647],[1412.1,755.408]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1236.4,803.351],[1236.4,904.336],[1412.1,768.765],[1412.1,856.526]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1305.24,336.374],[1305.24,246.004],[1338.55,345.713],[1338.55,259.504]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1338.55,345.713],[1338.55,259.504],[1350.35,354.577],[1350.35,272.316]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1427.38,452.351],[1427.38,364.252],[1439.02,456.38],[1439.02,372.365]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1427.38,552.276],[1427.38,464.177],[1439.02,551.672],[1439.02,467.657]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1427.38,566.973],[1427.38,655.072],[1439.02,565.688],[1439.02,649.702]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:37,
                    verts:[[1427.38,665.237],[1427.38,753.336],[1439.02,659.396],[1439.02,743.41]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[668.082,437.282],[668.082,333.905],[469.999,442.76],[469.999,344.939]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[668.082,554.534],[668.082,451.158],[469.999,553.713],[469.999,455.891]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[668.082,571.78],[668.082,675.156],[469.999,570.032],[469.999,667.854]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[668.082,687.083],[668.082,790.459],[469.999,679.14],[469.999,776.962]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[558.888,326.885],[558.888,232.288],[551.866,333.639],[551.866,242.05]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[603.263,324.251],[603.263,228.481],[558.888,326.885],[558.888,232.288]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[616.612,317.413],[616.612,218.597],[580.219,321.343],[580.219,224.279]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[644.819,314.626],[644.819,214.569],[616.612,317.413],[616.612,218.597]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[691.238,310.708],[691.238,208.906],[644.819,314.626],[644.819,214.569]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[891.366,431.106],[891.366,321.469],[669.286,437.248],[669.286,333.838]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[891.366,555.459],[891.366,445.822],[669.286,554.539],[669.286,451.129]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[891.366,573.75],[891.366,683.387],[669.286,571.79],[669.286,675.2]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[891.366,696.036],[891.366,805.674],[669.286,687.131],[669.286,790.541]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[892.048,825.839],[892.048,935.423],[670.031,809.569],[670.031,912.932]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[753.663,307.952],[753.663,204.923],[695.083,310.471],[695.083,208.563]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[795.223,306.513],[795.223,202.842],[753.663,307.952],[753.663,204.923]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[854.926,304.71],[854.926,200.236],[795.222,306.513],[795.222,202.842]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[854.927,304.71],[854.927,200.236],[875.764,308.074],[875.764,205.099]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[928.407,304.949],[928.407,200.582],[875.764,308.074],[875.764,205.099]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[891.366,431.106],[891.366,321.469],[979.353,431.536],[979.353,322.335]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[891.366,555.459],[891.366,445.822],[979.353,555.395],[979.353,446.194]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[891.366,573.75],[891.366,683.387],[979.353,573.612],[979.353,682.813]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[891.366,696.036],[979.353,695.413],[891.366,805.674],[979.353,804.614]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[892.048,825.839],[980.17,824.645],[892.048,935.423],[980.17,933.773]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[928.407,304.95],[928.407,200.582],[1012,307.141],[1012,203.749]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[979.353,431.536],[979.353,322.335],[1013.15,434.277],[1013.15,327.855]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[979.353,555.395],[979.353,446.194],[1013.15,554.984],[1013.15,448.562]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[979.353,573.612],[979.353,682.813],[1013.15,572.738],[1013.15,679.16]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[979.353,695.413],[979.353,804.614],[1013.15,691.439],[1013.15,797.861]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[980.17,824.645],[980.17,933.773],[1012.36,817.724],[1012.36,924.206]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1012,307.141],[1012,203.749],[1091.46,312.056],[1091.46,210.854]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1057.08,820.814],[1057.08,928.477],[1012.36,817.724],[1012.36,924.206]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1056.23,433.156],[1056.23,325.596],[1013.15,434.277],[1013.15,327.855]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1056.23,555.152],[1056.23,447.593],[1013.15,554.984],[1013.15,448.562]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1056.23,573.096],[1056.23,680.655],[1013.15,572.738],[1013.15,679.16]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1056.23,693.065],[1056.23,800.624],[1013.15,691.439],[1013.15,797.861]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1056.23,433.156],[1056.23,325.596],[1119.76,438.542],[1119.76,336.444]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1056.23,555.152],[1056.23,447.593],[1119.76,554.345],[1119.76,452.247]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1056.23,573.096],[1056.23,680.655],[1119.76,571.377],[1119.76,673.476]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1056.23,693.065],[1056.23,800.624],[1119.76,685.256],[1119.76,787.354]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1057.08,820.814],[1057.08,928.477],[1124.77,805.571],[1124.77,907.406]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1091.46,312.056],[1091.46,210.854],[1186.23,320.317],[1186.23,222.794]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1193.44,436.749],[1193.44,332.833],[1119.76,438.542],[1119.76,336.444]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1193.44,554.614],[1193.44,450.698],[1119.76,554.345],[1119.76,452.247]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1193.44,571.949],[1193.44,675.866],[1119.76,571.377],[1119.76,673.476]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1193.44,687.855],[1193.44,791.771],[1119.76,685.256],[1119.76,787.354]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1191.74,810.933],[1191.74,914.818],[1118.41,806.202],[1118.41,908.277]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1186.68,320.862],[1186.68,223.58],[1260.4,329.75],[1260.4,236.43]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1191.74,810.933],[1191.74,914.818],[1286.75,799.791],[1286.75,899.415]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1193.44,436.749],[1193.44,332.833],[1283.58,440.715],[1283.58,340.819]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1193.44,554.614],[1193.44,450.698],[1283.58,554.019],[1283.58,454.124]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1193.44,571.949],[1193.44,675.866],[1283.58,570.684],[1283.58,670.58]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1193.44,687.855],[1193.44,791.771],[1283.58,682.106],[1283.58,782.001]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1260.4,329.75],[1260.4,236.43],[1314.22,340.519],[1314.22,251.995]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1271.42,444.84],[1271.42,345.815],[1411.08,457.567],[1411.08,371.891]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1271.42,557.157],[1271.42,458.132],[1411.08,554.743],[1411.08,469.067]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1271.42,573.677],[1271.42,672.702],[1411.08,569.036],[1411.08,654.712]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1271.42,684.127],[1271.42,783.152],[1411.08,664.598],[1411.08,750.274]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1271.42,798.224],[1271.42,897.249],[1411.08,763.314],[1411.08,848.99]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1314.22,340.519],[1314.22,251.995],[1337.07,349.786],[1337.07,265.391]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1337.07,349.786],[1337.07,265.391],[1339.67,358.446],[1339.67,277.908]]
                },{
                    num:"502",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1426.45,454.464],[1426.45,368.507],[1428.59,458.385],[1428.59,376.403]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1426.45,551.959],[1426.45,466.002],[1428.59,551.371],[1428.59,469.39]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1426.45,566.299],[1426.45,652.256],[1428.59,565.048],[1428.59,647.03]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:38,
                    verts:[[1426.45,662.173],[1426.45,748.13],[1428.59,656.489],[1428.59,738.47]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[717.615,437.194],[717.615,333.729],[503.748,441.931],[503.748,343.269]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[717.615,554.547],[717.615,451.082],[503.748,553.837],[503.748,455.175]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[717.615,571.808],[717.615,675.273],[503.748,570.296],[503.748,668.959]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[717.615,687.21],[717.615,790.676],[503.748,680.343],[503.748,779.005]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[586.65,325.649],[586.65,230.502],[572.414,332.313],[572.414,240.135]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[634.407,323.37],[634.407,227.208],[586.65,325.649],[586.65,230.502]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[655.055,316.693],[655.055,217.556],[614.109,320.307],[614.109,222.781]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[686.436,314.156],[686.436,213.89],[655.055,316.693],[655.055,217.556]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[737.229,310.654],[737.229,208.827],[686.436,314.156],[686.436,213.89]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[954.792,431.94],[954.792,323.149],[718.904,437.165],[718.904,333.671]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[954.792,555.334],[954.792,446.543],[718.904,554.551],[718.904,451.057]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[954.792,573.483],[954.792,682.275],[718.904,571.817],[718.904,675.311]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[954.792,694.827],[954.792,803.618],[718.904,687.252],[718.904,790.746]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[955.346,823.623],[955.346,932.36],[719.544,809.783],[719.544,913.228]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[802.652,308.44],[802.652,205.627],[741.338,310.45],[741.338,208.533]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[845.633,307.36],[845.633,204.067],[802.653,308.44],[802.653,205.627]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[906.875,306.075],[906.875,202.21],[845.632,307.36],[845.632,204.067]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[906.875,306.075],[906.875,202.21],[924.115,309.546],[924.115,207.226]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[979.389,306.908],[979.389,203.414],[924.116,309.546],[924.116,207.226]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[954.792,431.94],[954.792,323.149],[1040.57,432.689],[1040.57,324.657]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[954.792,555.334],[954.792,446.543],[1040.57,555.222],[1040.57,447.19]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[954.792,573.483],[954.792,682.275],[1040.57,573.245],[1040.57,681.276]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[954.792,694.827],[954.792,803.618],[1040.57,693.741],[1040.57,801.773]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[955.346,823.623],[955.346,932.36],[1041.21,821.585],[1041.21,929.542]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[979.389,306.909],[979.389,203.414],[1059.51,309.724],[1059.51,207.483]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1040.57,432.689],[1040.57,324.657],[1067.48,435.488],[1067.48,330.294]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1040.57,555.222],[1040.57,447.19],[1067.48,554.803],[1067.48,449.608]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1040.57,573.245],[1040.57,681.276],[1067.48,572.352],[1067.48,677.546]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1040.57,693.741],[1040.57,801.773],[1067.48,689.683],[1067.48,794.878]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1041.21,821.585],[1041.21,929.542],[1066.84,814.518],[1066.84,919.773]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1059.51,309.724],[1059.51,207.483],[1132.4,315.145],[1132.4,215.319]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1112.26,434.551],[1112.26,328.406],[1067.48,435.488],[1067.48,330.294]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1112.26,554.943],[1112.26,448.799],[1067.48,554.803],[1067.48,449.608]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1112.26,572.651],[1112.26,678.795],[1067.48,572.352],[1067.48,677.546]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1112.26,691.042],[1112.26,797.187],[1067.48,689.683],[1067.48,794.878]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1113.32,817.099],[1113.32,923.341],[1066.84,814.518],[1066.84,919.773]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1112.26,434.551],[1112.26,328.406],[1162.04,440.02],[1162.04,339.42]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1112.26,554.943],[1112.26,448.799],[1162.04,554.124],[1162.04,453.523]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1112.26,572.651],[1112.26,678.795],[1162.04,570.906],[1162.04,671.506]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1112.26,691.042],[1112.26,797.187],[1162.04,683.113],[1162.04,783.714]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1113.32,817.099],[1113.32,923.342],[1166.33,801.626],[1166.33,901.952]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1132.4,315.145],[1132.4,215.319],[1216.5,323.907],[1216.5,227.983]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1237.74,438.533],[1237.74,336.425],[1162.04,440.02],[1162.04,339.42]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1237.74,554.346],[1237.74,452.239],[1162.04,554.124],[1162.04,453.523]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1237.74,571.38],[1237.74,673.488],[1162.04,570.906],[1162.04,671.506]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1237.74,685.269],[1237.74,787.377],[1162.04,683.113],[1162.04,783.714]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1236.02,806.222],[1236.02,908.305],[1160.67,802.298],[1160.67,902.88]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1216.4,324.439],[1216.4,228.752],[1279.05,333.609],[1279.05,242.008]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1236.02,806.222],[1236.02,908.305],[1318.45,794.565],[1318.45,892.19]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1237.74,438.533],[1237.74,336.425],[1315.99,442.684],[1315.99,344.785]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1237.74,554.346],[1237.74,452.239],[1315.99,553.724],[1315.99,455.825]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1237.74,571.38],[1237.74,673.488],[1315.99,570.056],[1315.99,667.956]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1237.74,685.269],[1237.74,787.377],[1315.99,679.251],[1315.99,777.15]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1279.05,333.609],[1279.05,242.008],[1320.41,344.429],[1320.41,257.647]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1320.41,344.429],[1320.41,257.647],[1333.32,353.568],[1333.32,270.857]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1302.33,446.678],[1302.33,349.581],[1407.29,459.414],[1407.29,375.674]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1302.33,556.808],[1302.33,459.711],[1407.29,554.393],[1407.29,470.654]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1302.33,573.006],[1302.33,670.103],[1407.29,568.363],[1407.29,652.102]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1302.33,681.306],[1302.33,778.404],[1407.29,661.764],[1407.29,745.503]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:39,
                    verts:[[1302.33,793.182],[1302.33,890.279],[1407.29,758.248],[1407.29,841.987]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[542.795,446.244],[542.795,351.954],[505.533,446.858],[505.533,353.19]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[542.795,553.191],[542.795,458.901],[505.533,553.099],[505.533,459.431]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[542.795,568.921],[542.795,663.211],[505.533,568.725],[505.533,662.392]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[542.795,674.09],[542.795,768.38],[505.533,673.2],[505.533,766.867]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[540.829,441.144],[540.829,341.683],[510.29,443.921],[510.29,347.275]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[540.829,553.955],[540.829,454.494],[510.29,553.539],[510.29,456.894]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[540.829,570.548],[540.829,670.008],[510.29,569.662],[510.29,666.307]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[540.829,681.484],[540.829,780.945],[510.29,677.458],[510.29,774.103]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[768.322,437.189],[768.322,333.718],[540.829,441.144],[540.829,341.683]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[768.322,554.548],[768.322,451.078],[540.829,553.955],[540.829,454.494]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[768.322,571.809],[768.322,675.28],[540.829,570.547],[540.829,670.008]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[768.322,687.218],[768.322,790.688],[540.829,681.484],[540.829,780.945]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[616.892,324.46],[616.892,228.783],[595.5,330.988],[595.5,238.219]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[667.611,322.555],[667.611,226.029],[616.892,324.46],[616.892,228.783]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[695.37,316.088],[695.37,216.682],[650.26,319.359],[650.26,221.41]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[729.602,313.82],[729.602,213.403],[695.37,316.088],[695.37,216.682]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[784.217,310.756],[784.217,208.975],[729.602,313.82],[729.602,213.403]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1016.4,432.876],[1016.4,325.032],[769.682,437.165],[769.682,333.671]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1016.4,555.194],[1016.4,447.351],[769.682,554.551],[769.682,451.057]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1016.4,573.185],[1016.4,681.028],[769.682,571.817],[769.682,675.311]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1016.4,693.471],[1016.4,801.314],[769.682,687.252],[769.682,790.747]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1016.83,821.141],[1016.83,928.929],[770.211,809.779],[770.211,913.223]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[851.906,309.092],[851.906,206.57],[788.542,310.588],[788.542,208.732]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[895.819,308.372],[851.906,309.092],[895.819,205.529],[851.906,206.57]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[957.901,307.598],[895.818,308.372],[957.901,204.411],[895.818,205.529]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[957.902,307.598],[957.902,204.411],[971.46,311.143],[971.46,209.534]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1028.69,308.993],[1028.69,206.427],[971.46,311.143],[971.46,209.534]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1016.4,432.876],[1016.4,325.032],[1099.04,433.921],[1099.04,327.137]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1016.4,555.194],[1016.4,447.351],[1099.04,555.038],[1099.04,448.254]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1016.4,573.185],[1016.4,681.028],[1099.04,572.852],[1099.04,679.635]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1016.4,693.471],[1016.4,801.314],[1099.04,691.956],[1099.04,798.74]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1016.83,821.141],[1016.83,928.929],[1099.5,818.319],[1099.5,925.027]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1028.69,308.993],[1028.69,206.427],[1104.61,312.378],[1104.61,211.32]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1099.04,433.921],[1099.04,327.137],[1119.05,436.75],[1119.05,332.834]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1099.04,555.038],[1099.04,448.254],[1119.05,554.614],[1119.05,450.698]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1099.04,572.852],[1099.04,679.635],[1119.05,571.949],[1119.05,675.865]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1099.04,691.956],[1099.04,798.74],[1119.05,687.854],[1119.05,791.77]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1099.5,818.319],[1099.5,925.027],[1118.55,811.175],[1118.55,915.153]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1104.61,312.378],[1104.61,211.32],[1170.51,318.231],[1170.51,219.78]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1166.2,813.258],[1118.55,811.175],[1166.2,918.032],[1118.55,915.153]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1164.94,435.993],[1164.94,331.311],[1119.05,436.75],[1119.05,332.834]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1164.94,554.727],[1164.94,450.045],[1119.05,554.614],[1119.05,450.698]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1164.94,572.19],[1164.94,676.873],[1119.05,571.949],[1119.05,675.865]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1164.94,688.951],[1164.94,793.633],[1119.05,687.854],[1119.05,791.77]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1164.94,435.993],[1164.94,331.311],[1201.12,441.494],[1201.12,342.388]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1164.94,554.727],[1164.94,450.045],[1201.12,553.903],[1201.12,454.797]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1164.94,572.19],[1164.94,676.873],[1201.12,570.436],[1201.12,669.542]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1164.94,688.951],[1164.94,793.633],[1201.12,680.976],[1201.12,780.082]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1166.2,813.258],[1166.2,918.032],[1204.69,797.698],[1204.69,896.522]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1170.51,318.231],[1170.51,219.78],[1243.69,327.391],[1243.69,233.021]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1277.97,440.302],[1277.97,339.988],[1201.12,441.494],[1201.12,342.388]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1277.97,554.081],[1277.97,453.767],[1201.12,553.903],[1201.12,454.797]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1277.97,570.816],[1277.97,671.13],[1201.12,570.436],[1201.12,669.542]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1277.97,682.704],[1277.97,783.018],[1201.12,680.976],[1201.12,780.082]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1276.24,801.548],[1276.24,901.845],[1199.75,798.403],[1199.75,897.496]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1243.07,327.909],[1243.07,233.767],[1294.75,337.273],[1294.75,247.303]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1276.24,801.548],[1276.24,901.845],[1346.06,789.513],[1346.06,885.208]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1277.97,440.302],[1277.97,339.988],[1344.3,444.59],[1344.3,348.622]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1277.97,554.081],[1277.97,453.767],[1344.3,553.439],[1344.3,457.471]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1277.97,570.816],[1277.97,671.13],[1344.3,569.448],[1344.3,665.416]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1277.97,682.704],[1277.97,783.018],[1344.3,676.489],[1344.3,772.456]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1294.75,337.273],[1294.75,247.303],[1324.11,348.068],[1324.11,262.908]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1324.11,348.068],[1324.11,262.908],[1327.61,357.036],[1327.61,275.869]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1329.36,448.454],[1329.36,353.22],[1401.1,461.111],[1401.1,379.151]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1329.36,556.471],[1329.36,461.237],[1401.1,554.071],[1401.1,472.112]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1329.36,572.359],[1329.36,667.593],[1401.1,567.744],[1401.1,649.703]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1329.36,678.581],[1329.36,773.815],[1401.1,659.16],[1401.1,741.119]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:40,
                    verts:[[1329.36,788.309],[1329.36,883.543],[1401.1,753.594],[1401.1,835.553]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[586.331,450.602],[586.331,360.729],[522.086,451.359],[522.086,362.254]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[586.331,552.538],[586.331,462.665],[522.086,552.424],[522.086,463.319]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[586.331,567.531],[586.331,657.403],[522.086,567.289],[522.086,656.394]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[586.331,667.772],[586.331,757.645],[522.086,666.675],[522.086,755.78]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[570.853,445.48],[570.853,350.416],[531.399,445.973],[531.399,351.408]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[570.853,553.305],[570.853,458.241],[531.399,553.231],[531.399,458.666]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[570.853,569.164],[570.853,664.229],[531.399,569.007],[531.399,663.572]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[570.853,675.197],[570.853,770.262],[531.399,674.483],[531.399,769.048]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[580.892,440.382],[580.892,340.15],[543.21,443.052],[543.21,345.526]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[580.892,554.069],[580.892,453.837],[543.21,553.669],[543.21,456.143]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[580.892,570.79],[580.892,671.023],[543.21,569.939],[543.21,667.465]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[580.892,682.588],[580.892,782.821],[543.21,678.717],[543.21,776.244]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[819.761,437.241],[819.761,333.824],[580.892,440.382],[580.892,340.15]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[819.761,554.54],[819.761,451.123],[580.892,554.069],[580.892,453.837]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[819.761,571.792],[819.761,675.21],[580.892,570.79],[580.892,671.023]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[819.761,687.142],[819.761,790.559],[580.892,682.588],[580.892,782.821]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[620.904,329.628],[620.904,236.254],[615.266,337.057],[615.266,246.992]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[649.337,323.28],[649.337,227.078],[620.904,329.628],[620.904,236.254]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[702.583,321.764],[702.583,224.887],[649.337,323.28],[649.337,227.078]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[737.2,315.552],[737.2,215.907],[688.346,318.456],[688.346,220.104]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[773.944,313.567],[773.944,213.039],[737.2,315.552],[737.2,215.908]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[831.808,310.96],[831.808,209.27],[773.944,313.567],[773.944,213.039]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1075.82,433.874],[1075.82,327.043],[821.177,437.223],[821.177,333.787]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1075.82,555.045],[1075.82,448.214],[821.177,554.543],[821.177,451.107]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1075.82,572.867],[1075.82,679.697],[821.177,571.798],[821.177,675.234]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1075.82,692.023],[1075.82,798.854],[821.177,687.169],[821.177,790.605]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1076.11,818.492],[1076.11,925.267],[821.59,809.623],[821.59,913.007]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[901.045,309.848],[901.045,207.662],[836.305,310.828],[836.305,209.079]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[945.422,309.483],[901.045,309.848],[945.422,207.135],[901.045,207.662]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1007.68,309.21],[945.422,309.483],[1007.68,206.74],[945.422,207.135]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1007.68,309.21],[1007.68,206.74],[1017.52,312.799],[1017.53,211.928]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1076.08,311.132],[1076.08,209.519],[1017.53,312.799],[1017.53,211.928]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1076.08,311.132],[1076.08,209.519],[1147.21,315.032],[1147.21,215.156]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1075.82,433.874],[1075.82,327.043],[1154.5,435.191],[1154.5,329.696]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1075.82,555.045],[1075.82,448.214],[1154.5,554.847],[1154.5,449.352]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1075.82,572.866],[1075.82,679.697],[1154.5,572.446],[1154.5,677.942]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1075.82,692.023],[1075.82,798.854],[1154.5,690.114],[1154.5,795.609]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1076.11,818.492],[1076.11,925.267],[1154.78,814.95],[1154.78,920.37]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1147.21,315.032],[1147.21,215.156],[1205.78,321.249],[1205.78,224.142]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1154.5,435.191],[1154.5,329.696],[1167.68,438.027],[1167.68,335.406]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1154.5,554.847],[1154.5,449.352],[1167.68,554.422],[1167.68,451.801]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1154.5,572.446],[1154.5,677.942],[1167.68,571.542],[1167.68,674.163]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1154.5,690.114],[1154.5,795.609],[1167.68,686.003],[1167.68,788.624]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1154.78,814.95],[1154.78,920.37],[1167.34,807.791],[1167.34,910.474]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1215.59,809.389],[1167.34,807.791],[1215.59,912.684],[1167.34,910.474]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1214.17,437.446],[1214.17,334.237],[1167.68,438.027],[1167.68,335.406]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1214.17,554.509],[1214.17,451.3],[1167.68,554.422],[1167.68,451.801]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1214.17,571.727],[1214.17,674.937],[1167.68,571.542],[1167.68,674.163]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1214.17,686.845],[1167.68,686.003],[1214.17,790.054],[1167.68,788.624]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1205.78,321.249],[1205.78,224.142],[1267.94,330.718],[1267.94,237.829]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1214.17,437.446],[1214.17,334.237],[1237.04,442.935],[1237.04,345.29]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1214.17,554.509],[1214.17,451.3],[1237.04,553.687],[1237.04,456.042]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1214.17,571.727],[1214.17,674.937],[1237.04,569.976],[1237.04,667.621]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1214.17,686.845],[1214.17,790.054],[1237.04,678.887],[1237.04,776.532]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1215.59,809.389],[1215.59,912.684],[1239.89,793.865],[1239.89,891.224]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1314.25,442.025],[1314.25,343.458],[1237.04,442.935],[1237.04,345.29]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1314.25,553.823],[1314.25,455.256],[1237.04,553.687],[1237.04,456.042]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1314.25,570.266],[1314.25,668.834],[1237.04,569.976],[1237.04,667.621]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1314.25,680.206],[1314.25,778.774],[1237.04,678.887],[1237.04,776.532]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1312.55,796.996],[1235.68,794.595],[1312.55,895.552],[1235.68,892.232]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1266.84,331.219],[1266.84,238.552],[1307.75,340.702],[1307.75,252.261]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1307.75,340.702],[1307.75,252.261],[1325.58,351.413],[1325.58,267.742]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1312.55,796.996],[1312.55,895.552],[1369.88,784.702],[1369.88,878.556]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1314.25,442.025],[1314.25,343.458],[1368.77,446.407],[1368.77,352.281]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1314.25,553.823],[1314.25,455.256],[1368.77,553.166],[1368.77,459.041]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1314.25,570.266],[1314.25,668.834],[1368.77,568.869],[1368.77,662.994]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1314.25,680.206],[1314.25,778.774],[1368.77,673.854],[1368.77,767.98]]
                },{
                    num:"503",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1352.76,450.146],[1352.76,356.686],[1392.85,462.653],[1392.85,382.311]]
                },{
                    num:"403",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1352.76,556.151],[1352.76,462.691],[1392.85,553.779],[1392.85,473.437]]
                },{
                    num:"303",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1352.76,571.742],[1352.76,665.202],[1392.85,567.182],[1392.85,647.523]]
                },{
                    num:"203",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1352.76,675.985],[1352.76,769.444],[1392.85,656.793],[1392.85,737.135]]
                },{
                    num:"103",
                    tipo:"TorreB",
                    frame:41,
                    verts:[[1352.76,783.669],[1352.76,877.129],[1392.85,749.363],[1392.85,829.704]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[605.243,449.867],[605.243,359.249],[537.96,450.428],[537.96,360.379]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[605.243,552.648],[605.243,462.03],[537.96,552.564],[537.96,462.515]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[605.243,567.765],[605.243,658.383],[537.96,567.586],[537.96,657.635]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[605.243,668.838],[605.243,759.456],[537.96,668.024],[537.96,758.073]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[601.496,444.694],[601.496,348.832],[560.138,445.059],[560.138,349.568]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[601.496,553.423],[601.496,457.561],[560.138,553.368],[560.138,457.877]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[601.496,569.415],[601.496,665.277],[560.138,569.299],[560.138,664.79]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[601.496,676.337],[601.496,772.199],[560.138,675.807],[560.138,771.299]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[623.64,439.632],[623.64,338.638],[579.042,442.174],[579.042,343.757]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[623.64,554.182],[623.64,453.188],[579.042,553.801],[579.042,455.384]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[623.64,571.03],[623.64,672.024],[579.042,570.219],[579.042,668.636]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[623.64,683.676],[623.64,784.67],[579.042,679.991],[579.042,778.408]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[871.573,437.33],[871.573,334.002],[623.64,439.632],[623.64,338.638]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[871.573,554.527],[871.573,451.199],[623.64,554.182],[623.64,453.188]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[871.573,571.764],[871.573,675.092],[623.64,571.03],[623.64,672.024]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[871.573,687.014],[871.573,790.341],[623.64,683.676],[623.64,784.67]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[648.443,328.203],[648.443,234.194],[635.095,335.586],[635.095,244.865]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[683.756,322.076],[683.756,225.337],[648.444,328.203],[648.444,234.194]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[739.082,320.962],[739.082,223.727],[683.756,322.075],[683.756,225.337]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[780.255,315.045],[780.255,215.174],[728.1,317.561],[728.1,218.811]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[819.159,313.356],[819.159,212.733],[780.255,315.045],[780.255,215.174]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[879.691,311.218],[879.691,209.643],[819.159,313.356],[819.159,212.733]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1132.76,434.905],[1132.76,329.119],[873.031,437.316],[873.031,333.975]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1132.76,554.89],[1132.76,449.104],[873.031,554.529],[873.031,451.188]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1132.76,572.538],[1132.76,678.324],[873.031,571.769],[873.031,675.11]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1132.76,690.529],[1132.76,796.315],[873.031,687.033],[873.031,790.374]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1132.93,815.76],[1132.93,921.49],[873.326,809.373],[873.326,912.661]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[949.776,310.655],[884.314,311.122],[949.776,208.829],[884.314,209.504]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[949.776,310.655],[994.172,310.639],[949.776,208.829],[994.172,208.806]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[994.172,310.639],[1056,310.851],[994.172,208.806],[1056,209.113]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1056,310.851],[1056,209.113],[1062.13,314.459],[1062.13,214.328]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1121.41,313.266],[1062.13,314.46],[1121.41,212.603],[1062.13,214.328]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1121.41,313.266],[1121.41,212.603],[1187.24,317.629],[1187.24,218.91]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1132.76,434.905],[1132.76,329.119],[1206.81,436.47],[1206.81,332.271]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1132.76,554.89],[1132.76,449.104],[1206.81,554.656],[1206.81,450.457]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1132.76,572.538],[1132.76,678.324],[1206.81,572.038],[1206.81,676.237]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1132.76,690.529],[1132.76,796.315],[1206.81,688.26],[1206.81,792.459]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1132.93,815.76],[1132.93,921.49],[1206.92,811.561],[1206.92,915.685]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1187.24,317.629],[1187.24,218.91],[1238.28,324.148],[1238.28,228.333]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1206.81,436.47],[1206.81,332.271],[1213.32,439.291],[1213.32,337.952]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1206.81,554.656],[1206.81,450.457],[1213.32,554.233],[1213.32,452.894]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1206.81,572.038],[1206.81,676.237],[1213.32,571.139],[1213.32,672.478]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1206.81,688.26],[1206.81,792.459],[1213.32,684.17],[1213.32,785.509]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1206.92,811.561],[1206.92,915.685],[1213.12,804.438],[1213.12,905.839]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1259.91,438.88],[1213.32,439.291],[1259.91,337.123],[1213.32,337.952]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1259.91,554.295],[1259.91,452.538],[1213.32,554.233],[1213.32,452.894]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1259.91,571.27],[1259.91,673.026],[1213.32,571.139],[1213.32,672.478]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1259.91,684.767],[1213.32,684.17],[1259.91,786.523],[1213.32,785.509]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1261.48,805.571],[1213.12,804.438],[1261.48,907.406],[1213.12,905.839]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1238.28,324.148],[1238.28,228.333],[1289.44,333.849],[1289.44,242.354]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1259.91,438.88],[1259.91,337.123],[1269.89,444.32],[1269.89,348.079]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1259.91,554.294],[1259.91,452.538],[1269.89,553.479],[1269.89,457.238]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1259.91,571.27],[1259.91,673.026],[1269.89,569.534],[1269.89,665.775]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1259.91,684.767],[1259.91,786.523],[1269.89,676.879],[1269.89,773.12]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1261.48,805.571],[1261.48,907.406],[1272.02,790.186],[1272.02,886.137]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1346.77,443.678],[1269.89,444.32],[1346.77,346.787],[1269.89,348.079]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1346.77,553.575],[1346.77,456.684],[1269.89,553.479],[1269.89,457.238]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1346.77,569.739],[1346.77,666.63],[1269.89,569.534],[1269.89,665.775]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1346.77,677.81],[1269.89,676.879],[1346.77,774.701],[1269.89,773.12]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1345.1,792.629],[1268.55,790.935],[1345.1,889.514],[1268.55,887.173]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1287.88,334.331],[1287.88,243.049],[1318.26,343.872],[1318.26,256.842]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1318.26,343.872],[1318.26,256.842],[1325.07,354.448],[1325.07,272.13]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1345.1,792.629],[1345.1,889.514],[1390.17,780.174],[1390.17,872.297]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1346.77,443.678],[1346.77,346.787],[1389.7,448.118],[1389.7,355.728]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1346.77,553.575],[1346.77,456.684],[1389.7,552.91],[1389.7,460.52]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1346.77,569.739],[1346.77,666.63],[1389.7,568.323],[1389.7,660.713]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:42,
                    verts:[[1346.77,677.81],[1346.77,774.701],[1389.7,671.373],[1389.7,763.764]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[626.333,449.07],[626.333,357.645],[556.423,449.427],[556.423,358.363]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[626.333,552.767],[626.333,461.342],[556.423,552.714],[556.423,461.65]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[626.333,568.019],[626.333,659.445],[556.423,567.905],[556.423,658.969]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[626.333,669.993],[626.333,761.418],[556.423,669.476],[556.423,760.539]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[634.566,443.874],[634.566,347.181],[591.607,444.106],[591.607,347.647]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[634.566,553.546],[634.566,456.853],[591.607,553.511],[591.607,457.053]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[634.566,569.677],[634.566,666.37],[591.607,569.603],[591.607,666.061]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[634.566,677.526],[634.566,774.219],[591.607,677.19],[591.607,773.648]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[668.827,438.879],[668.827,337.122],[617.595,441.274],[617.595,341.945]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[668.827,554.295],[668.827,452.538],[617.595,553.936],[617.595,454.607]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[668.827,571.27],[668.827,673.027],[617.595,570.506],[617.595,669.835]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[668.827,684.767],[668.827,786.524],[617.595,681.295],[617.595,780.624]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[656.902,333.982],[656.902,242.546],[647.076,344.053],[647.076,257.104]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[677.978,326.686],[677.978,232],[656.902,333.982],[656.902,242.546]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[923.475,437.436],[923.475,334.216],[668.827,438.879],[668.827,337.122]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[923.475,554.511],[923.475,451.291],[668.827,554.295],[668.827,452.538]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[923.475,571.73],[923.475,674.95],[668.827,571.27],[668.827,673.027]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[923.475,686.859],[923.475,790.079],[668.827,684.767],[668.827,786.524]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[719.966,320.818],[719.966,223.519],[677.979,326.686],[677.979,232]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[776.916,320.118],[776.916,222.507],[719.966,320.818],[719.966,223.519]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[824.299,314.532],[824.299,214.434],[769.302,316.644],[769.302,217.485]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[865.001,313.149],[865.001,212.434],[824.299,314.532],[824.299,214.434]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[927.617,311.491],[927.617,210.038],[865.001,313.149],[865.001,212.434]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1187.08,435.942],[1187.08,331.208],[924.96,437.428],[924.96,334.199]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1187.08,554.735],[1187.08,450.001],[924.96,554.512],[924.96,451.284]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1187.08,572.207],[1187.08,676.941],[924.96,571.733],[924.96,674.961]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1187.08,689.025],[1187.08,793.759],[924.96,686.872],[924.96,790.1]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1187.12,813.009],[1187.12,917.688],[925.133,809.076],[925.133,912.25]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[932.321,311.431],[997.876,311.472],[932.321,209.951],[997.876,210.01]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[997.876,311.472],[1041.87,311.796],[997.876,210.01],[1041.87,210.479]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1041.87,311.796],[1102.68,312.478],[1041.87,210.478],[1102.68,211.463]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1102.68,312.478],[1102.68,211.463],[1105.14,316.082],[1105.14,216.673]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1164.59,315.351],[1105.14,316.082],[1164.59,215.617],[1105.14,216.673]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1164.59,315.351],[1164.59,215.617],[1224.72,320.128],[1224.72,222.522]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1187.08,435.942],[1187.08,331.208],[1255.92,437.733],[1255.92,334.814]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1187.08,554.735],[1187.08,450.001],[1255.92,554.466],[1255.92,451.548]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1187.08,572.207],[1187.08,676.941],[1255.92,571.636],[1255.92,674.554]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1187.08,689.025],[1187.08,793.759],[1255.92,686.429],[1255.92,789.347]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1187.12,813.009],[1187.12,917.688],[1255.86,808.215],[1255.86,911.06]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1224.72,320.128],[1224.72,222.522],[1268.09,326.894],[1268.09,232.302]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1255.96,440.522],[1302.22,440.272],[1255.96,340.43],[1302.22,339.927]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1255.96,554.049],[1302.22,554.086],[1255.96,453.957],[1302.22,453.741]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1255.96,570.746],[1302.22,570.826],[1255.96,670.838],[1302.22,671.17]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1255.96,682.386],[1302.22,682.748],[1255.96,782.478],[1302.22,783.093]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1255.9,801.174],[1303.92,801.861],[1255.9,901.327],[1303.92,902.277]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1268.09,326.894],[1268.09,232.302],[1308.33,336.757],[1308.33,246.558]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1299.77,445.633],[1375.73,445.246],[1299.77,350.724],[1375.73,349.943]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1299.77,553.282],[1299.77,458.373],[1375.73,553.34],[1375.73,458.038]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1299.77,569.115],[1375.73,569.239],[1299.77,664.025],[1375.73,664.542]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1299.77,674.975],[1375.73,675.537],[1299.77,769.885],[1375.73,770.84]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1298.47,787.464],[1374.1,788.488],[1298.47,882.375],[1374.1,883.79]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1306.34,337.219],[1306.34,247.224],[1326.5,346.765],[1326.5,261.024]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1374.1,788.488],[1374.1,883.79],[1407.2,775.957],[1407.2,866.468]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1375.73,445.246],[1375.73,349.943],[1407.33,449.713],[1407.33,358.94]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1375.73,553.34],[1375.73,458.038],[1407.33,552.671],[1407.33,461.898]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1375.73,569.239],[1375.73,664.542],[1407.33,567.814],[1407.33,658.587]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:43,
                    verts:[[1375.73,675.537],[1375.73,770.84],[1407.33,669.061],[1407.33,759.834]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[577.441,448.346],[577.441,356.186],[566.085,452.796],[566.085,365.148]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[577.441,552.876],[577.441,460.716],[566.085,552.209],[566.085,464.561]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[577.441,568.25],[577.441,660.41],[566.085,566.831],[566.085,654.478]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[577.441,671.043],[577.441,763.202],[566.085,664.591],[566.085,752.239]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[649.543,448.203],[649.543,355.899],[577.441,448.346],[577.441,356.186]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[649.543,552.897],[649.543,460.593],[577.441,552.876],[577.441,460.716]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[649.543,568.296],[649.543,660.6],[577.441,568.25],[577.441,660.41]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[649.543,671.25],[649.543,763.554],[577.441,671.043],[577.441,763.202]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[669.954,443.011],[669.954,345.442],[625.715,443.103],[625.715,345.628]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[669.954,553.675],[669.954,456.107],[625.715,553.661],[625.715,456.187]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[669.954,569.952],[669.954,667.52],[625.715,569.922],[625.715,667.397]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[669.954,678.778],[669.954,776.346],[625.715,678.644],[625.715,776.118]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[716.26,438.115],[716.26,335.583],[658.732,440.344],[658.732,340.072]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[716.26,554.409],[716.26,451.878],[658.732,554.075],[658.732,453.803]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[716.26,571.514],[716.26,674.045],[658.732,570.803],[658.732,671.075]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[716.26,685.875],[716.26,788.407],[658.732,682.644],[658.732,782.916]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[680.625,332.224],[680.625,240.006],[660.399,342.27],[660.399,254.527]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[709.411,325.055],[709.411,229.643],[680.625,332.224],[680.625,240.006]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[757.831,319.485],[757.831,221.592],[709.411,325.055],[709.411,229.643]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[975.242,437.547],[975.242,334.44],[716.26,438.115],[716.26,335.583]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[975.242,554.494],[975.242,451.387],[716.26,554.409],[716.26,451.878]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[975.242,571.695],[975.242,674.802],[716.26,571.514],[716.26,674.045]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[975.242,686.698],[975.242,789.806],[716.26,685.875],[716.26,788.407]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[815.938,319.208],[757.83,319.485],[815.938,221.193],[757.83,221.593]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[869.148,313.99],[869.148,213.649],[811.785,315.68],[811.785,216.093]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[911.28,312.921],[911.28,212.105],[869.148,313.99],[869.148,213.649]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[975.398,311.75],[975.398,210.412],[911.28,312.921],[911.28,212.105]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[976.738,437.544],[1238.66,436.969],[976.738,334.433],[1238.66,333.276]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[976.738,554.495],[976.738,451.384],[1238.66,554.581],[1238.66,450.888]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[976.738,571.696],[1238.66,571.879],[976.738,674.807],[1238.66,675.572]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[976.738,686.703],[1238.66,687.536],[976.738,789.814],[1238.66,791.229]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[976.791,808.767],[1238.58,810.289],[976.791,911.824],[1238.58,913.927]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[980.138,311.727],[1045.18,312.267],[980.138,210.379],[1045.18,211.159]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1045.18,312.267],[1088.37,312.923],[1045.18,211.159],[1088.37,212.107]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1088.37,312.923],[1088.37,212.107],[1147.64,314.056],[1147.64,213.745]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1146.49,317.635],[1205.58,317.353],[1146.49,218.918],[1205.58,218.511]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1205.58,317.353],[1205.58,218.511],[1259.68,322.499],[1259.68,225.949]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1238.66,436.969],[1238.66,333.276],[1301.82,438.963],[1301.82,337.291]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1238.66,554.581],[1238.66,450.888],[1301.82,554.282],[1301.82,452.61]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1238.66,571.879],[1238.66,675.572],[1301.82,571.243],[1301.82,672.915]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1238.66,687.536],[1238.66,791.229],[1301.82,684.646],[1301.82,786.318]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1238.58,810.289],[1238.58,913.927],[1301.6,804.958],[1301.6,906.558]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1259.68,322.499],[1259.68,225.949],[1295.31,329.463],[1295.31,236.014]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1295.31,329.463],[1295.31,236.014],[1324.77,339.429],[1324.77,250.42]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1295.62,441.704],[1341.15,441.609],[1295.62,342.811],[1341.15,342.619]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1295.62,553.871],[1295.62,454.978],[1341.15,553.885],[1341.15,454.896]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1295.62,570.369],[1295.62,669.262],[1341.15,570.399],[1341.15,669.389]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1295.62,680.672],[1341.15,680.81],[1295.62,779.566],[1341.15,779.8]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1295.7,798.038],[1342.96,798.3],[1295.7,896.992],[1342.96,897.354]]
                },{
                    num:"603",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1322.39,339.87],[1322.39,251.055],[1332.61,349.376],[1332.61,264.798]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1326.82,446.864],[1326.82,353.203],[1401.3,446.717],[1401.3,352.906]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1326.82,553.098],[1326.82,459.436],[1401.3,553.12],[1401.3,459.309]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1326.82,568.723],[1326.82,662.384],[1401.3,568.77],[1401.3,662.581]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1326.82,673.191],[1326.82,766.852],[1401.3,673.404],[1401.3,767.215]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1325.56,784.211],[1399.72,784.6],[1325.56,877.878],[1399.72,878.415]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1399.72,784.6],[1399.72,878.415],[1421.21,772.066],[1421.21,861.089]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1401.3,446.717],[1401.3,352.906],[1421.91,451.187],[1421.91,361.907]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1401.3,553.12],[1401.3,459.309],[1421.91,552.45],[1421.91,463.171]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1401.3,568.77],[1401.3,662.581],[1421.91,567.344],[1421.91,656.624]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:44,
                    verts:[[1401.3,673.404],[1401.3,767.215],[1421.91,666.925],[1421.91,756.204]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[601.025,447.178],[601.025,353.835],[579.083,451.638],[579.083,362.816]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[601.025,553.051],[601.025,459.708],[579.083,552.382],[579.083,463.561]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[601.025,568.623],[601.025,661.966],[579.083,567.2],[579.083,656.022]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[601.025,672.736],[601.025,766.079],[579.083,666.27],[579.083,755.092]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[674.86,447.26],[674.86,354],[601.025,447.178],[601.025,353.835]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[674.86,553.039],[674.86,459.778],[601.025,553.051],[601.025,459.708]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[674.86,568.597],[674.86,661.857],[601.025,568.623],[601.025,661.966]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[674.86,672.617],[674.86,765.878],[601.025,672.736],[601.025,766.079]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[707.59,442.099],[662.408,442.046],[707.59,343.606],[662.408,343.499]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[707.59,553.812],[707.59,455.319],[662.408,553.82],[662.408,455.274]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[707.59,570.243],[707.59,668.736],[662.408,570.26],[662.408,668.806]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[707.59,680.1],[662.408,680.176],[707.59,778.593],[662.408,778.723]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[677.511,340.704],[677.511,252.261],[665.965,350.18],[665.965,265.96]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[706.24,330.299],[706.24,237.223],[675.501,340.271],[675.501,251.637]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[765.788,437.334],[765.788,334.011],[702.355,439.378],[702.355,338.127]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[765.788,554.526],[765.788,451.203],[702.355,554.22],[702.355,452.969]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[765.788,571.763],[765.788,675.086],[702.355,571.111],[702.355,672.362]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[765.788,687.007],[765.788,790.331],[702.355,684.044],[702.355,785.296]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[742.683,323.298],[742.683,227.103],[706.24,330.299],[706.24,237.223]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[797.251,318.064],[797.251,219.538],[742.683,323.298],[742.683,227.103]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[765.788,437.334],[1026.69,437.654],[765.788,334.011],[1026.69,334.655]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[765.788,554.526],[1026.69,554.478],[765.788,451.203],[1026.69,451.48]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[765.788,571.763],[1026.69,571.661],[765.788,675.086],[1026.69,674.659]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[765.788,687.007],[1026.69,686.543],[765.788,790.331],[1026.69,789.542]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[856.039,318.22],[797.251,318.064],[856.039,219.764],[797.251,219.538]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[914.656,313.402],[914.656,212.799],[855.418,314.657],[855.418,214.614]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[957.845,312.656],[914.656,313.402],[957.845,211.721],[914.656,212.799]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1022.88,311.977],[957.845,312.656],[1022.88,210.74],[957.845,211.721]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1027.61,311.99],[1027.61,210.759],[1091.55,313.021],[1091.55,212.249]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1028.19,437.656],[1028.19,334.659],[1287.44,437.974],[1287.44,335.3]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1028.19,554.478],[1028.19,451.481],[1287.44,554.43],[1287.44,451.756]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1028.19,571.66],[1028.19,674.657],[1287.44,571.559],[1287.44,674.233]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1028.19,686.541],[1028.19,789.537],[1287.44,686.079],[1287.44,788.754]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1028.12,808.47],[1028.12,911.413],[1287.24,807.628],[1287.24,910.248]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1091.55,313.021],[1091.55,212.249],[1133.57,313.998],[1133.57,213.661]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1133.57,313.998],[1133.57,213.661],[1190.79,315.565],[1190.79,215.926]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1186.11,319.1],[1244.35,319.255],[1186.11,221.035],[1244.35,221.259]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1244.35,319.255],[1244.35,221.259],[1292.15,324.726],[1292.15,229.168]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1287.44,437.974],[1287.44,335.3],[1344.51,440.149],[1344.51,339.68]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1287.44,554.43],[1287.44,451.756],[1344.51,554.104],[1344.51,453.635]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1287.44,571.559],[1287.44,674.233],[1344.51,570.865],[1344.51,671.334]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1287.44,686.079],[1287.44,788.754],[1344.51,682.926],[1344.51,783.395]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1287.24,807.628],[1287.24,910.248],[1344.14,801.817],[1344.14,902.216]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1292.15,324.726],[1292.15,229.168],[1320.02,331.842],[1320.02,239.453]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1320.02,331.842],[1320.02,239.453],[1338.88,341.858],[1338.88,253.931]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1332.56,795.052],[1378.7,794.909],[1332.56,892.864],[1378.7,892.666]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1332.34,442.829],[1332.34,345.076],[1376.8,442.881],[1376.8,345.181]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1332.34,553.703],[1332.34,455.95],[1376.8,553.695],[1376.8,455.995]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1332.34,570.01],[1332.34,667.763],[1376.8,569.994],[1376.8,667.693]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1332.34,679.041],[1332.34,776.794],[1376.8,678.966],[1376.8,776.666]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1351.14,448.008],[1351.14,355.506],[1423.65,448.088],[1423.65,355.668]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1351.14,552.926],[1351.14,460.425],[1423.65,552.914],[1423.65,460.494]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1351.14,568.358],[1351.14,660.86],[1423.65,568.332],[1423.65,660.753]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1351.14,671.533],[1351.14,764.034],[1423.65,671.416],[1423.65,763.837]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1349.92,781.188],[1349.92,873.699],[1422.14,780.976],[1422.14,873.406]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1422.14,780.976],[1422.14,873.406],[1432.38,768.502],[1432.38,856.163]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1423.65,448.088],[1423.65,355.668],[1433.62,452.538],[1433.62,364.627]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1423.65,552.914],[1423.65,460.494],[1433.62,552.248],[1433.62,464.338]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1423.65,568.332],[1423.65,660.753],[1433.62,566.913],[1433.62,654.823]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:45,
                    verts:[[1423.65,671.416],[1423.65,763.837],[1433.62,664.966],[1433.62,752.876]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[627.22,445.92],[627.22,351.301],[594.445,450.368],[594.445,360.258]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[627.22,553.239],[627.22,458.621],[594.445,552.573],[594.445,462.463]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[627.22,569.024],[627.22,663.643],[594.445,567.605],[594.445,657.715]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[627.22,674.56],[627.22,769.178],[594.445,668.112],[594.445,758.222]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[702.294,446.237],[627.22,445.92],[702.294,351.939],[627.22,351.301]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[702.294,553.192],[702.294,458.894],[627.22,553.239],[627.22,458.621]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[702.294,568.923],[627.22,569.024],[702.294,663.221],[627.22,663.643]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[702.294,674.101],[627.22,674.56],[702.294,768.399],[627.22,769.178]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[694.022,338.497],[694.022,249.071],[672.655,347.989],[672.655,262.793]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[733.748,328.199],[733.748,234.187],[692.413,338.046],[692.413,248.421]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[701.668,440.932],[747.433,441.136],[701.668,341.256],[747.433,341.667]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[701.668,553.987],[747.433,553.956],[701.668,454.311],[747.433,454.487]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[701.668,570.615],[747.433,570.55],[701.668,670.291],[747.433,670.019]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[701.668,681.791],[747.433,681.496],[701.668,781.467],[747.433,780.965]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[777.758,321.408],[777.758,224.372],[733.748,328.199],[733.748,234.187]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[748.394,438.375],[748.394,336.107],[747.433,441.136],[747.433,341.667]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[748.394,554.37],[748.394,452.102],[747.433,553.956],[747.433,454.487]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[748.394,571.431],[748.394,673.699],[747.433,570.55],[747.433,670.019]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[748.394,685.498],[748.394,787.766],[747.433,681.496],[747.433,780.965]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[817.283,436.535],[817.283,332.402],[748.394,438.375],[748.394,336.107]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[817.283,554.646],[817.283,450.513],[748.394,554.37],[748.394,452.102]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[817.283,572.018],[817.283,676.151],[748.394,571.431],[748.394,673.699]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[817.283,688.165],[817.283,792.298],[748.394,685.498],[748.394,787.766]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[838.151,316.549],[838.151,217.349],[777.758,321.408],[777.758,224.372]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[817.283,436.535],[817.283,332.402],[1077.65,437.754],[1077.65,334.856]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[817.283,554.646],[817.283,450.513],[1077.65,554.463],[1077.65,451.566]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[817.283,572.018],[817.283,676.151],[1077.65,571.629],[1077.65,674.526]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[817.283,688.165],[817.283,792.298],[1077.65,686.398],[1077.65,789.296]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[838.151,316.549],[897.127,317.148],[838.151,217.349],[897.127,218.215]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[900.09,313.569],[900.09,213.042],[897.127,317.148],[897.127,218.215]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[960.695,312.763],[900.09,313.569],[960.695,211.876],[900.09,213.042]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1004.56,312.346],[960.695,312.763],[1004.56,211.274],[960.695,211.876]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1004.56,312.346],[1069.92,312.165],[1004.56,211.274],[1069.92,211.011]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1074.6,312.214],[1074.6,211.082],[1136.88,313.726],[1136.88,213.268]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1079.13,437.761],[1079.13,334.87],[1333.36,438.951],[1333.36,337.267]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1079.13,554.462],[1079.13,451.572],[1333.36,554.284],[1333.36,452.6]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1079.13,571.627],[1079.13,674.517],[1333.36,571.247],[1333.36,672.931]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1079.13,686.388],[1079.13,789.279],[1333.36,684.663],[1333.36,786.347]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1078.94,808.193],[1078.94,911.03],[1333.04,805.041],[1333.04,906.673]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1136.88,313.726],[1136.88,213.268],[1177.36,315.014],[1177.36,215.129]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1177.36,315.014],[1177.36,215.129],[1232.07,316.996],[1232.07,217.995]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1223.97,320.468],[1223.97,223.014],[1280.89,321.046],[1280.89,223.849]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1280.89,321.047],[1280.89,223.849],[1322.15,326.803],[1322.15,232.17]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1322.15,326.803],[1322.15,232.17],[1342.28,334.029],[1342.28,242.615]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1333.36,438.951],[1333.36,337.267],[1384.01,441.288],[1384.01,341.972]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1333.36,554.284],[1333.36,452.6],[1384.01,553.934],[1384.01,454.618]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1333.36,571.247],[1333.36,672.931],[1384.01,570.502],[1384.01,669.817]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1333.36,684.663],[1333.36,786.347],[1384.01,681.276],[1384.01,780.591]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1333.04,805.041],[1333.04,906.673],[1383.49,798.805],[1383.49,898.053]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1342.28,334.029],[1342.28,242.615],[1350.75,344.048],[1350.75,257.096]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1366.17,443.893],[1366.17,347.22],[1409.22,444.085],[1409.22,347.606]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1366.17,553.543],[1366.17,456.87],[1409.22,553.514],[1409.22,457.036]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1366.17,569.671],[1366.17,666.344],[1409.22,569.609],[1409.22,666.088]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1366.17,677.498],[1366.17,774.171],[1409.22,677.22],[1409.22,773.699]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1366.5,792.226],[1366.5,888.957],[1411.18,791.698],[1411.18,888.227]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1372.81,449.064],[1372.81,357.632],[1442.92,449.36],[1442.92,358.228]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1372.81,552.768],[1372.81,461.337],[1442.92,552.724],[1442.92,461.592]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1372.81,568.021],[1372.81,659.453],[1442.92,567.927],[1442.92,659.059]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1372.81,670.002],[1372.81,761.434],[1442.92,669.573],[1442.92,760.705]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:46,
                    verts:[[1371.64,778.399],[1371.64,869.843],[1441.47,777.618],[1441.47,868.764]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[656.109,444.571],[656.109,348.585],[612.28,448.982],[612.28,357.467]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[656.109,553.442],[656.109,457.455],[612.28,552.781],[612.28,461.266]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[656.109,569.454],[656.109,665.441],[612.28,568.047],[612.28,659.562]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[656.109,676.515],[656.109,772.502],[612.28,670.121],[612.28,761.636]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[656.109,444.571],[731.887,445.134],[656.109,348.585],[731.887,349.718]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[656.109,553.442],[656.109,457.455],[731.887,553.357],[731.887,457.941]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[656.109,569.454],[656.109,665.441],[731.887,569.275],[731.887,664.691]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[656.109,676.515],[731.887,675.7],[656.109,772.502],[731.887,771.116]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[680.981,345.526],[680.981,259.233],[672.753,355.973],[672.753,274.333]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[712.379,336.059],[712.379,245.547],[680.981,345.526],[680.981,259.233]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[763.175,325.925],[763.175,230.901],[711.195,335.591],[711.195,244.873]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[743.497,439.764],[743.497,338.904],[731.887,445.134],[731.887,349.718]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[743.497,554.162],[743.497,453.302],[731.887,553.357],[731.887,457.941]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[743.497,570.988],[743.497,671.848],[731.887,569.275],[731.887,664.691]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[743.497,683.485],[743.497,784.345],[731.887,675.7],[731.887,771.115]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[743.497,439.764],[789.458,440.125],[743.497,338.904],[789.458,339.631]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[743.497,554.162],[743.497,453.302],[789.458,554.108],[789.458,453.614]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[743.497,570.988],[743.497,671.848],[789.458,570.873],[789.458,671.366]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[743.497,683.485],[789.458,682.961],[743.497,784.345],[789.458,783.455]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[814.619,319.391],[814.619,221.456],[763.175,325.925],[763.175,230.901]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[796.795,437.339],[796.795,334.021],[789.458,440.125],[789.458,339.631]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[796.795,554.525],[796.795,451.207],[789.458,554.108],[789.458,453.614]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[796.795,571.761],[796.795,675.08],[789.458,570.873],[789.458,671.366]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[796.795,687],[796.795,790.319],[789.458,682.961],[789.458,783.455]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[870.628,435.723],[870.628,330.767],[796.795,437.339],[796.795,334.021]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[870.628,554.768],[870.628,449.811],[796.795,554.525],[796.795,451.207]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[870.628,572.277],[870.628,677.233],[796.795,571.761],[796.795,675.08]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[870.628,689.343],[870.628,794.299],[796.795,687],[796.795,790.318]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[880.464,314.948],[880.464,215.034],[814.62,319.391],[814.62,221.456]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[870.628,435.723],[870.628,330.767],[1127.96,437.848],[1127.96,335.047]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[870.628,554.768],[870.628,449.811],[1127.96,554.449],[1127.96,451.647]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[870.628,572.277],[870.628,677.233],[1127.96,571.599],[1127.96,674.401]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[870.628,689.343],[870.628,794.299],[1127.96,686.262],[1127.96,789.064]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[880.463,314.948],[939.118,315.998],[880.463,215.034],[939.118,216.552]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[945.695,312.423],[945.695,211.385],[939.118,315.998],[939.118,216.552]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1007.14,312.079],[945.695,312.423],[1007.14,210.887],[945.695,211.385]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1007.14,312.079],[1051.28,311.998],[1007.14,210.887],[1051.28,210.77]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1051.28,311.998],[1116.38,312.317],[1051.28,210.77],[1116.38,211.231]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1120.97,312.401],[1120.97,211.354],[1181.02,314.384],[1181.02,214.219]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1129.41,437.86],[1129.41,335.071],[1376.33,439.899],[1376.33,339.177]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1129.41,554.447],[1129.41,451.658],[1376.33,554.142],[1376.33,453.419]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1129.41,571.595],[1129.41,674.385],[1376.33,570.945],[1376.33,671.667]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1129.41,686.244],[1129.41,789.034],[1376.33,683.288],[1376.33,784.01]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1129.1,807.931],[1129.1,910.668],[1375.91,802.53],[1375.91,903.202]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1181.02,314.384],[1181.02,214.219],[1219.62,315.972],[1219.62,216.514]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1219.62,315.972],[1219.62,216.514],[1271.38,318.351],[1271.38,219.954]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1259.97,321.743],[1259.97,224.857],[1315.14,322.731],[1315.14,226.284]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1315.14,322.731],[1315.14,226.284],[1349.69,328.733],[1349.69,234.96]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1349.69,328.733],[1349.69,234.96],[1362.13,336.031],[1362.13,245.508]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1376.33,439.899],[1376.33,339.177],[1420.29,442.378],[1420.29,344.168]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1376.33,554.142],[1376.33,453.419],[1420.29,553.77],[1420.29,455.56]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1376.33,570.945],[1376.33,671.667],[1420.29,570.154],[1420.29,668.364]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1376.33,683.288],[1376.33,784.01],[1420.29,679.695],[1420.29,777.905]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1375.91,802.53],[1375.91,903.202],[1419.64,795.921],[1419.64,894.065]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1397.08,444.899],[1397.08,349.244],[1438.43,445.223],[1438.43,349.898]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1397.08,553.392],[1397.08,457.738],[1438.43,553.344],[1438.43,458.019]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1397.08,569.35],[1397.08,665.004],[1438.43,569.246],[1438.43,664.571]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1397.08,676.041],[1397.08,771.695],[1438.43,675.57],[1438.43,770.895]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1397.54,789.556],[1397.54,885.267],[1440.44,788.662],[1440.44,884.031]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1391.86,450.034],[1391.86,359.587],[1459.17,450.534],[1459.17,360.593]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1391.86,552.623],[1391.86,462.175],[1459.17,552.548],[1459.17,462.607]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1391.86,567.712],[1391.86,658.159],[1459.17,567.552],[1459.17,657.493]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1391.86,668.595],[1391.86,759.043],[1459.17,667.87],[1459.17,757.811]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:47,
                    verts:[[1390.76,775.834],[1390.76,866.298],[1457.81,774.514],[1457.81,864.473]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[650.254,451.178],[650.254,358.801],[606.478,463.484],[606.478,384.015]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[650.254,555.955],[650.254,463.578],[606.478,553.621],[606.478,474.152]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[650.254,571.366],[650.254,663.743],[606.478,566.878],[606.478,646.348]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[650.254,674.401],[650.254,766.778],[606.478,655.517],[606.478,734.987]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[687.8,443.135],[687.8,345.694],[632.734,447.481],[632.734,354.446]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[687.8,553.657],[687.8,456.215],[632.734,553.005],[632.734,459.97]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[687.8,569.912],[687.8,667.354],[632.734,568.526],[632.734,661.562]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[687.8,678.597],[687.8,776.038],[632.734,672.296],[632.734,765.332]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[691.041,342.788],[691.041,255.276],[672.016,353.345],[672.016,270.534]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[687.8,443.135],[687.8,345.694],[763.694,443.956],[763.694,347.346]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[687.8,553.657],[687.8,456.215],[763.694,553.534],[763.694,456.924]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[687.8,569.912],[687.8,667.354],[763.694,569.651],[763.694,666.26]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[687.8,678.597],[687.8,776.038],[763.694,677.407],[763.694,774.017]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[732.667,333.396],[732.667,241.697],[691.042,342.788],[691.042,255.276]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[794.559,323.489],[794.559,227.379],[731.933,332.913],[731.933,241.001]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[787.903,438.55],[787.903,336.459],[763.694,443.956],[763.694,347.346]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[787.903,554.344],[787.903,452.253],[763.694,553.534],[763.694,456.924]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[787.903,571.375],[787.903,673.466],[763.694,569.65],[763.694,666.26]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[787.903,685.245],[787.903,787.335],[763.694,677.407],[763.694,774.017]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[787.903,438.55],[787.903,336.459],[833.644,439.074],[833.644,337.515]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[787.903,554.344],[787.903,452.253],[833.644,554.265],[833.644,452.706]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[787.903,571.375],[787.903,673.465],[833.644,571.208],[833.644,672.767]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[787.903,685.245],[787.903,787.335],[833.644,684.485],[833.644,786.044]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[853.254,317.261],[853.254,218.377],[794.559,323.489],[794.559,227.379]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[847.5,436.279],[847.5,331.887],[833.644,439.074],[833.644,337.515]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[847.5,554.684],[847.5,450.292],[833.644,554.265],[833.644,452.706]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[847.5,572.099],[847.5,676.492],[833.644,571.208],[833.644,672.767]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[847.5,688.536],[847.5,792.928],[833.644,684.485],[833.644,786.044]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[925.687,434.908],[925.687,329.125],[847.5,436.279],[847.5,331.887]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[925.687,554.89],[925.687,449.107],[847.5,554.684],[847.5,450.292]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[925.687,572.537],[925.687,678.319],[847.5,572.099],[847.5,676.492]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[925.687,690.525],[925.687,796.307],[847.5,688.536],[847.5,792.928]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[924.119,313.276],[924.119,212.618],[853.255,317.261],[853.255,218.377]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[924.118,313.276],[924.118,212.618],[981.919,314.786],[981.919,214.8]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[925.687,434.908],[925.687,329.125],[1177.42,437.944],[1177.42,335.239]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[925.687,554.89],[925.687,449.107],[1177.42,554.435],[1177.42,451.73]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[925.687,572.537],[925.687,678.319],[1177.42,571.568],[1177.42,674.273]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[925.687,690.524],[925.687,796.307],[1177.42,686.123],[1177.42,788.828]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[992.116,311.236],[992.116,209.67],[981.919,314.785],[981.919,214.8]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[992.116,311.236],[1053.84,311.367],[992.116,209.67],[1053.84,209.858]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1053.84,311.367],[1097.86,311.627],[1053.84,209.858],[1097.86,210.234]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1097.86,311.627],[1097.86,210.234],[1162.09,312.448],[1162.09,211.421]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1166.55,312.568],[1166.55,211.595],[1223.84,315.009],[1223.84,215.122]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1178.4,807.667],[1178.4,910.303],[1415.72,800.083],[1415.72,899.819]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1178.83,437.961],[1178.83,335.273],[1416.25,440.824],[1416.25,341.039]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1178.83,554.432],[1178.83,451.745],[1416.25,554.003],[1416.25,454.218]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1178.83,571.563],[1178.83,674.251],[1416.25,570.65],[1416.25,670.434]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1178.83,686.099],[1178.83,788.786],[1416.25,681.947],[1416.25,781.732]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1223.84,315.009],[1223.84,215.122],[1260.22,316.885],[1260.22,217.834]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1260.22,316.885],[1260.22,217.834],[1308.61,319.642],[1308.61,221.819]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1294.04,322.936],[1294.04,226.581],[1347.02,324.32],[1347.02,228.581]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1347.02,324.32],[1347.02,228.581],[1374.73,330.53],[1374.73,237.557]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1374.73,330.53],[1374.73,237.557],[1379.55,337.86],[1379.55,248.152]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1416.25,440.824],[1416.25,341.039],[1453.29,443.425],[1453.29,346.277]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1416.25,554.003],[1416.25,454.218],[1453.29,553.613],[1453.29,456.465]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1416.25,570.649],[1416.25,670.434],[1453.29,569.82],[1453.29,666.968]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1416.25,681.947],[1416.25,781.732],[1453.29,678.177],[1453.29,775.326]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1415.72,800.083],[1415.72,899.819],[1452.52,793.152],[1452.52,890.238]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1425.05,445.85],[1425.05,351.159],[1464.41,446.301],[1464.41,352.068]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1425.05,553.25],[1425.05,458.56],[1464.41,553.182],[1464.41,458.949]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1425.05,569.047],[1425.05,663.737],[1464.41,568.903],[1464.41,663.136]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1425.05,674.662],[1425.05,769.352],[1464.41,674.008],[1464.41,768.241]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1425.62,787.03],[1425.62,881.774],[1466.46,785.788],[1466.46,880.058]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1408.31,450.926],[1408.31,361.382],[1472.45,451.619],[1472.45,362.778]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1408.31,552.489],[1408.31,462.945],[1472.45,552.385],[1472.45,463.544]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1408.31,567.427],[1408.31,656.971],[1472.45,567.206],[1472.45,656.047]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1408.31,667.303],[1408.31,756.847],[1472.45,666.298],[1472.45,755.139]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:48,
                    verts:[[1407.28,773.48],[1407.27,863.043],[1471.16,771.648],[1471.16,860.511]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[615.467,750.636],[615.467,831.465],[595.204,741.711],[595.204,819.127]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[672.417,449.69],[672.417,355.752],[597.914,462.119],[597.914,381.217]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[672.417,556.237],[672.417,462.299],[597.914,553.88],[597.914,472.978]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[672.417,571.908],[672.417,665.846],[597.914,567.376],[597.914,648.278]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[672.417,676.685],[672.417,770.622],[597.914,657.612],[597.914,738.514]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[623.761,761.085],[623.761,845.909],[601.699,751.061],[601.699,832.052]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[722.411,441.623],[722.411,342.648],[655.982,445.872],[655.982,351.205]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[722.411,553.883],[722.411,454.908],[655.982,553.247],[655.982,458.579]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[722.411,570.395],[722.411,669.37],[655.982,569.039],[655.982,663.707]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[722.411,680.789],[722.411,779.765],[655.982,674.629],[655.982,769.297]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[672.748,350.404],[672.748,266.284],[668.211,359.193],[668.211,278.988]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[702.962,339.783],[702.962,250.931],[672.748,350.404],[672.748,266.284]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[754.984,330.52],[754.984,237.54],[702.962,339.783],[702.962,250.931]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[722.411,441.623],[722.411,342.648],[797.775,442.713],[797.775,344.844]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[722.411,553.883],[722.411,454.908],[797.775,553.72],[797.775,455.85]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[722.411,570.395],[722.411,669.37],[797.775,570.047],[797.775,667.917]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[722.411,680.789],[722.411,779.765],[797.775,679.209],[797.775,777.078]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[827.938,320.912],[827.938,223.654],[754.726,330.023],[754.726,236.825]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[834.88,437.304],[834.88,333.951],[797.775,442.713],[797.775,344.844]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[834.88,554.531],[834.88,451.177],[797.775,553.72],[797.775,455.85]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[834.88,571.772],[834.88,675.126],[797.775,570.047],[797.775,667.917]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[834.88,687.05],[834.88,790.404],[797.775,679.209],[797.775,777.078]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[893.633,315.044],[893.633,215.174],[827.938,320.912],[827.938,223.654]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[834.88,437.304],[834.88,333.951],[879.95,437.997],[879.95,335.345]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[834.88,554.531],[834.88,451.177],[879.95,554.427],[879.95,451.775]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[834.88,571.772],[834.88,675.126],[879.95,571.551],[879.95,674.203]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[834.88,687.05],[834.88,790.404],[879.95,686.047],[879.95,788.698]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[900.419,435.212],[900.419,329.738],[879.95,437.997],[879.95,335.345]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[900.419,554.844],[900.419,449.37],[879.95,554.427],[879.95,451.775]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[900.419,572.44],[900.419,677.914],[879.95,571.552],[879.95,674.203]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[900.419,690.083],[900.419,795.557],[879.95,686.047],[879.95,788.698]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[969.017,311.564],[969.017,210.143],[893.634,315.045],[893.634,215.174]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[982.289,434.106],[982.289,327.51],[900.419,435.212],[900.419,329.738]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[982.289,555.01],[982.289,448.414],[900.419,554.844],[900.419,449.37]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[982.289,572.793],[982.289,679.388],[900.419,572.44],[900.419,677.914]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[982.289,691.687],[982.289,798.283],[900.419,690.083],[900.419,795.557]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[969.017,311.564],[969.017,210.143],[1025.41,313.539],[1025.41,212.998]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[982.289,434.106],[982.289,327.51],[1225.8,438.052],[1225.8,335.457]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[982.289,555.01],[982.289,448.414],[1225.8,554.419],[1225.8,451.824]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[982.289,572.793],[982.289,679.388],[1225.8,571.534],[1225.8,674.129]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[982.289,691.687],[982.289,798.283],[1225.8,685.966],[1225.8,788.561]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1039.2,310.039],[1039.2,207.939],[1025.41,313.539],[1025.41,212.998]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1039.2,310.039],[1100.62,310.655],[1039.2,207.939],[1100.62,208.829]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1100.62,310.655],[1144.1,311.261],[1100.62,208.829],[1144.1,209.705]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1144.1,311.261],[1144.1,209.705],[1206.86,312.584],[1206.86,211.618]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1211.14,312.739],[1211.14,211.842],[1265.14,315.623],[1265.14,216.01]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1227.15,438.074],[1227.15,335.501],[1452.95,441.734],[1452.95,342.871]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1227.15,554.415],[1227.15,451.842],[1452.95,553.867],[1452.95,455.004]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1227.15,571.527],[1227.15,674.099],[1452.95,570.359],[1452.95,669.222]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1227.15,685.934],[1227.15,788.507],[1452.95,680.629],[1452.95,779.492]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1226.61,807.37],[1226.61,909.893],[1452.33,797.678],[1452.33,896.494]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1265.14,315.623],[1265.14,216.01],[1298.99,317.774],[1298.99,219.119]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1298.99,317.774],[1298.99,219.119],[1343.62,320.889],[1343.62,223.621]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1326.03,324.068],[1326.03,228.216],[1376.42,325.832],[1376.42,230.767]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1376.42,325.832],[1376.42,230.767],[1397.18,332.211],[1397.18,239.987]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1452.33,797.678],[1452.33,896.494],[1482.03,790.477],[1482.03,886.539]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1452.95,441.734],[1452.95,342.871],[1482.92,444.437],[1482.92,348.315]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1452.95,553.867],[1452.95,455.004],[1482.92,553.462],[1482.92,457.339]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1452.95,570.359],[1452.95,669.222],[1482.92,569.497],[1482.92,665.619]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1452.95,680.629],[1452.95,779.492],[1482.92,676.71],[1482.92,772.832]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1450.66,784.624],[1450.66,878.449],[1489.17,783.054],[1489.17,876.279]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1449.98,446.755],[1449.98,352.982],[1487.11,447.325],[1487.11,354.131]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1449.98,553.114],[1449.98,459.342],[1487.11,553.029],[1487.11,459.835]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1449.98,568.758],[1449.98,662.53],[1487.11,568.576],[1487.11,661.77]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:49,
                    verts:[[1449.98,673.35],[1449.98,767.122],[1487.11,672.523],[1487.11,765.717]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[608.749,754.672],[608.749,837.044],[580.04,745.691],[580.04,824.629]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[697.372,448.108],[697.372,352.51],[590.859,460.597],[590.859,378.1]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[697.372,556.537],[697.372,460.94],[590.859,554.169],[590.859,471.671]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[697.372,572.485],[697.372,668.083],[590.859,567.931],[590.859,650.429]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[697.372,679.113],[697.372,774.71],[590.859,659.947],[590.859,742.445]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[626.478,765.296],[626.478,851.73],[594.961,755.211],[594.961,837.788]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[675.101,347.157],[675.101,261.59],[661.445,356.101],[661.445,274.518]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[716.895,336.524],[716.895,246.221],[675.101,347.157],[675.101,261.59]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[760.059,440.049],[760.059,339.479],[682.222,444.164],[682.222,347.765]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[760.059,554.119],[760.059,453.549],[682.222,553.503],[682.222,457.104]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[760.059,570.897],[760.059,671.467],[682.222,569.584],[682.222,665.983]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[760.059,683.071],[760.059,783.641],[682.222,677.105],[682.222,773.504]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[779.439,327.456],[779.439,233.112],[716.895,336.524],[716.895,246.221]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[760.058,440.049],[760.058,339.479],[834.171,441.421],[834.171,342.241]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[760.058,554.119],[760.058,453.549],[834.171,553.914],[834.171,454.734]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[760.058,570.897],[760.058,671.467],[834.171,570.459],[834.171,669.639]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[760.058,683.071],[760.058,783.641],[834.171,681.082],[834.171,780.262]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[863.332,318.228],[863.332,219.776],[779.682,326.948],[779.682,232.38]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[884.379,436.048],[884.379,331.42],[834.171,441.421],[834.171,342.241]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[884.379,554.719],[884.379,450.092],[834.171,553.914],[834.171,454.734]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[884.379,572.173],[884.379,676.801],[834.171,570.459],[834.171,669.639]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[884.379,688.872],[884.379,793.5],[834.171,681.082],[834.171,780.262]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[935.694,312.782],[935.694,211.904],[863.332,318.228],[863.332,219.776]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[884.379,436.047],[884.379,331.42],[928.291,436.913],[928.291,333.163]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[884.379,554.719],[884.379,450.091],[928.291,554.589],[928.291,450.839]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[884.379,572.173],[884.379,676.801],[928.291,571.897],[928.291,675.647]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[884.379,688.872],[884.379,793.5],[928.291,687.617],[928.291,791.367]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[955.407,434.161],[955.407,327.62],[928.291,436.913],[928.291,333.163]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[955.407,555.002],[955.407,448.461],[928.291,554.589],[928.291,450.839]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[955.407,572.775],[955.407,679.315],[928.291,571.897],[928.291,675.647]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[955.407,691.608],[955.407,798.148],[928.291,687.618],[928.291,791.367]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1015.02,309.854],[1015.02,207.671],[935.695,312.782],[935.695,211.904]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1040.19,433.34],[1040.19,325.967],[955.407,434.161],[955.407,327.62]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1040.19,555.125],[1040.19,447.752],[955.407,555.002],[955.407,448.461]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1040.19,573.037],[1040.19,680.409],[955.407,572.775],[955.407,679.315]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1040.19,692.798],[1040.19,800.17],[955.407,691.608],[955.407,798.148]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1015.02,309.854],[1015.02,207.671],[1069.41,312.298],[1069.41,211.203]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1040.19,433.34],[1040.19,325.967],[1272.81,438.19],[1272.81,335.734]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1040.19,555.125],[1040.19,447.752],[1272.81,554.398],[1272.81,451.942]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1040.19,573.037],[1040.19,680.409],[1272.81,571.49],[1272.81,673.946]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1040.19,692.798],[1040.19,800.17],[1272.81,685.767],[1272.81,788.223]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1086.75,308.872],[1086.75,206.252],[1069.41,312.298],[1069.41,211.203]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1086.75,308.872],[1086.75,206.252],[1147.26,309.983],[1147.26,207.858]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1147.26,309.983],[1147.26,207.858],[1189.75,310.937],[1189.75,209.237]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1189.75,310.937],[1189.75,209.237],[1250.42,312.76],[1250.42,211.872]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1254.48,312.949],[1254.48,212.145],[1304.67,316.259],[1304.67,216.929]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1273.44,806.998],[1273.44,909.378],[1485.51,795.283],[1485.51,893.184]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1274.08,438.216],[1274.08,335.787],[1486.22,442.639],[1486.22,344.694]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1274.08,554.394],[1274.08,451.965],[1486.22,553.731],[1486.22,455.786]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1274.08,571.481],[1274.08,673.91],[1486.22,570.071],[1486.22,668.016]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1274.08,685.728],[1274.08,788.157],[1486.22,679.316],[1486.22,777.262]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1304.67,316.259],[1304.67,216.929],[1335.69,318.671],[1335.69,220.415]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1335.69,318.67],[1335.69,220.415],[1376.18,322.119],[1376.18,225.4]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1355.76,325.165],[1355.76,229.802],[1403.17,327.295],[1403.17,232.881]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1403.17,327.295],[1403.17,232.881],[1416.91,333.803],[1416.91,242.288]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:50,
                    verts:[[1472.52,782.31],[1472.52,875.25],[1508.46,780.431],[1508.46,872.652]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[568.859,455.855],[568.859,371.308],[565.916,459.67],[565.916,378.991]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[568.859,551.751],[568.859,467.204],[565.916,551.179],[565.916,470.499]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[568.859,565.855],[568.859,650.402],[565.916,564.638],[565.916,645.317]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[568.859,660.157],[568.859,744.704],[565.916,654.626],[565.916,735.305]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[603.686,759.122],[603.686,843.195],[566.132,750.13],[566.132,830.765]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[725.306,446.447],[725.306,349.107],[585.539,458.921],[585.539,374.664]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[725.306,556.852],[725.306,459.513],[585.539,554.487],[585.539,470.23]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[725.306,573.091],[725.306,670.43],[585.539,568.542],[585.539,652.799]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[725.306,681.661],[725.306,779],[585.539,662.52],[585.539,746.776]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[631.344,769.874],[631.343,858.059],[589.955,759.783],[589.955,844.11]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[655.848,352.753],[655.848,269.68],[652.537,361.184],[652.537,281.866]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[679.262,343.616],[679.262,256.471],[656.034,352.677],[656.034,269.569]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[733.004,333.036],[733.004,241.18],[679.263,343.616],[679.263,256.471]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[800.824,438.438],[800.824,336.234],[711.652,442.375],[711.652,344.162]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[800.824,554.361],[800.824,452.157],[711.652,553.771],[711.652,455.558]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[800.824,571.411],[800.824,673.615],[711.652,570.155],[711.652,668.368]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[800.824,685.407],[800.824,787.611],[711.652,679.699],[711.652,777.912]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[806.131,324.241],[806.131,228.464],[733.004,333.036],[733.004,241.18]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[800.824,438.438],[800.824,336.234],[872.893,440.101],[872.893,339.583]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[800.824,554.361],[800.824,452.157],[872.893,554.112],[872.893,453.593]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[800.824,571.411],[800.824,673.615],[872.893,570.88],[872.893,671.398]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[800.824,685.407],[800.824,787.611],[872.893,682.996],[872.893,783.514]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[900.726,315.487],[900.726,215.813],[806.896,323.724],[806.896,227.72]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[936.283,434.808],[936.283,328.924],[872.893,440.101],[872.893,339.583]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[936.283,554.905],[936.283,449.021],[872.893,554.111],[872.893,453.593]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[936.283,572.569],[936.283,678.453],[872.893,570.88],[872.893,671.398]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[936.283,690.669],[936.283,796.554],[872.893,682.996],[872.893,783.514]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[979.318,310.527],[979.318,208.644],[900.726,315.487],[900.726,215.813]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[936.283,434.808],[936.283,328.924],[978.513,435.85],[978.513,331.022]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[936.283,554.905],[936.283,449.021],[978.513,554.748],[978.513,449.921]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[936.283,572.569],[936.283,678.453],[978.513,572.236],[978.513,677.064]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[936.283,690.669],[936.283,796.554],[978.513,689.159],[978.513,793.987]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1012.23,433.153],[1012.23,325.592],[978.513,435.85],[978.513,331.022]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1012.23,555.153],[1012.23,447.591],[978.513,554.749],[978.513,449.921]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1012.23,573.096],[1012.23,680.658],[978.513,572.236],[978.513,677.064]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1012.23,693.068],[1012.23,800.63],[978.513,689.159],[978.513,793.987]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1061.9,308.199],[1061.9,205.279],[979.319,310.527],[979.319,208.644]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1099.06,432.639],[1099.06,324.556],[1012.23,433.153],[1012.23,325.592]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1099.06,555.23],[1099.06,447.147],[1012.23,555.153],[1012.23,447.591]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1099.06,573.26],[1099.06,681.344],[1012.23,573.096],[1012.23,680.658]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1099.06,693.814],[1012.23,693.068],[1099.06,801.897],[1012.23,800.63]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1061.9,308.199],[1061.9,205.279],[1113.69,311.112],[1113.69,209.49]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1099.06,432.639],[1099.06,324.556],[1318.08,438.375],[1318.08,336.108]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1099.06,555.23],[1099.06,447.147],[1318.08,554.37],[1318.08,452.103]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1099.06,573.26],[1099.06,681.344],[1318.08,571.431],[1318.08,673.698]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1099.06,693.814],[1099.06,801.897],[1318.08,685.498],[1318.08,787.765]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1134.49,307.79],[1134.49,204.688],[1113.69,311.112],[1113.69,209.49]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1134.49,307.79],[1134.49,204.688],[1193.43,309.401],[1193.43,207.017]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1193.43,309.401],[1193.43,207.017],[1234.51,310.704],[1234.51,208.9]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1234.51,310.704],[1234.51,208.9],[1292.45,313.02],[1292.45,212.248]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1296.25,313.242],[1296.25,212.568],[1342.14,316.956],[1342.14,217.936]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1319.27,438.407],[1319.27,336.171],[1515.8,443.554],[1515.8,346.537]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1319.27,554.365],[1319.27,452.13],[1515.8,553.594],[1515.8,456.577]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1319.27,571.421],[1319.27,673.657],[1515.8,569.779],[1515.8,666.796]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1319.27,685.452],[1319.27,787.688],[1515.8,677.99],[1515.8,775.007]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1318.53,806.499],[1318.53,908.688],[1515.01,792.864],[1515.01,889.839]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1342.14,316.956],[1342.14,217.936],[1370.04,319.611],[1370.04,221.774]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1370.04,319.611],[1370.04,221.774],[1406.06,323.368],[1406.06,227.205]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1383,326.261],[1383,231.387],[1427.05,328.739],[1427.05,234.968]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:51,
                    verts:[[1427.05,328.739],[1427.05,234.968],[1433.76,335.333],[1433.76,244.5]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[565.669,453.904],[565.669,367.379],[553.609,457.821],[553.609,375.267]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[565.669,552.043],[565.669,465.518],[553.609,551.456],[553.609,468.902]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[565.669,566.477],[565.669,653.002],[553.609,565.228],[553.609,647.782]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[565.669,662.986],[565.669,749.511],[553.609,657.307],[553.609,739.861]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[600.539,763.975],[600.539,849.904],[553.728,755.028],[553.728,837.536]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[756.383,444.73],[756.383,345.591],[582.232,457.093],[582.232,370.919]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[756.383,557.178],[756.383,458.038],[582.232,554.833],[582.232,468.66]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[756.383,573.716],[756.383,672.856],[582.232,569.209],[582.232,655.383]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[756.383,684.295],[756.383,783.435],[582.232,665.325],[582.232,751.499]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[638.627,774.794],[638.627,864.86],[586.955,764.767],[586.955,850.999]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[651.919,349.01],[651.919,264.269],[639.767,357.635],[639.767,276.735]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[685.448,339.803],[685.448,250.961],[652.189,348.933],[652.189,264.157]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[751.461,329.359],[751.461,235.864],[685.448,339.803],[685.448,250.961]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[844.73,436.819],[844.73,332.974],[744.455,440.528],[744.455,340.444]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[844.73,554.603],[844.73,450.758],[744.455,554.047],[744.455,453.963]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[844.73,571.927],[844.73,675.772],[744.455,570.744],[744.455,670.828]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[844.73,687.754],[844.73,791.599],[744.455,682.376],[744.455,782.461]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[835.13,320.925],[835.13,223.672],[751.461,329.359],[751.461,235.864]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[940.039,312.749],[940.039,211.855],[836.439,320.404],[836.439,222.92]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[844.73,436.819],[844.73,332.974],[913.884,438.782],[913.884,336.926]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[844.73,554.603],[844.73,450.758],[913.884,554.309],[913.884,452.454]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[844.73,571.927],[844.73,675.772],[913.884,571.301],[913.884,673.157]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[844.73,687.754],[844.73,791.599],[913.884,684.909],[913.884,786.764]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[990.372,433.621],[990.372,326.533],[913.884,438.782],[913.884,336.926]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[990.372,555.083],[990.372,447.995],[913.884,554.309],[913.884,452.454]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[990.372,572.947],[990.372,680.035],[913.884,571.301],[913.884,673.157]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[990.372,692.391],[990.372,799.478],[913.884,684.909],[913.884,786.764]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1024.3,308.346],[1024.3,205.492],[940.039,312.749],[940.039,211.855]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[990.372,433.621],[990.372,326.533],[1030.36,434.84],[1030.36,328.989]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[990.372,555.083],[990.372,447.995],[1030.36,554.9],[1030.36,449.048]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[990.372,572.947],[990.372,680.035],[1030.36,572.558],[1030.36,678.41]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[990.372,692.391],[990.372,799.478],[1030.36,690.623],[1030.36,796.474]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1109.37,306.668],[1109.37,203.066],[1024.3,308.346],[1024.3,205.492]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1070.54,432.227],[1070.54,323.727],[1030.36,434.84],[1030.36,328.989]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1070.54,555.292],[1070.54,446.791],[1030.36,554.9],[1030.36,449.049]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1070.54,573.392],[1070.54,681.892],[1030.36,572.558],[1030.36,678.41]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1070.54,694.411],[1070.54,802.911],[1030.36,690.623],[1030.36,796.474]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1070.54,432.227],[1158.43,432.038],[1070.54,323.727],[1158.43,323.345]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1070.54,555.292],[1158.43,555.32],[1070.54,446.791],[1158.43,446.627]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1070.54,573.392],[1158.43,573.452],[1070.54,681.892],[1158.43,682.145]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1070.54,694.411],[1158.43,694.685],[1070.54,802.911],[1158.43,803.378]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1109.37,306.668],[1109.37,203.066],[1157.93,310.045],[1157.93,207.947]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1182.04,306.856],[1182.04,203.338],[1157.93,310.045],[1157.93,207.947]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1158.43,432.038],[1158.43,323.345],[1361.16,438.632],[1361.16,336.625]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1158.43,555.32],[1158.43,446.627],[1361.16,554.332],[1361.16,452.325]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1158.43,573.452],[1158.43,682.145],[1361.16,571.349],[1361.16,673.356]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1158.43,694.685],[1158.43,803.378],[1361.16,685.125],[1361.16,787.132]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1182.04,306.856],[1182.04,203.338],[1238.76,308.969],[1238.76,206.392]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1238.76,308.969],[1238.76,206.392],[1277.96,310.617],[1277.96,208.774]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1277.96,310.617],[1277.96,208.774],[1332.55,313.414],[1332.55,212.817]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1336.05,313.667],[1336.05,213.183],[1377.17,317.758],[1377.17,219.096]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1361.42,805.813],[1361.42,907.74],[1540.51,790.379],[1540.51,886.404]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1362.26,438.668],[1362.26,336.697],[1541.37,444.494],[1541.37,348.43]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1362.26,554.326],[1362.26,452.355],[1541.37,553.453],[1541.37,457.389]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1362.26,571.337],[1362.26,673.308],[1541.37,569.479],[1541.37,665.543]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1362.26,685.073],[1362.26,787.044],[1541.37,676.627],[1541.37,772.691]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1377.17,317.758],[1377.17,219.096],[1401.69,320.637],[1401.69,223.257]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1401.69,320.636],[1401.69,223.257],[1432.92,324.673],[1432.92,229.092]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:52,
                    verts:[[1407.46,327.394],[1407.46,233.025],[1447.8,330.199],[1447.8,237.079]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[564.958,451.801],[564.958,363.144],[543.137,455.802],[543.137,371.201]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[564.958,552.358],[564.958,463.701],[543.137,551.758],[543.137,467.158]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[564.958,567.148],[564.958,655.805],[543.137,565.872],[543.137,650.472]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[564.958,666.034],[564.958,754.691],[543.137,660.233],[543.137,744.834]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[599.624,769.205],[599.624,857.134],[543.151,760.375],[543.151,844.927]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[790.725,442.989],[790.725,342.022],[581.276,455.122],[581.276,366.881]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[790.725,557.508],[790.725,456.542],[581.276,555.207],[581.276,466.966]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[790.725,574.351],[790.725,675.318],[581.276,569.928],[581.276,658.168]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[790.725,686.967],[790.725,787.934],[581.276,668.349],[581.276,756.59]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[648.631,780.012],[648.631,872.073],[586.297,770.137],[586.297,858.421]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[628.28,353.747],[628.28,271.115],[626.019,359.632],[626.019,279.622]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[649.809,344.968],[649.809,258.427],[628.28,353.747],[628.28,271.115]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[693.901,335.754],[693.901,245.109],[650.168,344.891],[650.168,258.315]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[772.428,325.543],[772.428,230.349],[693.901,335.754],[693.901,245.109]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[866.464,317.575],[866.464,218.83],[772.427,325.543],[772.427,230.349]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[891.706,435.233],[891.706,329.78],[780.763,438.658],[780.763,336.678]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[891.706,554.841],[891.706,449.388],[780.763,554.328],[780.763,452.347]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[891.706,572.433],[891.706,677.886],[780.763,571.34],[780.763,673.321]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[891.706,690.053],[891.706,795.507],[780.763,685.087],[780.763,787.068]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[981.113,310.092],[981.113,208.015],[868.335,317.052],[868.335,218.076]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[891.706,435.233],[891.706,329.78],[957.001,437.499],[957.001,334.342]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[891.706,554.841],[891.706,449.388],[957.001,554.502],[957.001,451.345]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[891.706,572.433],[891.706,677.886],[957.001,571.71],[957.001,674.867]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[891.706,690.053],[891.706,795.507],[957.001,686.769],[957.001,789.925]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1046.29,432.529],[1046.29,324.334],[957.001,437.499],[957.001,334.342]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1046.29,555.246],[1046.29,447.052],[957.001,554.501],[957.001,451.345]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1046.29,573.296],[1046.29,681.49],[957.001,571.71],[957.001,674.867]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1046.29,693.974],[1046.29,802.169],[957.001,686.769],[957.001,789.925]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1070.35,306.32],[1070.35,202.563],[981.113,310.092],[981.113,208.015]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1046.29,432.529],[1046.29,324.334],[1083.46,433.924],[1083.46,327.143]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1046.29,555.246],[1046.29,447.051],[1083.46,555.037],[1083.46,448.257]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1046.29,573.296],[1046.29,681.49],[1083.46,572.851],[1083.46,679.631]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1046.29,693.974],[1046.29,802.169],[1083.46,691.951],[1083.46,798.731]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1157.01,305.339],[1070.35,306.32],[1157.01,201.145],[1070.35,202.563]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1129.84,431.424],[1129.84,322.11],[1083.46,433.924],[1083.46,327.144]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1129.84,555.412],[1129.84,446.098],[1083.46,555.037],[1083.46,448.257]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1129.84,573.648],[1129.84,682.962],[1083.46,572.851],[1083.46,679.631]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1129.84,695.575],[1129.84,804.889],[1083.46,691.951],[1083.46,798.731]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1129.84,431.424],[1129.84,322.11],[1217.7,431.576],[1217.7,322.415]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1129.84,555.412],[1129.84,446.098],[1217.7,555.389],[1217.7,446.229]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1129.84,573.648],[1129.84,682.962],[1217.7,573.6],[1217.7,682.76]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1129.84,695.575],[1129.84,804.889],[1217.7,695.355],[1217.7,804.515]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1157.01,305.339],[1157.01,201.145],[1201.71,309.165],[1201.71,206.676]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1228.93,306.144],[1228.93,202.309],[1201.71,309.165],[1201.71,206.676]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1217.7,431.576],[1217.7,322.415],[1401.54,438.985],[1401.54,337.335]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1217.7,555.389],[1217.7,446.229],[1401.54,554.279],[1401.54,452.629]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1217.7,573.6],[1217.7,682.76],[1401.54,571.236],[1401.54,672.886]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1217.7,695.355],[1217.7,804.515],[1401.54,684.614],[1401.54,786.263]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1228.93,306.144],[1228.93,202.309],[1282.75,308.752],[1282.75,206.079]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1282.75,308.752],[1282.75,206.079],[1319.61,310.737],[1319.61,208.948]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1319.61,310.737],[1319.61,208.948],[1370.25,313.997],[1370.25,213.659]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1373.41,314.28],[1373.41,214.068],[1409.33,318.715],[1409.33,220.48]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1401.6,804.875],[1401.6,906.443],[1561.65,787.787],[1561.65,882.822]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1402.52,439.025],[1402.52,337.415],[1562.57,445.475],[1562.57,350.404]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1402.52,554.273],[1402.52,452.664],[1562.57,553.306],[1562.57,458.236]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1402.52,571.224],[1402.52,672.833],[1562.57,569.166],[1562.57,664.236]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1402.52,684.556],[1402.52,786.166],[1562.57,675.206],[1562.57,770.276]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1409.33,318.715],[1409.33,220.48],[1430.23,321.793],[1430.23,224.929]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1430.23,321.793],[1430.23,224.928],[1456.42,326.075],[1456.42,231.118]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:53,
                    verts:[[1428.8,328.605],[1428.8,234.775],[1465.11,331.713],[1465.11,239.268]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[593.582,762.315],[593.582,847.61],[526.944,754.098],[526.944,836.25]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[592.232,455.321],[592.232,370.232],[529.941,458.213],[529.941,376.057]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[592.232,551.831],[592.232,466.742],[529.941,551.397],[529.941,469.241]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[592.232,566.025],[592.232,651.114],[529.941,565.103],[529.941,647.259]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[592.232,660.931],[592.232,746.02],[529.941,656.738],[529.941,738.894]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[567.145,449.561],[567.145,358.634],[534.899,453.622],[534.899,366.812]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[567.145,552.694],[567.145,461.766],[534.899,552.085],[534.899,465.275]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[567.145,567.862],[567.145,658.79],[534.899,566.567],[534.899,653.378]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[567.145,669.281],[567.145,760.208],[534.899,663.394],[534.899,750.204]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[601.31,774.773],[601.31,864.83],[534.801,766.15],[534.801,852.91]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[828.38,441.261],[828.38,338.482],[583.064,453.023],[583.064,362.582]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[828.38,557.836],[828.38,455.057],[583.064,555.605],[583.064,465.163]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[828.38,574.981],[828.38,677.76],[583.064,570.693],[583.064,661.134]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[828.38,689.619],[828.38,792.398],[583.064,671.569],[583.064,762.011]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[661.677,785.468],[661.677,879.616],[588.367,775.852],[588.367,866.322]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[618.368,349.539],[618.368,265.034],[609.833,355.581],[609.833,273.766]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[649.817,340.661],[649.817,252.201],[618.368,349.539],[618.368,265.034]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[704.878,331.519],[704.878,238.986],[650.268,340.584],[650.268,252.089]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[796.036,321.657],[796.036,224.732],[704.879,331.519],[704.879,238.986]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[900.087,314.272],[900.087,214.055],[796.036,321.657],[796.036,224.732]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[941.551,433.727],[941.551,326.746],[820.63,436.806],[820.63,332.948]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[941.551,555.067],[941.551,448.086],[820.63,554.605],[820.63,450.747]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[941.551,572.914],[941.551,679.894],[820.63,571.931],[820.63,675.789]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[941.551,692.237],[941.551,799.217],[820.63,687.772],[820.63,791.631]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1023.68,307.606],[1023.68,204.422],[902.53,313.753],[902.53,213.307]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[941.551,433.727],[941.551,326.746],[1001.99,436.294],[1001.99,331.917]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[941.551,555.067],[941.551,448.086],[1001.99,554.682],[1001.99,450.305]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[941.551,572.914],[941.551,679.894],[1001.99,572.095],[1001.99,676.472]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[941.551,692.237],[941.551,799.217],[1001.99,688.515],[1001.99,792.892]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1103.51,431.58],[1103.51,322.423],[1001.99,436.294],[1001.99,331.917]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1103.51,555.388],[1103.51,446.232],[1001.99,554.682],[1001.99,450.305]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1103.51,573.598],[1103.51,682.755],[1001.99,572.095],[1001.99,676.472]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1103.51,695.349],[1103.51,804.506],[1001.99,688.515],[1001.99,792.892]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1117.03,304.54],[1117.03,199.99],[1023.68,307.606],[1023.68,204.422]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1103.51,431.58],[1103.51,322.423],[1137.27,433.145],[1137.27,325.576]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1103.51,555.388],[1103.51,446.232],[1137.27,555.154],[1137.27,447.584]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1103.51,573.598],[1103.51,682.755],[1137.27,573.099],[1137.27,680.668]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1103.51,695.349],[1103.51,804.506],[1137.27,693.08],[1137.27,800.649]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1117.03,304.54],[1204.29,304.296],[1117.03,199.99],[1204.29,199.638]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1189.45,430.792],[1189.45,320.837],[1137.27,433.145],[1137.27,325.576]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1189.45,555.507],[1189.45,445.551],[1137.27,555.154],[1137.27,447.584]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1189.45,573.85],[1189.45,683.805],[1137.27,573.099],[1137.27,680.669]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1189.45,696.491],[1189.45,806.447],[1137.27,693.08],[1137.27,800.649]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1189.45,430.792],[1189.45,320.837],[1276.12,431.296],[1276.12,321.852]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1189.45,555.507],[1189.45,445.551],[1276.12,555.431],[1276.12,445.987]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1189.45,573.85],[1189.45,683.805],[1276.12,573.689],[1276.12,683.133]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1189.45,696.491],[1189.45,806.447],[1276.12,695.761],[1276.12,805.205]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1204.29,304.296],[1204.29,199.638],[1244.51,308.551],[1244.51,205.788]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1274.58,305.731],[1274.58,201.712],[1244.51,308.551],[1244.51,205.788]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1274.58,305.731],[1274.58,201.712],[1324.82,308.821],[1324.82,206.178]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1276.12,431.296],[1276.12,321.852],[1438.62,439.458],[1438.62,338.288]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1276.12,555.431],[1276.12,445.987],[1438.62,554.208],[1438.62,453.038]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1276.12,573.689],[1276.12,683.133],[1438.62,571.085],[1438.62,672.255]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1276.12,695.761],[1276.12,805.205],[1438.62,683.928],[1438.62,785.098]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1324.82,308.821],[1324.82,206.178],[1358.89,311.13],[1358.89,209.515]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1358.89,311.13],[1358.89,209.515],[1404.99,314.825],[1404.99,214.857]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1407.79,315.135],[1407.79,215.305],[1438.13,319.876],[1438.13,222.157]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1438.13,319.876],[1438.13,222.157],[1455.22,323.125],[1455.22,226.854]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1438.49,803.619],[1438.49,904.708],[1578.05,785.052],[1578.05,879.04]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1439.48,439.501],[1439.48,338.375],[1579.02,446.51],[1579.02,352.489]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1439.48,554.201],[1439.48,453.075],[1579.02,553.151],[1579.02,459.13]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1439.48,571.072],[1439.48,672.198],[1579.02,568.836],[1579.02,662.857]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1439.48,683.865],[1439.48,784.992],[1579.02,673.705],[1579.02,767.726]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1455.22,323.125],[1455.22,226.854],[1476.15,327.614],[1476.15,233.343]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:54,
                    verts:[[1446.66,329.933],[1446.66,236.695],[1478.65,333.317],[1478.65,241.585]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[586.631,767.832],[586.631,855.236],[509.972,759.919],[509.972,844.297]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[543.988,457.047],[543.988,373.709],[511.092,458.292],[511.092,376.217]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[543.988,551.572],[543.988,468.234],[511.092,551.385],[511.092,469.309]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[543.988,565.475],[543.988,648.813],[511.092,565.077],[511.092,647.153]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[543.988,658.428],[543.988,741.766],[511.092,656.623],[511.092,738.699]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[584.742,453.242],[584.742,366.046],[513.1,456.027],[513.1,371.654]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[584.742,552.142],[584.742,464.946],[513.1,551.725],[513.1,467.352]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[584.742,566.688],[584.742,653.885],[513.1,565.8],[513.1,650.173]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[584.742,663.945],[584.742,751.141],[513.1,659.907],[513.1,744.28]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[572.692,447.208],[572.692,353.895],[529.368,451.296],[529.368,362.127]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[572.692,553.046],[572.692,459.733],[529.368,552.434],[529.368,463.265]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[572.692,568.613],[572.692,661.926],[529.368,567.309],[529.368,656.478]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[572.692,672.692],[572.692,766.005],[529.368,666.766],[529.368,755.935]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[606.004,780.619],[606.004,872.912],[529.147,772.314],[529.147,861.431]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[869.282,439.594],[869.282,335.066],[588.033,450.818],[588.033,358.064]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[869.282,558.152],[869.282,453.624],[588.033,556.023],[588.033,463.269]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[869.282,575.589],[869.282,680.117],[588.033,571.497],[588.033,664.251]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[869.282,692.177],[869.282,796.705],[588.033,674.953],[588.033,767.707]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[678.082,791.08],[678.082,887.374],[593.595,781.853],[593.595,874.618]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[610.382,345.044],[610.382,258.536],[595.138,351.208],[595.138,267.446]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[652.277,336.135],[652.277,245.659],[610.382,345.044],[610.382,258.536]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[718.634,327.162],[718.634,232.689],[652.824,336.059],[652.824,245.55]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[822.363,317.786],[822.363,219.137],[718.635,327.162],[718.635,232.689]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[935.856,311.113],[935.856,209.489],[822.362,317.786],[822.362,219.137]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[993.888,432.355],[993.888,323.985],[863.982,435.023],[863.982,329.358]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[993.888,555.272],[993.888,446.902],[863.982,554.872],[863.982,449.207]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[993.888,573.351],[993.888,681.721],[863.982,572.5],[863.982,678.165]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[993.888,694.225],[993.888,802.596],[863.982,690.357],[863.982,796.022]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1067.33,305.394],[1067.33,201.225],[938.875,310.604],[938.875,208.755]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[993.888,432.355],[993.888,323.985],[1048.44,435.216],[1048.44,329.745]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[993.888,555.272],[993.888,446.902],[1048.44,554.844],[1048.44,449.373]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[993.888,573.351],[993.888,681.721],[1048.44,572.439],[1048.44,677.909]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[993.888,694.225],[993.888,802.596],[1048.44,690.078],[1048.44,795.549]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1161.33,430.827],[1161.33,320.907],[1048.44,435.216],[1048.44,329.745]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1161.33,555.501],[1161.33,445.582],[1048.44,554.844],[1048.44,449.373]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1161.33,573.838],[1161.33,683.758],[1048.44,572.438],[1048.44,677.909]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1161.33,696.441],[1161.33,806.36],[1048.44,690.078],[1048.44,795.549]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1163.77,303.105],[1163.77,197.916],[1067.33,305.394],[1067.33,201.225]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1161.33,430.827],[1161.33,320.907],[1191.11,432.553],[1191.11,324.382]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1161.33,555.501],[1161.33,445.582],[1191.11,555.243],[1191.11,447.072]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1161.33,573.838],[1161.33,683.758],[1191.11,573.288],[1191.11,681.458]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1161.33,696.44],[1161.33,806.36],[1191.11,693.939],[1191.11,802.109]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1163.77,303.105],[1163.77,197.916],[1250.54,303.632],[1250.54,198.677]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1248.53,430.379],[1248.53,320.005],[1191.11,432.553],[1191.11,324.382]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1248.53,555.568],[1248.53,445.195],[1191.11,555.243],[1191.11,447.072]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1248.53,573.981],[1248.53,684.355],[1191.11,573.288],[1191.11,681.459]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1248.53,697.09],[1248.53,807.464],[1191.11,693.939],[1191.11,802.11]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1248.53,430.379],[1248.53,320.005],[1332.76,431.241],[1332.76,321.741]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1248.53,555.568],[1248.53,445.195],[1332.76,555.439],[1332.76,445.939]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1248.53,573.981],[1248.53,684.355],[1332.76,573.706],[1332.76,683.207]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1248.53,697.09],[1248.53,807.464],[1332.76,695.841],[1332.76,805.341]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1250.54,303.632],[1250.54,198.677],[1285.7,308.281],[1285.7,205.398]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1318.29,305.698],[1318.29,201.664],[1285.7,308.281],[1285.7,205.398]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1318.29,305.698],[1318.29,201.664],[1364.29,309.245],[1364.29,206.791]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1332.76,431.241],[1332.76,321.741],[1471.75,440.074],[1471.75,339.529]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1332.76,555.439],[1332.76,445.939],[1471.75,554.115],[1471.75,453.57]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1332.76,573.706],[1332.76,683.207],[1471.75,570.889],[1471.75,671.434]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1332.76,695.841],[1332.76,805.341],[1471.75,683.035],[1471.75,783.58]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1364.29,309.245],[1364.29,206.791],[1395.17,311.857],[1395.17,210.567]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1395.17,311.857],[1395.17,210.567],[1436.19,315.954],[1436.19,216.488]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1438.58,316.288],[1438.58,216.971],[1463.05,321.286],[1463.05,224.195]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1463.05,321.286],[1463.05,224.195],[1476.19,324.675],[1476.19,229.094]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1471.43,801.986],[1471.43,902.449],[1589.34,782.138],[1589.34,875.013]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1472.49,440.121],[1472.49,339.623],[1590.36,447.612],[1590.36,354.708]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1472.49,554.108],[1472.49,453.611],[1590.36,552.986],[1590.36,460.082]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1472.49,570.874],[1472.49,671.372],[1590.36,568.484],[1590.36,661.388]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1472.49,682.967],[1472.49,783.465],[1590.36,672.107],[1590.36,765.01]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:55,
                    verts:[[1476.19,324.675],[1476.19,229.094],[1491.71,329.328],[1491.71,235.819]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[528.246,454.844],[528.246,369.272],[490.961,456.024],[490.961,371.648]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[528.246,551.902],[528.246,466.33],[490.961,551.725],[490.961,467.349]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[528.246,566.177],[528.246,651.749],[490.961,565.801],[490.961,650.177]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[528.246,661.622],[528.246,747.194],[490.961,659.912],[490.961,744.288]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[526.138,762.97],[526.138,848.514],[490.643,759.991],[490.643,844.396]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[582.298,773.643],[582.298,863.268],[495.339,766.154],[495.339,852.916]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[579.84,451.05],[579.84,361.633],[498.586,453.686],[498.586,366.94]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[579.84,552.471],[579.84,463.053],[498.586,552.076],[498.586,465.33]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[579.84,567.388],[579.84,656.805],[498.586,566.547],[498.586,653.293]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[579.84,667.122],[579.84,756.54],[498.586,663.301],[498.586,750.047]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[582.091,444.773],[582.091,348.991],[527.086,448.845],[527.086,357.192]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[582.091,553.411],[582.091,457.63],[527.086,552.801],[527.086,461.148]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[582.091,569.39],[582.091,665.171],[527.086,568.091],[527.086,659.744]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[582.091,676.223],[582.091,772.004],[527.086,670.319],[527.086,761.972]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[614.139,786.662],[614.139,881.266],[526.732,778.808],[526.732,870.409]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[604.725,340.306],[604.725,251.688],[582.339,346.547],[582.339,260.709]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[698.139,796.742],[698.139,895.2],[602.432,788.057],[602.432,883.195]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[913.211,438.042],[913.211,331.887],[596.646,448.537],[596.646,353.39]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[913.211,558.446],[913.211,452.291],[596.646,556.456],[596.646,461.309]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[913.211,576.155],[913.211,682.31],[596.646,572.328],[596.646,667.475]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[913.211,694.558],[913.211,800.714],[596.646,678.453],[596.646,773.6]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[657.543,331.455],[657.543,238.894],[604.725,340.306],[604.725,251.688]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[735.399,322.767],[735.399,226.336],[658.188,331.381],[658.188,238.787]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[851.402,314.032],[851.402,213.71],[735.399,322.767],[735.399,226.336]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[973.505,308.208],[973.505,205.29],[851.402,314.032],[851.402,213.71]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1048.14,431.179],[1048.14,321.617],[910.584,433.369],[910.584,326.027]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1048.14,555.448],[1048.14,445.886],[910.584,555.12],[910.584,447.778]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1048.14,573.726],[1048.14,683.289],[910.584,573.027],[910.584,680.37]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1048.14,695.93],[1048.14,805.492],[910.584,692.755],[910.584,800.097]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1111.52,303.565],[1111.52,198.581],[977.09,307.715],[977.09,204.58]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1048.14,431.179],[1048.14,321.617],[1095.79,434.316],[1095.79,327.932]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1048.14,555.448],[1048.14,445.886],[1095.79,554.979],[1095.79,448.595]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1048.14,573.726],[1048.14,683.289],[1095.79,572.726],[1095.79,679.109]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1048.14,695.93],[1048.14,805.492],[1095.79,691.383],[1095.79,797.767]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1218.85,430.324],[1218.85,319.894],[1095.79,434.316],[1095.79,327.932]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1218.85,555.577],[1218.85,445.147],[1095.79,554.979],[1095.79,448.595]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1218.85,573.999],[1218.85,684.429],[1095.79,572.726],[1095.79,679.109]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1218.85,697.17],[1218.85,807.6],[1095.79,691.383],[1095.79,797.767]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1209.87,302.118],[1111.52,303.565],[1209.87,196.489],[1111.52,198.581]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1209.87,302.118],[1209.87,196.489],[1294.99,303.433],[1294.99,198.391]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1218.85,430.324],[1218.85,319.894],[1244.11,432.194],[1244.11,323.659]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1218.85,555.577],[1218.85,445.147],[1244.11,555.296],[1244.11,446.762]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1218.85,573.999],[1218.85,684.429],[1244.11,573.402],[1244.11,681.937]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1218.85,697.17],[1218.85,807.6],[1244.11,694.459],[1244.11,802.994]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1306.05,430.234],[1306.05,319.713],[1244.11,432.194],[1244.11,323.659]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1306.05,555.59],[1306.05,445.069],[1244.11,555.297],[1244.11,446.762]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1306.05,574.028],[1306.05,684.549],[1244.11,573.403],[1244.11,681.937]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1306.05,697.301],[1306.05,807.822],[1244.11,694.459],[1244.11,802.994]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1294.99,303.433],[1294.99,198.391],[1324.56,308.433],[1324.56,205.617]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1306.05,430.234],[1306.05,319.713],[1386.58,431.45],[1386.58,322.163]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1306.05,555.59],[1306.05,445.069],[1386.58,555.408],[1386.58,446.12]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1306.05,574.028],[1306.05,684.549],[1386.58,573.64],[1386.58,682.927]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1306.05,697.301],[1306.05,807.822],[1386.58,695.537],[1386.58,804.825]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1359.27,306.12],[1359.27,202.274],[1324.56,308.433],[1324.56,205.617]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1359.27,306.12],[1359.27,202.274],[1400.44,310.089],[1400.44,208.011]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1386.58,431.45],[1386.58,322.162],[1500.28,440.854],[1500.28,341.099]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1386.58,555.408],[1386.58,446.12],[1500.28,553.999],[1500.28,454.244]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1386.58,573.64],[1386.58,682.927],[1500.28,570.64],[1500.28,670.395]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1386.58,695.537],[1386.58,804.825],[1500.28,681.904],[1500.28,781.659]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1400.44,310.089],[1400.44,208.012],[1427.73,312.977],[1427.73,212.186]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1427.73,312.977],[1427.73,212.186],[1463.23,317.429],[1463.23,218.621]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1465.19,317.783],[1465.19,219.133],[1483.56,322.985],[1483.56,226.651]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1483.56,322.985],[1483.56,226.651],[1492.66,326.478],[1492.66,231.7]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1492.66,326.478],[1492.66,231.7],[1502.7,331.246],[1502.7,238.592]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1499.77,799.922],[1499.77,899.596],[1595.19,779.023],[1595.19,870.707]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1500.88,440.903],[1500.88,341.199],[1596.24,448.791],[1596.24,357.082]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1500.88,553.991],[1500.88,454.287],[1596.24,552.809],[1596.24,461.1]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1500.88,570.624],[1500.88,670.329],[1596.24,568.108],[1596.24,659.817]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:56,
                    verts:[[1500.88,681.833],[1500.88,781.537],[1596.24,670.398],[1596.24,762.107]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[512.8,769.169],[512.8,857.085],[473.015,766.41],[473.015,853.271]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[515.061,452.512],[515.061,364.576],[473.275,453.604],[473.275,366.776]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[515.061,552.252],[515.061,464.316],[473.275,552.088],[473.275,465.259]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[515.061,566.921],[515.061,654.857],[473.275,566.573],[473.275,653.401]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[515.061,665.003],[515.061,752.939],[473.275,663.419],[473.275,750.248]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[581.071,779.672],[581.071,871.603],[483.648,772.75],[483.648,862.034]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[578.017,448.774],[578.017,357.049],[486.998,451.21],[486.998,361.954]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[578.017,552.812],[578.017,461.086],[486.998,552.447],[486.998,463.191]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[578.017,568.114],[578.017,659.839],[486.998,567.336],[486.998,656.592]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[578.017,670.422],[578.017,762.147],[486.998,666.891],[486.998,756.146]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[595.829,442.298],[595.829,344.008],[528.643,446.302],[528.643,352.07]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[595.829,553.782],[595.829,455.492],[528.643,553.182],[528.643,458.95]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[595.829,570.179],[595.829,668.47],[528.643,568.902],[528.643,663.134]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[595.829,679.81],[595.829,778.101],[528.643,674.006],[528.643,768.238]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[626.14,792.797],[626.14,889.747],[528.148,785.551],[528.148,879.73]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[571.908,341.645],[571.908,253.624],[567.299,347.552],[567.299,262.162]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[601.85,335.386],[601.85,244.576],[571.908,341.645],[571.908,253.624]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[665.972,326.701],[665.972,232.022],[601.85,335.386],[601.85,244.576]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[722.069,802.322],[722.068,902.914],[615.329,794.355],[615.329,891.901]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[959.761,436.665],[959.761,329.067],[609.363,446.219],[609.363,348.641]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[959.761,558.707],[959.761,451.108],[609.363,556.895],[609.363,459.317]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[959.761,576.657],[959.761,684.256],[609.363,573.174],[609.363,670.752]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[959.761,696.67],[959.761,804.269],[609.363,682.01],[609.363,779.588]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[755.349,318.434],[755.349,220.073],[666.716,326.63],[666.716,231.92]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[883.038,310.509],[883.038,208.619],[755.349,318.434],[755.349,220.073]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1012.62,305.675],[1012.62,201.628],[883.037,310.509],[883.037,208.619]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1103.52,430.261],[1103.52,319.768],[959.994,431.909],[959.994,323.086]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1103.52,555.586],[1103.52,445.093],[959.994,555.339],[959.994,446.516]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1103.52,574.019],[1103.52,684.512],[959.994,573.493],[959.994,682.316]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1103.52,697.261],[1103.52,807.754],[959.994,694.872],[959.994,803.695]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1155.56,302.229],[1155.56,196.65],[1016.75,305.206],[1016.75,200.952]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1103.52,430.261],[1103.52,319.768],[1143.31,433.645],[1143.31,326.582]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1103.52,555.586],[1103.52,445.093],[1143.31,555.079],[1143.31,448.016]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1103.52,574.019],[1103.52,684.512],[1143.31,572.94],[1143.31,680.003]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1103.52,697.261],[1103.52,807.754],[1143.31,692.355],[1143.31,799.418]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1274.99,430.121],[1274.99,319.485],[1143.31,433.645],[1143.31,326.582]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1274.99,555.607],[1274.99,444.971],[1143.31,555.079],[1143.31,448.016]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1274.99,574.064],[1274.99,684.7],[1143.31,572.94],[1143.31,680.003]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1274.99,697.465],[1274.99,808.101],[1143.31,692.355],[1143.31,799.418]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1155.56,302.229],[1254.5,301.674],[1155.56,196.65],[1254.5,195.848]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1254.5,301.674],[1254.5,195.848],[1336.76,303.781],[1336.76,198.894]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1274.99,430.121],[1274.99,319.485],[1295.26,432.114],[1295.26,323.498]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1274.99,555.607],[1274.99,444.971],[1295.26,555.308],[1295.26,446.693]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1274.99,574.064],[1274.99,684.7],[1295.26,573.428],[1295.26,682.043]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1274.99,697.465],[1274.99,808.1],[1295.26,694.575],[1295.26,803.19]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1360.86,430.399],[1360.86,320.045],[1295.26,432.114],[1295.26,323.499]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1360.86,555.565],[1360.86,445.212],[1295.26,555.308],[1295.26,446.693]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1360.86,573.975],[1360.86,684.329],[1295.26,573.428],[1295.26,682.043]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1360.86,697.061],[1360.86,807.415],[1295.26,694.575],[1295.26,803.19]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1336.76,303.781],[1336.76,198.894],[1360.32,309.074],[1360.32,206.544]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1396.7,307.062],[1396.7,203.636],[1360.32,309.074],[1360.32,206.544]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1360.86,430.399],[1360.86,320.045],[1436.46,431.958],[1436.46,323.184]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1360.86,555.565],[1360.86,445.212],[1436.46,555.332],[1436.46,446.558]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1360.86,573.975],[1360.86,684.329],[1436.46,573.478],[1436.46,682.251]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1360.86,697.061],[1360.86,807.415],[1436.46,694.801],[1436.46,803.575]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1396.7,307.062],[1396.7,203.636],[1432.5,311.407],[1432.5,209.916]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1432.5,311.407],[1432.5,209.916],[1455.89,314.535],[1455.89,214.438]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1436.46,431.958],[1436.46,323.184],[1523.56,441.811],[1523.56,343.027]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1436.46,555.332],[1436.46,446.558],[1523.56,553.855],[1523.56,455.071]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1436.46,573.478],[1436.46,682.251],[1523.56,570.335],[1523.56,669.119]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1436.46,694.801],[1436.46,803.575],[1523.56,680.517],[1523.56,779.301]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1455.89,314.535],[1455.89,214.438],[1485.49,319.288],[1485.49,221.308]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1487,319.659],[1487,221.843],[1499.17,325.003],[1499.17,229.568]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1499.17,325.003],[1499.17,229.568],[1504.2,328.56],[1504.2,234.709]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1504.2,328.56],[1504.2,234.709],[1508.76,333.392],[1508.76,241.694]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1522.88,797.39],[1522.88,896.096],[1595.33,775.694],[1595.33,866.104]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1524.01,441.863],[1524.01,343.13],[1596.39,450.05],[1596.39,359.618]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1524.01,553.847],[1524.01,455.115],[1596.39,552.62],[1596.39,462.189]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1524.01,570.318],[1524.01,669.05],[1596.39,567.707],[1596.39,658.138]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:57,
                    verts:[[1524.01,680.442],[1524.01,779.174],[1596.39,668.572],[1596.39,759.004]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[505.055,450.078],[505.055,359.674],[458.713,451.058],[458.713,361.647]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[505.055,552.616],[505.055,462.213],[458.713,552.469],[458.713,463.059]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[505.055,567.698],[505.055,658.102],[458.713,567.385],[458.713,656.796]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[505.055,668.532],[505.055,758.936],[458.713,667.112],[458.713,756.522]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[502.648,775.643],[502.648,866.034],[458.52,773.168],[458.52,862.612]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[583.462,785.822],[583.462,880.104],[475.584,779.63],[475.584,871.545]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[579.791,446.449],[579.791,352.367],[479.013,448.628],[479.013,356.755]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[579.791,553.16],[579.791,459.078],[479.013,552.834],[479.013,460.96]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[579.791,568.855],[579.791,662.937],[479.013,568.16],[479.013,660.033]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[579.791,673.792],[579.791,767.874],[479.013,670.633],[479.013,762.507]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[642.397,798.893],[642.397,898.174],[534.007,792.431],[534.007,889.241]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[614.35,439.837],[614.35,339.05],[534.652,443.707],[534.652,346.844]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[614.35,554.151],[614.35,453.365],[534.652,553.571],[534.652,456.709]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[614.35,570.965],[614.35,671.751],[534.652,569.73],[534.652,666.592]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[614.35,683.379],[614.35,784.165],[534.652,677.768],[534.652,774.631]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[564.374,336.567],[564.374,246.283],[553.142,342.622],[553.142,255.036]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[602.233,330.362],[602.233,237.314],[564.374,336.567],[564.374,246.283]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[677.893,321.972],[677.893,225.187],[602.233,330.362],[602.233,237.314]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[749.99,807.669],[749.99,910.306],[632.69,800.614],[632.69,900.552]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1008.31,435.527],[1008.31,326.734],[626.602,443.914],[626.602,343.918]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1008.31,558.923],[1008.31,450.13],[626.602,557.333],[626.602,457.336]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1008.31,577.072],[1008.31,685.865],[626.602,574.014],[626.602,674.01]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1008.31,698.417],[1008.31,807.21],[626.602,685.548],[626.602,785.544]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[778.574,314.28],[778.574,214.069],[678.735,321.906],[678.735,225.092]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[917.013,307.345],[917.013,204.045],[778.575,314.28],[778.575,214.069]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1052.65,303.634],[1052.65,198.678],[917.013,307.345],[917.013,204.045]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1159.02,429.661],[1159.02,318.559],[1011.54,430.711],[1011.54,320.673]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1159.02,555.676],[1159.02,444.574],[1011.54,555.519],[1011.54,445.481]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1159.02,574.21],[1159.02,685.313],[1011.54,573.876],[1011.54,683.913]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1159.02,698.131],[1159.02,809.233],[1011.54,696.609],[1011.54,806.647]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1198.62,301.489],[1057.28,303.196],[1198.62,195.58],[1057.28,198.048]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1159.02,429.661],[1159.02,318.559],[1190.11,433.254],[1190.11,325.794]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1159.02,555.676],[1159.02,444.574],[1190.11,555.138],[1190.11,447.678]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1159.02,574.21],[1159.02,685.312],[1190.11,573.064],[1190.11,680.524]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1159.02,698.131],[1159.02,809.233],[1190.11,692.922],[1190.11,800.382]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1328.55,430.261],[1328.55,319.767],[1190.11,433.254],[1190.11,325.794]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1328.55,555.586],[1328.55,445.092],[1190.11,555.138],[1190.11,447.678]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1328.55,574.019],[1328.55,684.513],[1190.11,573.064],[1190.11,680.524]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1328.55,697.262],[1328.55,807.755],[1190.11,692.922],[1190.11,800.382]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1198.62,301.489],[1198.62,195.58],[1296.74,301.859],[1296.74,196.115]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1296.74,301.859],[1296.74,196.115],[1374.95,304.74],[1374.95,200.28]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1328.55,430.261],[1328.55,319.767],[1343.48,432.35],[1343.48,323.975]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1328.55,555.586],[1328.55,445.092],[1343.48,555.273],[1343.48,446.898]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1328.55,574.019],[1328.55,684.513],[1343.48,573.352],[1343.48,681.728]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1328.55,697.261],[1328.55,807.755],[1343.48,694.232],[1343.48,802.607]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1411.72,430.908],[1411.72,321.069],[1343.48,432.351],[1343.48,323.975]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1411.72,555.489],[1411.72,445.651],[1343.48,555.273],[1343.48,446.898]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1411.72,573.813],[1411.72,683.651],[1343.48,573.353],[1343.48,681.728]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1411.72,696.324],[1411.72,806.162],[1343.48,694.232],[1343.48,802.607]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1374.95,304.74],[1374.95,200.28],[1392.17,310.257],[1392.17,208.255]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1429.73,308.573],[1392.17,310.257],[1429.73,205.82],[1392.17,208.254]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1411.72,430.908],[1411.72,321.069],[1481.25,432.786],[1481.25,324.853]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1411.72,555.489],[1411.72,445.651],[1481.25,555.208],[1481.25,447.274]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1411.72,573.813],[1411.72,683.651],[1481.25,573.214],[1481.25,681.147]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1411.72,696.324],[1411.72,806.162],[1481.25,693.6],[1481.25,801.534]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1429.73,308.573],[1429.73,205.82],[1459.74,313.234],[1459.74,212.557]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1459.74,313.234],[1459.74,212.557],[1478.98,316.561],[1478.98,217.366]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1478.98,316.561],[1478.98,217.366],[1502.42,321.552],[1502.42,224.581]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1481.25,432.786],[1481.25,324.853],[1541.03,442.953],[1541.03,345.325]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1481.25,555.208],[1481.25,447.274],[1541.03,553.684],[1541.03,456.057]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1481.25,573.214],[1481.25,681.147],[1541.03,569.971],[1541.03,667.598]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1481.25,693.6],[1481.25,801.534],[1541.03,678.862],[1541.03,776.489]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1503.48,321.934],[1503.48,225.132],[1509.44,327.355],[1509.44,232.968]]
                },{
                    num:"604",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1509.44,327.355],[1509.44,232.968],[1510.44,330.935],[1510.44,238.142]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1541.34,443.005],[1541.34,345.432],[1590.64,451.391],[1590.64,362.318]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1541.34,553.676],[1541.34,456.103],[1590.64,552.42],[1590.64,463.347]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1541.34,569.954],[1541.34,667.527],[1590.64,567.279],[1590.64,656.352]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1541.34,678.785],[1541.34,776.359],[1590.64,666.629],[1590.64,755.702]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:58,
                    verts:[[1540.18,794.372],[1540.18,891.924],[1589.57,772.15],[1589.57,861.205]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[447.913,780.179],[447.913,872.305],[444.048,772.924],[444.048,862.274]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[448.032,448.415],[448.032,356.326],[444.522,451.146],[444.522,361.826]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[448.032,552.865],[448.032,460.776],[444.522,552.456],[444.522,463.136]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[448.032,568.228],[448.032,660.318],[444.522,567.357],[444.522,656.678]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[448.032,670.943],[448.032,763.032],[444.522,666.983],[444.522,756.304]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[498.9,447.577],[498.9,354.637],[448.032,448.415],[448.032,356.326]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[498.9,552.991],[498.9,460.052],[448.032,552.866],[448.032,460.776]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[498.9,568.496],[498.9,661.435],[448.032,568.228],[448.032,660.318]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[498.9,672.158],[498.9,765.097],[448.032,670.943],[448.032,763.032]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[496.357,782.297],[496.357,875.232],[447.913,780.179],[447.913,872.305]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[589.97,791.972],[589.97,888.606],[471.879,786.693],[471.879,881.309]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[585.672,444.121],[585.672,347.679],[475.358,445.979],[475.358,351.42]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[585.672,553.509],[585.672,457.067],[475.358,553.231],[475.358,458.672]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[585.672,569.598],[585.672,666.04],[475.358,569.005],[475.358,663.564]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[585.672,677.167],[585.672,773.61],[475.358,674.474],[475.358,769.033]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[560.299,331.392],[560.299,238.804],[541.972,337.538],[541.972,247.687]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[663.208,804.796],[663.208,906.334],[544.9,799.31],[544.9,898.751]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[637.994,437.451],[637.994,334.246],[545.7,441.113],[545.7,341.621]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[637.994,554.509],[637.994,451.304],[545.7,553.96],[545.7,454.468]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[637.994,571.726],[637.994,674.93],[545.7,570.557],[545.7,670.049]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[637.994,686.838],[637.994,790.042],[545.7,681.529],[545.7,781.021]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[606.346,325.331],[606.346,230.042],[560.299,331.392],[560.299,238.804]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[693.569,317.385],[693.569,218.557],[606.346,325.331],[606.346,230.042]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[781.866,812.612],[781.866,917.139],[654.827,806.671],[654.827,908.927]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1058.04,434.687],[1058.04,325.014],[648.689,441.679],[648.689,339.34]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1058.04,559.082],[1058.04,449.409],[648.689,557.756],[648.689,455.417]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1058.04,577.378],[1058.04,687.052],[648.689,574.829],[648.689,677.169]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1058.04,699.706],[1058.04,809.379],[648.689,688.977],[648.689,791.316]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[805.046,310.434],[805.046,208.509],[694.508,317.325],[694.508,218.471]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[952.914,304.668],[952.914,200.176],[805.046,310.434],[805.046,208.509]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1092.86,302.199],[1092.86,196.605],[952.914,304.668],[952.914,200.176]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1064.32,429.839],[1213.45,429.43],[1064.32,318.917],[1213.45,318.094]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1064.32,555.649],[1064.32,444.728],[1213.45,555.711],[1213.45,444.375]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1064.32,574.154],[1213.45,574.284],[1064.32,685.075],[1213.45,685.62]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1064.32,697.873],[1213.45,698.466],[1064.32,808.795],[1213.45,809.802]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1097.96,301.801],[1239.78,301.432],[1097.96,196.031],[1239.78,195.498]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1213.45,429.43],[1213.45,318.094],[1235.2,433.184],[1235.2,325.653]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1213.45,555.711],[1213.45,444.375],[1235.2,555.148],[1235.2,447.617]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1213.45,574.284],[1213.45,685.62],[1235.2,573.087],[1235.2,680.617]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1213.45,698.466],[1213.45,809.801],[1235.2,693.024],[1235.2,800.555]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1378.24,430.775],[1378.24,320.802],[1235.2,433.184],[1235.2,325.653]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1378.24,555.509],[1378.24,445.536],[1235.2,555.148],[1235.2,447.617]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1378.24,573.855],[1378.24,683.828],[1235.2,573.087],[1235.2,680.617]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1378.24,696.516],[1378.24,806.489],[1235.2,693.024],[1235.2,800.555]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1239.78,301.432],[1239.78,195.497],[1335.61,302.736],[1335.61,197.383]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1335.61,302.737],[1335.61,197.384],[1408.65,306.351],[1408.65,202.608]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1378.24,430.775],[1378.24,320.802],[1387.61,432.93],[1387.61,325.142]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1378.24,555.509],[1378.24,445.536],[1387.61,555.186],[1387.61,447.398]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1378.24,573.855],[1378.24,683.828],[1387.61,573.168],[1387.61,680.956]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1378.24,696.516],[1378.24,806.489],[1387.61,693.392],[1387.61,801.18]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1457.41,431.78],[1457.41,322.825],[1387.61,432.93],[1387.61,325.142]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1457.41,555.359],[1457.41,446.404],[1387.61,555.186],[1387.61,447.398]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1457.41,573.535],[1457.41,682.489],[1387.61,573.168],[1387.61,680.956]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1457.41,695.06],[1457.41,804.014],[1387.61,693.392],[1387.61,801.18]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1408.65,306.351],[1408.65,202.608],[1419.38,312.015],[1419.38,210.796]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1457.56,310.677],[1419.38,312.015],[1457.56,208.861],[1419.38,210.795]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1457.56,310.677],[1457.56,208.861],[1481.49,315.587],[1481.49,215.958]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1457.41,431.78],[1457.41,322.825],[1519.88,433.945],[1519.88,327.186]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1457.41,555.359],[1457.41,446.404],[1519.88,555.034],[1519.88,448.275]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1457.41,573.535],[1457.41,682.489],[1519.88,572.844],[1519.88,679.603]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1457.41,695.06],[1457.41,804.014],[1519.88,691.92],[1519.88,798.679]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1481.49,315.587],[1481.49,215.958],[1496.43,319.064],[1496.43,220.984]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1496.43,319.064],[1496.43,220.984],[1513.58,324.224],[1513.58,228.443]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1519.88,433.945],[1519.88,327.186],[1552.24,444.277],[1552.24,347.992]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1519.88,555.034],[1519.88,448.275],[1552.24,553.486],[1552.24,457.201]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1519.88,572.844],[1519.88,679.603],[1552.24,569.548],[1552.24,665.833]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1519.88,691.92],[1519.88,798.679],[1552.24,676.942],[1552.24,773.227]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1552.41,444.33],[1552.41,348.1],[1578.95,452.807],[1578.95,365.169]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1552.41,553.478],[1552.41,457.247],[1578.95,552.207],[1578.95,464.57]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1552.41,569.531],[1552.41,665.762],[1578.95,566.827],[1578.95,654.465]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1552.41,676.865],[1552.41,773.095],[1578.95,664.576],[1578.95,752.213]]
                },{
                    num:"104",
                    tipo:"TorreB",
                    frame:59,
                    verts:[[1551.24,790.871],[1551.24,887.085],[1577.89,768.406],[1577.89,856.029]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[441.994,787.332],[441.994,882.193],[431.02,779.874],[431.02,871.882]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[442.03,445.719],[442.03,350.896],[431.441,448.527],[431.441,356.552]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[442.03,553.27],[442.03,458.447],[431.441,552.849],[431.441,460.873]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[442.03,569.088],[442.03,663.911],[431.441,568.192],[431.441,660.168]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[442.03,674.852],[442.03,769.675],[431.441,670.78],[431.441,762.755]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[497.284,445.053],[497.284,349.556],[442.03,445.719],[442.03,350.896]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[497.284,553.369],[497.284,457.872],[442.03,553.27],[442.03,458.447]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[497.284,569.3],[497.284,664.798],[442.03,569.088],[442.03,663.911]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[497.284,675.816],[497.284,771.314],[442.03,674.852],[442.03,769.675]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[494.623,789.013],[494.623,884.516],[441.994,787.332],[441.994,882.193]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[601.041,797.979],[601.041,896.91],[473.274,793.809],[473.274,891.145]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[596.117,441.843],[596.117,343.092],[476.766,443.311],[476.766,346.047]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[596.117,553.85],[596.117,455.099],[476.766,553.63],[476.766,456.367]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[596.117,570.324],[596.117,669.076],[476.766,569.856],[476.766,667.12]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[596.117,680.47],[596.117,779.221],[476.766,678.342],[476.766,775.606]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[558.352,337.005],[558.352,246.916],[527.651,337.792],[527.651,248.054]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[560.242,326.222],[560.242,231.33],[534.404,332.384],[534.404,240.237]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[614.616,320.407],[614.616,222.925],[560.242,326.222],[560.242,231.33]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[688.733,810.332],[688.733,913.987],[561.337,806.023],[561.337,908.03]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[666.943,435.213],[666.943,329.739],[562.296,438.583],[562.296,336.526]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[666.943,554.844],[666.943,449.37],[562.296,554.339],[562.296,452.282]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[666.943,572.44],[666.943,677.913],[562.296,571.364],[562.296,673.421]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[666.943,690.083],[666.943,795.556],[562.296,685.196],[562.296,787.253]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[713.162,313.07],[713.162,212.319],[614.616,320.407],[614.616,222.925]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[817.469,816.973],[817.468,923.167],[681.902,812.349],[681.902,916.776]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1107.91,434.199],[1107.91,324.014],[675.799,439.582],[675.799,335.042]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1107.91,559.175],[1107.91,448.989],[675.799,558.154],[675.799,453.614]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1107.91,577.556],[1107.91,687.742],[675.799,575.594],[675.799,680.133]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1107.91,700.455],[1107.91,810.64],[675.799,692.195],[675.799,796.735]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[834.581,307.03],[834.581,203.589],[714.191,313.017],[714.191,212.243]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[990.166,302.602],[990.166,197.189],[834.581,307.03],[834.581,203.589]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1132.45,301.469],[990.166,302.602],[1132.45,195.549],[990.166,197.189]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1117.23,429.351],[1117.23,317.935],[1265.5,429.608],[1265.5,318.453]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1117.23,555.722],[1117.23,444.306],[1265.5,555.684],[1265.5,444.529]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1117.23,574.309],[1117.23,685.725],[1265.5,574.227],[1265.5,685.383]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1117.23,698.58],[1117.23,809.996],[1265.5,698.208],[1265.5,809.363]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1137.93,301.118],[1137.93,195.044],[1278.09,302.12],[1278.09,196.493]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1265.5,429.608],[1265.5,318.453],[1277.5,433.465],[1277.5,326.219]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1265.5,555.684],[1265.5,444.529],[1277.5,555.106],[1277.5,447.86]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1265.5,574.227],[1265.5,685.383],[1277.5,572.997],[1277.5,680.243]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1265.5,698.208],[1265.5,809.363],[1277.5,692.617],[1277.5,799.863]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1422.83,431.677],[1422.83,322.62],[1277.5,433.465],[1277.5,326.219]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1422.83,555.374],[1422.83,446.316],[1277.5,555.106],[1277.5,447.86]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1422.83,573.567],[1422.83,682.625],[1277.5,572.997],[1277.5,680.243]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1422.83,695.208],[1422.83,804.265],[1277.5,692.617],[1277.5,799.863]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1278.09,302.12],[1278.09,196.493],[1370.18,304.341],[1370.18,199.703]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1370.18,304.341],[1370.18,199.703],[1437.05,308.627],[1437.05,205.898]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1422.83,431.677],[1422.83,322.62],[1426.57,433.863],[1426.57,327.021]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1422.83,555.374],[1422.83,446.316],[1426.57,555.046],[1426.57,448.204]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1422.83,573.567],[1422.83,682.625],[1426.57,572.87],[1426.57,679.712]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1422.83,695.208],[1422.83,804.265],[1426.57,692.039],[1426.57,798.881]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1496.78,433.018],[1426.57,433.863],[1496.78,325.319],[1426.57,327.021]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1496.78,555.173],[1496.78,447.474],[1426.57,555.046],[1426.57,448.204]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1496.78,573.14],[1496.78,680.839],[1426.57,572.87],[1426.57,679.712]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1496.78,693.265],[1426.57,692.039],[1496.78,800.964],[1426.57,798.881]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1437.05,308.627],[1437.05,205.898],[1441.26,314.355],[1441.26,214.177]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1479.54,313.373],[1441.26,314.355],[1479.54,212.758],[1441.26,214.177]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1479.54,313.373],[1479.54,212.758],[1497.23,318.456],[1497.23,220.105]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1497.23,318.456],[1497.23,220.105],[1507.82,322.032],[1507.82,225.274]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1496.78,433.018],[1496.78,325.319],[1551.41,435.428],[1551.41,330.173]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1496.78,555.173],[1496.78,447.474],[1551.41,554.812],[1551.41,449.557]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1496.78,573.14],[1496.78,680.839],[1551.41,572.371],[1551.41,677.626]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1496.78,693.265],[1496.78,800.964],[1551.41,689.77],[1551.41,795.026]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1507.82,322.032],[1507.82,225.274],[1518.68,327.287],[1518.68,232.87]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1551.41,435.428],[1551.41,330.173],[1556.91,445.773],[1556.91,351.005]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1551.41,554.812],[1551.41,449.557],[1556.91,553.261],[1556.91,458.494]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1551.41,572.371],[1551.41,677.626],[1556.91,569.071],[1556.91,663.839]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1551.41,689.77],[1551.41,795.026],[1556.91,674.773],[1556.91,769.541]]
                },{
                    num:"504",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1556.94,445.826],[1556.94,351.113],[1561.44,454.287],[1561.44,368.151]]
                },{
                    num:"404",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1556.94,553.253],[1556.94,458.54],[1561.44,551.985],[1561.44,465.849]]
                },{
                    num:"304",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1556.94,569.054],[1556.94,663.768],[1561.44,566.355],[1561.44,652.491]]
                },{
                    num:"204",
                    tipo:"TorreB",
                    frame:60,
                    verts:[[1556.94,674.696],[1556.94,769.409],[1561.44,662.43],[1561.44,748.566]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[441.558,794.49],[441.558,892.087],[422.898,786.915],[422.898,881.616]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[441.501,443.02],[441.501,345.462],[423.256,445.874],[423.256,351.209]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[441.501,553.674],[441.501,456.116],[423.256,553.246],[423.256,458.581]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[441.501,569.949],[441.501,667.508],[423.256,569.039],[423.256,663.704]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[441.501,678.764],[441.501,776.322],[423.256,674.626],[423.256,769.291]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[500.862,442.561],[500.862,344.537],[441.501,443.02],[441.501,345.462]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[500.862,553.743],[500.862,455.719],[441.501,553.674],[441.501,456.116]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[500.862,570.095],[500.862,668.12],[441.501,569.949],[441.501,667.508]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[500.862,679.43],[500.862,777.454],[441.501,678.764],[441.501,776.322]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[498.104,795.651],[498.104,893.691],[441.558,794.49],[441.558,892.087]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[617.009,803.684],[617.009,904.796],[480.458,800.821],[480.458,900.839]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[611.478,439.675],[611.478,338.726],[483.917,440.683],[483.917,340.755]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[611.478,554.175],[611.478,453.226],[483.917,554.024],[483.917,454.096]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[611.478,571.016],[611.478,671.966],[483.917,570.695],[483.917,670.623]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[611.478,683.613],[611.478,784.563],[483.917,682.152],[483.917,782.08]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[550.731,332.215],[550.731,239.992],[517.997,332.755],[517.997,240.773]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[564.721,321.17],[564.721,224.027],[531.049,327.26],[531.049,232.831]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[627.383,315.717],[627.383,216.146],[564.721,321.17],[564.721,224.027]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[718.944,815.318],[718.944,920.88],[583.681,812.381],[583.681,916.82]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[701.156,433.198],[701.156,325.681],[584.798,436.188],[584.798,331.702]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[701.156,555.146],[701.156,447.629],[584.798,554.698],[584.798,450.213]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[701.156,573.082],[701.156,680.599],[584.798,572.128],[584.798,676.614]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[701.156,693.004],[701.156,800.521],[584.798,688.669],[584.798,793.154]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[736.687,309.161],[736.687,206.669],[627.383,315.717],[627.383,216.146]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[856.349,820.576],[856.349,928.148],[713.873,817.457],[713.873,923.837]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1156.76,434.103],[1156.76,323.816],[707.903,437.691],[707.903,331.169]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1156.76,559.193],[1156.76,448.907],[707.903,558.513],[707.903,451.99]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1156.76,577.591],[1156.76,687.878],[707.903,576.283],[707.903,682.806]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1156.76,700.602],[1156.76,810.889],[707.903,695.096],[707.903,801.619]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[866.826,304.2],[866.826,199.498],[737.797,309.117],[737.797,206.606]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1028.05,301.254],[1028.05,195.24],[866.826,304.2],[866.826,199.499]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1028.04,301.254],[1170.49,301.515],[1028.04,195.24],[1170.49,195.616]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1169,429.29],[1169,317.811],[1313.86,430.215],[1313.86,319.674]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1169,555.732],[1169,444.253],[1313.86,555.593],[1313.86,445.053]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1169,574.329],[1169,685.807],[1313.86,574.034],[1313.86,684.574]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1169,698.669],[1169,810.148],[1313.86,697.328],[1313.86,807.869]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1176.27,301.217],[1176.27,195.187],[1312.59,303.583],[1312.59,198.607]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1312.59,303.583],[1312.59,198.607],[1399.62,306.674],[1399.62,203.074]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1313.86,430.215],[1313.86,319.674],[1315.98,434.111],[1315.98,327.52]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1313.86,555.593],[1313.86,445.053],[1315.98,555.009],[1315.98,448.418]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1313.86,574.034],[1313.86,684.574],[1315.98,572.791],[1315.98,679.382]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1313.86,697.328],[1313.86,807.869],[1315.98,691.68],[1315.98,798.271]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1315.98,434.111],[1461.22,432.964],[1315.98,327.52],[1461.22,325.21]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1315.98,555.009],[1461.22,555.181],[1315.98,448.418],[1461.22,447.427]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1315.98,572.791],[1461.22,573.157],[1315.98,679.382],[1461.22,680.911]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1315.98,691.68],[1461.22,693.343],[1315.98,798.271],[1461.22,801.097]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1399.62,306.674],[1399.62,203.074],[1459.49,311.548],[1459.49,210.12]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1457.32,317.254],[1495.17,316.63],[1457.32,218.368],[1495.17,217.465]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1459.42,435.144],[1528.92,434.607],[1459.42,329.601],[1528.92,328.518]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1459.42,554.854],[1459.42,449.311],[1528.92,554.935],[1528.92,448.847]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1459.42,572.461],[1528.92,572.633],[1459.42,678.004],[1528.92,678.721]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1459.42,690.182],[1528.92,690.961],[1459.42,795.725],[1528.92,797.05]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1495.17,316.63],[1495.17,217.465],[1506.62,321.807],[1506.62,224.948]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1506.62,321.807],[1506.62,224.948],[1512.89,325.428],[1512.89,230.183]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1512.89,325.428],[1512.89,230.183],[1517.6,330.704],[1517.6,237.809]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1528.92,434.607],[1528.92,328.518],[1575.17,437.213],[1575.17,333.767]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1528.92,554.935],[1528.92,448.847],[1575.17,554.544],[1575.17,451.098]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1528.92,572.633],[1528.92,678.721],[1575.17,571.802],[1575.17,675.247]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:61,
                    verts:[[1528.92,690.961],[1528.92,797.05],[1575.17,687.183],[1575.17,790.629]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[447.166,440.38],[447.166,340.146],[420.773,443.239],[420.773,345.902]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[447.166,554.07],[447.166,453.835],[420.773,553.641],[420.773,456.305]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[447.166,570.791],[447.166,671.026],[420.773,569.879],[420.773,667.216]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[447.166,682.591],[447.166,782.825],[420.773,678.446],[420.773,775.783]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[447.324,801.491],[447.324,901.765],[420.488,793.908],[420.488,891.283]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[510.189,440.16],[510.189,339.702],[447.166,440.38],[447.166,340.146]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[510.189,554.103],[510.189,453.645],[447.166,554.07],[447.166,453.835]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[510.189,570.861],[510.189,671.32],[447.166,570.791],[447.166,671.026]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[510.189,682.91],[510.189,783.368],[447.166,682.591],[447.166,782.825]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[507.366,802.048],[507.366,902.535],[447.324,801.491],[447.324,901.765]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[638.05,808.917],[638.05,912.03],[494,807.552],[494,910.144]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[631.949,437.681],[631.949,334.709],[497.373,438.161],[497.373,335.677]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[631.949,554.474],[631.949,451.503],[497.373,554.402],[497.373,451.918]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[631.949,571.652],[631.949,674.624],[497.373,571.499],[497.373,673.983]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[631.949,686.504],[631.949,789.476],[497.373,685.808],[497.373,788.293]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[547.302,327.53],[512.754,327.788],[547.302,233.222],[512.754,233.594]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[574.154,316.363],[574.154,217.08],[532.464,322.28],[532.464,225.632]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[644.849,311.395],[644.849,209.899],[574.154,316.363],[574.154,217.08]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[753.579,819.574],[753.579,926.763],[612.078,818.186],[612.078,924.844]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[740.325,431.48],[740.325,322.223],[613.348,434.002],[613.348,327.301]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[740.325,555.403],[740.325,446.146],[613.348,555.025],[613.348,448.325]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[740.325,573.63],[740.325,682.887],[613.348,572.826],[613.348,679.526]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[740.325,695.493],[740.325,804.751],[613.348,691.837],[613.348,798.538]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[763.983,305.792],[763.983,201.8],[644.849,311.395],[644.849,209.899]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[897.837,823.265],[897.837,931.866],[750.455,821.808],[750.455,929.851]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1203.38,434.421],[1203.38,324.468],[744.724,436.077],[744.724,327.861]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1203.38,559.133],[1203.38,449.18],[744.724,558.819],[744.724,450.603]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1203.38,577.476],[1203.38,687.429],[744.724,576.872],[744.724,685.087]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1203.38,700.115],[1203.38,810.068],[744.724,697.573],[744.724,805.789]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[901.252,302.061],[901.252,196.407],[765.161,305.759],[765.161,201.752]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1065.72,300.703],[901.252,302.061],[1065.72,194.444],[901.252,196.407]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1065.72,300.703],[1065.72,194.444],[1206.08,302.374],[1206.08,196.857]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1212.08,302.133],[1212.08,196.511],[1342.48,305.812],[1342.48,201.829]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1218.31,429.677],[1218.31,318.592],[1357.3,431.249],[1357.3,321.757]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1218.31,555.674],[1218.31,444.588],[1357.3,555.438],[1357.3,445.946]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1218.31,574.205],[1218.31,685.291],[1357.3,573.704],[1357.3,683.196]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1218.31,698.108],[1218.31,809.193],[1357.3,695.829],[1357.3,805.321]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1342.48,305.812],[1342.48,201.829],[1423.25,309.699],[1423.25,207.447]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1349.71,435.119],[1349.71,329.55],[1492.53,434.609],[1492.53,328.524]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1349.71,554.858],[1349.71,449.289],[1492.53,554.934],[1492.53,448.849]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1349.71,572.469],[1349.71,678.038],[1492.53,572.632],[1492.53,678.717]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1349.71,690.218],[1349.71,795.787],[1492.53,690.957],[1492.53,797.043]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1423.25,309.699],[1423.25,207.447],[1475.51,315.065],[1475.51,215.203]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1467.27,320.666],[1504.18,320.39],[1467.27,223.299],[1504.18,222.901]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1485.43,436.75],[1485.43,332.834],[1553.18,436.513],[1553.18,332.357]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1485.43,554.614],[1485.43,450.698],[1553.18,554.649],[1553.18,450.493]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1485.43,571.949],[1485.43,675.865],[1553.18,572.025],[1553.18,676.181]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1485.43,687.855],[1485.43,791.77],[1553.18,688.198],[1553.18,792.354]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1504.18,320.39],[1504.18,222.901],[1509.54,325.582],[1509.54,230.406]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1509.54,325.582],[1509.54,230.406],[1511.63,329.196],[1511.63,235.63]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1553.18,436.513],[1553.18,332.357],[1590.78,439.262],[1590.78,337.894]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1553.18,554.649],[1553.18,450.493],[1590.78,554.237],[1590.78,452.869]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1553.18,572.025],[1553.18,676.181],[1590.78,571.148],[1590.78,672.516]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:62,
                    verts:[[1553.18,688.198],[1553.18,792.354],[1590.78,684.212],[1590.78,785.581]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[459.6,437.866],[459.6,335.083],[424.703,440.682],[424.703,340.752]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[459.6,554.446],[459.6,451.663],[424.703,554.024],[424.703,454.095]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[459.6,571.593],[459.6,674.377],[424.703,570.695],[424.703,670.624]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[459.6,686.236],[459.6,789.019],[424.703,682.154],[424.703,782.083]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[459.864,808.158],[459.864,910.981],[424.503,800.695],[424.503,900.664]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[525.661,437.915],[525.661,335.181],[459.6,437.866],[459.6,335.083]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[525.661,554.439],[525.661,451.705],[459.6,554.446],[459.6,451.663]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[525.661,571.577],[525.661,674.311],[459.6,571.593],[459.6,674.377]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[525.661,686.165],[525.661,788.899],[459.6,686.236],[459.6,789.019]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[522.809,808.034],[459.864,808.158],[522.809,910.81],[459.864,910.981]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[508.55,328.167],[508.55,234.141],[507.424,331.752],[507.424,239.323]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[512.478,323.002],[512.478,226.676],[508.55,328.167],[508.55,234.141]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[548.539,323.059],[512.478,323.002],[548.539,226.759],[512.478,226.676]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[664.129,813.512],[664.129,918.383],[514.271,813.812],[514.271,918.798]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[657.518,435.923],[657.518,331.169],[517.498,435.817],[517.498,330.956]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[657.518,554.738],[657.518,449.984],[517.498,554.753],[517.498,449.893]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[657.518,572.213],[657.518,676.966],[517.498,572.247],[517.498,677.108]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[657.518,689.053],[657.518,793.806],[517.498,689.206],[517.498,794.067]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[588.812,311.933],[588.812,210.677],[539.099,317.564],[539.099,218.816]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[667.031,307.575],[667.031,204.377],[588.812,311.933],[588.812,210.677]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[792.129,822.937],[646.401,823.239],[792.129,931.411],[646.401,931.83]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[783.85,430.129],[783.85,319.502],[647.812,432.101],[647.812,323.473]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[783.85,555.606],[783.85,444.979],[647.812,555.31],[647.812,446.682]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[783.85,574.061],[783.85,684.688],[647.812,573.432],[647.812,682.06]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[783.85,697.452],[783.85,808.079],[647.812,694.593],[647.812,803.221]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[794.692,303.085],[794.692,197.888],[667.031,307.575],[667.031,204.377]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[941.063,824.918],[791.095,825.232],[941.063,934.15],[791.095,934.584]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[937.173,300.705],[937.173,194.447],[795.924,303.063],[795.924,197.856]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[785.711,434.802],[785.711,325.248],[1246.58,435.154],[1246.58,325.97]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[785.711,559.061],[785.711,449.507],[1246.58,558.994],[1246.58,449.81]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[785.711,577.337],[785.711,686.89],[1246.58,577.208],[1246.58,686.392]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[785.711,699.53],[785.711,809.084],[1246.58,698.99],[1246.58,808.174]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[937.174,300.705],[1102.31,300.994],[937.174,194.447],[1102.31,194.864]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1102.31,300.994],[1102.31,194.864],[1238.37,304.043],[1238.37,199.269]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1244.48,303.863],[1244.48,199.012],[1367.1,308.761],[1367.1,206.091]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1263.92,430.513],[1263.92,320.275],[1394.78,432.687],[1394.78,324.652]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1263.92,555.548],[1263.92,445.31],[1394.78,555.223],[1394.78,447.188]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1263.92,573.939],[1263.92,684.177],[1394.78,573.245],[1394.78,681.28]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1263.92,696.896],[1263.92,807.134],[1394.78,693.745],[1394.78,801.779]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1367.1,308.761],[1367.1,206.091],[1440.66,313.349],[1440.66,212.723]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1377.94,436.467],[1377.94,332.266],[1516.2,436.572],[1516.2,332.476]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1377.94,554.656],[1377.94,450.454],[1516.2,554.64],[1516.2,450.545]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1377.94,572.039],[1377.94,676.241],[1516.2,572.006],[1516.2,676.102]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1377.94,688.263],[1377.94,792.465],[1516.2,688.112],[1516.2,792.208]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1440.66,313.349],[1440.66,212.723],[1484.93,319.096],[1484.93,221.031]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1471.02,324.517],[1506.58,324.573],[1471.02,228.865],[1506.58,228.946]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1504.2,438.64],[1504.2,336.64],[1569.25,438.688],[1569.25,336.737]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1504.2,554.33],[1504.2,452.331],[1569.25,554.323],[1569.25,452.373]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1504.2,571.346],[1504.2,673.346],[1569.25,571.331],[1569.25,673.282]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1504.2,685.114],[1504.2,787.114],[1569.25,685.044],[1569.25,786.995]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1569.25,438.688],[1569.25,336.737],[1598.2,441.526],[1598.2,342.453]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1569.25,554.323],[1569.25,452.373],[1598.2,553.898],[1598.2,454.825]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1569.25,571.331],[1569.25,673.282],[1598.2,570.426],[1598.2,669.499]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:63,
                    verts:[[1569.25,685.044],[1569.25,786.995],[1598.2,680.93],[1598.2,780.003]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[479.149,435.547],[479.149,330.413],[435.585,438.266],[435.585,335.887]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[479.149,554.794],[479.149,449.659],[435.585,554.387],[435.585,452.008]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[479.149,572.333],[479.149,677.467],[435.585,571.466],[435.585,673.844]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[479.149,689.598],[479.149,794.732],[435.585,685.657],[435.585,788.035]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[479.524,814.305],[479.524,919.479],[435.48,807.105],[435.48,909.525]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[547.444,435.891],[479.149,435.547],[547.444,331.105],[479.149,330.413]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[547.444,554.742],[547.444,449.956],[479.149,554.794],[479.149,449.659]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[547.444,572.223],[547.444,677.009],[479.149,572.333],[479.149,677.467]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[547.444,689.099],[479.149,689.598],[547.444,793.885],[479.149,794.732]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[544.605,813.436],[479.524,814.305],[544.605,918.278],[479.524,919.479]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[502.489,327.367],[502.489,232.985],[499.22,332.64],[499.22,240.607]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[507.701,323.728],[507.701,227.726],[502.489,327.367],[502.489,232.985]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[517.594,318.51],[517.594,220.183],[507.701,323.728],[507.701,227.726]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[554.792,318.909],[517.595,318.51],[554.792,220.76],[517.595,220.183]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[694.972,817.318],[541.375,819.412],[694.972,923.644],[541.375,926.539]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[687.93,434.459],[544.394,433.722],[687.93,328.221],[544.394,326.737]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[687.93,554.957],[687.93,448.719],[544.394,555.067],[544.394,448.082]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[687.93,572.68],[687.93,678.918],[544.394,572.915],[544.394,679.9]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[687.93,691.175],[544.394,692.244],[687.93,797.413],[544.394,799.229]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[608.766,308.008],[608.766,205.002],[551.238,313.236],[551.238,212.559]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[693.734,304.375],[693.734,199.752],[608.766,308.008],[608.766,205.002]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[686.213,827.362],[833.843,825.277],[686.213,937.529],[833.843,934.647]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[830.852,429.198],[830.852,317.628],[687.749,430.553],[687.749,320.354]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[830.852,555.745],[830.852,444.174],[687.749,555.542],[687.749,445.344]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[830.852,574.358],[830.852,685.929],[687.749,573.926],[687.749,684.124]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[830.852,698.802],[830.852,810.372],[687.749,696.839],[687.749,807.037]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[828.266,301.136],[828.266,195.071],[693.734,304.375],[693.734,199.752]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[973.787,300.19],[829.532,301.127],[973.787,193.702],[829.532,195.057]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[834.986,827.596],[834.986,937.852],[833.843,825.277],[833.843,934.647]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[834.986,827.596],[985.012,825.46],[834.986,937.852],[985.012,934.899]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[830.056,433.915],[830.056,323.431],[1285.33,436.282],[1285.33,328.282]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[830.056,559.229],[830.056,448.745],[1285.33,558.78],[1285.33,450.779]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[830.056,577.66],[830.056,688.144],[1285.33,576.797],[1285.33,684.797]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[830.056,700.891],[830.056,811.375],[1285.33,697.258],[1285.33,805.259]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[973.788,300.19],[973.788,193.702],[1136.94,302.129],[1136.94,196.505]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1136.94,302.129],[1136.94,196.505],[1266.64,306.479],[1266.64,202.79]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1272.77,306.361],[1272.77,202.622],[1386.04,312.349],[1386.04,211.277]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1304.72,431.773],[1304.72,322.812],[1425.57,434.484],[1425.57,328.271]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1304.72,555.36],[1304.72,446.399],[1425.57,554.953],[1425.57,448.741]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1304.72,573.537],[1304.72,682.498],[1425.57,572.672],[1425.57,678.884]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1304.72,695.069],[1304.72,804.03],[1425.57,691.139],[1425.57,797.352]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1386.04,312.349],[1386.04,211.277],[1451.68,317.526],[1451.68,218.76]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1400.16,438.118],[1400.16,335.589],[1532.02,438.795],[1532.02,336.953]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1400.16,554.409],[1400.16,451.88],[1532.02,554.307],[1532.02,452.465]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1400.16,571.513],[1400.16,674.041],[1532.02,571.297],[1532.02,673.139]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1400.16,685.871],[1400.16,788.4],[1532.02,684.889],[1532.02,786.731]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1451.68,317.526],[1451.68,218.76],[1487.8,323.543],[1487.8,227.458]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1468.74,328.717],[1468.74,234.936],[1502.58,329.08],[1502.58,235.461]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1515.58,440.763],[1515.58,340.916],[1577.19,441.073],[1577.19,341.54]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1515.58,554.012],[1515.58,454.165],[1577.19,553.966],[1577.19,454.433]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1515.58,570.669],[1515.58,670.516],[1577.19,570.57],[1577.19,670.103]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1515.58,682.036],[1515.58,781.884],[1577.19,681.587],[1577.19,781.12]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1577.19,441.073],[1577.19,341.54],[1597.69,443.948],[1597.69,347.33]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1577.19,553.966],[1577.19,454.433],[1597.69,553.535],[1597.69,456.917]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1577.19,570.57],[1577.19,670.103],[1597.69,569.653],[1597.69,666.271]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:64,
                    verts:[[1577.19,681.587],[1577.19,781.12],[1597.69,677.418],[1597.69,774.036]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[505.874,433.491],[505.874,326.271],[453.72,436.055],[453.72,331.435]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[505.874,555.102],[505.874,447.883],[453.72,554.718],[453.72,450.098]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[505.874,572.989],[505.874,680.208],[453.72,572.171],[453.72,676.791]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[505.874,692.579],[505.874,799.799],[453.72,688.862],[453.72,793.482]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[506.364,819.754],[506.364,927.012],[453.717,812.969],[453.717,917.632]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[502.759,323.257],[502.759,227.045],[493.424,328.576],[493.424,234.733]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[512.254,319.616],[512.254,221.782],[502.759,323.257],[502.759,227.045]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[505.874,433.491],[575.436,434.147],[505.874,326.271],[575.436,327.593]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[505.874,555.102],[505.874,447.883],[575.436,555.004],[575.436,448.45]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[505.874,572.989],[575.436,572.779],[505.874,680.208],[575.436,679.333]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[505.874,692.579],[575.436,691.627],[505.874,799.799],[575.436,798.181]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[506.364,819.754],[572.656,818.095],[506.364,927.012],[572.656,924.718]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[528.357,314.421],[528.357,214.273],[512.254,319.616],[512.254,221.782]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[528.357,314.421],[566.24,315.183],[528.357,214.273],[566.24,215.373]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[568.965,309.41],[568.965,207.029],[566.24,315.183],[566.24,215.374]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[633.859,304.699],[633.859,200.22],[568.964,309.41],[568.964,207.029]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[575.103,824.177],[575.103,933.126],[572.656,818.095],[572.656,924.718]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[577.85,431.94],[577.85,323.148],[575.436,434.147],[575.436,327.593]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[577.85,555.334],[577.85,446.543],[575.436,555.004],[575.436,448.45]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[577.85,573.483],[577.85,682.275],[575.436,572.779],[575.436,679.333]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[577.85,694.827],[577.85,803.619],[575.436,691.627],[575.436,798.181]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[575.103,824.177],[730.06,820.213],[575.103,933.126],[730.06,927.647]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[577.85,431.94],[577.85,323.148],[722.687,433.336],[722.687,325.959]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[577.85,555.334],[577.85,446.543],[722.687,555.125],[722.687,447.749]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[577.85,573.484],[577.85,682.275],[722.687,573.038],[722.687,680.415]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[577.85,694.827],[577.85,803.619],[722.687,692.804],[722.687,800.18]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[724.545,301.896],[724.545,196.168],[633.859,304.699],[633.859,200.22]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[730.769,830.411],[730.769,941.744],[721.149,820.048],[721.149,927.418]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[732.406,429.409],[732.406,318.052],[722.687,433.336],[722.687,325.959]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[732.406,555.714],[732.406,444.357],[722.687,555.125],[722.687,447.749]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[732.406,574.291],[732.406,685.648],[722.687,573.038],[722.687,680.415]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[732.406,698.496],[732.406,809.853],[722.687,692.804],[722.687,800.18]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[863.992,300.009],[863.992,193.441],[724.545,301.896],[724.545,196.168]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[730.769,830.411],[730.769,941.744],[877.776,826.514],[877.776,936.356]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[880.228,428.722],[880.228,316.667],[732.406,429.409],[732.406,318.052]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[880.228,555.817],[880.228,443.762],[732.406,555.714],[732.406,444.357]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[880.228,574.51],[880.228,686.564],[732.406,574.291],[732.406,685.648]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[880.228,699.493],[880.228,811.547],[732.406,698.496],[732.406,809.853]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[865.274,300.012],[1010.24,300.532],[865.274,193.446],[1010.24,194.196]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[881.118,828.815],[881.118,939.537],[877.776,826.514],[877.776,936.356]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[881.118,828.815],[881.118,939.537],[1028.61,824.872],[1028.61,934.086]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[876.737,433.449],[876.737,322.476],[1318.84,437.766],[1318.84,331.321]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[876.737,559.317],[876.737,448.345],[1318.84,558.498],[1318.84,452.054]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[876.737,577.83],[876.737,688.802],[1318.84,576.256],[1318.84,682.701]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[876.737,701.606],[876.737,812.578],[1318.84,694.982],[1318.84,801.427]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1010.24,300.532],[1010.24,194.196],[1168.83,304.069],[1168.83,199.31]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1168.83,304.069],[1168.83,199.31],[1290.37,309.603],[1290.37,207.306]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1296.42,309.546],[1296.42,207.226],[1399.13,316.468],[1399.13,217.231]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1339.86,433.411],[1339.86,326.112],[1449.26,436.581],[1449.26,332.494]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1339.86,555.114],[1339.86,447.814],[1449.26,554.639],[1449.26,450.552]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1339.86,573.014],[1339.86,680.314],[1449.26,572.003],[1449.26,676.09]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1339.86,692.694],[1339.86,799.994],[1449.26,688.099],[1449.26,792.186]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1399.13,316.468],[1399.13,217.231],[1456.41,322.114],[1456.41,225.392]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1416.15,440.019],[1416.15,339.418],[1540.12,441.214],[1540.12,341.824]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1416.15,554.124],[1416.15,453.523],[1540.12,553.945],[1540.12,454.555]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1416.15,570.906],[1416.15,671.507],[1540.12,570.525],[1540.12,669.915]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1416.15,683.115],[1416.15,783.716],[1540.12,681.382],[1540.12,780.772]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1456.41,322.114],[1456.41,225.392],[1484.44,328.292],[1484.44,234.322]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1460.79,333.165],[1460.79,241.367],[1492.63,333.806],[1492.63,242.292]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1519.8,443.059],[1519.8,345.54],[1577.37,443.603],[1577.37,346.635]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1519.8,553.668],[1519.8,456.149],[1577.37,553.587],[1577.37,456.619]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1519.8,569.937],[1519.8,667.455],[1577.37,569.763],[1577.37,666.731]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1519.8,678.707],[1519.8,776.226],[1577.37,677.919],[1577.37,774.887]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1577.37,443.603],[1577.37,346.635],[1589.82,446.468],[1589.82,352.405]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1577.37,553.587],[1577.37,456.619],[1589.82,553.157],[1589.82,459.094]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1577.37,569.763],[1577.37,666.731],[1589.82,568.849],[1589.82,662.912]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:65,
                    verts:[[1577.37,677.919],[1577.37,774.887],[1589.82,673.765],[1589.82,767.828]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[453.028,444.653],[453.028,348.751],[431.81,453.232],[431.81,366.026]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[453.028,553.429],[453.028,457.526],[431.81,552.144],[431.81,464.937]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[453.028,569.428],[453.028,665.331],[431.81,566.692],[431.81,653.898]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[453.028,676.396],[453.028,772.299],[431.81,663.96],[431.81,751.166]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[479.112,434.108],[479.112,327.513],[453.162,444.599],[453.162,348.641]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[479.112,555.01],[479.112,448.416],[453.162,553.437],[453.162,457.48]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[479.112,572.792],[479.112,679.386],[453.162,569.445],[453.162,665.403]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[479.112,691.685],[479.112,798.279],[453.162,676.475],[453.162,772.433]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[479.219,818.133],[479.219,924.771],[453.249,790.295],[453.249,886.289]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[539.514,431.755],[539.514,322.775],[479.112,434.108],[479.112,327.514]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[539.514,555.362],[539.514,446.383],[479.112,555.01],[479.112,448.416]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[539.514,573.543],[539.514,682.522],[479.112,572.792],[479.112,679.386]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[539.514,695.096],[539.514,804.075],[479.112,691.685],[479.112,798.279]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[540.114,824.352],[540.114,933.368],[479.219,818.133],[479.219,924.771]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[508.491,319.509],[508.491,221.626],[492.857,324.798],[492.857,229.272]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[522.381,315.921],[522.381,216.441],[508.49,319.509],[508.49,221.626]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[544.806,310.833],[544.806,209.087],[522.381,315.921],[522.381,216.441]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[539.514,431.755],[539.514,322.775],[609.244,432.733],[609.244,324.744]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[539.514,555.362],[539.514,446.383],[609.244,555.216],[609.244,447.228]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[539.514,573.543],[539.514,682.522],[609.244,573.231],[609.244,681.219]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[539.514,695.096],[539.514,804.075],[609.244,693.678],[609.244,801.666]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[540.114,824.352],[606.572,821.88],[540.114,933.368],[606.572,929.95]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[544.806,310.833],[582.864,311.968],[544.806,209.087],[582.864,210.727]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[592.126,306.182],[592.126,202.364],[582.864,311.968],[582.864,210.727]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[663.703,302.096],[663.703,196.457],[592.125,306.182],[592.125,202.364]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[614.918,827.967],[614.918,938.365],[606.572,821.88],[606.572,929.95]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[617.333,430.524],[617.333,320.297],[609.244,432.732],[609.244,324.744]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[617.333,555.547],[617.333,445.32],[609.244,555.216],[609.244,447.228]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[617.333,573.935],[617.333,684.162],[609.244,573.231],[609.244,681.219]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[617.333,696.88],[617.333,807.106],[609.244,693.678],[609.244,801.666]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[614.918,827.967],[614.918,938.365],[768.659,822.118],[768.659,930.28]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[617.333,430.524],[617.333,320.297],[761.068,432.584],[761.068,324.445]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[617.333,555.547],[617.333,445.32],[761.068,555.238],[761.068,447.099]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[617.333,573.935],[617.333,684.162],[761.068,573.278],[761.068,681.417]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[617.333,696.88],[617.333,807.107],[761.068,693.894],[761.068,802.032]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[758.848,300.202],[758.848,193.719],[663.703,302.096],[663.703,196.457]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[901.05,299.726],[758.848,300.202],[901.05,193.032],[758.848,193.719]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[779.059,832.296],[779.059,944.349],[759.499,822.06],[759.499,930.199]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[780.771,428.706],[780.771,316.637],[761.068,432.584],[761.068,324.445]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[780.771,555.819],[780.771,443.749],[761.068,555.238],[761.068,447.099]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[780.771,574.515],[780.771,686.585],[761.068,573.278],[761.068,681.417]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[780.771,699.515],[780.771,811.585],[761.068,693.894],[761.068,802.032]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[779.059,832.296],[779.059,944.349],[922.859,826.621],[922.859,936.504]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[930.739,428.709],[780.772,428.706],[930.739,316.642],[780.772,316.637]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[930.739,555.819],[930.739,443.752],[780.772,555.819],[780.772,443.749]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[930.739,574.514],[930.739,686.581],[780.772,574.515],[780.772,686.585]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[930.739,699.511],[780.772,699.515],[930.739,811.578],[780.772,811.585]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[902.327,299.742],[902.327,193.055],[1045.67,301.703],[1045.67,195.89]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[928.353,828.864],[928.353,939.605],[922.859,826.621],[922.859,936.504]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[928.353,828.864],[928.353,939.605],[1070.79,823.195],[1070.79,931.768]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[924.6,433.413],[924.6,322.404],[1346.59,439.548],[1346.59,334.973]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[924.6,559.324],[924.6,448.314],[1346.59,558.16],[1346.59,453.585]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[924.6,577.843],[924.6,688.852],[1346.59,575.606],[1346.59,680.181]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[924.6,701.661],[924.6,812.67],[1346.59,692.247],[1346.59,796.821]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1045.67,301.704],[1045.67,195.89],[1197.35,306.736],[1197.35,203.165]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1197.34,306.736],[1197.34,203.165],[1309.26,313.307],[1309.26,212.66]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1315.16,313.307],[1315.16,212.663],[1406.47,320.994],[1406.47,223.773]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1368.83,435.367],[1368.83,330.049],[1465.79,438.907],[1465.79,337.178]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1368.83,554.821],[1368.83,449.503],[1465.79,554.29],[1465.79,452.562]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1368.83,572.39],[1368.83,677.708],[1465.79,571.261],[1465.79,672.99]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1368.83,689.859],[1368.83,795.177],[1465.79,684.727],[1465.79,786.456]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1406.47,320.993],[1406.47,223.773],[1455.19,326.987],[1455.19,232.436]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1455.19,326.987],[1455.19,232.436],[1475.37,333.224],[1475.37,241.452]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1425.97,442.112],[1425.97,343.633],[1540.93,443.76],[1540.93,346.95]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1425.97,553.81],[1425.97,455.331],[1540.93,553.563],[1540.93,456.754]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1425.97,570.239],[1425.97,668.718],[1540.93,569.713],[1540.93,666.522]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1425.97,680.08],[1425.97,778.56],[1540.93,677.692],[1540.93,774.501]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1447.72,337.758],[1447.72,248.005],[1477.35,338.642],[1477.35,249.283]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1517.29,445.467],[1517.29,350.389],[1570.43,446.212],[1570.43,351.89]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1517.29,553.307],[1517.29,458.229],[1570.43,553.196],[1570.43,458.873]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1517.29,569.169],[1517.29,664.246],[1570.43,568.931],[1570.43,663.253]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1517.29,675.216],[1517.29,770.294],[1570.43,674.136],[1570.43,768.458]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1570.43,446.212],[1570.43,351.89],[1575.35,449.027],[1575.35,357.559]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1570.43,553.196],[1570.43,458.873],[1575.35,552.774],[1575.35,461.305]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1570.43,568.931],[1570.43,663.253],[1575.35,568.033],[1575.35,659.501]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:66,
                    verts:[[1570.43,674.136],[1570.43,768.458],[1575.35,670.055],[1575.35,761.524]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[457.537,442.985],[457.537,345.39],[413.516,451.567],[413.516,362.674]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[457.537,553.679],[457.537,456.085],[413.516,552.393],[413.516,463.499]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[457.537,569.96],[457.537,667.555],[413.516,567.223],[413.516,656.116]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[457.537,678.815],[457.537,776.41],[413.516,666.373],[413.516,755.267]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[457.537,794.484],[457.537,892.078],[413.516,771.728],[413.516,860.622]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[511.453,432.473],[511.453,324.221],[457.815,442.93],[457.815,345.281]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[511.453,555.255],[511.453,447.003],[457.815,553.688],[457.815,456.038]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[511.453,573.314],[511.453,681.565],[457.815,569.978],[457.815,667.628]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[511.453,694.055],[511.453,802.307],[457.815,678.894],[457.815,776.544]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[511.674,822.467],[511.674,930.762],[457.995,794.72],[457.995,892.405]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[493.236,327.318],[493.236,232.915],[493.041,330.944],[493.041,238.156]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[497.908,321.802],[497.908,224.941],[493.236,327.318],[493.236,232.915]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[519.746,316.196],[519.746,216.838],[497.707,321.375],[497.707,224.325]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[579.476,430.384],[579.476,320.016],[511.453,432.473],[511.453,324.221]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[579.476,555.568],[579.476,445.199],[511.453,555.255],[511.453,447.003]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[579.476,573.98],[579.476,684.348],[511.453,573.314],[511.453,681.565]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[579.476,697.083],[579.476,807.451],[511.453,694.055],[511.453,802.307]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[580.181,827.978],[580.181,938.38],[511.674,822.467],[511.674,930.762]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[538.049,312.719],[538.049,211.813],[519.745,316.196],[519.745,216.838]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[566.754,307.825],[566.754,204.738],[538.049,312.719],[538.049,211.813]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[566.755,307.825],[604.437,309.333],[566.755,204.738],[604.437,206.919]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[579.476,430.384],[579.476,320.016],[648.201,431.682],[648.201,322.628]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[579.476,555.568],[579.476,445.199],[648.201,555.373],[648.201,446.32]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[579.476,573.98],[579.476,684.348],[648.201,573.566],[648.201,682.619]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[579.476,697.083],[579.476,807.451],[648.201,695.202],[648.201,804.255]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[580.181,827.978],[580.181,938.38],[645.685,824.698],[645.685,933.846]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[620.34,303.626],[620.34,198.669],[604.437,309.333],[604.437,206.919]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[697.69,300.254],[697.69,193.795],[620.34,303.626],[620.34,198.669]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[659.983,830.683],[659.983,942.12],[645.685,824.698],[645.685,933.846]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[662.014,429.511],[662.014,318.256],[648.201,431.682],[648.201,322.628]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[662.014,555.699],[662.014,444.444],[648.201,555.373],[648.201,446.32]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[662.014,574.258],[662.014,685.513],[648.201,573.566],[648.201,682.619]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[662.014,698.349],[662.014,809.604],[648.201,695.202],[648.201,804.255]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[659.984,830.683],[659.984,942.12],[809.87,823.002],[809.87,931.502]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[662.014,429.511],[662.014,318.256],[802.185,432.217],[802.185,323.705]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[662.014,555.699],[662.014,444.444],[802.185,555.293],[802.185,446.782]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[662.014,574.258],[662.014,685.513],[802.185,573.395],[802.185,681.906]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[662.014,698.349],[662.014,809.604],[802.185,694.426],[802.185,802.937]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[795.869,299.321],[795.869,192.446],[697.69,300.254],[697.69,193.795]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[795.869,299.321],[938.571,300.269],[795.869,192.446],[938.571,193.817]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[829.889,832.983],[829.889,945.299],[800.608,823.052],[800.608,931.571]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[831.647,428.455],[831.647,316.131],[802.185,432.217],[802.185,323.705]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[831.647,555.857],[831.647,443.533],[802.185,555.293],[802.185,446.782]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[831.647,574.595],[831.647,686.919],[802.185,573.395],[802.185,681.906]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[831.647,699.879],[831.647,812.203],[802.185,694.426],[802.185,802.937]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[829.889,832.983],[829.889,945.299],[967.991,825.63],[967.991,935.134]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[831.647,428.455],[831.647,316.131],[981.111,429.147],[981.111,317.524]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[831.647,555.857],[831.647,443.533],[981.111,555.753],[981.111,444.13]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[831.647,574.595],[831.647,686.919],[981.111,574.374],[981.111,685.997]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[831.647,699.879],[831.647,812.203],[981.111,698.876],[981.111,810.499]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[939.824,300.298],[939.824,193.858],[1079.34,303.64],[1079.34,198.689]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[975.523,827.778],[975.523,938.104],[967.991,825.63],[967.991,935.134]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[975.523,827.778],[975.523,938.104],[1110.62,820.521],[1110.62,928.072]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[972.457,433.796],[972.457,323.188],[1368.37,441.565],[1368.37,339.105]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[972.457,559.251],[972.457,448.643],[1368.37,557.778],[1368.37,455.318]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[972.457,577.703],[972.457,688.311],[1368.37,574.871],[1368.37,677.33]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[972.457,701.073],[972.457,811.681],[1368.37,689.152],[1368.37,791.612]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1079.34,303.64],[1079.34,198.689],[1222.04,310.023],[1222.04,207.916]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1222.04,310.023],[1222.04,207.916],[1323.24,317.464],[1323.24,218.669]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1328.91,317.518],[1328.91,218.749],[1408.35,325.795],[1408.35,230.713]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1391.41,437.567],[1391.41,334.479],[1475.42,441.388],[1475.42,342.176]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1391.41,554.491],[1391.41,451.404],[1475.42,553.919],[1475.42,454.706]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1391.41,571.689],[1391.41,674.776],[1475.42,570.47],[1475.42,669.682]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1391.41,686.67],[1391.41,789.757],[1475.42,681.129],[1475.42,780.342]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1408.35,325.795],[1408.35,230.713],[1448.54,332.02],[1448.54,239.711]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1448.54,332.02],[1448.54,239.712],[1461.23,338.227],[1461.23,248.682]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1429.91,444.335],[1429.91,348.108],[1535.12,446.366],[1535.12,352.199]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1429.91,553.477],[1429.91,457.251],[1535.12,553.173],[1535.12,459.006]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1429.91,569.53],[1429.91,665.756],[1535.12,568.882],[1535.12,663.049]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1429.91,676.858],[1429.91,773.084],[1535.12,673.914],[1535.12,768.081]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1508.73,447.926],[1508.73,355.34],[1557.18,448.84],[1557.18,357.182]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1508.73,552.939],[1508.73,460.353],[1557.18,552.802],[1557.18,461.144]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1508.73,568.384],[1508.73,660.97],[1557.18,568.092],[1557.18,659.751]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:67,
                    verts:[[1508.73,671.652],[1508.73,764.238],[1557.18,670.326],[1557.18,761.984]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[467.974,441.494],[467.974,342.388],[400.486,449.964],[400.486,359.444]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[467.974,553.903],[467.974,454.797],[400.486,552.633],[400.486,462.114]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[467.974,570.436],[467.974,669.542],[400.486,567.734],[400.486,658.253]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[467.974,680.977],[467.974,780.083],[400.486,668.698],[400.486,759.217]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[467.974,798.436],[467.974,897.542],[400.486,775.98],[400.486,866.499]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[550.127,431.184],[550.127,321.625],[468.399,441.441],[468.399,342.28]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[550.127,555.448],[550.127,445.889],[468.399,553.911],[468.399,454.751]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[550.127,573.725],[550.127,683.283],[468.399,570.453],[468.399,669.613]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[550.127,695.924],[550.127,805.482],[468.399,681.054],[468.399,780.214]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[550.461,825.882],[550.461,935.483],[468.673,798.668],[468.673,897.863]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[492.474,327.927],[492.474,233.795],[488.955,332.859],[488.955,240.923]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[496.73,324.287],[496.73,228.533],[492.474,327.927],[492.474,233.795]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[507.702,318.791],[507.702,220.589],[496.73,324.287],[496.73,228.533]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[536.384,313.372],[536.384,212.757],[507.972,318.361],[507.972,219.967]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[559.012,310.064],[559.012,207.975],[536.383,313.372],[536.383,212.757]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[624.88,429.406],[624.88,318.046],[550.127,431.184],[550.127,321.625]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[624.88,555.714],[624.88,444.354],[550.127,555.448],[550.127,445.889]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[624.88,574.292],[624.88,685.652],[550.127,573.725],[550.127,683.283]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[624.88,698.5],[624.88,809.861],[550.127,695.924],[550.127,805.482]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[625.682,830.562],[625.682,941.953],[550.461,825.882],[550.461,935.483]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[593.797,305.445],[593.797,201.299],[559.011,310.064],[559.011,207.975]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[593.797,305.445],[593.797,201.299],[630.538,307.318],[630.538,204.005]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[624.88,429.406],[624.88,318.046],[691.414,431.01],[691.414,321.276]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[624.88,555.714],[624.88,444.354],[691.414,555.474],[691.414,445.74]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[624.88,574.292],[624.88,685.652],[691.414,573.78],[691.414,683.514]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[624.88,698.5],[624.88,809.861],[691.414,696.175],[691.414,805.909]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[625.682,830.562],[625.682,941.953],[689.1,826.507],[689.1,936.347]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[653.016,301.78],[653.016,196.001],[630.538,307.318],[630.538,204.005]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[735.046,299.191],[735.046,192.258],[653.016,301.78],[653.016,196.001]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[709.222,832.287],[709.222,944.337],[689.1,826.507],[689.1,936.347]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[710.825,428.914],[710.825,317.055],[691.414,431.01],[691.414,321.276]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[710.825,555.788],[710.825,443.929],[691.414,555.474],[691.414,445.74]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[710.825,574.449],[710.825,686.308],[691.414,573.78],[691.414,683.514]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[710.825,699.214],[710.825,811.073],[691.414,696.175],[691.414,805.909]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[709.223,832.287],[709.223,944.337],[852.704,822.885],[852.704,931.34]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[710.825,428.914],[710.825,317.055],[845.049,432.227],[845.049,323.726]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[710.825,555.788],[710.825,443.929],[845.049,555.292],[845.049,446.791]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[710.825,574.449],[710.825,686.308],[845.049,573.392],[845.049,681.893]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[710.825,699.214],[710.825,811.073],[845.049,694.411],[845.049,802.912]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[834.736,299.241],[735.047,299.191],[834.736,192.331],[735.047,192.258]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[834.736,299.241],[834.736,192.331],[975.711,301.579],[975.711,195.71]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[883.751,428.644],[883.751,316.51],[845.049,432.227],[845.049,323.726]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[883.751,555.828],[883.751,443.695],[845.049,555.292],[845.049,446.791]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[883.751,574.535],[883.751,686.668],[845.049,573.392],[845.049,681.893]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[883.751,699.606],[883.751,811.739],[845.049,694.411],[845.049,802.912]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[881.979,832.505],[881.979,944.638],[843.491,823.044],[843.491,931.559]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[881.979,832.505],[881.979,944.638],[1012.12,823.628],[1012.12,932.367]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[883.751,428.644],[883.751,316.51],[1030.15,429.999],[1030.15,319.24]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[883.751,555.828],[883.751,443.695],[1030.15,555.625],[1030.15,444.866]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[883.751,574.535],[883.751,686.668],[1030.15,574.102],[1030.15,684.862]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[883.751,699.606],[883.751,811.739],[1030.15,697.641],[1030.15,808.4]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[976.919,301.619],[976.919,195.769],[1110.59,306.242],[1110.59,202.45]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1021.53,825.649],[1021.53,935.16],[1012.12,823.628],[1012.12,932.367]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1021.53,825.649],[1021.53,935.16],[1147.34,816.987],[1147.34,923.186]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1019.18,434.564],[1019.18,324.762],[1384.23,443.746],[1384.23,343.574]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1019.18,559.106],[1019.18,449.303],[1384.23,557.364],[1384.23,457.192]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1019.18,577.423],[1019.18,687.226],[1384.23,574.075],[1384.23,674.248]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1019.18,699.894],[1019.18,809.697],[1384.23,685.805],[1384.23,785.978]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1110.59,306.242],[1110.59,202.45],[1242.68,313.802],[1242.68,213.378]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1242.68,313.802],[1242.68,213.378],[1332.44,321.94],[1332.44,225.139]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1337.81,322.042],[1337.81,225.288],[1405.24,330.742],[1405.24,237.864]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1405.24,330.742],[1405.24,237.864],[1437.1,337.095],[1437.1,247.046]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1407.7,439.936],[1407.7,339.25],[1478.63,443.954],[1478.63,347.342]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1407.7,554.136],[1407.7,453.451],[1478.63,553.534],[1478.63,456.922]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1407.7,570.933],[1407.7,671.619],[1478.63,569.651],[1478.63,666.263]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1407.7,683.236],[1407.7,783.921],[1478.63,677.41],[1478.63,774.022]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1437.1,337.095],[1437.1,247.046],[1442.77,343.195],[1442.77,255.863]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1428.46,446.626],[1428.46,352.722],[1523.51,448.972],[1523.51,357.446]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1428.46,553.134],[1428.46,459.23],[1523.51,552.782],[1523.51,461.257]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1428.46,568.799],[1428.46,662.702],[1523.51,568.051],[1523.51,659.576]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1428.46,673.537],[1428.46,767.44],[1523.51,670.136],[1523.51,761.661]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1494.89,450.38],[1494.89,360.282],[1538.57,451.433],[1538.57,362.402]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1494.89,552.571],[1494.89,462.473],[1538.57,552.413],[1538.57,463.383]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1494.89,567.602],[1494.89,657.699],[1538.57,567.266],[1538.57,656.296]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:68,
                    verts:[[1494.89,668.094],[1494.89,758.192],[1538.57,666.568],[1538.57,755.598]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[484.183,440.201],[484.183,339.784],[392.986,448.438],[392.986,356.372]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[484.183,554.096],[484.183,453.68],[392.986,552.862],[392.986,460.796]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[484.183,570.848],[484.183,671.265],[392.986,568.221],[392.986,660.287]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[484.183,682.851],[484.183,783.268],[392.986,670.909],[392.986,762.975]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[484.183,801.864],[484.183,902.281],[392.986,780.024],[392.986,872.09]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[594.267,430.258],[594.267,319.76],[484.755,440.149],[484.755,339.68]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[594.267,555.587],[594.267,445.089],[484.755,554.104],[484.755,453.635]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[594.267,574.02],[594.267,684.517],[484.755,570.865],[484.755,671.334]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[594.267,697.266],[594.267,807.763],[484.755,682.926],[484.755,783.395]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[594.713,828.333],[594.713,938.871],[485.124,802.089],[485.124,902.592]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[496.945,325.224],[496.945,229.888],[487.844,330.134],[487.844,236.985]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[505.362,321.617],[505.362,224.673],[496.945,325.224],[496.945,229.888]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[522.718,316.217],[522.718,216.869],[505.362,321.617],[505.362,224.673]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[558.079,311.07],[558.079,209.429],[523.472,315.79],[523.472,216.251]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[584.838,307.983],[584.838,204.967],[558.079,311.07],[558.079,209.429]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[625.345,303.716],[625.345,198.799],[584.838,307.983],[584.838,204.967]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[674.64,428.828],[674.64,316.881],[594.267,430.258],[594.267,319.76]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[674.64,555.801],[674.64,443.854],[594.267,555.587],[594.267,445.089]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[674.64,574.476],[674.64,686.423],[594.267,574.02],[594.267,684.517]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[674.64,699.339],[674.64,811.286],[594.267,697.266],[594.267,807.764]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[675.526,832.086],[675.526,944.059],[594.713,828.333],[594.713,938.871]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[625.345,303.716],[625.345,198.8],[660.589,305.932],[660.589,202.002]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[689.408,300.65],[689.408,194.368],[660.589,305.932],[660.589,202.002]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[674.64,428.828],[674.64,316.881],[737.846,430.716],[737.846,320.683]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[674.64,555.801],[674.64,443.854],[737.846,555.518],[737.846,445.485]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[674.64,574.476],[674.64,686.423],[737.846,573.874],[737.846,683.907]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[674.64,699.339],[674.64,811.286],[737.846,696.602],[737.846,806.635]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[675.526,832.086],[675.526,944.059],[735.774,827.312],[735.774,937.46]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[774.898,298.888],[774.898,191.821],[689.408,300.65],[689.408,194.368]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[761.418,832.792],[761.418,945.035],[735.773,827.312],[735.773,937.46]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[762.565,428.729],[762.565,316.682],[737.846,430.716],[737.846,320.683]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[762.565,555.816],[762.565,443.769],[737.846,555.518],[737.846,445.485]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[762.565,574.508],[762.565,686.555],[737.846,573.874],[737.846,683.907]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[762.565,699.483],[762.565,811.53],[737.846,696.602],[737.846,806.635]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[761.418,832.792],[761.418,945.035],[896.167,821.835],[896.167,929.889]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[762.565,428.729],[762.565,316.682],[888.663,432.59],[888.663,324.458]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[762.565,555.816],[762.565,443.769],[888.663,555.237],[888.663,447.105]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[762.565,574.508],[762.565,686.555],[888.663,573.276],[888.663,681.408]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[762.565,699.483],[762.565,811.53],[888.663,693.884],[888.663,802.017]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[774.899,298.888],[874.559,299.912],[774.899,191.821],[874.559,193.301]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[874.559,299.912],[874.559,193.301],[1011.71,303.567],[1011.71,198.583]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[935.835,429.238],[935.835,317.708],[888.663,432.59],[888.663,324.458]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[935.835,555.739],[935.835,444.209],[888.663,555.237],[888.663,447.105]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[935.835,574.345],[935.835,685.875],[888.663,573.276],[888.663,681.408]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[935.835,698.744],[935.835,810.274],[888.663,693.884],[888.663,802.017]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[934.078,830.949],[934.078,942.487],[887.148,822.097],[887.148,930.251]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[934.078,830.949],[934.078,942.487],[1054.35,820.743],[1054.35,928.379]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[935.835,429.238],[935.835,317.708],[1076.82,431.211],[1076.82,321.681]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[935.835,555.739],[935.835,444.209],[1076.82,555.444],[1076.82,445.913]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[935.835,574.345],[935.835,685.875],[1076.82,573.716],[1076.82,683.246]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[935.835,698.744],[935.835,810.274],[1076.82,695.884],[1076.82,805.414]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1012.86,303.618],[1012.86,198.657],[1138.96,309.389],[1138.96,206.999]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1065.41,822.61],[1065.41,930.96],[1180.39,812.756],[1180.39,917.337]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1063.8,435.669],[1063.8,327.024],[1394.48,446.024],[1394.48,348.241]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1063.8,558.896],[1063.8,450.252],[1394.48,556.932],[1394.48,459.149]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1063.8,577.021],[1063.8,685.665],[1394.48,573.245],[1394.48,671.028]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1063.8,698.2],[1063.8,806.844],[1394.48,682.31],[1394.48,780.093]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1138.96,309.389],[1138.96,206.999],[1259.2,317.939],[1259.2,219.357]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1259.2,317.939],[1259.2,219.357],[1337.14,326.604],[1337.14,231.88]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1342.18,326.748],[1342.18,232.091],[1397.73,335.718],[1397.73,245.057]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1397.73,335.718],[1397.73,245.056],[1421.59,342.106],[1421.59,254.29]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1418.04,442.401],[1418.04,344.214],[1476.11,446.538],[1476.11,352.546]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1418.04,553.767],[1418.04,455.58],[1476.11,553.147],[1476.11,459.155]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1418.04,570.147],[1418.04,668.334],[1476.11,568.827],[1476.11,662.819]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1418.04,679.662],[1418.04,777.849],[1476.11,673.664],[1476.11,767.656]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1422.22,448.93],[1422.22,357.363],[1506.98,451.526],[1506.98,362.59]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1422.22,552.788],[1422.22,461.221],[1506.98,552.399],[1506.98,463.464]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1422.22,568.064],[1422.22,659.631],[1506.98,567.236],[1506.98,656.172]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1422.22,670.196],[1422.22,761.763],[1506.98,666.433],[1506.98,755.369]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1476.62,452.782],[1476.62,365.12],[1515.52,453.944],[1515.52,367.46]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1476.62,552.211],[1476.62,464.549],[1515.52,552.037],[1515.52,465.553]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1476.62,566.835],[1476.62,654.497],[1515.52,566.464],[1515.52,652.948]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:69,
                    verts:[[1476.62,664.612],[1476.62,752.274],[1515.52,662.927],[1515.52,749.411]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[505.822,439.115],[505.822,337.597],[391.121,447.003],[391.121,353.482]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[505.822,554.259],[505.822,452.742],[391.121,553.077],[391.121,459.556]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[505.822,571.195],[505.822,672.712],[391.121,568.679],[391.121,662.2]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[505.822,684.425],[505.822,785.943],[391.121,672.99],[391.121,766.511]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[505.822,804.742],[505.822,906.26],[391.121,783.83],[391.121,877.351]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[506.325,322.85],[506.325,226.457],[491.569,327.678],[491.569,233.435]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[518.925,319.323],[518.925,221.358],[506.325,322.85],[506.325,226.457]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[642.827,429.693],[642.827,318.624],[506.538,439.066],[506.538,337.498]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[642.827,555.671],[642.827,444.602],[506.538,554.267],[506.538,452.699]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[642.827,574.2],[642.827,685.269],[506.538,571.211],[506.538,672.778]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[642.827,698.084],[642.827,809.153],[506.538,684.497],[506.538,786.064]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[643.38,829.823],[643.38,940.93],[506.999,804.957],[506.999,906.557]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[542.622,314.095],[542.622,213.801],[518.925,319.323],[518.925,221.358]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[584.349,309.295],[584.349,206.864],[543.862,313.676],[543.862,213.195]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[614.946,306.478],[614.946,202.791],[584.349,309.295],[584.349,206.864]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[660.677,302.628],[660.677,197.226],[614.946,306.478],[614.946,202.791]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[727.545,428.636],[727.545,316.495],[642.827,429.693],[642.827,318.624]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[727.545,555.83],[727.545,443.688],[642.827,555.671],[642.827,444.602]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[727.545,574.537],[727.545,686.679],[642.827,574.2],[642.827,685.269]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[727.545,699.617],[727.545,811.759],[642.827,698.084],[642.827,809.153]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[728.501,832.583],[728.501,944.746],[643.38,829.823],[643.38,940.93]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[660.677,302.628],[660.677,197.226],[693.902,305.158],[693.902,200.883]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[728.676,300.207],[728.676,193.728],[693.902,305.158],[693.902,200.884]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[727.545,428.636],[727.545,316.495],[786.398,430.777],[786.398,320.807]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[727.545,555.83],[727.545,443.688],[786.398,555.509],[786.398,445.538]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[727.545,574.537],[727.545,686.679],[786.398,573.854],[786.398,683.825]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[727.545,699.617],[727.545,811.759],[786.398,696.513],[786.398,806.483]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[816.339,299.293],[816.339,192.406],[728.675,300.207],[728.675,193.728]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[728.501,832.583],[728.501,944.746],[784.599,827.169],[784.599,937.262]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[815.315,832.266],[815.315,944.308],[784.599,827.169],[784.599,937.262]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[815.99,428.929],[815.99,317.085],[786.398,430.777],[786.398,320.807]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[815.99,555.786],[815.99,443.942],[786.398,555.509],[786.398,445.538]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[815.99,574.444],[815.99,686.288],[786.398,573.854],[786.398,683.825]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[815.99,699.192],[815.99,811.037],[786.398,696.513],[786.398,806.483]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[815.316,832.266],[815.316,944.308],[939.333,819.958],[939.333,927.294]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[816.339,299.293],[816.339,192.406],[914.487,301.254],[914.487,195.24]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[815.99,428.929],[815.99,317.085],[932.089,433.268],[932.089,325.823]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[815.99,555.786],[815.99,443.942],[932.089,555.135],[932.089,447.69]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[815.99,574.444],[815.99,686.288],[932.089,573.06],[932.089,680.505]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[815.99,699.193],[815.99,811.037],[932.089,692.902],[932.089,800.347]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[914.487,301.254],[914.487,195.24],[1045.95,306.119],[1045.95,202.273]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[986.771,430.189],[986.771,319.623],[932.089,433.268],[932.089,325.823]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[986.771,555.597],[986.771,445.031],[932.089,555.135],[932.089,447.69]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[986.771,574.042],[986.771,684.608],[932.089,573.06],[932.089,680.505]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[986.771,697.365],[986.771,807.932],[932.089,692.902],[932.089,800.347]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[985.058,828.448],[985.058,939.029],[930.639,820.316],[930.639,927.789]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[985.058,828.448],[985.058,939.029],[1093.94,817.132],[1093.94,923.386]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[986.771,430.189],[986.771,319.623],[1120.32,432.717],[1120.32,324.714]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[986.771,555.597],[986.771,445.031],[1120.32,555.218],[1120.32,447.215]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[986.771,574.042],[986.771,684.608],[1120.32,573.235],[1120.32,681.239]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[986.771,697.365],[986.771,807.932],[1120.32,693.7],[1120.32,801.703]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1047.02,306.179],[1047.02,202.36],[1164.16,312.951],[1164.16,212.148]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1106.42,818.828],[1106.42,925.731],[1209.46,808.003],[1209.46,910.768]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1105.54,437.049],[1105.54,329.852],[1399.58,448.337],[1399.58,352.98]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1105.54,558.634],[1105.54,451.438],[1399.58,556.494],[1399.58,461.137]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1105.54,576.517],[1105.54,683.714],[1399.58,572.401],[1399.58,667.759]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1105.54,696.082],[1105.54,803.279],[1399.58,678.761],[1399.58,774.118]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1164.16,312.951],[1164.16,212.148],[1271.71,322.299],[1271.71,225.66]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1271.71,322.299],[1271.71,225.66],[1337.75,331.334],[1337.75,238.717]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1342.44,331.514],[1342.44,238.98],[1386.44,340.62],[1386.44,252.141]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1386.44,340.62],[1386.44,252.141],[1402.72,346.967],[1402.72,261.316]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1422.94,444.895],[1422.94,349.237],[1468.6,449.085],[1468.6,357.675]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1422.94,553.393],[1422.94,457.735],[1468.6,552.765],[1468.6,461.355]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1422.94,569.351],[1422.94,665.009],[1468.6,568.014],[1468.6,659.425]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1422.94,676.046],[1422.94,771.704],[1468.6,669.971],[1468.6,761.382]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1411.86,451.2],[1411.86,361.933],[1486.41,453.986],[1486.41,367.544]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1411.86,552.448],[1411.86,463.182],[1486.41,552.031],[1486.41,465.589]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1411.86,567.34],[1411.86,656.606],[1486.41,566.451],[1486.41,652.893]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1411.86,666.906],[1411.86,756.172],[1486.41,662.866],[1486.41,749.308]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1454.74,455.094],[1454.74,369.776],[1488.97,456.339],[1488.97,372.284]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1454.74,551.865],[1454.74,466.546],[1488.97,551.678],[1488.97,467.622]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1454.74,566.098],[1454.74,651.416],[1488.97,565.7],[1488.97,649.756]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:70,
                    verts:[[1454.74,661.26],[1454.74,746.578],[1488.97,659.454],[1488.97,743.51]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[532.403,438.237],[532.403,335.828],[394.856,445.664],[394.856,350.786]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[532.403,554.391],[532.403,451.983],[394.856,553.278],[394.856,458.4]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[532.403,571.475],[532.403,673.883],[394.856,569.106],[394.856,663.984]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[532.403,685.699],[532.403,788.107],[394.856,674.931],[394.856,769.809]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[532.403,807.072],[532.403,909.48],[394.856,787.379],[394.856,882.257]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[529.844,327.778],[529.844,233.579],[498.229,331.357],[498.229,238.753]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[520.353,320.806],[520.353,223.502],[499.968,325.492],[499.968,230.275]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[537.083,317.404],[537.083,218.585],[520.353,320.806],[520.353,223.502]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[694.673,429.474],[694.673,318.182],[533.257,438.19],[533.257,335.735]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[694.673,555.704],[694.673,444.412],[533.257,554.398],[533.257,451.943]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[694.673,574.27],[694.673,685.562],[533.257,571.49],[533.257,673.945]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[694.673,698.403],[694.673,809.695],[533.257,685.766],[533.257,788.221]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[695.323,830.397],[695.323,941.725],[533.807,807.273],[533.807,909.758]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[566.954,312.415],[566.954,211.374],[537.083,317.404],[537.083,218.585]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[614.596,308.032],[614.596,205.037],[568.673,312.01],[568.673,210.788]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[648.656,305.523],[648.656,201.411],[614.596,308.032],[614.596,205.037]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[698.999,302.142],[698.999,196.524],[648.656,305.523],[648.656,201.411]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[782.372,428.801],[782.372,316.828],[694.673,429.474],[694.673,318.182]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[782.372,555.805],[782.372,443.831],[694.673,555.704],[694.673,444.412]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[782.372,574.485],[782.372,686.458],[694.673,574.27],[694.673,685.562]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[782.372,699.378],[782.372,811.351],[694.673,698.403],[694.673,809.695]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[783.381,832.133],[783.381,944.124],[695.323,830.397],[695.323,941.725]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[698.999,302.142],[698.999,196.524],[729.741,304.952],[729.741,200.585]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[769.951,300.396],[769.951,194],[729.741,304.952],[729.741,200.585]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[858.496,300.324],[769.95,300.396],[858.496,193.896],[769.95,194]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[782.372,428.801],[782.372,316.828],[835.998,431.16],[835.998,321.577]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[782.372,555.805],[782.372,443.831],[835.998,555.451],[835.998,445.869]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[782.372,574.485],[782.372,686.458],[835.998,573.732],[835.998,683.315]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[782.372,699.378],[782.372,811.351],[835.998,695.958],[835.998,805.541]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[783.381,832.133],[783.381,944.124],[834.496,826.169],[834.496,935.88]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[869.715,830.82],[869.715,942.309],[834.495,826.169],[834.495,935.88]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[869.917,429.473],[869.917,318.181],[835.998,431.16],[835.998,321.577]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[869.917,555.704],[869.917,444.412],[835.998,555.451],[835.998,445.869]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[869.917,574.27],[869.917,685.562],[835.998,573.732],[835.998,683.315]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[869.917,698.403],[869.917,809.695],[835.998,695.958],[835.998,805.541]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[858.497,300.324],[858.497,193.896],[953.768,303.163],[953.768,198]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[869.716,830.82],[869.716,942.309],[981.396,817.386],[981.396,923.738]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[869.917,429.473],[869.917,318.181],[974.51,434.211],[974.51,327.722]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[869.917,555.704],[869.917,444.412],[974.51,554.994],[974.51,448.505]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[869.917,574.27],[869.917,685.562],[974.51,572.759],[974.51,679.248]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[869.917,698.403],[869.917,809.695],[974.51,691.535],[974.51,798.024]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[953.768,303.163],[953.768,198],[1077.95,309.113],[1077.95,206.6]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1035.62,431.435],[1035.62,322.132],[974.51,434.211],[974.51,327.722]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1035.62,555.41],[1035.62,446.107],[974.51,554.994],[974.51,448.505]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1035.62,573.644],[1035.62,682.948],[974.51,572.759],[974.51,679.248]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1035.62,695.559],[1035.62,804.862],[974.51,691.535],[974.51,798.024]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1033.98,825.162],[1033.98,934.488],[973.145,817.831],[973.145,924.353]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1033.98,825.162],[1033.98,934.488],[1130.39,812.963],[1130.39,917.624]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1035.62,431.435],[1035.62,322.132],[1160.09,434.447],[1160.09,328.198]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1035.62,555.41],[1035.62,446.107],[1160.09,554.959],[1160.09,448.709]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1035.62,573.644],[1035.62,682.948],[1160.09,572.684],[1160.09,678.933]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1035.62,695.559],[1035.62,804.862],[1160.09,691.192],[1160.09,797.442]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1078.93,309.181],[1078.93,206.699],[1186.07,316.797],[1186.07,217.707]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1144.04,814.476],[1144.04,919.716],[1234.42,802.904],[1234.42,903.718]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1143.86,438.64],[1143.86,333.112],[1400.08,450.631],[1400.08,357.68]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1143.86,558.333],[1143.86,452.805],[1400.08,556.059],[1400.08,463.108]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1143.86,575.937],[1143.86,681.465],[1400.08,571.565],[1400.08,664.516]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1143.86,693.641],[1143.86,799.169],[1400.08,675.24],[1400.08,768.191]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1186.06,316.797],[1186.06,217.707],[1280.46,326.76],[1280.46,232.108]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1280.46,326.76],[1280.46,232.108],[1334.76,336.024],[1334.76,245.496]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1339.06,336.235],[1339.06,245.803],[1371.99,345.361],[1371.99,258.995]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1371.99,345.361],[1371.99,258.995],[1381.16,351.607],[1381.16,268.022]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1423.02,447.363],[1423.02,354.207],[1456.87,451.549],[1456.87,362.637]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1423.02,553.023],[1423.02,459.867],[1456.87,552.396],[1456.87,463.484]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1423.02,568.564],[1423.02,661.72],[1456.87,567.228],[1456.87,656.14]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1423.02,672.468],[1423.02,765.624],[1456.87,666.399],[1456.87,755.311]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1398.06,453.395],[1398.06,366.354],[1462.64,456.32],[1462.64,372.245]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1398.06,552.119],[1398.06,465.078],[1462.64,551.681],[1462.64,467.605]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1398.06,566.64],[1398.06,653.681],[1462.64,565.707],[1462.64,649.782]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:71,
                    verts:[[1398.06,663.723],[1398.06,750.764],[1462.64,659.482],[1462.64,743.558]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[563.337,437.556],[563.337,334.458],[404.023,444.423],[404.023,348.287]]
                },{
                    num:"402",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[563.337,554.493],[563.337,451.395],[404.023,553.464],[404.023,457.328]]
                },{
                    num:"302",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[563.337,571.692],[563.337,674.79],[404.023,569.501],[404.023,665.637]]
                },{
                    num:"202",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[563.337,686.685],[563.337,789.784],[404.023,676.729],[404.023,772.865]]
                },{
                    num:"102",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[563.337,808.876],[563.337,911.974],[404.023,790.668],[404.023,886.805]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[540.814,326.091],[540.814,231.14],[504.633,329.391],[504.633,235.911]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[538.674,319.076],[538.674,221.001],[512.777,323.564],[512.777,227.488]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[559.407,315.84],[559.407,216.324],[538.674,319.076],[538.674,221.001]]
                },{
                    num:"602",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[595.168,311.154],[595.168,209.55],[559.407,315.84],[559.407,216.324]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[748.67,429.567],[748.67,318.37],[564.32,437.514],[564.32,334.373]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[748.67,555.69],[748.67,444.493],[564.32,554.499],[564.32,451.358]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[748.67,574.24],[748.67,685.438],[564.32,571.706],[564.32,674.847]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[748.67,698.268],[748.67,809.465],[564.32,686.747],[564.32,789.888]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[749.406,830.141],[749.406,941.371],[564.953,809.061],[564.953,912.229]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[648.163,307.241],[648.163,203.894],[597.35,310.767],[597.35,208.991]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[685.245,305.071],[685.245,200.758],[648.163,307.241],[648.163,203.894]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[739.505,302.2],[739.505,196.607],[685.244,305.071],[685.244,200.758]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[739.506,302.2],[739.506,196.607],[767.369,305.248],[767.369,201.014]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[837.964,429.281],[837.964,317.794],[748.67,429.567],[748.67,318.37]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[837.964,555.733],[837.964,444.246],[748.67,555.69],[748.67,444.493]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[837.964,574.332],[837.964,685.819],[748.67,574.24],[748.67,685.438]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[837.964,698.682],[837.964,810.169],[748.67,698.268],[748.67,809.465]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[839.011,830.849],[749.406,830.141],[839.011,942.349],[749.406,941.371]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[812.401,301.137],[812.401,195.072],[767.369,305.249],[767.369,201.014]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[812.401,301.137],[900.589,301.884],[812.401,195.072],[900.589,196.151]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[837.964,429.281],[837.964,317.794],[885.668,431.818],[885.668,322.902]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[837.964,555.733],[837.964,444.246],[885.668,555.353],[885.668,446.437]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[837.964,574.332],[837.964,685.819],[885.668,573.522],[885.668,682.438]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[837.964,698.682],[837.964,810.169],[885.668,695.004],[885.668,803.92]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[839.011,830.849],[839.011,942.349],[884.478,824.434],[884.478,933.481]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[923.557,828.592],[923.557,939.229],[884.478,824.434],[884.478,933.481]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[923.295,430.31],[923.295,319.866],[885.668,431.818],[885.668,322.902]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[923.295,555.579],[923.295,445.135],[885.668,555.353],[885.668,446.437]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[923.295,574.003],[923.295,684.447],[885.668,573.522],[885.668,682.438]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[923.295,697.19],[923.295,807.633],[885.668,695.004],[885.668,803.92]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[900.589,301.884],[900.589,196.15],[991.782,305.526],[991.782,201.416]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[923.296,430.31],[923.296,319.867],[1015.27,435.364],[1015.27,330.044]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[923.296,555.579],[923.296,445.135],[1015.27,554.821],[1015.27,449.501]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[923.296,574.003],[923.296,684.447],[1015.27,572.391],[1015.27,677.711]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[923.296,697.19],[923.296,807.634],[1015.27,689.863],[1015.27,795.183]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[923.557,828.592],[923.557,939.229],[1021.71,814.265],[1021.71,919.424]]
                },{
                    num:"601",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[991.782,305.526],[991.782,201.416],[1107.39,312.422],[1107.39,211.383]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1081.67,432.91],[1081.67,325.102],[1015.27,435.364],[1015.27,330.044]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1081.67,555.189],[1081.67,447.381],[1015.27,554.821],[1015.27,449.501]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1081.67,573.174],[1081.67,680.982],[1015.27,572.391],[1015.27,677.711]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1081.67,693.421],[1081.67,801.229],[1015.27,689.863],[1015.27,795.183]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1080.11,821.268],[1080.11,929.105],[1014,814.785],[1014,920.143]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1080.11,821.268],[1080.11,929.105],[1163.38,808.407],[1163.38,911.326]]
                },{
                    num:"501",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1081.67,432.91],[1081.67,325.102],[1195.82,436.331],[1195.82,331.991]]
                },{
                    num:"401",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1081.67,555.189],[1081.67,447.381],[1195.82,554.676],[1195.82,450.336]]
                },{
                    num:"301",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1081.67,573.174],[1081.67,680.982],[1195.82,572.083],[1195.82,676.423]]
                },{
                    num:"201",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1081.67,693.421],[1081.67,801.229],[1195.82,688.461],[1195.82,792.801]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1108.28,312.497],[1108.28,211.491],[1204.68,320.802],[1204.68,223.495]]
                },{
                    num:"101",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1177.95,809.733],[1177.95,913.159],[1255.34,797.619],[1255.34,896.413]]
                },{
                    num:"506",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1178.43,440.377],[1178.43,336.671],[1396.57,452.863],[1396.57,362.253]]
                },{
                    num:"406",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1178.43,558.003],[1178.43,454.297],[1396.57,555.635],[1396.57,465.025]]
                },{
                    num:"306",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1178.43,575.304],[1178.43,679.01],[1396.57,570.751],[1396.57,661.361]]
                },{
                    num:"206",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1178.43,690.975],[1178.43,794.681],[1396.57,671.816],[1396.57,762.425]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1204.68,320.802],[1204.68,223.496],[1285.76,331.213],[1285.76,238.545]]
                },{
                    num:"606",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1285.76,331.213],[1285.76,238.545],[1328.64,340.584],[1328.64,252.088]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1332.56,340.821],[1332.56,252.432],[1354.98,349.876],[1354.98,265.52]]
                },{
                    num:"605",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1354.98,349.875],[1354.98,265.52],[1357.52,355.971],[1357.52,274.331]]
                },{
                    num:"505",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1418.9,449.757],[1418.9,359.029],[1441.67,453.896],[1441.67,367.363]]
                },{
                    num:"405",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1418.9,552.664],[1418.9,461.936],[1441.67,552.044],[1441.67,465.511]]
                },{
                    num:"305",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1418.9,567.8],[1418.9,658.529],[1441.67,566.48],[1441.67,653.013]]
                },{
                    num:"205",
                    tipo:"TorreB",
                    frame:72,
                    verts:[[1418.9,668.997],[1418.9,759.725],[1441.67,662.997],[1441.67,749.529]]
                },
                ],
                [
                
                ]
        ]
    }
}